export const LOCALES = [
  { id: 'tr', code: 'TR', label: 'Türkçe', flagIcon: '/flags/circle/tr.svg' },
  { id: 'en', code: 'EN', label: 'English', flagIcon: '/flags/circle/en.svg' },
  { id: 'de', code: 'DE', label: 'Deutsch', flagIcon: '/flags/circle/de.svg' },
  { id: 'nl', code: 'NL', label: 'Nederlands', flagIcon: '/flags/circle/nl.svg' },
  { id: 'ru', code: 'RU', label: 'Русский', flagIcon: '/flags/circle/ru.svg' },
  { id: 'fr', code: 'FR', label: 'Français', flagIcon: '/flags/circle/fr.svg' },
  { id: 'az', code: 'AZ', label: 'Azərbaycan', flagIcon: '/flags/circle/az.svg' },
  { id: 'tk', code: 'TK', label: 'Türkmençe', flagIcon: '/flags/circle/tk.svg' },
];

export const MESSAGES = {
  tr: {
    'network.offline': 'İnternet bağlantınız yok.',
    'network.online': 'Tekrar onlinesınız.',
    'network.poor': 'Zayıf internet bağlantısı.',
    'network.reconnecting': 'Tekrar deneniyor…',
    'nav.home': 'Anasayfa',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Spor',
    'nav.sportLive': 'Canlı bahis',
    'nav.liveCasino': 'Canlı Casino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slotlar',
    'nav.virtual': 'Sanal sporlar',
    'nav.fast': 'Hızlı oyunlar',
    'nav.tv': 'TV oyunları',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Canlı maç yayınlarını izle',
    'vtv.live': 'Canlı',
    'vtv.upcoming': 'Yaklaşan',
    'vtv.search': 'Ara',
    'vtv.searchPh': 'Takım, lig ara…',
    'vtv.allSports': 'Tüm sporlar',
    'vtv.loading': 'Yayınlar yükleniyor…',
    'vtv.empty': 'Maç bulunamadı',
    'vtv.error': 'Yayınlar yüklenemedi',
    'vtv.pick': 'İzlemek için bir maç seç',
    'vtv.streamError': 'Yayın açılamadı',
    'vtv.liveBadge': 'CANLI',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'YENİ',
    'nav.newGames': 'Yeni Oyunlar',
    'nav.newPromos': 'Yeni Promosyonlar',
    'nav.promos': 'Promosyonlar',
    'nav.casino': 'Casino',
    'nav.apps': 'Uygulamalar',
    'nav.results': 'Sonuçlar',
    'header.promos': 'Promosyonlar',
    'header.help': 'Yardım',
    'header.search': 'Ara',
    'header.settings': 'Ayarlar',
    'header.login': 'Giriş yap',
    'header.join': 'Kayıt ol',
    'header.logout': 'Çıkış yap',
    'header.account': 'Hesabım',
    'header.deposit': 'Para yatır',
    'header.inGame': '(Oyunda)',
    'header.hideBalance': 'Bakiyeyi gizle',
    'header.showBalance': 'Bakiyeyi göster',
    'header.notifications': 'Bildirimler',
    'mobile.menu': 'Menü',
    'mobile.home': 'Ana Sayfa',
    'mobile.myBets': 'Bahislerim',
    'mobile.navigation': 'Navigasyon',
    'mobile.menu.loginTitle': 'Hesabınıza giriş yapın',
    'mobile.menu.loginText': 'tüm hizmet seçeneklerine tam erişim için',
    'mobile.menu.tournaments': 'Turnuvalar',
    'mobile.menu.helpNote': 'SSS, öğrenme, sözlük',
    'mobile.menu.appsNote': 'Android, iOS için',
    'mobile.menu.about': 'VurgunBet hakkında',
    'mobile.menu.aboutNote': 'Bilgi, lisanslar',
    'basinda.title': 'Basında Biz',
    'basinda.lead': 'VurgunBet’in stadyum ve saha sponsorluklarından kareler.',
    'basinda.menuNote': 'Sponsorluklar, basın',
    'basinda.item1': 'Sassuolo - Pisa',
    'basinda.item2': 'Torino - Atalanta',
    'basinda.item3': 'Alaves - Elche',
    'basinda.item4': 'Levante - Alaves',
    'basinda.item5': 'Fenerbahçe - Pogon Szczecin',
    'mobile.menu.siteTour': 'Site turu',
    'mobile.menu.siteTourText': 'sadece 2 dakika sürer →',
    'mobile.menu.history': 'Geçmişi görüntüle',
    'mobile.menu.historyEmpty': 'Henüz gezinme geçmişi yok',
    'mobile.menu.historyEmptyText': 'İzlediğiniz tüm bölümleri ve spor etkinliklerini burada bulabilirsiniz',
    'mobile.menu.clearHistory': 'Geçmişi temizle',
    'mobile.menu.openPromos': 'Promosyonlar',
    'mobile.menu.searchGames': 'Oyun ara',
    'mobile.menu.responsibleGaming': 'Sorumlu oyun',
    'mobile.account.number': 'Hesap: {id}',
    'mobile.account.copy': 'Hesap numarasını kopyala',
    'mobile.account.copied': 'Kopyalandı',
    'mobile.account.balance': 'Bakiye: {amount}',
    'settings.section.sport': 'Spor',
    'settings.section.casino': 'Casino',
    'settings.section.interface': 'Arayüz',
    'settings.section.navigation': 'Navigasyon',
    'settings.eventDisplay': 'Etkinlik görünümü',
    'settings.eventDisplay.table': 'Tablo',
    'settings.eventDisplay.list': 'Liste',
    'settings.betSlipLocation': 'Kupon konumu',
    'settings.betSlipLocation.bottom': 'Alt panelde',
    'settings.betSlipLocation.above': 'Panelin üstünde',
    'settings.betSlipSettings': 'Kupon ayarları',
    'settings.betSlip.showLiveTimer': 'Kuponda canlı etkinlik zamanlayıcısını göster',
    'settings.betSlip.showEventTime': 'Kuponda etkinlik saati ve başlangıç tarihini göster',
    'settings.betSlip.skipClearConfirm': 'Kuponu temizlerken onay sorma',
    'settings.betSlip.view': 'Kupon görünümü',
    'settings.betSlip.view.auto': 'Otomatik',
    'settings.betSlip.view.narrow': 'Dar',
    'settings.betSlip.view.wide': 'Geniş',
    'settings.odds.title': 'Oranlar',
    'settings.odds.boosted': 'Artırılmış',
    'settings.odds.on': 'açık',
    'settings.odds.off': 'kapalı',
    'settings.odds.hideBoosted': 'Spor bölümünde artırılmış oranları gösterme',
    'settings.odds.european': 'Avrupa',
    'settings.odds.american': 'Amerikan',
    'settings.odds.hongkong': 'Hong Kong',
    'settings.odds.indonesian': 'Endonezya',
    'settings.odds.malaysian': 'Malezya',
    'settings.favouriteSports': 'Favori sporlar',
    'settings.favouriteSports.empty': 'Seçilmedi',
    'settings.favouriteSports.desc': 'Favori sporlarınızı ekleyin; Spor bölümünde önce gösterilir.',
    'settings.casinoProMode': 'Pro mod',
    'settings.casinoProMode.desc': 'Oyun kartında volatilite ve diğer değerleri göster',
    'settings.casinoView.standard': 'Standart görünüm',
    'settings.casinoView.pro': 'Pro mod',
    'settings.theme.title': 'Site teması',
    'settings.theme.auto': 'Otomatik',
    'settings.theme.light': 'Açık',
    'settings.theme.dark': 'Koyu',
    'settings.hideBalance': 'Bakiyeyi gizle',
    'settings.hideBalance.desc': 'Başlıktaki bakiyeyi gizlemek için kaydırın',
    'settings.showUpButton': '"Yukarı" düğmesini göster',
    'settings.language': 'Dil',
    'settings.nav.sportSection': 'Spor bölümünde',
    'settings.nav.casinoSection': 'Casino bölümünde',
    'settings.nav.menu': 'Menüde',
    'settings.title': 'Site ayarları',
    'settings.reset': 'Varsayılana dön',
    'settings.betSlip.title': 'Kupon',
    'settings.nav.betAcceptance': 'Bahis kabulü',
    'settings.nav.cashOut': 'Erken ödeme',
    'settings.nav.favouriteBets': 'Favori bahisler',
    'settings.nav.betSlip': 'Kupon görünümü',
    'settings.navigation.auto': 'Otomatik',
    'settings.navigation.left': 'Solda',
    'settings.navigation.top': 'Üstte',
    'settings.eventList.title': 'Etkinlik listesi',
    'settings.eventList.minimised': 'Tüm etkinlikler varsayılan olarak daraltılsın',
    'settings.eventPage.title': 'Etkinlik sayfası',
    'settings.view.large': 'Geniş görünüm',
    'settings.view.compact': 'Kompakt görünüm',
    'settings.favouriteSports.descLong': 'Favori sporlarınızı ekleyin; Spor bölümünde önce gösterilir. Sırayı sürükleyerek değiştirebilirsiniz',
    'settings.favouriteSports.hint': 'Sporu favorilere eklemek için ★ simgesine basın',
    'settings.sport.football': 'Futbol',
    'settings.sport.hockey': 'Buz hokeyi',
    'settings.sport.tennis': 'Tenis',
    'settings.sport.basketball': 'Basketbol',
    'settings.sport.esports': 'E-spor',
    'settings.sport.tableTennis': 'Masa tenisi',
    'settings.sport.volleyball': 'Voleybol',
    'settings.sport.handball': 'Hentbol',
    'settings.sport.mixFights': 'Karma dövüş',
    'settings.sport.boxing': 'Boks',
    'settings.sport.futsal': 'Futsal',
    'settings.sport.baseball': 'Beyzbol',
    'settings.sport.americanFootball': 'Amerikan futbolu',
    'settings.sport.rugby': 'Ragbi',
    'settings.sport.waterPolo': 'Su topu',
    'settings.sport.fieldHockey': 'Çim hokeyi',
    'settings.sport.racing': 'Yarış',
    'settings.sport.cycling': 'Bisiklet',
    'settings.sport.sports': 'Spor',
    'settings.sport.beachSoccer': 'Plaj futbolu',
    'settings.sport.basketball3x3': 'Basketbol 3x3',
    'settings.sport.lacrosse': 'Lakros',
    'settings.sport.australianFootball': 'Avustralya futbolu',
    'settings.sport.cricket': 'Kriket',
    'settings.sport.snooker': 'Snooker',
    'settings.sport.darts': 'Dart',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet — Online Spor Bahisleri',
    'auth.login.title': 'Hesabınıza giriş yapın',
    'auth.login.submit': 'Giriş yap',
    'auth.login.link': 'Giriş yap',
    'auth.register.title': 'Kayıt ol',
    'auth.register.bannerHighlight': '%100\'E VARAN',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPIN',
    'auth.register.bannerDesc': '+5 FREE BET',
    'auth.register.perkFast': 'Anonim',
    'auth.register.perkSafe': 'Sıfır Komisyon',
    'auth.register.perkBonus': 'VPN Dostu',
    'auth.register.orSignUpWith': 'VEYA ŞUNUNLA KAYIT OL',
    'auth.login.orSignInWith': 'VEYA ŞUNUNLA GİRİŞ YAP',
    'auth.webauthn.login': 'Face ID / Touch ID ile giriş',
    'auth.webauthn.offerTitle': 'Cihazda Face ID kaydet',
    'auth.webauthn.offerBody': 'Bir sonraki girişte Face ID veya Touch ID ile hızlıca oturum açabilirsiniz.',
    'auth.webauthn.offerConfirm': 'Bu cihazda kaydet',
    'auth.webauthn.offerSkip': 'Şimdi değil',
    'auth.webauthn.needRegister': 'Önce profilde Face ID / Touch ID kaydedin',
    'auth.webauthn.failed': 'Biyometrik giriş başarısız',
    'auth.webauthn.unsupported': 'Bu cihazda Face ID / Touch ID kullanılamıyor',
    'auth.webauthn.registerFailed': 'Biyometrik kayıt başarısız',
    'auth.webauthn.alreadyRegistered': 'Bu cihaz zaten kayıtlı',
    'auth.webauthn.thisDevice': 'Bu cihaz',
    'auth.webauthn.manageTitle': 'Face ID / Touch ID',
    'auth.webauthn.manageDesc': 'Bu cihazda Face ID, Touch ID veya Windows Hello ile giriş için bir anahtar kaydedin.',
    'auth.webauthn.empty': 'Kayıtlı biyometrik giriş yok',
    'auth.webauthn.add': 'Bu cihazda kaydet',
    'auth.webauthn.remove': 'Kaldır',
    'auth.webauthn.removed': 'Kayıt kaldırıldı',
    'auth.webauthn.registered': 'Biyometrik giriş kaydedildi',
    'auth.webauthn.loadFailed': 'Kayıtlar yüklenemedi',
    'auth.webauthn.removeFailed': 'Kayıt silinemedi',
    'account.profile.tab.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeysHint': 'Hızlı giriş',
    'auth.register.socialNotConfigured': 'Bu yöntem henüz yapılandırılmadı',
    'auth.register.pageTitle': 'Kayıt ol | VurgunBet',
    'auth.register.submit': 'Kayıt ol',
    'auth.register.link': 'Kayıt ol',
    'guestPopup.title': '100 TL bedava bahis + 300 ücretsiz dönüş',
    'guestPopup.subtitle': 'yeni müşteriler için',
    'guestPopup.cta': 'Kayıt ol',
    'language.choose': 'Dil seçin',
    'auth.register.slogan': 'OYUNA DAHA YAKIN',
    'auth.register.smsHint': 'Bu numaraya SMS kodu gönderilecek',
    'auth.register.promoToggle': 'Promosyon kodum var',
    'auth.register.rules': '18 yaşındayım ve Şartlar ve Koşullar ile Gizlilik Politikasını kabul ediyorum *',
    'auth.register.rulesBefore': '18 yaşındayım ve ',
    'auth.register.termsLink': 'Şartlar ve Koşullar',
    'auth.register.rulesAnd': ' ile ',
    'auth.register.privacyLink': 'Gizlilik Politikasını',
    'auth.register.rulesAfter': ' kabul ediyorum *',
    'auth.register.rulesLink': 'Şartlar ve Koşullar',
    'auth.register.rulesRequired': 'Şartları ve gizlilik politikasını kabul etmelisiniz',
    'auth.register.serviceMail': 'Servis bültenlerini almayı kabul ediyorum.',
    'auth.register.serviceMail2': 'Kişisel verilerin işlenmesi politikasını',
    'auth.register.here': 'buradan',
    'auth.register.adMail': 'Reklam posta listesinin',
    'auth.register.adTerms': 'koşullarını kabul ediyorum',
    'auth.register.adTermsLink': 'koşullarını',
    'auth.register.adTermsSuffix': 'kabul ediyorum',
    'auth.register.serviceMailSuffix': ' okuyabilirsiniz.',
    'auth.register.fullPromotionTerms': 'Tam promosyon kuralları',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Telefon numaranızı girin',
    'auth.validation.phoneOrEmailRequired': 'E-posta veya telefon girin',
    'auth.validation.phoneInvalid': 'Geçerli bir telefon numarası girin',
    'auth.validation.phoneExists': 'Bu telefon numarası zaten kayıtlı',
    'auth.validation.usernameRequired': 'Kullanıcı adı zorunlu',
    'auth.validation.usernameShort': 'Kullanıcı adı en az 3 karakter olmalı',
    'auth.validation.usernameInvalid': 'Kullanıcı adı geçersiz',
    'auth.validation.emailRequired': 'E-posta adresinizi girin',
    'auth.validation.emailInvalid': 'Geçerli bir e-posta adresi girin',
    'auth.validation.emailDomainInvalid': 'Geçerli bir e-posta kullanın (gmail, hotmail, outlook, icloud, yandex, yahoo, mynet vb.)',
    'auth.validation.emailExists': 'Bu e-posta adresi zaten kayıtlı',
    'auth.validation.passwordRequired': 'Şifrenizi girin',
    'auth.validation.passwordShort': 'Şifre en az 8 karakter olmalı',
    'auth.validation.registerFailed': 'Kayıt oluşturulamadı. Lütfen tekrar deneyin.',
    'auth.validation.loginFieldsRequired': 'Tüm alanları doldurun',
    'auth.validation.loginInvalid': 'Giriş bilgileri hatalı',
    'auth.validation.accountRequired': 'Oyuncu ID girin',
    'auth.validation.accountShort': 'Oyuncu ID en az 6 rakam olmalı',
    'auth.validation.codeInvalid': 'Onay kodu hatalı',
    'auth.validation.codeRequired': 'Onay kodunu girin',
    'auth.validation.codeSendFailed': 'Kod gönderilemedi',
    'auth.validation.codeThrottled': 'Kodu tekrar göndermek için biraz bekleyin',
    'auth.validation.challengeExpired': 'Doğrulama süresi doldu, tekrar giriş yapın',
    'auth.validation.serverUnreachable': 'Sunucuya bağlanılamadı. Terminalde npm run dev:server çalıştırın.',
    'auth.validation.serverError': 'Giriş yapılamadı. Sunucu ve veritabanını kontrol edin.',
    'auth.tab.phone': 'Telefon',
    'auth.tab.email': 'E-posta',
    'auth.tab.username': 'Kullanıcı adı',
    'auth.tab.account': 'ID No',
    'auth.label.phone': 'Telefon numarası',
    'auth.label.phoneOptional': 'Cep telefonu (opsiyonel)',
    'auth.label.email': 'E-posta',
    'auth.label.username': 'Kullanıcı adı',
    'auth.label.account': 'Oyuncu ID',
    'auth.label.password': 'Şifre',
    'auth.label.promo': 'Promosyon kodu',
    'auth.placeholder.account': 'Oyuncu ID',
    'auth.placeholder.username': 'Kullanıcı adı',
    'auth.forgot': 'Şifrenizi mi unuttunuz?',
    'auth.noAccount': 'Hesabınız yok mu?',
    'auth.haveAccount': 'Zaten hesabınız var mı?',
    'auth.login.pageTitle': 'Giriş | VurgunBet',
    'auth.verify.info': 'Hesabınızı korumak için bunun gerçekten siz olduğunuzdan emin olmamız gerekiyor.',
    'auth.verify.caption': 'Onay kodu alın:',
    'auth.verify.methodPhone': 'Kodu SMS veya Telegram ile {contact} numarasına göndereceğiz',
    'auth.verify.methodEmail': 'Kodu {contact} adresine e-posta ile göndereceğiz',
    'auth.verify.getCode': 'Kod al',
    'auth.verify.cancel': 'İptal',
    'auth.verify.noAccess': 'Telefon numarasına erişimim yok',
    'auth.verify.enterCode': 'Onay kodunu girin:',
    'auth.verify.confirm': 'Onayla',
    'auth.verify.continue': 'Devam et',
    'auth.verify.codeInfoPhone': 'Doğrulama kodunu girin. Kodu SMS veya Telegram ile {contact} numarasına gönderdik.',
    'auth.verify.codeInfoEmail': 'Doğrulama kodunu girin. Kodu {contact} adresine e-posta ile gönderdik.',
    'auth.verify.neverReceived': 'Kodu hiç almadım',
    'auth.verify.resend': 'Kodu tekrar gönder',
    'auth.verify.noAccessEmail': 'E-posta adresine erişimim yok',
    'auth.verify.help.title': 'Onay kodu gelmediyse',
    'auth.verify.help.bodyPhone': 'Telefon numaranızın doğru olduğundan ve cihazınızda yeterli boş bellek olduğundan emin olun. Mesajın istenmeyen (spam) klasörüne düşüp düşmediğini kontrol edin.',
    'auth.verify.help.bodyEmail': 'E-posta adresinizin doğru olduğundan emin olun. Mesajın istenmeyen (spam) klasörüne düşüp düşmediğini kontrol edin.',
    'auth.verify.help.step1': 'Mesajlar uygulamasını açın',
    'auth.verify.help.step2': 'Sağ üst köşedeki düğmeye basın',
    'auth.verify.help.step3': '"Spam ve engellenenler"i seçin',
    'auth.verify.help.understood': 'Anladım',
    'auth.recover.title': 'Şifre sıfırlama',
    'auth.recover.pageTitle': 'Şifre sıfırlama | VurgunBet',
    'auth.recover.continue': 'Devam',
    'auth.recover.noAccess': 'Telefon numarasına / e-postaya erişimim yok',
    'auth.recover.noAccessPhone': 'Telefon numarasına erişimim yok',
    'auth.recover.noAccessEmail': 'E-posta adresine erişimim yok',
    'auth.recover.newPassword': 'Yeni şifre',
    'auth.recover.confirmPassword': 'Yeni şifre (tekrar)',
    'auth.recover.passwordMismatch': 'Şifreler eşleşmiyor',
    'auth.recover.save': 'Şifreyi kaydet',
    'auth.recover.success': 'Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.',
    'auth.recover.notFound': 'Bu bilgilere ait hesap bulunamadı',
    'auth.verify.expiredTitle': 'Bu işlem için tanınan süre doldu.',
    'auth.verify.retry': 'Tekrar dene',
    'welcome.stepLabel': 'Adım 1 / 3: Kayıt',
    'welcome.title': '100 TL + 300 FS\'ye kadar hoş geldin bonusu kazanın!',
    'welcome.step1.title': 'Kayıt ol',
    'welcome.step1.sub': 'Web sitesinde veya uygulamada',
    'welcome.step2.title': 'Doğrulamayı tamamlayın',
    'welcome.step2.sub': 'Sadece birkaç dakika sürer',
    'welcome.step3.title': 'Para yatırın',
    'welcome.step3.sub': 'Daha büyük yatırım – daha büyük bonus!',
    'welcome.start': 'Başla',
    'welcome.rules': 'Tam promosyon kuralları',
    'account.loading': 'Yükleniyor...',
    'account.save': 'Kaydet',
    'account.empty': 'Kayıt bulunamadı',
    'account.nav.overview': 'Genel bakış',
    'account.nav.profile': 'Kişisel veriler',
    'account.nav.verification': 'Doğrulama',
    'account.nav.cashier': 'Kasa',
    'account.nav.bets': 'Bahislerim',
    'account.nav.bonuses': 'Bonuslar',
    'account.nav.notifications': 'Bildirimler',
    'account.nav.security': 'Güvenlik',
    'account.nav.support': 'Destek',
    'account.menu.profile': 'Profilim',
    'account.menu.payments': 'Para yatırma ve çekme',
    'account.menu.history': 'Bahis ve işlem geçmişi',
    'account.menu.requests': 'Talepler',
    'account.menu.responsible': 'Sorumlu oyun',
    'account.menu.vip': 'VIP durumunuz',
    'support.liveChat': 'Canlı destek',
    'account.menu.deposit': 'Para yatır',
    'account.overview.title': 'Hesap özeti',
    'account.overview.balance': 'Bakiye',
    'account.overview.bonusBalance': 'Bonus bakiyesi',
    'account.wager.progress': 'Çevrim durumu',
    'account.wager.bonusTitle': 'Bonus çevrimi',
    'account.wager.depositTitle': 'Yatırım çevrimi',
    'account.overview.accountNo': 'Hesap no',
    'account.overview.verification': 'Doğrulama',
    'account.overview.totalBets': 'Toplam bahis',
    'account.profile.name': 'Ad soyad',
    'account.profile.saved': 'Bilgileriniz kaydedildi',
    'account.profile.marketingEmail': 'E-posta ile promosyon bildirimleri almak istiyorum',
    'account.profile.marketingSms': 'SMS ile promosyon bildirimleri almak istiyorum',
    'account.profile.tab.details': 'Kişisel bilgiler',
    'account.profile.tab.phone': 'Telefon numarasını değiştir',
    'account.profile.tab.phoneAdd': 'Telefon numarası ekle',
    'account.profile.tab.phoneVerify': 'Telefon numarasını doğrula',
    'account.profile.tab.email': 'E-postayı değiştir',
    'account.profile.tab.emailAdd': 'E-posta ekle',
    'account.profile.tab.emailVerify': 'E-postayı doğrula',
    'account.profile.tab.password': 'Şifreyi değiştir',
    'account.profile.section.personal': 'KİŞİSEL VERİLER',
    'account.profile.section.lastLogin': 'SON GİRİŞ BİLGİLERİ',
    'account.profile.section.contacts': 'İLETİŞİM',
    'account.profile.section.marketing': 'İLETİŞİM TERCİHLERİ',
    'account.profile.field.name': 'Ad:',
    'account.profile.field.verification': 'Kimlik doğrulama durumu:',
    'account.profile.field.accountNo': 'Hesap numarası:',
    'account.profile.field.currency': 'Para birimi:',
    'account.profile.field.phone': 'Telefon numarası:',
    'account.profile.field.email': 'E-posta:',
    'account.profile.field.time': 'Zaman:',
    'account.profile.field.ip': 'IP adresi:',
    'account.profile.change': 'Değiştir',
    'account.profile.add': 'Ekle',
    'account.profile.status.verified': 'Onaylı',
    'account.profile.status.unverified': 'Onaysız',
    'account.profile.marketingIntro': 'Promosyon ve haber bildirimleri al:',
    'account.profile.marketing.email': 'E-posta',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Anlık bildirimler',
    'account.profile.marketing.web': 'Site bildirimleri',
    'account.profile.verification.basic': 'Doğrulanmadı',
    'account.profile.verification.verified': 'Doğrulandı',
    'account.profile.verification.pending': 'Beklemede',
    'account.profile.verify': 'Doğrula',
    'account.profile.tab.kyc': 'Kimlik doğrulama',
    'account.profile.kyc.title': 'Kimlik doğrulama',
    'account.profile.kyc.intro': 'TC Kimlik No, şehir, adres ve kimlik fotoğraflarınızı gönderin. Talebiniz incelendikten sonra hesabınız doğrulanır.',
    'account.profile.kyc.tcLabel': 'TC Kimlik No',
    'account.profile.kyc.tcInvalid': 'Geçerli bir 11 haneli TC Kimlik No girin',
    'account.profile.kyc.cityLabel': 'Şehir',
    'account.profile.kyc.cityPlaceholder': 'Şehir seçin',
    'account.profile.kyc.cityRequired': 'Şehir seçimi zorunlu',
    'account.profile.kyc.addressLabel': 'Adres',
    'account.profile.kyc.addressHint': 'Açık adresinizi yazın. Yanlışsa düzeltebilirsiniz.',
    'account.profile.kyc.addressRequired': 'Adres en az 5 karakter olmalı',
    'account.profile.kyc.frontLabel': 'Kimlik ön yüz',
    'account.profile.kyc.frontHint': 'Kimliğinizin ön yüz fotoğrafını yükleyin',
    'account.profile.kyc.backLabel': 'Kimlik arka yüz',
    'account.profile.kyc.backHint': 'Kimliğinizin arka yüz fotoğrafını yükleyin',
    'account.profile.kyc.photoRequired': 'Kimlik ön yüz fotoğrafı zorunlu',
    'account.profile.kyc.backRequired': 'Kimlik arka yüz fotoğrafı zorunlu',
    'account.profile.kyc.submit': 'Gönder',
    'account.profile.kyc.submitted': 'Doğrulama talebiniz alındı, inceleniyor',
    'account.profile.kyc.pendingMessage': 'Doğrulama talebiniz inceleniyor. Sonuçlanana kadar yeni belge gönderemezsiniz.',
    'account.profile.kyc.alreadyVerified': 'Hesabınız zaten doğrulanmış.',
    'account.profile.todayAt': 'Bugün saat',
    'account.profile.mobile.personalData': 'Kişisel veriler',
    'account.profile.mobile.aboutAccount': 'Hesap hakkında',
    'account.profile.mobile.passwordChange': 'Şifre değiştir',
    'account.profile.next': 'İleri',
    'account.profile.changeEmailTitle': 'Yeni e-posta adresi',
    'account.profile.changePhoneTitle': 'Yeni telefon numarası',
    'account.profile.addEmailTitle': 'E-posta adresi ekle',
    'account.profile.addPhoneTitle': 'Telefon numarası ekle',
    'account.profile.verifyEmailTitle': 'E-posta adresini doğrula',
    'account.profile.verifyPhoneTitle': 'Telefon numarasını doğrula',
    'account.profile.contactSupport': 'Bilgi değiştirilmesi için destek ile iletişime geçiniz.',
    'account.profile.contactSupportAddPhone': 'Telefon numarası eklemek için destek talebi oluşturun.',
    'account.profile.contactSupportChangePhone': 'Telefon numaranızı değiştirmek için destek talebi oluşturun.',
    'account.profile.contactSupportVerifyPhone': 'Telefon numaranızı doğrulamak için destek talebi oluşturun.',
    'account.profile.contactSupportAddEmail': 'E-posta adresi eklemek için destek talebi oluşturun.',
    'account.profile.contactSupportChangeEmail': 'E-posta adresinizi değiştirmek için destek talebi oluşturun.',
    'account.profile.step.support': 'Destek talebi oluşturun',
    'account.profile.step.sharePhone': 'Telefon numaranızı bildirin',
    'account.profile.step.shareNewPhone': 'Yeni telefon numaranızı bildirin',
    'account.profile.step.requestVerify': 'Doğrulama talebinizi iletin',
    'account.profile.step.confirmSms': 'SMS kodu ile onaylayın',
    'account.profile.step.shareEmail': 'E-posta adresinizi bildirin',
    'account.profile.step.shareNewEmail': 'Yeni e-posta adresinizi bildirin',
    'account.profile.step.confirmEmail': 'E-posta doğrulamasını tamamlayın',
    'account.profile.contactSupportBtn': 'Destek ile iletişime geç',
    'account.profile.otp.addPhoneHint': 'Yeni telefon numaranızı girin. SMS ile doğrulama kodu göndereceğiz.',
    'account.profile.otp.changePhoneHint': 'Yeni telefon numaranızı girin. Değişiklik SMS kodu ile onaylanır.',
    'account.profile.otp.verifyPhoneHint': 'Telefon numaranızı doğrulamak için kod göndereceğiz.',
    'account.profile.otp.addEmailHint': 'E-posta adresinizi girin. Doğrulama kodunu e-posta ile göndereceğiz.',
    'account.profile.otp.verifyEmailHint': 'E-posta adresinizi doğrulamak için kod göndereceğiz.',
    'account.profile.otp.changeEmailHint': 'Yeni e-posta adresinizi girin. Değişiklik e-posta kodu ile onaylanır.',
    'account.profile.otp.codeSentPhone': 'Doğrulama kodunu şu numaraya gönderdik:',
    'account.profile.otp.codeSentEmail': 'Doğrulama kodunu şu adrese gönderdik:',
    'account.profile.otp.codeSent': 'Doğrulama kodu gönderildi',
    'account.profile.otp.codeLabel': 'Doğrulama kodu',
    'account.profile.otp.resend': 'Kodu tekrar gönder',
    'account.profile.otp.phoneRequired': 'Telefon numarası gerekli',
    'account.profile.otp.emailRequired': 'E-posta adresi gerekli',
    'account.profile.otp.codeRequired': 'Doğrulama kodu gerekli',
    'account.profile.otp.sessionMissing': 'Doğrulama oturumu bulunamadı',
    'account.profile.otp.saved': 'İletişim bilgileriniz güncellendi',
    'account.profile.passwordConfirm': 'Yeni şifre (tekrar)',
    'account.profile.passwordRequired': 'Tüm şifre alanlarını doldurun',
    'account.profile.passwordMismatch': 'Yeni şifreler eşleşmiyor',
    'account.profile.passwordSame': 'Yeni şifre mevcut şifre ile aynı olamaz',
    'account.profile.send': 'Gönder',
    'account.profile.passwordHint': 'Şifre değiştirmek için güvenlik bölümünü kullanın.',
    'account.verification.desc': 'Para çekmek ve tam hesap erişimi için kimlik doğrulaması gereklidir.',
    'account.verification.verified': 'Doğrulandı',
    'account.verification.pending': 'İnceleniyor',
    'account.verification.rejected': 'Reddedildi',
    'account.verification.step1': 'Pasaport veya kimlik belgenizin fotoğrafını yükleyin',
    'account.verification.step2': 'Selfie ile belgeyi tuttuğunuz fotoğrafı ekleyin',
    'account.verification.step3': 'İnceleme genelde 24 saat içinde tamamlanır',
    'account.verification.submit': 'Doğrulamayı başlat',
    'account.verification.submitted': 'Belgeleriniz inceleniyor',
    'account.cashier.deposit': 'Para yatır',
    'account.cashier.withdraw': 'Para çek',
    'account.cashier.amount': 'Tutar (TL)',
    'account.cashier.balance': 'Mevcut bakiye: {amount}',
    'account.cashier.history': 'İşlem geçmişi',
    'account.cashier.type': 'Tür',
    'account.cashier.date': 'Tarih',
    'account.payments.title': 'Para yatırma ve çekme',
    'account.payments.back': 'Geri',
    'account.payments.selectMethod': 'Yöntem seçin',
    'account.payments.group.havale': 'Havale',
    'account.payments.group.card': 'Kredi Kartı',
    'account.payments.group.crypto': 'Kripto',
    'account.payments.group.other': 'Diğer',
    'account.payments.noMethods': 'Şu an kullanılabilir yöntem yok.',
    'account.payments.from': '{amount} TL\'den itibaren',
    'account.payments.depositTitle': '{method} ile bakiye yükle',
    'account.payments.withdrawTitle': '{method} ile para çek',
    'account.payments.depositNotice': 'Dikkat! Banka kartı hesap sahibi adına kayıtlı olmalıdır. Üçüncü şahıs kartlarıyla yapılan ödemeler reddedilir.',
    'account.payments.withdrawNotice': 'Çekim talepleri doğrulama durumunuza göre işleme alınır.',
    'account.payments.addAmount': 'Para yatır',
    'account.payments.withdrawSubmit': '{amount} TL çek',
    'account.payments.requests': 'Talepleriniz',
    'account.payments.insufficientBalance': 'Yetersiz bakiye',
    'account.payments.minWithdrawNotice': 'Kazanç çekimi için gereken minimum tutar: {amount}',
    'account.payments.withdrawGoDeposit': 'Para Yatır',
    'account.payments.selectAnotherMethod': 'Başka yöntem seç',
    'account.payments.requestsTitle': 'İşlem talepleri',
    'account.payments.requestsEmpty': 'Henüz işlem talebiniz yok.',
    'account.payments.filterAll': 'Tümü',
    'account.payments.filterCompleted': 'Tamamlandı',
    'account.payments.filterProcessing': 'İşleniyor',
    'account.payments.filterCancelled': 'İptal edildi',
    'account.payments.colNumber': 'NUMARA',
    'account.payments.colDate': 'TARİH',
    'account.payments.colType': 'TÜR',
    'account.payments.colMethod': 'YÖNTEM',
    'account.payments.colAmount': 'TUTAR',
    'account.payments.status': 'Durum',
    'account.payments.status_completed': 'Tamamlandı',
    'account.payments.status_pending': 'Beklemede',
    'account.payments.status_processing': 'İşleniyor',
    'account.payments.status_cancelled': 'İptal edildi',
    'account.payments.status_rejected': 'Reddedildi',
    'account.payments.status_failed': 'Başarısız',
    'account.payments.status_approved': 'Onaylandı',
    'account.payments.status_expired': 'Süresi doldu',
    'account.payments.goToRequests': 'Taleplerim',
    'account.payments.method.crypto': 'Kripto',
    'account.payments.method.maxhavale': 'Max Havale',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Speed Havale',
    'account.payments.havalespeed.depositPending': 'Speed Havale yatırımını tamamlayın',
    'account.payments.havalespeed.withdrawPending': 'Speed Havale çekiminiz işleniyor',
    'account.payments.havalespeed.processing': 'Kalan süre',
    'account.payments.havalespeed.confirmPaid': 'Havale yaptım, bildir',
    'account.payments.havalespeed.confirming': 'Bildirim gönderiliyor…',
    'account.payments.havalespeed.confirmSent': 'Bildiriminiz alındı. Onay bekleniyor.',
    'account.payments.havalespeed.cancelDeposit': 'Talebi iptal et',
    'account.payments.havalespeed.cancelling': 'İptal ediliyor…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Ad Soyad',
    'account.payments.havale.amountLabel': 'Tutar',
    'account.payments.havalespeed.approvedHint': '{amount} bakiyenize eklendi.',
    'account.payments.havalespeed.approvedHintGeneric': 'Yatırımınız onaylandı ve bakiyenize eklendi.',
    'account.payments.havalespeed.rejectedHint': 'Speed Havale talebiniz reddedildi. Yeni bir yatırım deneyebilirsiniz.',
    'account.payments.maxhavale.depositPending': 'Max Havale yatırımını tamamlayın',
    'account.payments.maxhavale.withdrawPending': 'Max Havale çekiminiz işleniyor',
    'account.payments.maxhavale.processing': 'Kalan süre',
    'account.payments.maxhavale.cancelDeposit': 'Talebi iptal et',
    'account.payments.maxhavale.cancelling': 'İptal ediliyor…',
    'account.payments.maxhavale.openPayment': 'Yatırım sayfasını aç',
    'account.payments.maxhavale.urlMissing': 'Ödeme bilgisi alınamadı. Talebi iptal edip yeniden deneyebilirsiniz.',
    'account.payments.maxhavale.bankName': 'Banka',
    'account.payments.havaleBtq.depositPending': 'Havale yatırımını tamamlayın',
    'account.payments.havaleBtq.withdrawPending': 'Havale çekiminiz işleniyor',
    'account.payments.havaleBtq.processing': 'Kalan süre',
    'account.payments.havaleBtq.cancelDeposit': 'Talebi iptal et',
    'account.payments.havaleBtq.cancelling': 'İptal ediliyor…',
    'account.payments.havaleBtq.openPayment': 'Yatırım sayfasını aç',
    'account.payments.havaleBtq.urlMissing': 'Ödeme bilgisi alınamadı. Talebi iptal edip yeniden deneyebilirsiniz.',
    'account.payments.havaleBtq.bankName': 'Banka',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'PayUrus cüzdan ID',
    'account.payments.payurus.walletName': 'Cüzdan sahibi adı',
    'account.payments.payurus.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payurus.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payurus.urlMissing': 'Ödeme sayfası bağlantısı alınamadı. Talebi iptal edip yeniden deneyebilirsiniz.',
    'account.payments.payurus.cancelDeposit': 'Talebi iptal et',
    'account.payments.payurus.cancelling': 'İptal ediliyor…',
    'account.payments.payurus.depositPending': 'PayUrus ödemesini tamamlayın',
    'account.payments.payurus.withdrawPending': 'PayUrus çekiminiz işleniyor',
    'account.payments.payurus.processing': 'Kalan süre',
    'account.payments.payurus.depositSuccess': 'Ödeme başarılı',
    'account.payments.payurus.depositSuccessHint': '{amount} bakiyenize eklendi.',
    'account.payments.payurus.depositSuccessHintGeneric': '{provider} yatırımınız bakiyenize eklendi.',
    'account.payments.payurus.depositProcessing': 'Ödemeniz işleniyor',
    'account.payments.payurus.depositProcessingHint': '{provider} ödemeniz doğrulanıyor. Lütfen bekleyin.',
    'account.payments.payurus.depositFailed': 'Ödeme başarısız',
    'account.payments.payurus.depositFailedHint': '{provider} ödemesi tamamlanamadı. Yeni bir yatırım deneyebilirsiniz.',
    'account.payments.payurus.continue': 'Devam et',
    'account.payments.payurus.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payurus.nameMismatchDetail': 'Hesap sahibi ile alt yapıdan gelen Ad Soyad eşleşmiyor. Payurus Hesap Sahibi : {name}',
    'account.payments.payurus.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payurus.rateLimitDetail': 'PayUrus aynı cüzdan için bir süre bekletme uyguluyor. Lütfen daha sonra tekrar deneyin.',
    'account.payments.payurus.walletInvalid': 'PayUrus cüzdan bilgisi doğrulanamadı',
    'account.payments.payurus.walletInvalidDetail': 'Cüzdan ID veya cüzdan sahibi adını kontrol edip tekrar deneyin.',
    'account.payments.method.oplati': 'Papara',
    'account.payments.method.raschet': '«Raschet» Ödeme sistemi',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'TC Kimlik No',
    'account.payments.havale.firstName': 'Ad',
    'account.payments.havale.lastName': 'Soyad',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Banka',
    'account.payments.havale.transferTo': 'Aşağıdaki hesaba havale yapın',
    'account.payments.havale.accountName': 'Hesap adı',
    'account.payments.havale.copyIban': 'Kopyala',
    'account.payments.havale.copyName': 'Kopyala',
    'account.payments.havale.copyAmount': 'Tutarı kopyala',
    'account.payments.havale.copyBank': 'Bankayı kopyala',
    'account.payments.havale.copied': 'Kopyalandı',
    'account.payments.havale.countdown': 'Kalan süre',
    'account.payments.havale.activeNotice': 'Aktif talebiniz var. Süre dolmadan yeni talep açılamaz.',
    'account.payments.havale.amountDue': 'Yatırılacak tutar',
    'account.payments.havale.waitNew': 'Yeni talep için bekleyin',
    'account.payments.havale.resultApproved': 'Yatırım onaylandı',
    'account.payments.havale.resultApprovedHint': '{amount} bakiyenize eklendi.',
    'account.payments.havale.resultRejected': 'Yatırım reddedildi',
    'account.payments.havale.resultRejectedHint': 'Talebiniz onaylanmadı. Yeni bir yatırım deneyebilirsiniz.',
    'account.payments.havale.resultExpired': 'Talebin süresi doldu',
    'account.payments.havale.resultExpiredHint': '{provider} ödeme süresi sona erdi. Yeni bir talep oluşturabilirsiniz.',
    'account.payments.havale.withdrawReceived': 'Çekim talebiniz alındı',
    'account.payments.havale.withdrawReceivedHint': '{amount} tutarındaki çekim talebiniz alındı ve inceleniyor.',
    'account.payments.havale.withdrawApproved': 'Çekim onaylandı',
    'account.payments.havale.withdrawApprovedHint': '{amount} tutarındaki çekim talebiniz tamamlandı.',
    'account.payments.havale.withdrawRejected': 'Çekim reddedildi',
    'account.payments.havale.withdrawRejectedHint': 'Çekim talebiniz onaylanmadı. Gerekirse yeni bir talep oluşturabilirsiniz.',
    'account.payments.havale.tryAgain': 'Tekrar dene',
    'account.payments.crypto.selectCoin': 'Kripto para seçin',
    'account.payments.crypto.selectNetwork': 'Ağ seçin',
    'account.payments.crypto.network': 'Ağ',
    'account.payments.crypto.selectedNetwork': 'Seçili ağ',
    'account.payments.crypto.networkWarning': 'Yalnızca {network} ağına gönderin. Yanlış ağda gönderilen işlemler kaybolabilir.',
    'account.payments.crypto.coin': 'Kripto',
    'account.payments.crypto.depositAddress': 'Yatırım adresi',
    'account.payments.crypto.copyAddress': 'Adresi kopyala',
    'account.payments.crypto.yourAddress': 'Cüzdan adresiniz',
    'account.payments.crypto.estimated': 'Tahmini tutar',
    'account.payments.crypto.txHashOptional': 'TX Hash (opsiyonel)',
    'account.payments.crypto.submitTxHash': 'TX Hash gönder',
    'account.payments.crypto.continueToWallet': 'Cüzdan adresini göster',
    'account.payments.crypto.txHashError': 'TX hash kaydedilemedi',
    'account.payments.crypto.confirmations': 'Ağ onayları',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': '{amount}\'den itibaren',
    'account.cashier.amountUsd': 'Tutar (USD)',
    'account.payments.addAmountUsd': 'Yatır {amount}',
    'account.payments.crypto.activeNotice': 'Transferinizi gönderin. Ağ onayları otomatik izlenir; gereken onaylara ulaşınca bakiye güncellenir.',
    'account.payments.crypto.noAssets': 'Şu an aktif kripto ağı bulunmuyor. Lütfen daha sonra tekrar deneyin.',
    'account.bets.stake': 'Kupon',
    'account.bets.odds': 'Oran',
    'account.bets.win': 'Kazanç',
    'account.bets.status': 'Durum',
    'account.bets.status_pending': 'Bekliyor',
    'account.bets.status_won': 'Kazandı',
    'account.bets.status_lost': 'Kaybetti',
    'account.history.tabBets': 'Bahisler',
    'account.history.tabTransactions': 'İşlem geçmişi',
    'account.history.filters': 'Filtreler',
    'account.history.filterGroupBetType': 'Bahis türü',
    'account.history.filterGroupResult': 'Bahis sonuçları',
    'account.history.filterBetType_all': 'Tümü',
    'account.history.filterBetType_bets': 'Bahisler',
    'account.history.filterBetType_slot': 'Slot oyunu',
    'account.history.filterBetType_dice_live': 'Canlı modda zar oyunu',
    'account.history.filterBetType_card_live': 'Canlı modda kart oyunu',
    'account.history.filterBetType_cylinder_live': 'Canlı modda rulet oyunu',
    'account.history.filterBetType_online_game': 'Bahisçinin çevrimiçi oyunu',
    'account.history.filterResult_all': 'Tümü',
    'account.history.filterResult_not_settled': 'Sonuçlanmadı',
    'account.history.filterResult_win': 'Kazanç',
    'account.history.filterResult_loss': 'Kayıp',
    'account.history.filterResult_cashed_out': 'Cash out',
    'account.history.filterResult_void': 'Geçersiz',
    'account.history.filterResult_return': 'İade',
    'account.history.colDate': 'TARİH',
    'account.history.colTime': 'SAAT',
    'account.history.colBetNo': 'BAHİS №',
    'account.history.colCoupon': 'KUPON',
    'account.history.colStake': 'BAHİS TUTARI',
    'account.history.colPotential': 'POTANSİYEL',
    'account.history.details': 'Detaylar',
    'account.history.colTransactionNo': 'İŞLEM №',
    'account.history.colNumber': 'NUMARA',
    'account.history.colTransaction': 'İŞLEM',
    'account.history.colAmountBonuses': 'TUTAR / BONUSLAR',
    'account.history.colBalanceBonuses': 'BAKİYE / BONUSLAR',
    'account.history.operation_deposit': 'Para yatırma',
    'account.history.operation_deposit_pending': 'Yatırım onayı bekleniyor',
    'account.history.operation_withdrawal_pending': 'Çekim onayı bekleniyor',
    'account.history.operation_withdrawal_cancelled': 'Çekim iptal edildi',
    'account.history.operation_withdrawal_rejected': 'Çekim reddedildi',
    'account.history.operation_withdrawal_approved': 'Çekim onaylandı',
    'account.history.operation_withdrawal_completed': 'Çekim tamamlandı',
    'account.history.operation_bet_placed': 'Bahis yapıldı',
    'account.history.operation_bet_settled': 'Bahis sonuçlandı',
    'account.history.operation_bet_lost': 'Bahis kaybedildi',
    'account.history.operation_slot_bet_settled': 'Slot oyunu bahsi sonuçlandı',
    'account.history.operation_slot_bet_placed': 'Slot oyunu bahsi yapıldı',
    'account.history.operation_accrual_bonus_account': 'Bonus hesabına tahakkuk',
    'account.history.operation_close_bonus_account': 'Bonus hesabı kapatıldı',
    'account.history.operation_bonus_conversion': 'Bonus dönüşümü',
    'account.history.filterOperation_close_bonus_account': 'Bonus hesabı kapatıldı',
    'account.history.filterOperation_accrual_bonus_account': 'Bonus hesabına tahakkuk',
    'account.history.filterOperation_slot_bet_settled': 'Slot oyunu bahsi sonuçlandı',
    'account.history.filterOperation_slot_bet_placed': 'Slot oyunu bahsi yapıldı',
    'account.history.filterOperation_withdrawal_cancelled': 'Çekim iptal edildi',
    'account.history.filterOperation_withdrawal_rejected': 'Çekim reddedildi',
    'account.history.filterOperation_withdrawal_approved': 'Çekim onaylandı',
    'account.history.filterOperation_withdrawal_completed': 'Çekim tamamlandı',
    'account.history.filterOperation_withdrawal_pending': 'Çekim onayı bekleniyor',
    'account.history.filterOperation_bonus_conversion': 'Bonus dönüşümü',
    'account.history.filterOperation_bet_lost': 'Bahis kaybedildi',
    'account.history.filterOperation_bet_placed': 'Bahis yapıldı',
    'account.history.filterOperation_bet_settled': 'Bahis sonuçlandı',
    'account.history.filterOperation_deposit': 'Para yatırma',
    'account.history.filterOperation_deposit_pending': 'Yatırım onayı bekleniyor',
    'account.history.colBetType': 'BAHİS TÜRÜ',
    'account.history.colType': 'TÜR',
    'account.history.colDescription': 'AÇIKLAMA',
    'account.history.colOdds': 'ORAN',
    'account.history.colResult': 'SONUÇ',
    'account.history.colAmount': 'TUTAR',
    'account.history.colStatus': 'DURUM',
    'account.history.betTypeSlot': 'Slot oyunu',
    'account.history.betTypeSportsbook': 'Spor Bahisleri',
    'account.history.betTypeSingle': 'Tekli',
    'account.history.betTypeExpress': 'Kombine',
    'account.history.result_pending': 'Sonuçlanmadı',
    'account.history.result_won': 'Kazanç',
    'account.history.result_lost': 'Kayıp',
    'account.history.result_completed': 'Tamamlandı',
    'account.history.betsEmpty': 'Henüz bahis geçmişiniz yok.',
    'account.history.transactionsEmpty': 'Henüz işlem geçmişiniz yok.',
    'account.bonuses.welcomeTitle': 'Hoş geldin bonusu',
    'account.bonuses.welcomeDesc': 'İlk yatırımınıza özel bonus fırsatlarını kaçırmayın.',
    'account.bonuses.viewPromos': 'Promosyonları gör',
    'account.bonuses.freeSpinsTitle': 'Bedava oyunlarınız',
    'account.bonuses.freeSpinsEmpty': 'Henüz bedava oyun hakkınız yok.',
    'account.bonuses.viewFreeSpins': 'Bonuslarımı gör',
    'account.vip.title': 'VIP Cashback',
    'account.vip.subtitleLine1': 'Ayrıcalıklarınızdan yararlanın',
    'account.vip.subtitleLine2': 'her hafta cashback kazanın!',
    'account.vip.yourStatus': 'Durumunuz',
    'account.vip.yourCashback': 'Cashback\'iniz',
    'account.vip.promotionRules': 'Promosyon kuralları',
    'account.vip.stillQuestions': 'Hâlâ sorularınız mı var?',
    'account.vip.cardCashbackFreeAndBonus': 'Bedava bahis ve bonuslarda',
    'account.vip.cardCashbackBonusOnly': 'Bonuslarda',
    'account.vip.cardCashbackTail': '\'e kadar cashback',
    'account.vip.tierCashbackDesc': '{metal} — bedava bahis ve bonuslarda %{percent}\'e kadar cashback',
    'account.vip.fromAmount': 'En az',
    'account.vip.betAmountWeeks': '4 haftalık bahis tutarı',
    'account.vip.yourStatusBadge': 'VIP DURUMUNUZ',
    'account.vip.targetStatus': 'HEDEF DURUM',
    'account.vip.cashbackLabel': 'CASHBACK',
    'account.vip.needToBet': 'Bahis yapmanız gereken tutar:',
    'account.vip.totalSettled': 'Toplam sonuçlanan bahisler',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback bedava bahisler spor bahislerinde, bonuslar casino slot oyunlarında kullanılır.',
    'account.vip.prev': 'Önceki',
    'account.vip.next': 'Sonraki',
    'account.vip.rulesLoadError': 'Promosyon kuralları yüklenemedi.',
    'account.vip.faqLoadError': 'SSS yüklenemedi.',
    'account.vip.cashbackHistoryTitle': 'Cashback tahakkuk geçmişi',
    'account.vip.cashbackHistoryDesc': 'Önceki haftanın cashback\'i her Pazartesi 18:00\'a kadar yatırılır. Cashback tahakkuk durumu hakkında SMS ile bilgilendirileceksiniz.',
    'account.vip.cashbackHistoryDate': 'Tarih',
    'account.vip.cashbackHistoryStatus': 'Durum',
    'account.vip.cashbackHistoryAmount': 'Cashback tutarı',
    'account.vip.cashbackCalculating': 'Hesaplanıyor',
    'account.vip.pendingCashback': 'Bu hafta tahakkuk',
    'common.close': 'Kapat',
    'appUpdate.title': 'Güncellemeyi indir',
    'appUpdate.text': 'yeni özelliklere erişmek için',
    'appUpdate.action': 'Güncelle',
    'account.notifications.readAll': 'Tümünü okundu işaretle',
    'account.notifications.empty': 'Bildirim yok',
    'account.notifications.emptyUnread': 'Okunmamış bildirim yok',
    'account.notifications.filterAll': 'Tümü',
    'account.notifications.filterUnread': 'Okunmamış ({count})',
    'account.notifications.viewAll': 'Tüm bildirimler',
    'account.notifications.details': 'Detaylar',
    'account.security.current': 'Mevcut şifre',
    'account.security.enterCurrent': 'Mevcut şifrenizi girin',
    'account.security.new': 'Yeni şifre',
    'account.security.saved': 'Şifreniz güncellendi',
    'account.responsible.tabDeposit': 'Yatırım limitleri',
    'account.responsible.tabSession': 'Oyun oturumu limitleri',
    'account.responsible.depositDescription': 'Yatırım limiti belirleyin. Limite ulaşıldığında, belirtilen süre sonuna kadar hesabınıza para yatıramazsınız. Limit anında düşürülebilir veya kaldırılabilir. Limiti artırmak için 24 saatlik bekleme süresi geçmelidir.',
    'account.responsible.sessionDescription': 'Oyun oturumu limiti belirleyin. Günlük, haftalık veya aylık maksimum oyun süresini ayarlayın. Limite ulaşıldığında oturumunuz sonlandırılır ve belirtilen süre dolana kadar tekrar giriş yapamazsınız. Limit anında düşürülebilir veya kaldırılabilir. Limiti artırmak için 24 saatlik bekleme süresi geçmelidir.',
    'account.responsible.currentRestrictions': 'Mevcut kısıtlamalar',
    'account.responsible.futureRestrictions': 'Gelecek kısıtlamalar',
    'account.responsible.limitNotSet': 'Limit belirlenmedi',
    'account.responsible.notSet': 'Belirlenmedi',
    'account.responsible.dailyLimit': 'Günlük limit',
    'account.responsible.weeklyLimit': 'Haftalık limit',
    'account.responsible.monthlyLimit': 'Aylık limit',
    'account.responsible.hoursShort': 'saat',
    'account.responsible.saved': 'Limitler güncellendi',
    'account.responsible.timeLimitsTitle': 'Zaman limitleri',
    'account.responsible.timeDescription': 'Limit dolduğunda hesabınızdan çıkış yapılır ve yeni dönem başlayana kadar tekrar giriş yapamazsınız.',
    'account.responsible.sessionLimitMinutes': 'Oturum limiti (dakika)',
    'account.responsible.install': 'Uygula',
    'account.responsible.confirmTitle': 'Limit ayarlansın mı?',
    'account.responsible.confirmRemoveOrLower': 'Limit artırılırsa 24 saat sonra yürürlüğe girer. Limit düşürme hemen uygulanır.',
    'account.responsible.confirmTightenImmediately': 'Onaydan sonra daha düşük limit hemen uygulanır.',
    'account.responsible.confirmSet': 'Ayarla',
    'account.responsible.confirmCancel': 'İptal',
    'account.responsible.currentLimits': 'Mevcut limitler',
    'account.responsible.sessionLimit': 'Oturum limiti',
    'account.responsible.timeRemaining': 'Kalan süre',
    'account.responsible.delete': 'Sil',
    'account.responsible.confirmChangeTitle': 'Limit değerlerini değiştirmek istediğinize emin misiniz?',
    'account.responsible.confirmDeleteTitle': 'Limiti kaldırmak istediğinize emin misiniz?',
    'account.responsible.minutesShort': 'dk',
    'account.responsible.sessionMaxTip': 'Maksimum oturum süresi – 1.440 dakika (24 saat)',
    'account.responsible.limitBlocked': 'Oyun süresi limitine ulaşıldı. Hesabınızdan çıkış yapıldı.',
    'account.requests.title': 'Talepler',
    'account.requests.newRequest': 'Yeni talep',
    'account.requests.empty': 'Mevcut talep yok',
    'account.requests.chooseType': 'Talep türünü seçin',
    'account.requests.cancel': 'İptal',
    'account.requests.sendRequest': 'Talep gönder',
    'account.requests.submit': 'Gönder',
    'account.requests.error': 'Talep gönderilemedi',
    'account.requests.notFound': 'Talep türü bulunamadı',
    'account.requests.type.sport_bet_settlement': 'Spor bahsi sonuçlandırma',
    'account.requests.type.casino_bet_settlement': 'Casino bahsi sonuçlandırma',
    'account.requests.type.hotline': 'Çağrı merkezi hakkında soru',
    'account.requests.type.deposit': 'Para yatırma sorusu',
    'account.requests.type.withdrawal': 'Para çekme sorusu',
    'account.requests.type.website_app': 'Site veya mobil uygulama kullanımı hakkında soru',
    'account.requests.type.admin': 'Yönetici için soru',
    'account.requests.type.verification': 'Doğrulama sorusu',
    'account.requests.type.bonus': 'Bonus sorusu',
    'account.requests.mobile.title': 'Bir sorun mu var?',
    'account.requests.mobile.desc': 'Yeni bir talep oluşturun veya Yardım merkezimizde cevapları bulabilirsiniz',
    'account.requests.mobile.create': 'Yeni talep oluştur',
    'account.requests.mobile.helpCentre': 'Yardım merkezine git',
    'account.requests.group.deposit': 'PARA YATIRMA SORUSU',
    'account.requests.group.withdrawal': 'PARA ÇEKME SORUSU',
    'account.requests.group.other': 'DİĞER',
    'account.requests.template.depositBankCard': 'Banka kartı',
    'account.requests.template.depositRaschet': '"Raschet" birleşik ödeme sistemi',
    'account.requests.template.depositQiwi': 'QIWI terminal',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'Oplati',
    'account.requests.template.withdrawalOplati': 'Oplati',
    'account.requests.template.withdrawalBank': 'Banka kartı / transfer',
    'account.requests.form.operationDate': 'İşlem tarihi ve saati',
    'account.requests.form.amount': 'İşlem tutarı',
    'account.requests.form.selectOperationDesc': 'Sorunuzun ilgili olduğu işlemi seçin',
    'account.requests.form.selectOperationBtn': 'İşlem seç',
    'account.requests.form.selectedOperation': 'Seçilen işlem',
    'account.requests.form.noOperations': 'Uygun işlem bulunamadı',
    'account.requests.form.messagePlaceholder': 'Sorunuzu veya talebinizi açıklayın',
    'account.requests.form.symbolsRemaining': '{count} karakter kaldı',
    'account.requests.form.choose': 'Seç',
    'account.requests.form.dragOrUpload': 'Sürükleyin veya dosya yükleyin',
    'account.requests.form.attachFile': 'Dosya ekle',
    'account.requests.form.attachHint': 'En fazla 5 dosya. Format: jpg, png, pdf, mp4, mov, webm. Görsel/PDF en fazla 7 MB, video en fazla 25 MB.',
    'account.requests.form.attachments': 'Ekler',
    'account.helpCentre.title': 'Yardım merkezi',
    'account.helpCentre.text1': 'Burada bilgi bulabilirsiniz',
    'account.helpCentre.text2': 've kullanım ipuçları',
    'account.helpCentre.faq': 'SSS',
    'account.helpCentre.instructions': 'Talimatlar',
    'account.helpCentre.strategies': 'Bahis stratejileri',
    'account.helpCentre.glossary': 'Sözlük',
    'account.helpCentre.go': 'Yardım merkezine git',
    'account.support.subject': 'Konu',
    'account.support.message': 'Mesaj',
    'account.support.send': 'Gönder',
    'account.support.sent': 'Talebiniz alındı',
    'account.support.history': 'Geçmiş talepler',
    'account.support.status_open': 'Açık',
    'account.support.status_closed': 'Kapalı',
    'account.support.status_pending': 'Beklemede',
    'account.support.status_waiting': 'Beklemede',
    'account.support.status_answered': 'Cevaplandı',
    'account.support.status_replied': 'Yanıtlandı',
    'account.support.status_in_progress': 'İşlemde',
    'account.support.status_resolved': 'Çözüldü',
    'account.pageTitle': 'Hesabım | VurgunBet',
    'sport.filter.allTime': 'Tüm zamanlar',
    'sport.filter.allEvents': 'Tüm etkinlikler',
    'sport.filter.live': 'Canlı',
    'sport.filter.prematch': 'Maç öncesi',
    'sport.filter.all': 'Tümü',
    'betslip.title': 'Kupon',
    'betslip.empty': 'Kupon boş',
    'betslip.stake': 'Bahis tutarı',
    'betslip.totalOdds': 'Toplam oran',
    'betslip.potentialWin': 'Olası kazanç',
    'betslip.place': 'Bahis yap',
    'betslip.clear': 'Temizle',
    'betslip.accepted': 'Bahis kabul edildi',
    'betslip.login': 'Bahis yapmak için giriş yapın',
    'betslip.emptyHint': 'Bahis yapmak için etkinlik seçin',
    'betslip.amount': 'Tutar, TL',
    'betslip.promos': 'Promosyonlar',
    'betslip.active': 'Aktif',
    'betslip.popular': 'Popüler etkinlikler',
    'footer.about': 'Hakkımızda',
    'footer.basinda': 'Basında Biz',
    'footer.licence': 'Lisans',
    'footer.privacy': 'Gizlilik Politikası',
    'footer.responsible': 'Sorumlu Oyun',
    'footer.rules': 'Şartlar ve Koşullar',
    'footer.financial': 'Finansal hizmetler',
    'footer.vip': 'VIP program',
    'footer.help': 'Yardım merkezi',
    'footer.payments': 'Ödemeler',
    'footer.company': 'Şirket bilgileri',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Bahis noktası kuralları',
    'footer.appCaption': 'Uygulama',
    'footer.appIos': 'iOS için',
    'footer.appIosLong': 'iOS uygulaması',
    'footer.appAndroidLong': 'Android uygulaması',
    'footer.appAndroid': 'Android için',
    'footer.appMaintenance': 'Bakımda',
    'footer.telegram': 'Telegram',
    'footer.copyright': '18 yaşından küçüklerin bahis oynaması yasaktır. VurgunBet, uluslararası çevrimiçi oyun operatörü olarak faaliyet gösterir.',
    'footer.legal': 'VurgunBet; spor bahisleri, slot oyunları, canlı casino ve ilgili oyun ürünlerini 18 yaşını doldurmuş kullanıcılara sunar. Kullanıcı bulunduğu yerdeki yasal kısıtlamalara uymakla yükümlüdür.',
    'footer.legal1': '18 yaşının altındaki kişilerin kumar oynaması yasaktır; ayrıca kumarhanelere ve sanal kumarhanelere girişi ve/veya kumar oynaması kısıtlanmış kişilerin katılımı yasaktır.',
    'footer.legal2': 'VurgunBet; çevrimiçi spor bahisleri, slot oyunları, canlı casino ve ilgili oyun ürünlerini sunar. Hizmetler yalnızca yasal olarak izin verilen yerlerde ve koşullarda kullanılmalıdır.',
    'help.title': 'Yardım merkezi',
    'help.searchPlaceholder': 'Sorunuzu arayın',
    'help.searchSheetTitle': 'Yardım merkezi: arama',
    'help.searchSheetDesc': 'Sorunuza cevap bulun',
    'help.popularSearches': 'POPÜLER ARAMALAR',
    'help.popular.identification': 'Doğrulama nasıl yapılır?',
    'help.popular.deposit': 'Nasıl para yatırırım?',
    'help.popular.win': 'Kazancımı nasıl çekerim?',
    'help.askQuestion': 'Soru sor',
    'help.views': 'görüntülenme',
    'help.back': 'Geri',
    'help.noResults': 'Sonuç bulunamadı',
    'help.goToFaq': 'SSS\'ye git',
    'help.instructions': 'Talimatlar',
    'help.training': 'Eğitim',
    'help.glossary': 'Sözlük',
    'help.notFound.code': '404',
    'help.notFound.title': 'Sayfa bulunamadı',
    'help.notFound.description': 'Aradığınız sayfa mevcut değil. Taşınmış veya silinmiş olabilir.',
    'help.notFound.home': 'Ana sayfa',
    'help.feedback.review': 'Yorum yaz',
    'help.feedback.helpful': 'Bu bilgi faydalı oldu mu?',
    'help.feedback.yes': 'Evet, teşekkürler',
    'help.feedback.no': 'Hayır',
    'promos.tab.actions': 'Kampanyalar',
    'promos.tab.tournaments': 'Turnuvalar',
    'promos.tab.actionsDesc': 'Şampiyon olun',
    'promos.tab.tournamentsDesc': 'Turnuvalara katılın',
    'promos.tab.actionsTitle': 'Kampanyalar',
    'promos.tab.tournamentsTitle': 'Turnuvalar',
    'promos.tab.bonuses': 'Bonuslar',
    'promos.tab.bonusesDesc': 'Bonuslarınızı takip edin',
    'promos.tab.bonusesTitle': 'Bonuslarınız',
    'promos.tab.promoCode': 'Promosyon kodu',
    'promos.tab.promoCodeDesc': 'Hemen etkinleştir',
    'promos.tab.promoCodeTitle': 'Promosyon kodunuz var mı?',
    'promos.tournamentsIntro': 'Turnuvalara katılın ve değerli ödüller için yarışın',
    'promos.filter.all': 'Tümü',
    'promos.filter.sport': 'Spor',
    'promos.filter.casino': 'Casino',
    'promos.timer.ended': 'Süre doldu',
    'promos.timer.daysLeft': 'Kalan: {count} gün',
    'promos.timer.hoursLeft': 'Kalan: {count} saat',
    'promos.timer.minutesLeft': 'Kalan: {count} dk',
    'promos.tournament.active': 'Aktif',
    'promos.tournament.bonusFund': 'Bonus fonu',
    'promos.tournament.participants': 'Katılımcılar',
    'promos.tournament.places': 'Sıralama',
    'promos.tournament.untilCompletion': 'Bitişe kalan',
    'promos.tournament.untilStart': 'Başlamasına kalan',
    'promos.tournament.upcoming': 'Yakında',
    'promos.tournament.startsIn': 'Başlamasına',
    'promos.tournament.joinWhenLive': 'Başlayınca katıl',
    'promos.tournament.tab.rating': 'Sıralama',
    'promos.tournament.tab.terms': 'Kurallar',
    'promos.tournament.tab.games': 'Oyunlar',
    'promos.tournament.col.participant': 'Katılımcı',
    'promos.tournament.col.points': 'Puanlar',
    'promos.tournament.col.bonuses': 'Bonuslar',
    'promos.tournament.participate': 'Katıl',
    'promos.tournament.optOut': 'Ayrıl',
    'promos.tournament.loginToJoin': 'Katılmak için giriş yap',
    'promos.tournament.promoRules': 'Promosyon kuralları',
    'promos.tournament.questions': 'Hâlâ sorunuz mu var?',
    'promos.tournament.close': 'Kapat',
    'promos.tournament.loading': 'Sıralama yükleniyor…',
    'promos.tournament.emptyBoard': 'Henüz sıralama yok. İlk katılan siz olun!',
    'promos.tournament.noTerms': 'Kurallar yakında eklenecek.',
    'promos.tournament.noGames': 'Uygun oyun listesi yakında eklenecek.',
    'promos.tournament.joinedOk': 'Turnuvaya katıldınız',
    'promos.tournament.leftOk': 'Turnuvadan ayrıldınız',
    'promos.tournament.actionError': 'İşlem tamamlanamadı',
    'promos.tournament.working': 'İşleniyor…',
    'promos.tournament.gameBadge': 'TURNUVA',
    'promos.tournament.showAllGames': 'Tüm oyunları göster',
    'promos.tournament.askQuestion': 'Soru sor',
    'promos.tournament.faq.participate.q': 'Turnuvaya nasıl katılırım?',
    'promos.tournament.faq.participate.a': 'Turnuvalar bölümüne gidin, katılmak istediğiniz turnuvayı açın ve Katıl düğmesine basın.',
    'promos.tournament.faq.deposit.q': 'Turnuvaya katılmak için para yatırmam gerekir mi?',
    'promos.tournament.faq.deposit.a': 'Hayır — katılmak ücretsiz. Puan için Oyunlar listesindeki slotlarda gerçek bakiyeyle (min. 5 TL) oynamanız yeterli. Bonus bakiyesi puan yazmaz.',
    'promos.tournament.faq.multiple.q': 'Aynı anda birden fazla turnuvaya katılabilir miyim?',
    'promos.tournament.faq.multiple.a': 'Evet. Aynı anda birden fazla aktif turnuvaya katılabilirsiniz; her turnuvanın sıralaması ayrı tutulur.',
    'promos.tournament.faq.terms.q': 'Turnuva şartlarını nereden görebilirim?',
    'promos.tournament.faq.terms.a': 'Turnuva penceresindeki Kurallar sekmesinden veya Promosyon kuralları bağlantısından tüm şartları inceleyebilirsiniz.',
    'promos.tournament.faq.games.q': 'Turnuvaya hangi slot oyunları dahildir?',
    'promos.tournament.faq.games.a': 'Uygun oyunlar turnuva penceresindeki Oyunlar sekmesinde listelenir. Yalnızca listedeki oyunlarda yapılan bahisler puan kazandırır.',
    'promos.tournament.faq.bonuses.q': 'Turnuvaya katılarak ve kazanarak hangi bonusları alabilirim?',
    'promos.tournament.faq.bonuses.a': 'Sıralamadaki yerinize göre nakit ve bedava dönüş (FS) ödülleri kazanırsınız. Ödüller turnuva bitiminden sonra 48 saat içinde tanımlanır; FS 7 gün geçerlidir, nakit ödüllerde yalnızca x2 çevrim vardır.',
    'promos.tournament.faq.timed.q': 'Turnuvalar süreyle sınırlı mı?',
    'promos.tournament.faq.timed.a': 'Evet. VURGUN VAKTİ her hafta Pazartesi 11:00’de başlar ve Pazar 23:59’da biter; ardından otomatik yenilenir.',
    'promos.tournament.faq.track.q': 'Turnuva sonuçlarımı ve ilerlememi nasıl takip ederim?',
    'promos.tournament.faq.track.a': 'Turnuva penceresindeki Sıralama sekmesinden anlık puanınızı ve sıranızı görebilirsiniz. Puanlar gerçek bakiyeli bahislerden hemen sonra güncellenir.',
    'promos.tournament.faq.more.q': 'Hâlâ sorularım var.',
    'promos.tournament.faq.more.a': 'Aşağıdaki Soru sor düğmesiyle destek talebi oluşturabilirsiniz. Ekibimiz en kısa sürede dönüş yapar.',
    'promos.tournament.ask.title': 'Yeni talep',
    'promos.tournament.ask.subtitle': 'Bonus sorusu',
    'promos.tournament.ask.placeholder': 'Sorunuzu yazın veya sorunu açıklayın',
    'promos.tournament.ask.charsLeft': '{count} karakter kaldı',
    'promos.tournament.ask.attach': 'Dosya ekle',
    'promos.tournament.ask.attachHint': 'En fazla 5 dosya. Format: jpg, jpeg, png, pdf. En fazla 7 MB.',
    'promos.tournament.ask.cancel': 'İptal',
    'promos.tournament.ask.send': 'Talep gönder',
    'promos.tournament.ask.sending': 'Gönderiliyor…',
    'promos.tournament.ask.sent': 'Talebiniz alındı. En kısa sürede dönüş yapacağız.',
    'promos.tournament.ask.loginRequired': 'Talep göndermek için giriş yapın',
    'promos.tournament.ask.error': 'Talep gönderilemedi',
    'promos.tournament.terms.periodTitle': 'Haftalık turnuva dönemi',
    'promos.tournament.terms.pointsTitle': 'Puan kazanma koşulları',
    'promos.tournament.terms.points1': 'Minimum bahis sadece 5 TL — katılmak ücretsiz, puan için gerçek bakiyeyle oynamanız yeterli.',
    'promos.tournament.terms.points2': 'Her 1 TL gerçek bakiyeli bahis = 2 puan. Cuma–Pazar %20 ekstra puan!',
    'promos.tournament.terms.points3': 'Oyunlar sekmesindeki slotlarda yapılan tüm gerçek bakiyeli bahisler anında sıralamaya yazılır. Bonus bakiyesi sayılmaz.',
    'promos.tournament.terms.bonusesTitle': 'Bonus kullanım koşulları',
    'promos.tournament.terms.bonuses1': 'Nakit ve FS ödülleri turnuva bitiminden sonra 48 saat içinde tanımlanır; FS geçerliliği 7 gündür.',
    'promos.tournament.terms.bonuses2': 'Ödül kazançları yalnızca x2 çevrim ile çekilebilir — sektör ortalamasının çok altında.',
    'promos.tournament.terms.bonuses3': 'Turnuva her Pazartesi 11:00’de otomatik yenilenir; sıralama sıfırlanır, yeni hafta yeni şans.',
    'promos.bonuses.title': 'Bonuslarınız',
    'promos.promocode.title': 'Promosyon kodunuz var mı?',
    'promos.promocode.desc': 'Promosyon kodunuzu aşağıya girin ve Etkinleştir\'e tıklayın',
    'promos.promocode.placeholder': 'Promosyon kodunu girin',
    'promos.promocode.activate': 'Etkinleştir',
    'promos.promocode.activating': 'Uygulanıyor…',
    'promos.promocode.success': 'Promosyon kodu başarıyla uygulandı',
    'promos.promocode.error': 'Promosyon kodu uygulanamadı',
    'promos.promocode.loginRequired': 'Promosyon kodu için giriş yapmalısınız',
    'promos.bonuses.loading': 'Bonuslarınız yükleniyor…',
    'promos.bonuses.empty': 'Henüz bonusunuz yok.',
    'promos.bonuses.emptyCaption': 'Aktif bonus yok',
    'promos.bonuses.emptyDescription': 'Kampanyalara katılın ve yeni bonuslar kazanın!',
    'promos.bonuses.emptyButton': 'Kampanyalara git',
    'promos.bonuses.emptyArchiveCaption': 'Arşivde bonus yok',
    'promos.bonuses.emptyArchiveDescription': 'Kampanyalara katılın ve yeni bonuslar kazanın!',
    'promos.bonuses.kindFreeSpin': 'Bedava oyun',
    'promos.bonuses.kindFilterBonuses': 'Bonuslar',
    'promos.bonuses.kindFilterFreeSpins': 'Bedava dönüş',
    'promos.bonuses.kindFilterAll': 'Tümü',
    'promos.bonuses.fieldNominal': 'Nominal',
    'promos.bonuses.fieldStatus': 'Durum',
    'promos.bonuses.fieldExpires': 'Son geçerlilik',
    'promos.bonuses.fieldReceived': 'Alınma tarihi',
    'promos.bonuses.tabActive': 'Aktif',
    'promos.bonuses.tabArchive': 'Geçmiş',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'İlerlemeniz:',
    'promos.bonuses.statusWagering': 'Çevrim devam ediyor',
    'promos.bonuses.moreInfo': 'Daha fazla bilgi',
    'promos.bonuses.detailTitle': 'Bonus aktif',
    'promos.bonuses.leftDays': 'kalan {n} gün',
    'promos.bonuses.leftDay': 'kalan {n} gün',
    'promos.bonuses.detailLead': 'Çevrim şartını tamamlayın ve bonusunuzu ana hesabınıza alın',
    'promos.bonuses.placeBets': 'Toplam {amount} bahis yapın',
    'promos.bonuses.rulesTitle': 'BONUS HESABI ÇEVRİM KURALLARI',
    'promos.bonuses.rule1': 'Bonus hesabına eklenen kazançlar, tutarın {wagerMult} katı çevrildikten sonra ana hesapta kullanılabilir olur. Çevrim, Organizatörün belirlediği bazı slot oyunları hariç tüm casino sağlayıcılarının tüm slot oyunlarında tamamlanabilir.',
    'promos.bonuses.rule2': 'Bonus hesabından çevrim yapılırken önce ana hesap bakiyesi, ardından bonus hesabı bakiyesi kullanılır.',
    'promos.bonuses.rule3': 'Bonus hesabından kullanılan bakiyelerle elde edilen kazançlar bonus hesabına geri döner.',
    'promos.bonuses.rule4': 'Çevrim tamamlandıktan sonra bonus hesabında kalan tutar ana bakiyeye aktarılır; ancak başlangıçta bonus hesabına yatırılan tutarın {maxWithdrawMult} katını aşamaz.',
    'promos.bonuses.rule5': 'Çevrim süresi, bonus hesabının aktif edildiği andan itibaren {wageringDays} gündür.',
    'promos.bonuses.rule6': 'Her sonraki bonus, önceki bonusun çevrimi tamamlandıktan sonra otomatik olarak aktif edilir.',
    'promos.bonuses.rule7': 'Bonus hesabında bakiye varken ana hesaptan para çekimi yapılamaz.',
    'promos.bonuses.promotionRules': 'Promosyon kuralları',
    'promos.bonuses.askQuestion': 'Soru sor',
    'promos.bonuses.cancelBonus': 'Bonusu iptal et',
    'promos.bonuses.cancelConfirm': 'Bonus bakiyeniz silinecek ve çevrim iptal edilecek. Devam edilsin mi?',
    'promos.bonuses.cancelBusy': 'İptal ediliyor…',
    'promos.bonuses.cancelTitle': 'Gerçekten vazgeçmek istiyor musunuz?',
    'promos.bonuses.cancelBody': 'Vazgeçmeniz durumunda bonuslar yakılacaktır.\nİstediğiniz zaman iptal edebilirsiniz.',
    'promos.bonuses.cancelRefuse': 'Vazgeçmek istiyorum',
    'promos.bonuses.cancelBack': 'İkna oldum! Geri dön',
    'promos.bonuses.askPlaceholder': 'Sorunuzu yazın veya sorunu açıklayın',
    'promos.bonuses.askCharsLeft': '{n} karakter kaldı',
    'promos.bonuses.askAttach': 'Dosya ekle',
    'promos.bonuses.askFilesMax': 'En fazla 5 dosya.',
    'promos.bonuses.askFilesFormat': 'Format: jpg, jpeg, png, pdf.',
    'promos.bonuses.askFilesSize': 'En fazla 7Mb.',
    'promos.bonuses.askCancel': 'İptal',
    'promos.bonuses.askSend': 'Talep gönder',
    'promos.bonuses.askSending': 'Gönderiliyor…',
    'promos.bonuses.askSent': 'Talebiniz gönderildi.',
    'promos.bonuses.askError': 'Talep gönderilemedi',
    'promos.bonuses.askFileTooBig': 'Dosya 7Mb’den büyük.',
    'promos.bonuses.askFileBadType': 'Desteklenmeyen dosya formatı.',
    'promos.bonuses.askClose': 'Kapat',
    'promos.bonuses.askNewRequest': 'Yeni talep',
    'promos.bonuses.askBonusQuestion': 'Bonus sorusu',
    'promos.bonuses.askHint': 'Destek ekibine bonusunuz hakkında soru gönderin',
    'promos.bonuses.fieldWagering': 'Çevrim',
    'promos.bonuses.fieldWageringTime': 'Çevrim süresi',
    'promos.bonuses.fieldMaxWithdrawal': 'Maks. çekim',
    'promos.bonuses.fieldUsed': 'Kullanıldı',
    'promos.bonuses.statusAvailable': 'Kullanılabilir',
    'promos.bonuses.statusUsed': 'Kullanıldı',
    'promos.bonuses.activate': 'Aktif et',
    'promos.bonuses.days': 'gün',
    'promos.bonuses.games': 'Oyunlar',
    'promos.bonuses.noGames': 'Oyun bilgisi yok',
    'promos.bonuses.play': 'Oyna',
    'home.showcase.slots.title': 'Casino',
    'home.showcase.slots.count': '{count} oyun',
    'home.showcase.slots.link': 'Oyunları gör →',
    'home.showcase.live.title': 'Canlı casino',
    'home.showcase.live.count': '{count} oyun',
    'home.showcase.live.link': 'Hemen oyna →',
    'home.showcase.tv.title': 'TV oyunları',
    'home.showcase.tv.count': '{count} oyun',
    'home.showcase.fast.title': 'Hızlı oyunlar',
    'home.showcase.fast.count': '{count} oyun',
    'home.showcase.fast.link': 'Hemen oyna →',
    'home.showcase.virtual.title': 'Sanal sporlar',
    'home.showcase.virtual.count': '{count} oyun',
    'home.showcase.virtual.link': 'Hemen oyna →',
    'home.showcase.gamesCount': '{count} oyun',
    'home.showcase.tv.link': 'Hemen oyna →',
    'home.showcase.sport.title': 'Spor',
    'home.showcase.sport.count': '3380 etkinlik',
    'home.showcase.sport.link': 'Bahis yap →',
    'home.promo.category.promotions': 'Kampanyalar',
    'home.promo.category.tournaments': 'Turnuvalar',
    'home.promo.filter.all': 'Tümü',
    'home.promo.filter.sport': 'Spor (5)',
    'home.promo.filter.casino': 'Casino (5)',
    'home.promo.showAll': 'Tümünü göster →',
    'home.promo.allPromotions': 'Tüm promosyonlar',
    'home.promo.cta.play': 'Oyna',
    'home.promo.cta.join': 'Katıl',
    'home.promo.cta.details': 'Detaylar',
    'home.promo.cta.signup': 'Kayıt Ol',
    'home.sport.searchEvents': 'Etkinlik ara',
    'footer.contactUs': 'Bizimle iletişime geçin',
    'footer.usefulInfo': 'Faydalı bilgiler',
    'footer.socialMedia': 'Sosyal medya',
    'footer.partners': 'RESMÎ ORTAK',
    'footer.officialPartner': 'RESMÎ\nORTAK',
    'home.casino.loading': 'Oyunlar yükleniyor…',
    'home.casino.noGames': 'Oyun bulunamadı',
    'home.casino.viewAllMobile': '{count} oyunu gör',
    'home.shuffle.title': 'Sıradaki oyunun ne olsun?',
    'home.shuffle.cta': 'Hemen çevir',
    'home.shuffle.modalTitle': 'Sana uygun oyunu bulalım!',
    'home.shuffle.respin': 'Tekrar çevir',
    'home.shuffle.close': 'Kapat',
    'home.jackpot.casinoTitle': 'Casino Jackpot',
    'home.jackpot.title': 'VURGUN GRAND JACKPOT',
    'home.jackpot.badgeRest': 'GRAND JACKPOT',
    'home.jackpot.winners': 'Toplam kazanan: {count}',
    'home.jackpot.largest': 'En büyük kazanç',
    'home.jackpot.last': 'Son kazanç',
    'home.jackpot.onSlots': 'Tüm slotlarda',
    'home.jackpot.play': 'Jackpot oyunları',
    'home.liveWins.title': 'Anlık Kazançlar',
    'home.liveWins.heated': 'Vurgun',
    'home.topWins.title': 'En İyi Kazançlar',
    'home.topWins.week': 'Bu hafta',
    'home.topWins.month': 'Bu ay',
    'home.topWins.day': 'Bugün',
    'home.topWins.dailyTitle': 'Günlük En İyi Kazananlar',
    'home.topWins.monthlyTitle': 'Aylık En İyi Kazananlar',
    'home.topWins.myPrevious': 'Öncekilerim',
    'home.topWins.play': 'Oyna',
    'home.topWins.prev': 'Önceki',
    'home.topWins.next': 'Sonraki',
    'home.liveCasino.subtitle': '',
    'home.liveCasino.filterPopular': 'Popüler',
    'home.liveCasino.filterAll': 'Tümü',
    'home.liveCasino.filterRoulette': 'Rulet',
    'home.liveCasino.filterBlackjack': 'Blackjack',
    'home.liveCasino.filterBaccarat': 'Bakara',
    'home.liveCasino.filterGameShows': 'Oyun Şovları',
    'home.liveCasino.filterPoker': 'Poker',
    'home.popularSlots.title': 'Popüler Slotlar',
    'home.hotSlots.title': 'En Kazançlı',
    'home.hotSlots.badge': 'HOT',
    'home.matchCarousel.title': 'Maçlar',
    'home.matchCarousel.liveTv': 'Canlı TV',
    'home.slotsCarousel.showAll': 'Tümünü göster',
    'home.slotsCarousel.prev': 'Önceki',
    'home.slotsCarousel.next': 'Sonraki',
    'home.jackpot.grand': 'GRAND',
    'home.jackpot.major': 'MAJOR',
    'home.jackpot.minor': 'MINOR',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Kulüp',
    'home.heroSide.vipSub': 'Özel ayrıcalıklar',
    'home.heroSide.promosTitle': 'Bonuslar',
    'home.heroSide.promosSub': 'Güncel kampanyalar',
    'home.heroSide.sportTitle': 'Spor',
    'home.heroSide.sportSub': 'Canlı bahisler',
    'header.support': 'Yardım',
    'home.topEvents.showAll': 'Tümünü göster',
    'betslip.bonusFund': 'Bonus fonu',
    'betslip.participants': '{count} katılımcı',
    'betslip.hoursLeft': '{hours} saat kaldı',
    'betslip.details': 'Detaylar',
    'casino.viewAllCaption': 'Tümünü gör →',
    'casino.bside.promos': 'Kampanyalar',
    'casino.bside.showAll': 'Tümünü göster →',
    'casino.lobby.slots': 'Slotlar',
    'casino.lobby.live': 'Canlı Casino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'TV Oyunları',
    'casino.lobby.fast': 'Anlık Oyunlar',
    'casino.lobby.virtual': 'Sanal Spor',
    'casino.tab.review': 'Öne Çıkanlar',
    'casino.tab.favourites': 'Favoriler',
    'casino.tab.top': 'En İyi',
    'casino.tab.peter': 'Peter & Sons Hits',
    'casino.tab.free-spins': 'Bedava Spin',
    'casino.tab.all': 'Tüm Oyunlar',
    'casino.tab.tournaments': 'Turnuvalar',
    'casino.tab.jackpot-cards': 'Jackpot Kartları',
    'casino.tab.new': 'Yeni',
    'casino.tab.world-cup': 'Dünya Kupası 2026',
    'casino.tab.buy-bonus': 'Satın Al Bonusu',
    'casino.tab.exclusive': 'Eksklüzif',
    'casino.tab.vip-egt': 'Bell Link',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Pragmatic Play',
    'casino.tab.coins-link-vip': 'Coins Link VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'Kaskad',
    'casino.tab.megaways': 'Megaways',
    'casino.tab.collect': 'Topla',
    'casino.tab.wild': 'Wild',
    'casino.tab.double': 'Çift Şans',
    'casino.tab.megax': 'Mega X',
    'casino.tab.respin': 'Respin',
    'casino.tab.retro': 'Retro',
    'casino.tab.fruits': 'Meyveler',
    'casino.tab.books': 'Kitaplar',
    'casino.tab.fast-football': 'Hızlı Futbol',
    'casino.tab.holdem': 'Hold\'em',
    'casino.tab.caribbean': 'Caribbean',
    'casino.tab.video-poker': 'Video Poker',
    'casino.tab.crash': 'Crash',
    'casino.tab.table-games': 'Masa Oyunları',
    'casino.tab.mines': 'Mayınlar',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Zar',
    'casino.tab.scratch': 'Kazı Kazan',
    'casino.tab.other': 'Diğer',
    'casino.tab.football': 'Futbol',
    'casino.tab.horse-racing': 'At Yarışı',
    'casino.tab.recommended': 'Önerilen',
    'casino.topProviders': 'En İyi Sağlayıcılar',
    'casino.groupsAll': 'Tümü',
    'casino.groupsNew': 'Yenilikler',
    'casino.groupsTop': 'En iyi oyunlar',
    'casino.groupsFavourites': 'Favoriler',
    'casino.groupsLastPlayed': 'Son oynananlar',
    'casino.groupsBonusBuy': 'Bonus satın al',
    'casino.groupsMultipliers': 'Yüksek çarpan',
    'casino.groupsJackpot': 'Jackpot',
    'casino.groupsAllGames': 'Tüm oyunlar',
    'casino.groupsBellLink': 'Bell Link',
    'casino.groupsAmusnet': 'Amusnet',
    'casino.groupsVipTables': 'VIP masalar',
    'casino.groupsRoulette': 'Rulet',
    'casino.groupsBlackjack': 'Blackjack',
    'casino.groupsBaccarat': 'Baccarat',
    'casino.groupsGameShows': 'Oyun Şovları',
    'casino.groupsPokerLive': 'Poker',
    'casino.groupsSicBo': 'Sic Bo',
    'casino.topOfWeek': 'Haftanın en iyileri',
    'casino.tab.vip-tables': 'VIP masalar',
    'casino.tab.roulette': 'Rulet',
    'casino.tab.blackjack': 'Blackjack',
    'casino.tab.baccarat': 'Baccarat',
    'casino.tab.game-shows': 'Oyun Şovları',
    'casino.tab.poker-live': 'Poker',
    'casino.tab.sic-bo': 'Sic Bo',
    'casino.emptyFavorites': 'Henüz favori oyun yok',
    'casino.emptyLastPlayed': 'Henüz oynanan oyun yok',
    'casino.tab.lastplayed': 'Son oynananlar',
    'casino.tab.favourites': 'Favoriler',
    'casino.tab.vip-egt': 'Bell Link',
    'casino.tab.amusnet': 'Amusnet',
    'casino.groupsWager': 'Bonus için',
    'casino.groupsFreebonus': 'Free spin',
    'casino.lobbyHome': 'Ana sayfa',
    'casino.groups': 'Gruplar',
    'casino.providers': 'Sağlayıcılar',
    'casino.search': 'Ara',
    'casino.play': 'Oyna',
    'casino.demo': 'Demo',
    'casino.searchModal.title': 'Ara',
    'casino.searchModal.placeholder': 'Oyun ara',
    'casino.filters': 'Filtreler',
    'casino.filtersCount': 'Filtreler ({count})',
    'casino.filter.section.functions': 'Özellikler',
    'casino.filter.section.themes': 'Temalar',
    'casino.filter.bonusGame': 'Bonus Oyunu',
    'casino.filter.buyFeature': 'Bonus Satın Al',
    'casino.filter.expandingSymbols': 'Genişleyen Semboller',
    'casino.filter.freeSpins': 'Ücretsiz Dönüşler',
    'casino.filter.multiplier': 'Çarpan',
    'casino.filter.respins': 'Yeniden Dönüşler',
    'casino.filter.symbolsCollection': 'Sembol Toplama',
    'casino.filter.animals': 'Hayvanlar',
    'casino.filter.books': 'Kitaplar',
    'casino.filter.classic777': 'Klasik & 777',
    'casino.filter.coins': 'Paralar',
    'casino.filter.egypt': 'Mısır',
    'casino.filter.fruits': 'Meyveler',
    'casino.filter.gods': 'Tanrılar',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Tüm sağlayıcılar',
    'casino.selectProvider': 'Sağlayıcı seç',
    'casino.searchProviders': 'Sağlayıcı ara',
    'casino.loading': 'Oyunlar yükleniyor…',
    'casino.noGames': 'Oyun bulunamadı',
    'casino.lucky': 'Şanslıyım',
    'casino.sortBy': 'Sırala',
    'casino.sort.popular': 'En popüler',
    'casino.sort.default': 'Varsayılan',
    'casino.sort.az': 'A dan Z ye',
    'casino.sort.za': 'Z den A ya',
    'casino.sort.new': 'En yeni',
    'casino.sort.provider': 'Sağlayıcıya göre',
    'casino.sort.name': 'Ada göre',
    'casino.showMore': 'Daha fazla göster',
    'casino.viewAll': 'Tümünü gör',
    'casino.games': 'oyun',
    'casino.side.games': 'Oyunlar',
    'casino.side.tournament': 'Turnuva',
    'casino.side.search': 'Oyun ara',
    'casino.side.recommended': 'Önerilen oyunlar',
    'casino.side.noGames': 'Oyun bulunamadı',
    'casino.side.noTournaments': 'Aktif turnuva yok',
    'casino.side.loading': 'Yükleniyor…',
    'casino.game.play': 'Oyna',
    'casino.game.demo': 'Demo',
    'casino.game.favorite': 'Favorilere ekle',
    'casino.game.fullscreen': 'Tam ekran',
    'casino.game.noFreeSpins': 'Bu oyuna eklenecek freespin yok',
    'casino.game.linkCopied': 'Bağlantı kopyalandı',
    'casino.game.closeConfirmTitle': 'Oyunu kapat?',
    'casino.game.closeConfirmText': 'Oyun kapanacak. Devam etmek istiyor musunuz?',
    'casino.game.closeConfirmOk': 'Kapat',
    'casino.game.closeConfirmCancel': 'İptal',
    'casino.game.popout': 'Yeni pencerede aç',
    'casino.game.playReal': 'Gerçek parayla oyna',
    'casino.game.addFreeSpins': 'Freespin ekle',
    'casino.game.addFreeSpinsToGame': 'Oyuna bedava dönüş ekle',
    'casino.game.fsBet': 'Bahis',
    'casino.game.fsExpiresIn': 'Son geçerlilik',
    'casino.game.fsAdd': 'Ekle',
    'casino.game.fsBackToGame': 'Oyuna dön',
    'casino.game.fsNewAvailable': 'Yeni bedava dönüşler hazır',
    'casino.game.fsUpdateRequired': 'Oyunu güncellemeniz gerekiyor',
    'casino.game.fsUpdate': 'Güncelle',
    'casino.game.insufficientBalance': 'Yetersiz bakiye',
    'casino.game.insufficientBalanceHint': 'Gerçek parayla oynamak için bakiyenizi yükleyin',
    'casino.game.insufficientContinue': 'Devam et',
    'casino.game.makeDeposit': 'Para yatır',
    'casino.game.bonusInsufficientHint': 'Bonus bakiyeniz bu bahis için yetersiz. Ana paraya geçmek mevcut bonusu iptal eder.',
    'casino.game.switchToCash': 'Ana paraya geç',
    'casino.game.demoMode': 'Demo modu',
    'casino.game.signIn': 'Gerçek parayla oynamak için giriş yapın.',
    'casino.game.tryDemo': 'Demoyu dene',
    'casino.game.loading': 'Oyun yükleniyor…',
    'casino.game.notFound': 'Oyun bulunamadı',
    'casino.game.launchFailed': 'Oyun başlatılamadı',
    'casino.game.demoUnavailable': 'Demo bu oyun için kullanılamıyor.',
    'casino.game.unavailable': 'Oyun şu an başlatılamıyor. Lütfen daha sonra tekrar deneyin.',
    'casino.game.demoSuffix': '(Demo)',
    'casino.game.close': 'Kapat',
    'casino.game.menu': 'Menü',
    'casino.game.searchGames': 'Oyun ara',
    'casino.game.shareGame': 'Oyunu paylaş',
    'casino.game.gameDescription': 'Oyun açıklaması',
    'casino.game.demoModeTitle': 'Demo modunda oynuyorsunuz',
    'casino.game.demoModeHint': 'Gerçek kazanç için kayıt olun',
    'casino.game.register': 'Kayıt ol',
    'casino.badge.top': 'EN İYİ',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Turnuva',
    'casino.badge.new': 'YENİ',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'exclusive',
    'casino.badge.jackpot': 'jackpot',
    'casino.bside.tournaments': 'Turnuvalar',
  },
  en: {
    'network.offline': 'No internet connection.',
    'network.online': 'You are back online.',
    'network.poor': 'Weak internet connection.',
    'network.reconnecting': 'Reconnecting…',
    'nav.home': 'Home',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Sport',
    'nav.sportLive': 'Live betting',
    'nav.liveCasino': 'Live Casino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slots',
    'nav.virtual': 'Virtual sports',
    'nav.fast': 'Fast games',
    'nav.tv': 'TV games',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Watch live match streams',
    'vtv.live': 'Live',
    'vtv.upcoming': 'Upcoming',
    'vtv.search': 'Search',
    'vtv.searchPh': 'Search teams, leagues…',
    'vtv.allSports': 'All sports',
    'vtv.loading': 'Loading streams…',
    'vtv.empty': 'No matches available',
    'vtv.error': 'Unable to load streams',
    'vtv.pick': 'Pick a match to watch',
    'vtv.streamError': 'Unable to open stream',
    'vtv.liveBadge': 'LIVE',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'NEW',
    'nav.newGames': 'New Games',
    'nav.newPromos': 'New Promotions',
    'nav.promos': 'Promotions',
    'nav.casino': 'Casino',
    'nav.apps': 'Apps',
    'nav.results': 'Results',
    'header.promos': 'Promos',
    'header.help': 'Help',
    'header.search': 'Search',
    'header.settings': 'Settings',
    'header.login': 'Log in',
    'header.join': 'Join Now',
    'header.logout': 'Log out',
    'header.account': 'My account',
    'header.deposit': 'Deposit',
    'header.inGame': '(In Game)',
    'header.hideBalance': 'Hide balance',
    'header.showBalance': 'Show balance',
    'header.notifications': 'Notifications',
    'mobile.menu': 'Menu',
    'mobile.home': 'Home',
    'mobile.myBets': 'My bets',
    'mobile.navigation': 'Navigation',
    'mobile.menu.loginTitle': 'Log in to your account',
    'mobile.menu.loginText': 'to get full access to all service options',
    'mobile.menu.tournaments': 'Tournaments',
    'mobile.menu.helpNote': 'FAQ, learning, dictionary',
    'mobile.menu.appsNote': 'For Android, iOS',
    'mobile.menu.about': 'About VurgunBet',
    'mobile.menu.aboutNote': 'Information, licenses',
    'basinda.title': 'In the Press',
    'basinda.lead': 'Moments from VurgunBet stadium and pitch sponsorships.',
    'basinda.menuNote': 'Sponsorships, press',
    'basinda.item1': 'Sassuolo - Pisa',
    'basinda.item2': 'Torino - Atalanta',
    'basinda.item3': 'Alaves - Elche',
    'basinda.item4': 'Levante - Alaves',
    'basinda.item5': 'Fenerbahçe - Pogon Szczecin',
    'mobile.menu.siteTour': 'Site tour',
    'mobile.menu.siteTourText': 'only takes 2 minutes →',
    'mobile.menu.history': 'View history',
    'mobile.menu.historyEmpty': 'No browsing history yet',
    'mobile.menu.historyEmptyText': 'Here you can find all sections and sporting events that you have viewed',
    'mobile.menu.clearHistory': 'Clear history',
    'mobile.menu.openPromos': 'Promotions',
    'mobile.menu.searchGames': 'Search games',
    'mobile.menu.responsibleGaming': 'Responsible gaming',
    'mobile.account.number': 'Account: {id}',
    'mobile.account.copy': 'Copy account number',
    'mobile.account.copied': 'Copied',
    'mobile.account.balance': 'Balance: {amount}',
    'settings.section.sport': 'Sport',
    'settings.section.casino': 'Casino',
    'settings.section.interface': 'Interface',
    'settings.section.navigation': 'Navigation',
    'settings.eventDisplay': 'Event display',
    'settings.eventDisplay.table': 'Table',
    'settings.eventDisplay.list': 'List',
    'settings.betSlipLocation': 'Bet slip location',
    'settings.betSlipLocation.bottom': 'In the bottom panel',
    'settings.betSlipLocation.above': 'Above the panel',
    'settings.betSlipSettings': 'Bet slip settings',
    'settings.betSlip.showLiveTimer': 'Show Live event timer in bet slip',
    'settings.betSlip.showEventTime': 'Show event time and start date in the bet slip',
    'settings.betSlip.skipClearConfirm': 'Don\'t ask for confirmation to clear bet slips',
    'settings.betSlip.view': 'Bet slip view',
    'settings.betSlip.view.auto': 'Auto pick',
    'settings.betSlip.view.narrow': 'Narrow',
    'settings.betSlip.view.wide': 'Wide',
    'settings.odds.title': 'Odds',
    'settings.odds.boosted': 'Increased',
    'settings.odds.on': 'on',
    'settings.odds.off': 'off',
    'settings.odds.hideBoosted': 'Don\'t display boosted odds in Sports',
    'settings.odds.european': 'European',
    'settings.odds.american': 'American',
    'settings.odds.hongkong': 'Hong Kong',
    'settings.odds.indonesian': 'Indonesian',
    'settings.odds.malaysian': 'Malaysian',
    'settings.favouriteSports': 'Favourite sports',
    'settings.favouriteSports.empty': 'None',
    'settings.favouriteSports.desc': 'Add favourite sports to display them first in the Sports section.',
    'settings.casinoProMode': 'Pro mode',
    'settings.casinoProMode.desc': 'Display the slot\'s volatility and other values on the game card',
    'settings.casinoView.standard': 'Standard view',
    'settings.casinoView.pro': 'Pro mode',
    'settings.theme.title': 'Website theme',
    'settings.theme.auto': 'Auto',
    'settings.theme.light': 'Light',
    'settings.theme.dark': 'Dark',
    'settings.hideBalance': 'Hide balance',
    'settings.hideBalance.desc': 'Swipe your balance in the header to hide it',
    'settings.showUpButton': 'Show "Up" button',
    'settings.language': 'Language',
    'settings.nav.sportSection': 'In the Sports section',
    'settings.nav.casinoSection': 'In the Casino section',
    'settings.nav.menu': 'In Menu',
    'settings.title': 'Website settings',
    'settings.reset': 'Return by default',
    'settings.betSlip.title': 'Bet slip',
    'settings.nav.betAcceptance': 'Bet acceptance',
    'settings.nav.cashOut': 'Cash out',
    'settings.nav.favouriteBets': 'Favourite bets',
    'settings.nav.betSlip': 'Bet slip view',
    'settings.navigation.auto': 'Auto',
    'settings.navigation.left': 'On the left',
    'settings.navigation.top': 'Top',
    'settings.eventList.title': 'Event list',
    'settings.eventList.minimised': 'All events are minimised by default',
    'settings.eventPage.title': 'Event page',
    'settings.view.large': 'Large view',
    'settings.view.compact': 'Compact view',
    'settings.favouriteSports.descLong': 'Add your favourite sports to display them first in the Sports section. You can change their order by dragging them',
    'settings.favouriteSports.hint': 'Press ★ to add the sport to your favourites',
    'settings.sport.football': 'Football',
    'settings.sport.hockey': 'Hockey',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basketball',
    'settings.sport.esports': 'Esports',
    'settings.sport.tableTennis': 'Table tennis',
    'settings.sport.volleyball': 'Volleyball',
    'settings.sport.handball': 'Handball',
    'settings.sport.mixFights': 'Mix. Fights',
    'settings.sport.boxing': 'Boxing',
    'settings.sport.futsal': 'Futsal',
    'settings.sport.baseball': 'Baseball',
    'settings.sport.americanFootball': 'American football',
    'settings.sport.rugby': 'Rugby',
    'settings.sport.waterPolo': 'Water polo',
    'settings.sport.fieldHockey': 'Field hockey',
    'settings.sport.racing': 'Racing',
    'settings.sport.cycling': 'Cycling',
    'settings.sport.sports': 'Sports',
    'settings.sport.beachSoccer': 'Beach soccer',
    'settings.sport.basketball3x3': 'Basketball 3x3',
    'settings.sport.lacrosse': 'Lacrosse',
    'settings.sport.australianFootball': 'Australian football',
    'settings.sport.cricket': 'Cricket',
    'settings.sport.snooker': 'Snooker',
    'settings.sport.darts': 'Darts',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet — Online Sports Betting',
    'auth.login.title': 'Log in to your account',
    'auth.login.submit': 'Log in',
    'auth.login.link': 'Log in',
    'auth.register.title': 'Registration',
    'auth.register.bannerHighlight': '100% UP TO',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPINS',
    'auth.register.bannerDesc': '+5 FREE BETS',
    'auth.register.perkFast': 'Anonymous',
    'auth.register.perkSafe': 'Zero Fees',
    'auth.register.perkBonus': 'VPN Friendly',
    'auth.register.orSignUpWith': 'OR SIGN UP WITH',
    'auth.login.orSignInWith': 'OR SIGN IN WITH',
    'auth.webauthn.login': 'Sign in with Face ID / Touch ID',
    'auth.webauthn.offerTitle': 'Save Face ID on this device',
    'auth.webauthn.offerBody': 'Next time you can sign in quickly with Face ID, Touch ID, or Windows Hello.',
    'auth.webauthn.offerConfirm': 'Save on this device',
    'auth.webauthn.offerSkip': 'Not now',
    'auth.webauthn.needRegister': 'Save Face ID / Touch ID in your profile first',
    'auth.webauthn.failed': 'Biometric sign-in failed',
    'auth.webauthn.unsupported': 'Face ID / Touch ID is not available on this device',
    'auth.webauthn.registerFailed': 'Could not save biometric login',
    'auth.webauthn.alreadyRegistered': 'This device is already registered',
    'auth.webauthn.thisDevice': 'This device',
    'auth.webauthn.manageTitle': 'Face ID / Touch ID',
    'auth.webauthn.manageDesc': 'Register a passkey to sign in with Face ID, Touch ID, or Windows Hello on this device.',
    'auth.webauthn.empty': 'No biometric logins saved',
    'auth.webauthn.add': 'Save on this device',
    'auth.webauthn.remove': 'Remove',
    'auth.webauthn.removed': 'Passkey removed',
    'auth.webauthn.registered': 'Biometric login saved',
    'auth.webauthn.loadFailed': 'Could not load passkeys',
    'auth.webauthn.removeFailed': 'Could not remove passkey',
    'account.profile.tab.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeysHint': 'Quick sign-in',
    'auth.register.socialNotConfigured': 'This method is not configured yet',
    'auth.register.pageTitle': 'Registration | VurgunBet',
    'auth.register.submit': 'Register',
    'auth.register.link': 'Register',
    'guestPopup.title': 'Free bet 100 TL + 300 free spins',
    'guestPopup.subtitle': 'for new clients',
    'guestPopup.cta': 'Registration',
    'language.choose': 'Choose language',
    'auth.register.slogan': 'CLOSER TO THE GAME',
    'auth.register.smsHint': 'Text message code will be sent to this number',
    'auth.register.promoToggle': 'I have a promo code',
    'auth.register.rules': 'I am 18 years old and I accept the Terms and Conditions and Privacy Policy *',
    'auth.register.rulesBefore': 'I am 18 years old and I accept the ',
    'auth.register.termsLink': 'Terms and Conditions',
    'auth.register.rulesAnd': ' and ',
    'auth.register.privacyLink': 'Privacy Policy',
    'auth.register.rulesAfter': ' *',
    'auth.register.rulesLink': 'Terms and Conditions',
    'auth.register.rulesRequired': 'You must accept the Terms and Conditions and Privacy Policy',
    'auth.register.serviceMail': 'I agree to receive service newsletters.',
    'auth.register.serviceMail2': 'You can read the personal data processing policy',
    'auth.register.here': 'here',
    'auth.register.adMail': 'I agree to the',
    'auth.register.adTerms': 'terms of the advertising mailing list',
    'auth.register.adTermsLink': 'terms',
    'auth.register.adTermsSuffix': 'of the advertising mailing list',
    'auth.register.serviceMailSuffix': '.',
    'auth.register.fullPromotionTerms': 'Full Promotion Terms',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Enter your phone number',
    'auth.validation.phoneOrEmailRequired': 'Enter email or phone',
    'auth.validation.phoneInvalid': 'Enter a valid phone number',
    'auth.validation.phoneExists': 'This phone number is already registered',
    'auth.validation.emailRequired': 'Enter your email',
    'auth.validation.emailInvalid': 'Enter a valid email address',
    'auth.validation.emailDomainInvalid': 'Use a valid email (gmail, hotmail, outlook, icloud, yandex, yahoo, mynet, etc.)',
    'auth.validation.emailExists': 'This email is already registered',
    'auth.validation.passwordRequired': 'Enter your password',
    'auth.validation.passwordShort': 'Password must be at least 8 characters',
    'auth.validation.registerFailed': 'Registration failed. Please try again.',
    'auth.validation.loginFieldsRequired': 'Fill in all fields',
    'auth.validation.loginInvalid': 'Incorrect login or password',
    'auth.validation.accountRequired': 'Enter your player ID',
    'auth.validation.accountShort': 'Player ID must be at least 6 digits',
    'auth.validation.codeInvalid': 'Incorrect confirmation code',
    'auth.validation.codeRequired': 'Enter the confirmation code',
    'auth.validation.codeSendFailed': 'Could not send code',
    'auth.validation.codeThrottled': 'Please wait before requesting another code',
    'auth.validation.challengeExpired': 'Verification expired, please log in again',
    'auth.validation.serverUnreachable': 'Cannot reach server. Run npm run dev:server in the terminal.',
    'auth.validation.serverError': 'Login failed. Check the server and database.',
    'auth.tab.phone': 'Phone',
    'auth.tab.email': 'Email',
    'auth.tab.username': 'Username',
    'auth.tab.account': 'ID No',
    'auth.label.phone': 'Phone number',
    'auth.label.phoneOptional': 'Mobile phone (optional)',
    'auth.label.email': 'Email',
    'auth.label.username': 'Username',
    'auth.label.account': 'Player ID',
    'auth.label.password': 'Password',
    'auth.label.promo': 'Promo code',
    'auth.placeholder.account': 'Player ID',
    'auth.placeholder.username': 'Username',
    'auth.forgot': 'Forgotten password?',
    'auth.noAccount': 'Don\'t have an account?',
    'auth.haveAccount': 'Already have an account?',
    'auth.login.pageTitle': 'Log in | VurgunBet',
    'auth.verify.info': 'To protect your account, we need to make sure that this is really you.',
    'auth.verify.caption': 'Get confirmation code:',
    'auth.verify.methodPhone': 'we\'ll send the code by text message or by Telegram to your phone number {contact}',
    'auth.verify.methodEmail': 'we\'ll send the code by email to {contact}',
    'auth.verify.getCode': 'Get code',
    'auth.verify.cancel': 'Cancel',
    'auth.verify.noAccess': 'I do not have access to phone number',
    'auth.verify.enterCode': 'Enter confirmation code:',
    'auth.verify.confirm': 'Confirm',
    'auth.verify.continue': 'Continue',
    'auth.verify.codeInfoPhone': 'Enter verification code. We sent it by text message or by Telegram to your phone number {contact}.',
    'auth.verify.codeInfoEmail': 'Enter verification code. We sent it by email to {contact}.',
    'auth.verify.neverReceived': 'I never received a code',
    'auth.verify.resend': 'Resend code',
    'auth.verify.noAccessEmail': 'I do not have access to email',
    'auth.verify.help.title': 'If a confirmation code never arrived',
    'auth.verify.help.bodyPhone': 'Make sure the phone number is correct and your device has enough free memory. Check if the message ended up in the spam folder.',
    'auth.verify.help.bodyEmail': 'Make sure the email address is correct. Check if the message ended up in the spam folder.',
    'auth.verify.help.step1': 'Open the Messages app',
    'auth.verify.help.step2': 'Press the button in the top right corner',
    'auth.verify.help.step3': 'Select "Spam and blocked"',
    'auth.verify.help.understood': 'Understood',
    'auth.recover.title': 'Password recovery',
    'auth.recover.pageTitle': 'Password recovery | VurgunBet',
    'auth.recover.continue': 'Continue',
    'auth.recover.noAccess': 'I do not have access to phone number / email',
    'auth.recover.noAccessPhone': 'I do not have access to phone number',
    'auth.recover.noAccessEmail': 'I do not have access to email',
    'auth.recover.newPassword': 'New password',
    'auth.recover.confirmPassword': 'Confirm new password',
    'auth.recover.passwordMismatch': 'Passwords do not match',
    'auth.recover.save': 'Save password',
    'auth.recover.success': 'Your password has been updated. You can log in with your new password.',
    'auth.recover.notFound': 'No account found with these details',
    'auth.verify.expiredTitle': 'The time allowed for this process has expired.',
    'auth.verify.retry': 'Retry',
    'welcome.stepLabel': 'Step 1 of 3: Registration',
    'welcome.title': 'Get a welcome bonus up to 100 TL + 300 FS!',
    'welcome.step1.title': 'Register',
    'welcome.step1.sub': 'On the website or in the app',
    'welcome.step2.title': 'Complete the verification',
    'welcome.step2.sub': 'It will take just a few minutes',
    'welcome.step3.title': 'Make a deposit',
    'welcome.step3.sub': 'Bigger deposit – bigger bonus!',
    'welcome.start': 'Start',
    'welcome.rules': 'Full Promotion Terms',
    'account.loading': 'Loading...',
    'account.save': 'Save',
    'account.empty': 'No records found',
    'account.nav.overview': 'Overview',
    'account.nav.profile': 'Personal data',
    'account.nav.verification': 'Verification',
    'account.nav.cashier': 'Cashier',
    'account.nav.bets': 'My bets',
    'account.nav.bonuses': 'Bonuses',
    'account.nav.notifications': 'Notifications',
    'account.nav.security': 'Security',
    'account.nav.support': 'Support',
    'account.menu.profile': 'My profile',
    'account.menu.payments': 'Deposits and withdrawals',
    'account.menu.history': 'Bet and transaction history',
    'account.menu.requests': 'Requests',
    'account.menu.responsible': 'Responsible gaming',
    'account.menu.vip': 'Your VIP status',
    'support.liveChat': 'Live support',
    'account.menu.deposit': 'Make a deposit',
    'account.overview.title': 'Account summary',
    'account.overview.balance': 'Balance',
    'account.overview.bonusBalance': 'Bonus balance',
    'account.wager.progress': 'Wagering status',
    'account.wager.bonusTitle': 'Bonus wagering',
    'account.wager.depositTitle': 'Deposit wagering',
    'account.overview.accountNo': 'Account no.',
    'account.overview.verification': 'Verification',
    'account.overview.totalBets': 'Total bets',
    'account.profile.name': 'Full name',
    'account.profile.saved': 'Your details have been saved',
    'account.profile.marketingEmail': 'I want to receive promo emails',
    'account.profile.marketingSms': 'I want to receive promo SMS',
    'account.profile.tab.details': 'Personal details',
    'account.profile.tab.phone': 'Change phone number',
    'account.profile.tab.phoneAdd': 'Add phone number',
    'account.profile.tab.phoneVerify': 'Verify phone number',
    'account.profile.tab.email': 'Change email',
    'account.profile.tab.emailAdd': 'Add email',
    'account.profile.tab.emailVerify': 'Verify email',
    'account.profile.tab.password': 'Change password',
    'account.profile.section.personal': 'PERSONAL DATA',
    'account.profile.section.lastLogin': 'LAST LOGIN INFORMATION',
    'account.profile.section.contacts': 'CONTACTS',
    'account.profile.section.marketing': 'CONTACT PREFERENCES',
    'account.profile.field.name': 'Name:',
    'account.profile.field.verification': 'Identity verification status:',
    'account.profile.field.accountNo': 'Account number:',
    'account.profile.field.currency': 'Currency:',
    'account.profile.field.phone': 'Phone number:',
    'account.profile.field.email': 'Email:',
    'account.profile.field.time': 'Time:',
    'account.profile.field.ip': 'IP address:',
    'account.profile.change': 'Change',
    'account.profile.add': 'Add',
    'account.profile.status.verified': 'Verified',
    'account.profile.status.unverified': 'Unverified',
    'account.profile.marketingIntro': 'Get notifications about promotions and news:',
    'account.profile.marketing.email': 'Email',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Push notifications',
    'account.profile.marketing.web': 'Website notifications',
    'account.profile.verification.basic': 'Unverified',
    'account.profile.verification.verified': 'Verified',
    'account.profile.verification.pending': 'Pending',
    'account.profile.verify': 'Verify',
    'account.profile.tab.kyc': 'Identity verification',
    'account.profile.kyc.title': 'Identity verification',
    'account.profile.kyc.intro': 'Submit your national ID number, city, address, and ID photos. Your account will be verified after review.',
    'account.profile.kyc.tcLabel': 'National ID number',
    'account.profile.kyc.tcInvalid': 'Enter a valid 11-digit national ID number',
    'account.profile.kyc.cityLabel': 'City',
    'account.profile.kyc.cityPlaceholder': 'Select a city',
    'account.profile.kyc.cityRequired': 'City selection is required',
    'account.profile.kyc.addressLabel': 'Address',
    'account.profile.kyc.addressHint': 'Enter your full address. Edit it if it is incorrect.',
    'account.profile.kyc.addressRequired': 'Address must be at least 5 characters',
    'account.profile.kyc.frontLabel': 'ID front',
    'account.profile.kyc.frontHint': 'Upload a photo of the front of your ID',
    'account.profile.kyc.backLabel': 'ID back',
    'account.profile.kyc.backHint': 'Upload a photo of the back of your ID',
    'account.profile.kyc.photoRequired': 'ID front photo is required',
    'account.profile.kyc.backRequired': 'ID back photo is required',
    'account.profile.kyc.submit': 'Submit',
    'account.profile.kyc.submitted': 'Your verification request was received and is under review',
    'account.profile.kyc.pendingMessage': 'Your verification request is under review. You cannot submit new documents until it is resolved.',
    'account.profile.kyc.alreadyVerified': 'Your account is already verified.',
    'account.profile.todayAt': 'Today at',
    'account.profile.mobile.personalData': 'Personal data',
    'account.profile.mobile.aboutAccount': 'About account',
    'account.profile.mobile.passwordChange': 'Password Change',
    'account.profile.next': 'Next',
    'account.profile.changeEmailTitle': 'New email address',
    'account.profile.changePhoneTitle': 'New phone number',
    'account.profile.addEmailTitle': 'Add email address',
    'account.profile.addPhoneTitle': 'Add phone number',
    'account.profile.verifyEmailTitle': 'Verify email address',
    'account.profile.verifyPhoneTitle': 'Verify phone number',
    'account.profile.contactSupport': 'Please contact support to change your details.',
    'account.profile.contactSupportAddPhone': 'Create a support request to add a phone number.',
    'account.profile.contactSupportChangePhone': 'Create a support request to change your phone number.',
    'account.profile.contactSupportVerifyPhone': 'Create a support request to verify your phone number.',
    'account.profile.contactSupportAddEmail': 'Create a support request to add an email address.',
    'account.profile.contactSupportChangeEmail': 'Create a support request to change your email address.',
    'account.profile.step.support': 'Create a support request',
    'account.profile.step.sharePhone': 'Share your phone number',
    'account.profile.step.shareNewPhone': 'Share your new phone number',
    'account.profile.step.requestVerify': 'Submit your verification request',
    'account.profile.step.confirmSms': 'Confirm with the SMS code',
    'account.profile.step.shareEmail': 'Share your email address',
    'account.profile.step.shareNewEmail': 'Share your new email address',
    'account.profile.step.confirmEmail': 'Complete email confirmation',
    'account.profile.contactSupportBtn': 'Contact support',
    'account.profile.otp.addPhoneHint': 'Enter your phone number. We will send a verification code by SMS.',
    'account.profile.otp.changePhoneHint': 'Enter your new phone number. The change is confirmed with an SMS code.',
    'account.profile.otp.verifyPhoneHint': 'We will send a code to verify your phone number.',
    'account.profile.otp.addEmailHint': 'Enter your email address. We will send a verification code by email.',
    'account.profile.otp.verifyEmailHint': 'We will send a code to verify your email address.',
    'account.profile.otp.changeEmailHint': 'Enter your new email address. The change is confirmed with an email code.',
    'account.profile.otp.codeSentPhone': 'We sent a verification code to:',
    'account.profile.otp.codeSentEmail': 'We sent a verification code to:',
    'account.profile.otp.codeSent': 'Verification code sent',
    'account.profile.otp.codeLabel': 'Verification code',
    'account.profile.otp.resend': 'Resend code',
    'account.profile.otp.phoneRequired': 'Phone number is required',
    'account.profile.otp.emailRequired': 'Email address is required',
    'account.profile.otp.codeRequired': 'Verification code is required',
    'account.profile.otp.sessionMissing': 'Verification session not found',
    'account.profile.otp.saved': 'Your contact details have been updated',
    'account.profile.passwordConfirm': 'Confirm new password',
    'account.profile.passwordRequired': 'Fill in all password fields',
    'account.profile.passwordMismatch': 'New passwords do not match',
    'account.profile.passwordSame': 'New password cannot be the same as your current password',
    'account.profile.send': 'Send',
    'account.profile.passwordHint': 'Use the security section to change your password.',
    'account.verification.desc': 'Identity verification is required for withdrawals and full account access.',
    'account.verification.verified': 'Verified',
    'account.verification.pending': 'Pending',
    'account.verification.rejected': 'Rejected',
    'account.verification.step1': 'Upload a photo of your passport or ID',
    'account.verification.step2': 'Add a selfie holding the document',
    'account.verification.step3': 'Review usually completes within 24 hours',
    'account.verification.submit': 'Start verification',
    'account.verification.submitted': 'Your documents are under review',
    'account.cashier.deposit': 'Deposit',
    'account.cashier.withdraw': 'Withdraw',
    'account.cashier.amount': 'Amount (TL)',
    'account.cashier.balance': 'Current balance: {amount}',
    'account.cashier.history': 'Transaction history',
    'account.cashier.type': 'Type',
    'account.cashier.date': 'Date',
    'account.payments.title': 'Deposits and withdrawals',
    'account.payments.back': 'Back',
    'account.payments.selectMethod': 'Select a method',
    'account.payments.group.havale': 'Bank transfer',
    'account.payments.group.card': 'Credit card',
    'account.payments.group.crypto': 'Crypto',
    'account.payments.group.other': 'Other',
    'account.payments.noMethods': 'No payment methods available right now.',
    'account.payments.from': 'from {amount} TL',
    'account.payments.depositTitle': 'Top up balance with {method}',
    'account.payments.withdrawTitle': 'Withdraw with {method}',
    'account.payments.depositNotice': 'Attention! The bank card must be registered in the name of the account owner. Payments made using third-party cards will be rejected.',
    'account.payments.withdrawNotice': 'Withdrawal requests are processed according to your verification status.',
    'account.payments.addAmount': 'Deposit',
    'account.payments.withdrawSubmit': 'Withdraw {amount} TL',
    'account.payments.requests': 'Your requests',
    'account.payments.insufficientBalance': 'Insufficient balance',
    'account.payments.minWithdrawNotice': 'Minimum amount required to withdraw Winnings: {amount}',
    'account.payments.withdrawGoDeposit': 'Deposit',
    'account.payments.selectAnotherMethod': 'Select another method',
    'account.payments.requestsTitle': 'Transaction requests',
    'account.payments.requestsEmpty': 'You have no transaction requests yet.',
    'account.payments.filterAll': 'All',
    'account.payments.filterCompleted': 'Completed',
    'account.payments.filterProcessing': 'Processing',
    'account.payments.filterCancelled': 'Cancelled',
    'account.payments.colNumber': 'NUMBER',
    'account.payments.colDate': 'DATE',
    'account.payments.colType': 'TYPE',
    'account.payments.colMethod': 'METHOD',
    'account.payments.colAmount': 'AMOUNT',
    'account.payments.status': 'Status',
    'account.payments.status_completed': 'Completed',
    'account.payments.status_pending': 'Pending',
    'account.payments.status_processing': 'Processing',
    'account.payments.status_cancelled': 'Cancelled',
    'account.payments.status_rejected': 'Rejected',
    'account.payments.status_failed': 'Failed',
    'account.payments.status_approved': 'Approved',
    'account.payments.status_expired': 'Expired',
    'account.payments.goToRequests': 'My requests',
    'account.payments.method.crypto': 'Crypto',
    'account.payments.method.maxhavale': 'Max Havale',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Speed Havale',
    'account.payments.havalespeed.depositPending': 'Complete your Speed Havale deposit',
    'account.payments.havalespeed.withdrawPending': 'Your Speed Havale withdrawal is processing',
    'account.payments.havalespeed.processing': 'Time left',
    'account.payments.havalespeed.confirmPaid': 'I transferred, notify',
    'account.payments.havalespeed.confirming': 'Sending notification…',
    'account.payments.havalespeed.confirmSent': 'Notification received. Waiting for approval.',
    'account.payments.havalespeed.cancelDeposit': 'Cancel request',
    'account.payments.havalespeed.cancelling': 'Cancelling…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Full name',
    'account.payments.havale.amountLabel': 'Amount',
    'account.payments.havalespeed.approvedHint': '{amount} was added to your balance.',
    'account.payments.havalespeed.approvedHintGeneric': 'Your deposit was approved and added to your balance.',
    'account.payments.havalespeed.rejectedHint': 'Your Speed Havale request was rejected. You can try a new deposit.',
    'account.payments.maxhavale.depositPending': 'Complete your Max Havale deposit',
    'account.payments.maxhavale.withdrawPending': 'Your Max Havale withdrawal is processing',
    'account.payments.maxhavale.processing': 'Time left',
    'account.payments.maxhavale.cancelDeposit': 'Cancel request',
    'account.payments.maxhavale.cancelling': 'Cancelling…',
    'account.payments.maxhavale.openPayment': 'Open deposit page',
    'account.payments.maxhavale.urlMissing': 'Payment details could not be loaded. You can cancel this request and try again.',
    'account.payments.maxhavale.bankName': 'Bank',
    'account.payments.havaleBtq.depositPending': 'Complete your Havale deposit',
    'account.payments.havaleBtq.withdrawPending': 'Your Havale withdrawal is processing',
    'account.payments.havaleBtq.processing': 'Time left',
    'account.payments.havaleBtq.cancelDeposit': 'Cancel request',
    'account.payments.havaleBtq.cancelling': 'Cancelling…',
    'account.payments.havaleBtq.openPayment': 'Open deposit page',
    'account.payments.havaleBtq.urlMissing': 'Payment details could not be loaded. You can cancel this request and try again.',
    'account.payments.havaleBtq.bankName': 'Bank',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'PayUrus wallet ID',
    'account.payments.payurus.walletName': 'Wallet holder name',
    'account.payments.payurus.openPayment': 'Reopen deposit page',
    'account.payments.payurus.reopenPayment': 'Reopen deposit page',
    'account.payments.payurus.urlMissing': 'Payment page link could not be loaded. You can cancel this request and try again.',
    'account.payments.payurus.cancelDeposit': 'Cancel request',
    'account.payments.payurus.cancelling': 'Cancelling…',
    'account.payments.payurus.depositPending': 'Complete your PayUrus payment',
    'account.payments.payurus.withdrawPending': 'Your PayUrus withdrawal is processing',
    'account.payments.payurus.processing': 'Time left',
    'account.payments.payurus.depositSuccess': 'Payment successful',
    'account.payments.payurus.depositSuccessHint': '{amount} was added to your balance.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Your {provider} deposit was added to your balance.',
    'account.payments.payurus.depositProcessing': 'Payment processing',
    'account.payments.payurus.depositProcessingHint': 'Your {provider} payment is being verified. Please wait.',
    'account.payments.payurus.depositFailed': 'Payment failed',
    'account.payments.payurus.depositFailedHint': 'Your {provider} payment could not be completed. You can try a new deposit.',
    'account.payments.payurus.continue': 'Continue',
    'account.payments.payurus.nameMismatch': 'Your first and last name do not match',
    'account.payments.payurus.nameMismatchDetail': 'The account holder name does not match the name returned by the provider. PayUrus account holder: {name}',
    'account.payments.payurus.rateLimit': 'Another withdrawal to this wallet is not allowed yet',
    'account.payments.payurus.rateLimitDetail': 'PayUrus limits how often you can withdraw to the same wallet. Please try again later.',
    'account.payments.payurus.walletInvalid': 'PayUrus wallet details could not be verified',
    'account.payments.payurus.walletInvalidDetail': 'Please check the wallet ID or wallet holder name and try again.',
    'account.payments.method.oplati': 'Papara',
    'account.payments.method.raschet': '«Raschet» Payment system',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'National ID (TC)',
    'account.payments.havale.firstName': 'First name',
    'account.payments.havale.lastName': 'Last name',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Bank',
    'account.payments.havale.transferTo': 'Transfer to the account below',
    'account.payments.havale.accountName': 'Account name',
    'account.payments.havale.copyIban': 'Copy',
    'account.payments.havale.copyName': 'Copy',
    'account.payments.havale.copyAmount': 'Copy amount',
    'account.payments.havale.copyBank': 'Copy bank',
    'account.payments.havale.copied': 'Copied',
    'account.payments.havale.countdown': 'Time left',
    'account.payments.havale.activeNotice': 'You have an active request. A new one cannot be created until the timer ends.',
    'account.payments.havale.amountDue': 'Amount to deposit',
    'account.payments.havale.waitNew': 'Wait to create a new request',
    'account.payments.havale.resultApproved': 'Deposit approved',
    'account.payments.havale.resultApprovedHint': '{amount} was added to your balance.',
    'account.payments.havale.resultRejected': 'Deposit rejected',
    'account.payments.havale.resultRejectedHint': 'Your request was not approved. You can try again.',
    'account.payments.havale.resultExpired': 'Request expired',
    'account.payments.havale.resultExpiredHint': 'The {provider} payment window has ended. You can create a new request.',
    'account.payments.havale.withdrawReceived': 'Withdrawal request received',
    'account.payments.havale.withdrawReceivedHint': 'Your withdrawal of {amount} was received and is under review.',
    'account.payments.havale.withdrawApproved': 'Withdrawal approved',
    'account.payments.havale.withdrawApprovedHint': 'Your withdrawal of {amount} has been completed.',
    'account.payments.havale.withdrawRejected': 'Withdrawal rejected',
    'account.payments.havale.withdrawRejectedHint': 'Your withdrawal was not approved. You can create a new request if needed.',
    'account.payments.havale.tryAgain': 'Try again',
    'account.payments.crypto.selectCoin': 'Select cryptocurrency',
    'account.payments.crypto.selectNetwork': 'Select network',
    'account.payments.crypto.network': 'Network',
    'account.payments.crypto.selectedNetwork': 'Selected network',
    'account.payments.crypto.networkWarning': 'Send only on the {network} network. Funds sent on the wrong network may be lost.',
    'account.payments.crypto.coin': 'Coin',
    'account.payments.crypto.depositAddress': 'Deposit address',
    'account.payments.crypto.copyAddress': 'Copy address',
    'account.payments.crypto.yourAddress': 'Your wallet address',
    'account.payments.crypto.estimated': 'Estimated amount',
    'account.payments.crypto.txHashOptional': 'TX Hash (optional)',
    'account.payments.crypto.submitTxHash': 'Submit TX hash',
    'account.payments.crypto.continueToWallet': 'Show deposit address',
    'account.payments.crypto.txHashError': 'Could not save TX hash',
    'account.payments.crypto.confirmations': 'Network confirmations',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': 'from {amount}',
    'account.cashier.amountUsd': 'Amount (USD)',
    'account.payments.addAmountUsd': 'Deposit {amount}',
    'account.payments.crypto.activeNotice': 'Send your transfer. Network confirmations are tracked automatically; balance updates when required confirmations are reached.',
    'account.payments.crypto.noAssets': 'No active crypto networks right now. Please try again later.',
    'account.bets.stake': 'Stake',
    'account.bets.odds': 'Odds',
    'account.bets.win': 'Win',
    'account.bets.status': 'Status',
    'account.bets.status_pending': 'Pending',
    'account.bets.status_won': 'Won',
    'account.bets.status_lost': 'Lost',
    'account.history.tabBets': 'Bets',
    'account.history.tabTransactions': 'Transaction history',
    'account.history.filters': 'Filters',
    'account.history.filterGroupBetType': 'Bet type',
    'account.history.filterGroupResult': 'Bet results',
    'account.history.filterBetType_all': 'All',
    'account.history.filterBetType_bets': 'Bets',
    'account.history.filterBetType_slot': 'Slot game',
    'account.history.filterBetType_dice_live': 'Dice game in Live mode',
    'account.history.filterBetType_card_live': 'Card game in Live mode',
    'account.history.filterBetType_cylinder_live': 'Roulette game in Live mode',
    'account.history.filterBetType_online_game': 'Bookmaker\'s online-game',
    'account.history.filterResult_all': 'All',
    'account.history.filterResult_not_settled': 'Not settled',
    'account.history.filterResult_win': 'Win',
    'account.history.filterResult_loss': 'Loss',
    'account.history.filterResult_cashed_out': 'Cashed out',
    'account.history.filterResult_void': 'Void',
    'account.history.filterResult_return': 'Return',
    'account.history.colDate': 'DATE',
    'account.history.colTime': 'TIME',
    'account.history.colBetNo': 'BET №',
    'account.history.colCoupon': 'COUPON',
    'account.history.colStake': 'STAKE',
    'account.history.colPotential': 'POTENTIAL',
    'account.history.details': 'Details',
    'account.history.colTransactionNo': 'TRANSACTION №',
    'account.history.colNumber': 'NUMBER',
    'account.history.colTransaction': 'TRANSACTION',
    'account.history.colAmountBonuses': 'AMOUNT / BONUSES',
    'account.history.colBalanceBonuses': 'BALANCE / BONUSES',
    'account.history.operation_deposit': 'Deposit',
    'account.history.operation_deposit_pending': 'Waiting for deposit confirmation',
    'account.history.operation_withdrawal_pending': 'Waiting for withdrawal confirmation',
    'account.history.operation_withdrawal_cancelled': 'Withdrawal cancelled',
    'account.history.operation_withdrawal_rejected': 'Withdrawal rejected',
    'account.history.operation_withdrawal_approved': 'Withdrawal approved',
    'account.history.operation_withdrawal_completed': 'Withdrawal completed',
    'account.history.operation_bet_placed': 'Bet placed',
    'account.history.operation_bet_settled': 'Bet settled',
    'account.history.operation_bet_lost': 'Bet lost',
    'account.history.operation_slot_bet_settled': 'Slot game bet settled',
    'account.history.operation_slot_bet_placed': 'Slot game bet placed',
    'account.history.operation_accrual_bonus_account': 'Accrual to bonus account',
    'account.history.operation_close_bonus_account': 'Close bonus account',
    'account.history.operation_bonus_conversion': 'Bonus conversion',
    'account.history.filterOperation_close_bonus_account': 'Close bonus account',
    'account.history.filterOperation_accrual_bonus_account': 'Accrual to bonus account',
    'account.history.filterOperation_slot_bet_settled': 'Slot game bet settled',
    'account.history.filterOperation_slot_bet_placed': 'Slot game bet placed',
    'account.history.filterOperation_withdrawal_cancelled': 'Withdrawal cancelled',
    'account.history.filterOperation_withdrawal_rejected': 'Withdrawal rejected',
    'account.history.filterOperation_withdrawal_approved': 'Withdrawal approved',
    'account.history.filterOperation_withdrawal_completed': 'Withdrawal completed',
    'account.history.filterOperation_withdrawal_pending': 'Waiting for withdrawal confirmation',
    'account.history.filterOperation_bonus_conversion': 'Bonus conversion',
    'account.history.filterOperation_bet_lost': 'Bet lost',
    'account.history.filterOperation_bet_placed': 'Bet placed',
    'account.history.filterOperation_bet_settled': 'Bet settled',
    'account.history.filterOperation_deposit': 'Deposit',
    'account.history.filterOperation_deposit_pending': 'Waiting for deposit confirmation',
    'account.history.colBetType': 'BET TYPE',
    'account.history.colType': 'TYPE',
    'account.history.colDescription': 'DESCRIPTION',
    'account.history.colOdds': 'ODDS',
    'account.history.colResult': 'RESULT',
    'account.history.colAmount': 'AMOUNT',
    'account.history.colStatus': 'STATUS',
    'account.history.betTypeSlot': 'Slot game',
    'account.history.betTypeSportsbook': 'Sports betting',
    'account.history.betTypeSingle': 'Single',
    'account.history.betTypeExpress': 'Express',
    'account.history.result_pending': 'Not settled',
    'account.history.result_won': 'Win',
    'account.history.result_lost': 'Loss',
    'account.history.result_completed': 'Completed',
    'account.history.betsEmpty': 'You have no bet history yet.',
    'account.history.transactionsEmpty': 'You have no transaction history yet.',
    'account.bonuses.welcomeTitle': 'Welcome bonus',
    'account.bonuses.welcomeDesc': 'Don\'t miss bonus offers on your first deposit.',
    'account.bonuses.viewPromos': 'View promos',
    'account.bonuses.freeSpinsTitle': 'Your free games',
    'account.bonuses.freeSpinsEmpty': 'You have no free games yet.',
    'account.bonuses.viewFreeSpins': 'View my bonuses',
    'account.vip.title': 'VIP Cashback',
    'account.vip.subtitleLine1': 'Take advantage of your privileges',
    'account.vip.subtitleLine2': 'and get cashback every week!',
    'account.vip.yourStatus': 'Your status',
    'account.vip.yourCashback': 'Your cashback',
    'account.vip.promotionRules': 'Promotion rules',
    'account.vip.stillQuestions': 'Still have questions?',
    'account.vip.cardCashbackFreeAndBonus': 'Cashback in free bets and in bonuses',
    'account.vip.cardCashbackBonusOnly': 'Cashback in bonuses',
    'account.vip.cardCashbackTail': 'up to',
    'account.vip.tierCashbackDesc': '{metal} — Cashback in free bets and in bonuses up to {percent}%',
    'account.vip.fromAmount': 'from',
    'account.vip.betAmountWeeks': 'bet amount for 4 weeks',
    'account.vip.yourStatusBadge': 'YOUR VIP STATUS',
    'account.vip.targetStatus': 'TARGET STATUS',
    'account.vip.cashbackLabel': 'CASHBACK',
    'account.vip.needToBet': 'You need to bet from',
    'account.vip.totalSettled': 'Total settled bets',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback free bets for betting on sports, bonuses — for betting in casino slot games',
    'account.vip.prev': 'Previous',
    'account.vip.next': 'Next',
    'account.vip.rulesLoadError': 'Unable to load promotion rules.',
    'account.vip.faqLoadError': 'Unable to load FAQ.',
    'account.vip.cashbackHistoryTitle': 'Cashback accrual history',
    'account.vip.cashbackHistoryDesc': 'Cashback for the previous week is credited every Monday until 18:00. We will notify you about the status of your cashback accrual via SMS.',
    'account.vip.cashbackHistoryDate': 'Date',
    'account.vip.cashbackHistoryStatus': 'Status',
    'account.vip.cashbackHistoryAmount': 'Cashback amount',
    'account.vip.cashbackCalculating': 'Calculating',
    'account.vip.pendingCashback': 'This week accrual',
    'common.close': 'Close',
    'appUpdate.title': 'Download update',
    'appUpdate.text': 'to access new features',
    'appUpdate.action': 'Update',
    'account.notifications.readAll': 'Mark all as read',
    'account.notifications.empty': 'No notifications',
    'account.notifications.emptyUnread': 'No unread notifications',
    'account.notifications.filterAll': 'All',
    'account.notifications.filterUnread': 'Unread ({count})',
    'account.notifications.viewAll': 'All notifications',
    'account.notifications.details': 'Details',
    'account.security.current': 'Current password',
    'account.security.enterCurrent': 'Enter current password',
    'account.security.new': 'New password',
    'account.security.saved': 'Password updated',
    'account.responsible.tabDeposit': 'Deposit limits',
    'account.responsible.tabSession': 'Game session limits',
    'account.responsible.depositDescription': 'Set the deposit limit. When the limit is reached, you will not be able to deposit money to your account until the end of the specified period. The limit can be lowered or removed instantly. Increasing a limit requires a 24-hour cooling-off period.',
    'account.responsible.sessionDescription': 'Set the game session limit. Specify the maximum time you can spend playing per day, week or month. When the limit is reached, you will be logged out and will not be able to log in until the end of the specified period. The limit can be lowered or removed instantly. Increasing a limit requires a 24-hour cooling-off period.',
    'account.responsible.currentRestrictions': 'Current restrictions',
    'account.responsible.futureRestrictions': 'Future restrictions',
    'account.responsible.limitNotSet': 'Limit not set',
    'account.responsible.notSet': 'Not set',
    'account.responsible.dailyLimit': 'Daily limit',
    'account.responsible.weeklyLimit': 'Weekly limit',
    'account.responsible.monthlyLimit': 'Monthly limit',
    'account.responsible.hoursShort': 'h',
    'account.responsible.saved': 'Limits updated',
    'account.responsible.timeLimitsTitle': 'Time limits',
    'account.responsible.timeDescription': 'Once the limit ends, you will be logged out of your account and be unable to log in again until the start of the next period.',
    'account.responsible.sessionLimitMinutes': 'Session limit (in minutes)',
    'account.responsible.install': 'Install',
    'account.responsible.confirmTitle': 'Set limit?',
    'account.responsible.confirmRemoveOrLower': 'If you increase the limit, it takes effect after 24 hours. Lowering applies immediately.',
    'account.responsible.confirmTightenImmediately': 'A lower limit will apply immediately after confirmation.',
    'account.responsible.confirmSet': 'Set',
    'account.responsible.confirmCancel': 'Cancel',
    'account.responsible.currentLimits': 'Current limits',
    'account.responsible.sessionLimit': 'Session limit',
    'account.responsible.timeRemaining': 'Time remaining',
    'account.responsible.delete': 'Delete',
    'account.responsible.confirmChangeTitle': 'Are you sure you want to change the limit values?',
    'account.responsible.confirmDeleteTitle': 'Are you sure you want to remove the limit?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Max session time – 1,440 minutes (24 hours)',
    'account.responsible.limitBlocked': 'Session limit reached. You have been logged out.',
    'account.requests.title': 'Requests',
    'account.requests.newRequest': 'New request',
    'account.requests.empty': 'No current requests',
    'account.requests.chooseType': 'Choose request type',
    'account.requests.cancel': 'Cancel',
    'account.requests.sendRequest': 'Send request',
    'account.requests.submit': 'Submit',
    'account.requests.error': 'Could not send request',
    'account.requests.notFound': 'Request type not found',
    'account.requests.type.sport_bet_settlement': 'Sport bet settlement',
    'account.requests.type.casino_bet_settlement': 'Casino bet settlement',
    'account.requests.type.hotline': 'Question about hotline',
    'account.requests.type.deposit': 'Deposit question',
    'account.requests.type.withdrawal': 'Withdrawal question',
    'account.requests.type.website_app': 'Question about using the website or mobile app',
    'account.requests.type.admin': 'Question for the Admin',
    'account.requests.type.verification': 'Verification question',
    'account.requests.type.bonus': 'Bonus question',
    'account.requests.mobile.title': 'Any problems?',
    'account.requests.mobile.desc': 'Create a new request or you can find answers in our Help Centre',
    'account.requests.mobile.create': 'Create a new request',
    'account.requests.mobile.helpCentre': 'Go to the Help Centre',
    'account.requests.group.deposit': 'DEPOSIT QUESTION',
    'account.requests.group.withdrawal': 'WITHDRAWAL QUESTION',
    'account.requests.group.other': 'OTHER',
    'account.requests.template.depositBankCard': 'Bank card',
    'account.requests.template.depositRaschet': '"Raschet" unified payment system',
    'account.requests.template.depositQiwi': 'QIWI terminal',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'Oplati',
    'account.requests.template.withdrawalOplati': 'Oplati',
    'account.requests.template.withdrawalBank': 'Bank card / transfer',
    'account.requests.form.operationDate': 'Operation date and time',
    'account.requests.form.amount': 'Transaction amount',
    'account.requests.form.selectOperationDesc': 'Choose the operation you have a question about',
    'account.requests.form.selectOperationBtn': 'Select operation',
    'account.requests.form.selectedOperation': 'Selected operation',
    'account.requests.form.noOperations': 'No matching operations found',
    'account.requests.form.messagePlaceholder': 'Describe your question or issue',
    'account.requests.form.symbolsRemaining': '{count} symbols remaining',
    'account.requests.form.choose': 'Choose',
    'account.requests.form.dragOrUpload': 'Drag here or upload files',
    'account.requests.form.attachFile': 'Attach file',
    'account.requests.form.attachHint': 'Up to 5 files. Format: jpg, png, pdf, mp4, mov, webm. Images/PDF up to 7 MB, video up to 25 MB.',
    'account.requests.form.attachments': 'Attachments',
    'account.helpCentre.title': 'Help centre',
    'account.helpCentre.text1': 'Here you can find information',
    'account.helpCentre.text2': 'and usage tips',
    'account.helpCentre.faq': 'FAQ',
    'account.helpCentre.instructions': 'Instructions',
    'account.helpCentre.strategies': 'Bet strategies',
    'account.helpCentre.glossary': 'Glossary',
    'account.helpCentre.go': 'Go to Help Centre',
    'account.support.subject': 'Subject',
    'account.support.message': 'Message',
    'account.support.send': 'Send',
    'account.support.sent': 'Your request has been received',
    'account.support.history': 'Previous requests',
    'account.support.status_open': 'Open',
    'account.support.status_closed': 'Closed',
    'account.support.status_pending': 'Pending',
    'account.support.status_waiting': 'Pending',
    'account.support.status_answered': 'Answered',
    'account.support.status_replied': 'Answered',
    'account.support.status_in_progress': 'In progress',
    'account.support.status_resolved': 'Resolved',
    'account.pageTitle': 'My account | VurgunBet',
    'sport.filter.allTime': 'All time',
    'sport.filter.allEvents': 'All Events',
    'sport.filter.live': 'Live',
    'sport.filter.prematch': 'Pre-match',
    'sport.filter.all': 'All',
    'betslip.title': 'Bet slip',
    'betslip.empty': 'Bet slip is empty',
    'betslip.stake': 'Stake',
    'betslip.totalOdds': 'Total odds',
    'betslip.potentialWin': 'Potential win',
    'betslip.place': 'Place bet',
    'betslip.clear': 'Clear',
    'betslip.accepted': 'Bet accepted',
    'betslip.login': 'Log in to place a bet',
    'betslip.emptyHint': 'Select event outcome to place bet',
    'betslip.amount': 'Amount, TL',
    'betslip.promos': 'Promos',
    'betslip.active': 'Active',
    'betslip.popular': 'Popular events',
    'footer.about': 'About us',
    'footer.basinda': 'In the Press',
    'footer.licence': 'Licence',
    'footer.privacy': 'Privacy Policy',
    'footer.responsible': 'Responsible Gaming',
    'footer.rules': 'Terms and Conditions',
    'footer.financial': 'Financial services',
    'footer.vip': 'VIP program',
    'footer.help': 'Help center',
    'footer.payments': 'Payments',
    'footer.company': 'Company details',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Betting shop rules',
    'footer.appCaption': 'Application',
    'footer.appIos': 'for iOS',
    'footer.appIosLong': 'Application for iOS',
    'footer.appAndroidLong': 'Application for Android',
    'footer.appAndroid': 'for Android',
    'footer.appMaintenance': 'Under maintenance',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Gambling is illegal for persons under the age of 18. VurgunBet operates as an international online gaming operator.',
    'footer.legal': 'VurgunBet offers sports betting, slot games, live casino and related gaming products to users aged 18+. Users must comply with legal restrictions applicable in their location.',
    'footer.legal1': 'Gambling is illegal for persons under the age of 18, as well as for persons restricted in visiting gambling establishments and virtual gambling establishments and/or participating in gambling.',
    'footer.legal2': 'VurgunBet offers online sports betting, slot games, live casino and related gaming products. Services may be used only where legally permitted.',
    'help.title': 'Help Centre',
    'help.searchPlaceholder': 'Search your question',
    'help.searchSheetTitle': 'Help centre: search',
    'help.searchSheetDesc': 'Find the answer to your question',
    'help.popularSearches': 'POPULAR SEARCHES',
    'help.popular.identification': 'How to complete identification',
    'help.popular.deposit': 'How to top up your balance',
    'help.popular.win': 'How to get a win',
    'help.askQuestion': 'Ask a question',
    'help.views': 'views',
    'help.back': 'Back',
    'help.noResults': 'No results found',
    'help.goToFaq': 'Go to FAQ',
    'help.instructions': 'Instructions',
    'help.training': 'Training',
    'help.glossary': 'Glossary',
    'help.notFound.code': '404',
    'help.notFound.title': 'Page not found',
    'help.notFound.description': 'Oops! The page you\'re looking for does not exist. It may have been moved or deleted.',
    'help.notFound.home': 'Home',
    'help.feedback.review': 'Write a review',
    'help.feedback.helpful': 'Was this information helpful?',
    'help.feedback.yes': 'Yes, thank you',
    'help.feedback.no': 'No',
    'promos.tab.actions': 'Promos',
    'promos.tab.tournaments': 'Tournaments',
    'promos.tab.actionsDesc': 'Become a champion',
    'promos.tab.tournamentsDesc': 'Join tournaments',
    'promos.tab.actionsTitle': 'Promos',
    'promos.tab.tournamentsTitle': 'Tournaments',
    'promos.tab.bonuses': 'Bonuses',
    'promos.tab.bonusesDesc': 'Track your bonuses',
    'promos.tab.bonusesTitle': 'Your bonuses',
    'promos.tab.promoCode': 'Promo code',
    'promos.tab.promoCodeDesc': 'Activate now',
    'promos.tab.promoCodeTitle': 'Got a promo code?',
    'promos.tournamentsIntro': 'Join tournaments and compete for valuable prizes',
    'promos.filter.all': 'All',
    'promos.filter.sport': 'Sport',
    'promos.filter.casino': 'Casino',
    'promos.timer.ended': 'Ended',
    'promos.timer.daysLeft': 'Left: {count} day(s)',
    'promos.timer.hoursLeft': 'Left: {count} hour(s)',
    'promos.timer.minutesLeft': 'Left: {count} min',
    'promos.tournament.active': 'Active',
    'promos.tournament.bonusFund': 'Bonus fund',
    'promos.tournament.participants': 'Participants',
    'promos.tournament.places': 'Places',
    'promos.tournament.untilCompletion': 'Until completion',
    'promos.tournament.untilStart': 'Until start',
    'promos.tournament.upcoming': 'Upcoming',
    'promos.tournament.startsIn': 'Starts in',
    'promos.tournament.joinWhenLive': 'Join when live',
    'promos.tournament.tab.rating': 'Rating',
    'promos.tournament.tab.terms': 'Terms',
    'promos.tournament.tab.games': 'Games',
    'promos.tournament.col.participant': 'Participant',
    'promos.tournament.col.points': 'Points',
    'promos.tournament.col.bonuses': 'Bonuses',
    'promos.tournament.participate': 'Participate',
    'promos.tournament.optOut': 'Opt Out',
    'promos.tournament.loginToJoin': 'Sign in to join',
    'promos.tournament.promoRules': 'Promotion rules',
    'promos.tournament.questions': 'Still have questions?',
    'promos.tournament.close': 'Close',
    'promos.tournament.loading': 'Loading leaderboard…',
    'promos.tournament.emptyBoard': 'No rankings yet. Be the first to join!',
    'promos.tournament.noTerms': 'Rules will be added soon.',
    'promos.tournament.noGames': 'Eligible games will be listed soon.',
    'promos.tournament.joinedOk': 'You joined the tournament',
    'promos.tournament.leftOk': 'You left the tournament',
    'promos.tournament.actionError': 'Could not complete the action',
    'promos.tournament.working': 'Working…',
    'promos.tournament.gameBadge': 'TOURNAMENT',
    'promos.tournament.showAllGames': 'Show all games',
    'promos.tournament.askQuestion': 'Ask a Question',
    'promos.tournament.faq.participate.q': 'How to participate in the tournament',
    'promos.tournament.faq.participate.a': 'Go to the Tournaments section, open the tournament you want and press the Participate button.',
    'promos.tournament.faq.deposit.q': 'Do I need to make a deposit to participate in the tournament?',
    'promos.tournament.faq.deposit.a': 'No — joining is free. Earn points with real-balance bets (min. 5 TL) on Games-tab slots. Bonus-balance bets do not score.',
    'promos.tournament.faq.multiple.q': 'Can I participate in multiple tournaments at the same time?',
    'promos.tournament.faq.multiple.a': 'Yes. You can join several active tournaments at once; each tournament keeps its own leaderboard.',
    'promos.tournament.faq.terms.q': 'Where can I check tournament terms and conditions?',
    'promos.tournament.faq.terms.a': 'Open the Terms tab in the tournament window or tap Promotion rules to review the full conditions.',
    'promos.tournament.faq.games.q': 'What slot games are included in the tournament?',
    'promos.tournament.faq.games.a': 'Eligible games are listed under the Games tab. Only bets on those games count toward the tournament score.',
    'promos.tournament.faq.bonuses.q': 'What bonuses can I get for participating in and winning tournaments?',
    'promos.tournament.faq.bonuses.a': 'You earn cash and free-spin (FS) prizes by rank. Prizes are credited within 48 hours after the tournament ends; FS stay valid for 7 days and cash prizes only need ×2 wagering.',
    'promos.tournament.faq.timed.q': 'Are tournaments time limited?',
    'promos.tournament.faq.timed.a': 'Yes. VURGUN VAKTİ runs weekly from Monday 11:00 to Sunday 23:59, then auto-renews.',
    'promos.tournament.faq.track.q': 'How can I track my tournament results and progress?',
    'promos.tournament.faq.track.a': 'Open the Rating tab in the tournament window to see your live points and place. Scores update right after real-balance bets.',
    'promos.tournament.faq.more.q': 'I still have questions.',
    'promos.tournament.faq.more.a': 'Tap Ask a Question below to open a support request. Our team will get back to you shortly.',
    'promos.tournament.ask.title': 'New request',
    'promos.tournament.ask.subtitle': 'Bonus question',
    'promos.tournament.ask.placeholder': 'Enter your question or describe the problem',
    'promos.tournament.ask.charsLeft': '{count} characters remaining',
    'promos.tournament.ask.attach': 'Attach file',
    'promos.tournament.ask.attachHint': 'Up to 5 files. Format: jpg, jpeg, png, pdf. Up to 7Mb.',
    'promos.tournament.ask.cancel': 'Cancel',
    'promos.tournament.ask.send': 'Send request',
    'promos.tournament.ask.sending': 'Sending…',
    'promos.tournament.ask.sent': 'Your request was received. We will get back to you shortly.',
    'promos.tournament.ask.loginRequired': 'Sign in to send a request',
    'promos.tournament.ask.error': 'Could not send the request',
    'promos.tournament.terms.periodTitle': 'Weekly tournament period',
    'promos.tournament.terms.pointsTitle': 'Conditions for awarding points',
    'promos.tournament.terms.points1': 'Minimum bet is only 5 TL — joining is free; play with real balance to earn points.',
    'promos.tournament.terms.points2': 'Every 1 TL real-balance bet = 2 points. Friday–Sunday gets a 20% points boost!',
    'promos.tournament.terms.points3': 'All real-balance bets on Games-tab slots are credited instantly. Bonus-balance bets do not count.',
    'promos.tournament.terms.bonusesTitle': 'Bonuses use conditions',
    'promos.tournament.terms.bonuses1': 'Cash and FS prizes are credited within 48 hours after the tournament ends; FS stay valid for 7 days.',
    'promos.tournament.terms.bonuses2': 'Prize winnings only need ×2 wagering — far below industry average.',
    'promos.tournament.terms.bonuses3': 'The tournament auto-renews every Monday at 11:00; the leaderboard resets for a fresh week.',
    'promos.bonuses.title': 'Your bonuses',
    'promos.promocode.title': 'Got a promo code?',
    'promos.promocode.desc': 'Enter your promo code below and select Activate',
    'promos.promocode.placeholder': 'Enter promo code',
    'promos.promocode.activate': 'Activate',
    'promos.promocode.activating': 'Applying…',
    'promos.promocode.success': 'Promo code applied successfully',
    'promos.promocode.error': 'Could not apply promo code',
    'promos.promocode.loginRequired': 'Sign in to redeem a promo code',
    'promos.bonuses.loading': 'Loading your bonuses…',
    'promos.bonuses.empty': 'You have no bonuses yet.',
    'promos.bonuses.emptyCaption': 'No active bonuses',
    'promos.bonuses.emptyDescription': 'Take part in promos and get new bonuses!',
    'promos.bonuses.emptyButton': 'Go to promos',
    'promos.bonuses.emptyArchiveCaption': 'No archived bonuses',
    'promos.bonuses.emptyArchiveDescription': 'Take part in promos and get new bonuses!',
    'promos.bonuses.kindFilterBonuses': 'Bonuses',
    'promos.bonuses.kindFilterFreeSpins': 'Free spins',
    'promos.bonuses.kindFilterAll': 'All',
    'promos.bonuses.kindFreeSpin': 'Free game',
    'promos.bonuses.fieldNominal': 'Nominal',
    'promos.bonuses.fieldStatus': 'Status',
    'promos.bonuses.fieldExpires': 'Expires',
    'promos.bonuses.fieldReceived': 'Received',
    'promos.bonuses.tabActive': 'Active',
    'promos.bonuses.tabArchive': 'Archive',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'Your progress:',
    'promos.bonuses.statusWagering': 'Wagering in progress',
    'promos.bonuses.moreInfo': 'More information',
    'promos.bonuses.detailTitle': 'Bonus activated',
    'promos.bonuses.leftDays': 'left {n} days',
    'promos.bonuses.leftDay': 'left {n} day',
    'promos.bonuses.detailLead': 'Complete the wagering requirement and receive the bonus in your main account',
    'promos.bonuses.placeBets': 'Place bets totaling {amount}',
    'promos.bonuses.rulesTitle': 'BONUS ACCOUNT WAGERING RULES',
    'promos.bonuses.rule1': 'Winnings added to the bonus account balance will become available on the main account after the amount is wagered by a factor of {wagerMult}. Wagering can be completed in all slot games of all casino providers, except for certain slot games as established by the Organiser.',
    'promos.bonuses.rule2': 'When wagering funds from the bonus account balance, funds are first credited from the main account, then from the bonus account balance.',
    'promos.bonuses.rule3': 'When funds are credited from the bonus account balance, winnings are returned to the bonus account balance.',
    'promos.bonuses.rule4': 'After wagering is completed, the remaining amount of the bonus account is transferred to the main balance, but cannot exceed x{maxWithdrawMult} of the amount initially credited to the bonus account balance.',
    'promos.bonuses.rule5': 'The wagering period is {wageringDays} days from the moment when the bonus account is activated.',
    'promos.bonuses.rule6': 'Each subsequent bonus is activated automatically after wagering the previous bonus.',
    'promos.bonuses.rule7': 'If there are funds in the bonus account, the withdrawal of funds from the main account is not available.',
    'promos.bonuses.promotionRules': 'Promotion rules',
    'promos.bonuses.askQuestion': 'Ask question',
    'promos.bonuses.cancelBonus': 'Cancel the bonus',
    'promos.bonuses.cancelConfirm': 'Your bonus balance will be removed and wagering cancelled. Continue?',
    'promos.bonuses.cancelBusy': 'Cancelling…',
    'promos.bonuses.cancelTitle': 'Do you really want to opt out?',
    'promos.bonuses.cancelBody': 'In case of refusal, the bonuses will be burned.\nYou can cancel at any time.',
    'promos.bonuses.cancelRefuse': 'I want to refuse',
    'promos.bonuses.cancelBack': 'Convinced! Back',
    'promos.bonuses.askClose': 'Close',
    'promos.bonuses.askFileBadType': 'Unsupported file format.',
    'promos.bonuses.askFileTooBig': 'File is larger than 7Mb.',
    'promos.bonuses.askError': 'Could not send request',
    'promos.bonuses.askSent': 'Your request has been sent.',
    'promos.bonuses.askSending': 'Sending…',
    'promos.bonuses.askSend': 'Send request',
    'promos.bonuses.askCancel': 'Cancel',
    'promos.bonuses.askFilesSize': 'Up to 7Mb.',
    'promos.bonuses.askFilesMax': 'Up to 5 files.',
    'promos.bonuses.askAttach': 'Attach file',
    'promos.bonuses.askCharsLeft': '{n} characters remaining',
    'promos.bonuses.askPlaceholder': 'Enter your question or describe the problem',
    'promos.bonuses.askNewRequest': 'New request',
    'promos.bonuses.askBonusQuestion': 'Bonus question',
    'promos.bonuses.askHint': 'Send a question about your bonus to support',
    'promos.bonuses.fieldWagering': 'Wagering',
    'promos.bonuses.fieldWageringTime': 'Wagering time',
    'promos.bonuses.fieldMaxWithdrawal': 'Max. withdrawal',
    'promos.bonuses.fieldUsed': 'Used',
    'promos.bonuses.statusAvailable': 'Available',
    'promos.bonuses.statusUsed': 'Used',
    'promos.bonuses.activate': 'Activate',
    'promos.bonuses.days': 'days',
    'promos.bonuses.games': 'Games',
    'promos.bonuses.noGames': 'No game info',
    'promos.bonuses.play': 'Play',
    'home.showcase.slots.title': 'Casino',
    'home.showcase.slots.count': '{count} games',
    'home.showcase.slots.link': 'View games →',
    'home.showcase.live.title': 'Live-casino',
    'home.showcase.live.count': '{count} games',
    'home.showcase.live.link': 'Play now →',
    'home.showcase.tv.title': 'TV-games',
    'home.showcase.tv.count': '{count} games',
    'home.showcase.fast.title': 'Fast games',
    'home.showcase.fast.count': '{count} games',
    'home.showcase.fast.link': 'Play now →',
    'home.showcase.virtual.title': 'Virtual sports',
    'home.showcase.virtual.count': '{count} games',
    'home.showcase.virtual.link': 'Play now →',
    'home.showcase.gamesCount': '{count} games',
    'home.showcase.tv.link': 'Play now →',
    'home.showcase.sport.title': 'Sport',
    'home.showcase.sport.count': '3380 events',
    'home.showcase.sport.link': 'Bet now →',
    'home.promo.category.promotions': 'Promotions',
    'home.promo.category.tournaments': 'Tournaments',
    'home.promo.filter.all': 'All',
    'home.promo.filter.sport': 'Sport (5)',
    'home.promo.filter.casino': 'Casino (5)',
    'home.promo.showAll': 'Show all →',
    'home.promo.allPromotions': 'All promotions',
    'home.promo.cta.play': 'Play',
    'home.promo.cta.join': 'Join',
    'home.promo.cta.details': 'Details',
    'home.promo.cta.signup': 'Sign Up',
    'home.sport.searchEvents': 'Search by events',
    'footer.contactUs': 'Contact us',
    'footer.usefulInfo': 'Useful information',
    'footer.socialMedia': 'Social media',
    'footer.partners': 'Official Partner',
    'footer.officialPartner': 'Official\nPartner',
    'home.casino.loading': 'Loading games…',
    'home.casino.noGames': 'No games available',
    'home.casino.viewAllMobile': 'View {count} games',
    'home.shuffle.title': 'Not sure what game to play next?',
    'home.shuffle.cta': 'Spin now',
    'home.shuffle.modalTitle': 'Let us find the perfect game for you!',
    'home.shuffle.respin': 'Spin again',
    'home.shuffle.close': 'Close',
    'home.jackpot.casinoTitle': 'Casino Jackpot',
    'home.jackpot.title': 'VURGUN GRAND JACKPOT',
    'home.jackpot.badgeRest': 'GRAND JACKPOT',
    'home.jackpot.winners': 'Total winners: {count}',
    'home.jackpot.largest': 'Largest win',
    'home.jackpot.last': 'Last win',
    'home.jackpot.onSlots': 'On all slots',
    'home.jackpot.play': 'Jackpot games',
    'home.liveWins.title': 'Live wins',
    'home.liveWins.heated': 'Vurgun',
    'home.topWins.title': 'Top wins',
    'home.topWins.week': 'This week',
    'home.topWins.month': 'This month',
    'home.topWins.day': 'Today',
    'home.topWins.dailyTitle': 'Daily Top Winners',
    'home.topWins.monthlyTitle': 'Monthly Top Winners',
    'home.topWins.myPrevious': 'My Previous',
    'home.topWins.play': 'Play',
    'home.topWins.prev': 'Previous',
    'home.topWins.next': 'Next',
    'home.liveCasino.subtitle': '',
    'home.liveCasino.filterPopular': 'Popular',
    'home.liveCasino.filterAll': 'All',
    'home.liveCasino.filterRoulette': 'Roulette',
    'home.liveCasino.filterBlackjack': 'Blackjack',
    'home.liveCasino.filterBaccarat': 'Baccarat',
    'home.liveCasino.filterGameShows': 'Oyun Şovları',
    'home.liveCasino.filterPoker': 'Poker',
    'home.popularSlots.title': 'Popular Slots',
    'home.hotSlots.title': 'Top Earners',
    'home.hotSlots.badge': 'HOT',
    'home.matchCarousel.title': 'Matches',
    'home.matchCarousel.liveTv': 'Live TV',
    'home.slotsCarousel.showAll': 'Show all',
    'home.slotsCarousel.prev': 'Previous',
    'home.slotsCarousel.next': 'Next',
    'home.jackpot.grand': 'GRAND',
    'home.jackpot.major': 'MAJOR',
    'home.jackpot.minor': 'MINOR',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Club',
    'home.heroSide.vipSub': 'Exclusive perks',
    'home.heroSide.promosTitle': 'Bonuses',
    'home.heroSide.promosSub': 'Latest promos',
    'home.heroSide.sportTitle': 'Sport',
    'home.heroSide.sportSub': 'Live betting',
    'header.support': 'Support',
    'home.topEvents.showAll': 'Show all',
    'betslip.bonusFund': 'Bonus fund',
    'betslip.participants': '{count} participants',
    'betslip.hoursLeft': '{hours} hours left',
    'betslip.details': 'Details',
    'casino.viewAllCaption': 'View all →',
    'casino.bside.promos': 'Promos',
    'casino.bside.showAll': 'Show all →',
    'casino.lobby.slots': 'Slots',
    'casino.lobby.live': 'Live-casino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'TV-games',
    'casino.lobby.fast': 'Fast games',
    'casino.lobby.virtual': 'Virtual sports',
    'casino.tab.review': 'Review',
    'casino.tab.favourites': 'Favourites',
    'casino.tab.top': 'Top games',
    'casino.tab.peter': 'Peter & Sons Hits',
    'casino.tab.free-spins': 'With free spins',
    'casino.tab.all': 'All games',
    'casino.tab.tournaments': 'Tournaments',
    'casino.tab.jackpot-cards': 'Jackpot Cards',
    'casino.tab.new': 'NEW',
    'casino.tab.world-cup': 'World Cup 2026',
    'casino.tab.buy-bonus': 'Buy Bonus',
    'casino.tab.exclusive': 'Exclusive',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Pragmatic Play',
    'casino.tab.coins-link-vip': 'Coins Link VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'Cascade',
    'casino.tab.megaways': 'Megaways',
    'casino.tab.collect': 'Collect',
    'casino.tab.wild': 'Wild',
    'casino.tab.double': 'Double chance',
    'casino.tab.megax': 'Mega X',
    'casino.tab.respin': 'Respin',
    'casino.tab.retro': 'Retro',
    'casino.tab.fruits': 'Fruits',
    'casino.tab.books': 'Books',
    'casino.tab.fast-football': 'Fast Football',
    'casino.tab.holdem': 'Hold\'em',
    'casino.tab.caribbean': 'Caribbean',
    'casino.tab.video-poker': 'Video Poker',
    'casino.tab.crash': 'Crash games',
    'casino.tab.table-games': 'Table games',
    'casino.tab.mines': 'Mines',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Dice',
    'casino.tab.scratch': 'Scratch games',
    'casino.tab.other': 'Other',
    'casino.tab.football': 'Football',
    'casino.tab.horse-racing': 'Horse Racing',
    'casino.tab.recommended': 'Recommended',
    'casino.topProviders': 'Best Providers',
    'casino.groupsAll': 'All',
    'casino.groupsNew': 'New Games',
    'casino.groupsTop': 'Best games',
    'casino.groupsFavourites': 'Favorites',
    'casino.groupsLastPlayed': 'Last played',
    'casino.groupsBonusBuy': 'Bonus buy',
    'casino.groupsMultipliers': 'High multipliers',
    'casino.groupsJackpot': 'Jackpot',
    'casino.groupsAllGames': 'All games',
    'casino.groupsBellLink': 'Bell Link',
    'casino.groupsAmusnet': 'Amusnet',
    'casino.groupsVipTables': 'VIP tables',
    'casino.groupsRoulette': 'Roulette',
    'casino.groupsBlackjack': 'Blackjack',
    'casino.groupsBaccarat': 'Baccarat',
    'casino.groupsGameShows': 'Oyun Şovları',
    'casino.groupsPokerLive': 'Poker',
    'casino.groupsSicBo': 'Sic Bo',
    'casino.topOfWeek': 'Top games of the week',
    'casino.tab.vip-tables': 'VIP tables',
    'casino.tab.roulette': 'Roulette',
    'casino.tab.blackjack': 'Blackjack',
    'casino.tab.baccarat': 'Baccarat',
    'casino.tab.game-shows': 'Oyun Şovları',
    'casino.tab.poker-live': 'Poker',
    'casino.tab.sic-bo': 'Sic Bo',
    'casino.emptyFavorites': 'No favorite games yet',
    'casino.emptyLastPlayed': 'No recently played games',
    'casino.tab.lastplayed': 'Last played',
    'casino.tab.vip-egt': 'Bell Link',
    'casino.groupsWager': 'For wagering',
    'casino.groupsFreebonus': 'For freebonus',
    'casino.lobbyHome': 'Lobby Home',
    'casino.groups': 'Groups',
    'casino.providers': 'Providers',
    'casino.search': 'Search',
    'casino.play': 'Play',
    'casino.demo': 'Demo',
    'casino.searchModal.title': 'Search',
    'casino.searchModal.placeholder': 'Search games',
    'casino.filters': 'Filters',
    'casino.filtersCount': 'Filters ({count})',
    'casino.filter.section.functions': 'Functions',
    'casino.filter.section.themes': 'Themes',
    'casino.filter.bonusGame': 'Bonus Game',
    'casino.filter.buyFeature': 'Buy Feature',
    'casino.filter.expandingSymbols': 'Expanding Symbols',
    'casino.filter.freeSpins': 'Free Spins',
    'casino.filter.multiplier': 'Multiplier',
    'casino.filter.respins': 'Respins',
    'casino.filter.symbolsCollection': 'Symbols Collection',
    'casino.filter.animals': 'Animals',
    'casino.filter.books': 'Books',
    'casino.filter.classic777': 'Classic & 777',
    'casino.filter.coins': 'Coins',
    'casino.filter.egypt': 'Egypt',
    'casino.filter.fruits': 'Fruits',
    'casino.filter.gods': 'Gods',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'All providers',
    'casino.selectProvider': 'Select provider',
    'casino.searchProviders': 'Search providers',
    'casino.loading': 'Loading games…',
    'casino.noGames': 'No games found',
    'casino.lucky': 'I\'m lucky',
    'casino.sortBy': 'Sort by',
    'casino.sort.popular': 'Most Popular',
    'casino.sort.default': 'Default',
    'casino.sort.az': 'A to Z',
    'casino.sort.za': 'Z to A',
    'casino.sort.new': 'Newest',
    'casino.sort.provider': 'By provider',
    'casino.sort.name': 'By name',
    'casino.showMore': 'Show more',
    'casino.viewAll': 'View all',
    'casino.games': 'games',
    'casino.side.games': 'Games',
    'casino.side.tournament': 'Tournament',
    'casino.side.search': 'Search games',
    'casino.side.recommended': 'Recommended games',
    'casino.side.noGames': 'No games found',
    'casino.side.noTournaments': 'No active tournaments',
    'casino.side.loading': 'Loading…',
    'casino.game.play': 'Play',
    'casino.game.demo': 'Demo',
    'casino.game.favorite': 'Add to favorites',
    'casino.game.fullscreen': 'Fullscreen',
    'casino.game.noFreeSpins': 'No free spins to add to this game',
    'casino.game.linkCopied': 'Link copied',
    'casino.game.closeConfirmTitle': 'Close game?',
    'casino.game.closeConfirmText': 'The game will close. Do you want to continue?',
    'casino.game.closeConfirmOk': 'Close',
    'casino.game.closeConfirmCancel': 'Cancel',
    'casino.game.popout': 'Open in new window',
    'casino.game.playReal': 'Play for real money',
    'casino.game.addFreeSpins': 'Add free spins',
    'casino.game.addFreeSpinsToGame': 'Add free spins to game',
    'casino.game.fsBet': 'Bet',
    'casino.game.fsExpiresIn': 'Expires in',
    'casino.game.fsAdd': 'Add',
    'casino.game.fsBackToGame': 'Back to game',
    'casino.game.fsNewAvailable': 'New free spins available',
    'casino.game.fsUpdateRequired': 'Game update required',
    'casino.game.fsUpdate': 'Update',
    'casino.game.insufficientBalance': 'Insufficient balance',
    'casino.game.insufficientBalanceHint': 'Top up your balance to play for real money',
    'casino.game.insufficientContinue': 'Continue',
    'casino.game.makeDeposit': 'Make a deposit',
    'casino.game.bonusInsufficientHint': 'Your bonus balance is too low for this bet. Switching to cash will cancel the current bonus.',
    'casino.game.switchToCash': 'Switch to cash',
    'casino.game.demoMode': 'Demo mode',
    'casino.game.signIn': 'Sign in to play for real money.',
    'casino.game.tryDemo': 'Try demo',
    'casino.game.loading': 'Loading game…',
    'casino.game.notFound': 'Game not found',
    'casino.game.launchFailed': 'Could not start the game',
    'casino.game.demoUnavailable': 'Demo is not available for this game.',
    'casino.game.unavailable': 'This game cannot be started right now. Please try again later.',
    'casino.game.demoSuffix': '(Demo)',
    'casino.badge.top': 'En İyi',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Tournament',
    'casino.badge.new': 'NEW',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'exclusive',
    'casino.badge.jackpot': 'jackpot',
    'casino.bside.tournaments': 'Tournaments',
  },
  de: {
    'nav.home': 'Startseite',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Sport',
    'nav.sportLive': 'Live-Wetten',
    'nav.liveCasino': 'Live-Casino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slots',
    'nav.virtual': 'Virtueller Sport',
    'nav.fast': 'Schnellspiele',
    'nav.tv': 'TV-Spiele',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Live-Spielübertragungen ansehen',
    'vtv.live': 'Live',
    'vtv.upcoming': 'Demnächst',
    'vtv.search': 'Suche',
    'vtv.searchPh': 'Teams, Ligen suchen…',
    'vtv.allSports': 'Alle Sportarten',
    'vtv.loading': 'Streams werden geladen…',
    'vtv.empty': 'Keine Spiele verfügbar',
    'vtv.error': 'Streams konnten nicht geladen werden',
    'vtv.pick': 'Wähle ein Spiel zum Ansehen',
    'vtv.streamError': 'Stream konnte nicht geöffnet werden',
    'vtv.liveBadge': 'LIVE',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'NEU',
    'nav.newGames': 'Neue Spiele',
    'nav.newPromos': 'Neue Aktionen',
    'nav.promos': 'Aktionen',
    'nav.casino': 'Casino',
    'nav.apps': 'Apps',
    'nav.results': 'Ergebnisse',
    'header.promos': 'Aktionen',
    'header.help': 'Hilfe',
    'header.search': 'Suchen',
    'header.settings': 'Einstellungen',
    'header.login': 'Anmelden',
    'header.join': 'Registrieren',
    'header.logout': 'Abmelden',
    'header.account': 'Mein Konto',
    'header.deposit': 'Einzahlen',
    'header.hideBalance': 'Guthaben ausblenden',
    'header.showBalance': 'Guthaben anzeigen',
    'header.notifications': 'Benachrichtigungen',
    'mobile.menu': 'Speisekarte',
    'mobile.home': 'Startseite',
    'mobile.myBets': 'Meine Wetten',
    'mobile.navigation': 'Navigation',
    'mobile.menu.loginTitle': 'Melden Sie sich bei Ihrem Konto an',
    'mobile.menu.loginText': 'um vollen Zugriff auf alle Serviceoptionen zu erhalten',
    'mobile.menu.tournaments': 'Turniere',
    'mobile.menu.helpNote': 'FAQ, Lernen, Wörterbuch',
    'mobile.menu.appsNote': 'Für Android, iOS',
    'mobile.menu.about': 'Über VurgunBet',
    'mobile.menu.aboutNote': 'Informationen, Lizenzen',
    'basinda.title': 'In der Presse',
    'basinda.lead': 'Momente von VurgunBet Stadion- und Spielfeldsponsoring.',
    'basinda.menuNote': 'Sponsoring, Presse',
    'basinda.item1': 'Sassuolo - Pisa',
    'basinda.item2': 'Turin – Atalanta',
    'basinda.item3': 'Alaves - Elche',
    'basinda.item4': 'Levante – Alaves',
    'basinda.item5': 'Fenerbahçe - Pogon Stettin',
    'mobile.menu.siteTour': 'Besichtigung vor Ort',
    'mobile.menu.siteTourText': 'dauert nur 2 Minuten →',
    'mobile.menu.history': 'Verlauf anzeigen',
    'mobile.menu.historyEmpty': 'Noch kein Browserverlauf',
    'mobile.menu.historyEmptyText': 'Hier finden Sie alle Rubriken und Sportveranstaltungen, die Sie sich angesehen haben',
    'mobile.menu.clearHistory': 'Klare Geschichte',
    'mobile.menu.openPromos': 'Aktionen',
    'mobile.menu.searchGames': 'Suchspiele',
    'mobile.menu.responsibleGaming': 'Verantwortungsvolles Spielen',
    'mobile.account.number': 'Konto: {id}',
    'mobile.account.copy': 'Kontonummer kopieren',
    'mobile.account.copied': 'Kopiert',
    'mobile.account.balance': 'Guthaben: {amount}',
    'settings.section.sport': 'Sport',
    'settings.section.casino': 'Casino',
    'settings.section.interface': 'Schnittstelle',
    'settings.section.navigation': 'Navigation',
    'settings.eventDisplay': 'Ereignisdarstellung',
    'settings.eventDisplay.table': 'Tisch',
    'settings.eventDisplay.list': 'Liste',
    'settings.betSlipLocation': 'Standort des Wettscheins',
    'settings.betSlipLocation.bottom': 'Im unteren Bereich',
    'settings.betSlipLocation.above': 'Über der Tafel',
    'settings.betSlipSettings': 'Wettscheineinstellungen',
    'settings.betSlip.showLiveTimer': 'Live-Event-Timer im Wettschein anzeigen',
    'settings.betSlip.showEventTime': 'Zeigen Sie die Veranstaltungszeit und das Startdatum im Wettschein an',
    'settings.betSlip.skipClearConfirm': 'Bitten Sie nicht um eine Bestätigung, um Wettscheine einzulösen',
    'settings.betSlip.view': 'Wettscheinansicht',
    'settings.betSlip.view.auto': 'Automatische Auswahl',
    'settings.betSlip.view.narrow': 'Eng',
    'settings.betSlip.view.wide': 'Breit',
    'settings.odds.title': 'Quote',
    'settings.odds.boosted': 'Erhöht',
    'settings.odds.on': 'An',
    'settings.odds.off': 'aus',
    'settings.odds.hideBoosted': 'Im Sportbereich werden keine erhöhten Quoten angezeigt',
    'settings.odds.european': 'europäisch',
    'settings.odds.american': 'amerikanisch',
    'settings.odds.hongkong': 'Hongkong',
    'settings.odds.indonesian': 'Indonesisch',
    'settings.odds.malaysian': 'malaysisch',
    'settings.favouriteSports': 'Lieblingssport',
    'settings.favouriteSports.empty': 'Keiner',
    'settings.favouriteSports.desc': 'Fügen Sie Lieblingssportarten hinzu, um sie zuerst im Abschnitt „Sport“ anzuzeigen.',
    'settings.casinoProMode': 'Pro-Modus',
    'settings.casinoProMode.desc': 'Zeigen Sie die Volatilität des Slots und andere Werte auf der Spielkarte an',
    'settings.casinoView.standard': 'Standardansicht',
    'settings.casinoView.pro': 'Pro-Modus',
    'settings.theme.title': 'Website-Thema',
    'settings.theme.auto': 'Auto',
    'settings.theme.light': 'Licht',
    'settings.theme.dark': 'Dunkel',
    'settings.hideBalance': 'Guthaben ausblenden',
    'settings.hideBalance.desc': 'Wischen Sie über Ihr Guthaben in der Kopfzeile, um es auszublenden',
    'settings.showUpButton': 'Schaltfläche „Nach oben“ anzeigen',
    'settings.language': 'Sprache',
    'settings.nav.sportSection': 'In der Rubrik Sport',
    'settings.nav.casinoSection': 'Im Casino-Bereich',
    'settings.nav.menu': 'Im Menü',
    'settings.title': 'Website-Einstellungen',
    'settings.reset': 'Standardmäßig zurückkehren',
    'settings.betSlip.title': 'Wettschein',
    'settings.nav.betAcceptance': 'Wettannahme',
    'settings.nav.cashOut': 'Auszahlung',
    'settings.nav.favouriteBets': 'Lieblingswetten',
    'settings.nav.betSlip': 'Wettscheinansicht',
    'settings.navigation.auto': 'Auto',
    'settings.navigation.left': 'Auf der linken Seite',
    'settings.navigation.top': 'Spitze',
    'settings.eventList.title': 'Veranstaltungsliste',
    'settings.eventList.minimised': 'Alle Ereignisse werden standardmäßig minimiert',
    'settings.eventPage.title': 'Veranstaltungsseite',
    'settings.view.large': 'Große Ansicht',
    'settings.view.compact': 'Kompaktansicht',
    'settings.favouriteSports.descLong': 'Fügen Sie Ihre Lieblingssportarten hinzu, um sie zuerst im Abschnitt „Sport“ anzuzeigen. Sie können ihre Reihenfolge ändern, indem Sie sie ziehen',
    'settings.favouriteSports.hint': 'Drücken Sie ★, um die Sportart zu Ihren Favoriten hinzuzufügen',
    'settings.sport.football': 'Fußball',
    'settings.sport.hockey': 'Eishockey',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basketball',
    'settings.sport.esports': 'Esport',
    'settings.sport.tableTennis': 'Tischtennis',
    'settings.sport.volleyball': 'Volleyball',
    'settings.sport.handball': 'Handball',
    'settings.sport.mixFights': 'Mischen. Kämpfe',
    'settings.sport.boxing': 'Boxen',
    'settings.sport.futsal': 'Futsal',
    'settings.sport.baseball': 'Baseball',
    'settings.sport.americanFootball': 'American Football',
    'settings.sport.rugby': 'Rugby',
    'settings.sport.waterPolo': 'Wasserball',
    'settings.sport.fieldHockey': 'Hockey',
    'settings.sport.racing': 'Rennen',
    'settings.sport.cycling': 'Radfahren',
    'settings.sport.sports': 'Sport',
    'settings.sport.beachSoccer': 'Strandfußball',
    'settings.sport.basketball3x3': 'Basketball 3x3',
    'settings.sport.lacrosse': 'Lacrosse',
    'settings.sport.australianFootball': 'Australischer Fußball',
    'settings.sport.cricket': 'Kricket',
    'settings.sport.snooker': 'Snooker',
    'settings.sport.darts': 'Darts',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet – Online-Sportwetten',
    'auth.login.title': 'Anmelden',
    'auth.login.submit': 'Anmelden',
    'auth.login.link': 'Anmelden',
    'auth.register.title': 'Registrieren',
    'auth.register.bannerHighlight': '100 % BIS ZU',
    'auth.register.bannerTitle': 'BONUS +100 FREISPIELE',
    'auth.register.bannerDesc': '+5 FREE BETS',
    'auth.register.perkFast': 'Anonym',
    'auth.register.perkSafe': 'Keine Gebühren',
    'auth.register.perkBonus': 'VPN-freundlich',
    'auth.register.orSignUpWith': 'ODER ANMELDEN MIT',
    'auth.login.orSignInWith': 'ODER MELDEN SIE SICH AN MIT',
    'auth.webauthn.login': 'Melden Sie sich mit Face ID/Touch ID an',
    'auth.webauthn.offerTitle': 'Speichern Sie Face ID auf diesem Gerät',
    'auth.webauthn.offerBody': 'Beim nächsten Mal können Sie sich schnell mit Face ID, Touch ID oder Windows Hello anmelden.',
    'auth.webauthn.offerConfirm': 'Sparen Sie auf diesem Gerät',
    'auth.webauthn.offerSkip': 'Nicht jetzt',
    'auth.webauthn.needRegister': 'Speichern Sie zunächst Face ID / Touch ID in Ihrem Profil',
    'auth.webauthn.failed': 'Die biometrische Anmeldung ist fehlgeschlagen',
    'auth.webauthn.unsupported': 'Face ID/Touch ID ist auf diesem Gerät nicht verfügbar',
    'auth.webauthn.registerFailed': 'Die biometrische Anmeldung konnte nicht gespeichert werden',
    'auth.webauthn.alreadyRegistered': 'Dieses Gerät ist bereits registriert',
    'auth.webauthn.thisDevice': 'Dieses Gerät',
    'auth.webauthn.manageTitle': 'Gesichts-ID / Touch-ID',
    'auth.webauthn.manageDesc': 'Registrieren Sie einen Passkey, um sich mit Face ID, Touch ID oder Windows Hello auf diesem Gerät anzumelden.',
    'auth.webauthn.empty': 'Keine biometrischen Anmeldungen gespeichert',
    'auth.webauthn.add': 'Sparen Sie auf diesem Gerät',
    'auth.webauthn.remove': 'Entfernen',
    'auth.webauthn.removed': 'Passkey entfernt',
    'auth.webauthn.registered': 'Biometrische Anmeldung gespeichert',
    'auth.webauthn.loadFailed': 'Passschlüssel konnten nicht geladen werden',
    'auth.webauthn.removeFailed': 'Der Hauptschlüssel konnte nicht entfernt werden',
    'account.profile.tab.passkeys': 'Gesichts-ID / Touch-ID',
    'account.profile.mobile.passkeys': 'Gesichts-ID / Touch-ID',
    'account.profile.mobile.passkeysHint': 'Schnelle Anmeldung',
    'auth.register.socialNotConfigured': 'Diese Methode ist noch nicht konfiguriert',
    'auth.register.pageTitle': 'Registrierung | VurgunBet',
    'auth.register.submit': 'Registrieren',
    'auth.register.link': 'Registrieren',
    'guestPopup.title': 'Free bet 100 TL + 300 free spins',
    'guestPopup.subtitle': 'für Neukunden',
    'guestPopup.cta': 'Anmeldung',
    'language.choose': 'Sprache wählen',
    'auth.register.slogan': 'NÄHER AM SPIEL',
    'auth.register.smsHint': 'Der SMS-Code wird an diese Nummer gesendet',
    'auth.register.promoToggle': 'Ich habe einen Promo-Code',
    'auth.register.rules': 'Ich bin 18 Jahre alt und akzeptiere die Allgemeinen Geschäftsbedingungen und Datenschutzbestimmungen *',
    'auth.register.rulesBefore': 'Ich bin 18 Jahre alt und akzeptiere das',
    'auth.register.termsLink': 'Geschäftsbedingungen',
    'auth.register.rulesAnd': 'Und',
    'auth.register.privacyLink': 'Datenschutzrichtlinie',
    'auth.register.rulesAfter': ' *',
    'auth.register.rulesLink': 'Geschäftsbedingungen',
    'auth.register.rulesRequired': 'Sie müssen die Allgemeinen Geschäftsbedingungen und Datenschutzbestimmungen akzeptieren',
    'auth.register.serviceMail': 'Ich bin damit einverstanden, Service-Newsletter zu erhalten.',
    'auth.register.serviceMail2': 'Sie können die Richtlinie zur Verarbeitung personenbezogener Daten lesen',
    'auth.register.here': 'Hier',
    'auth.register.adMail': 'Ich stimme dem zu',
    'auth.register.adTerms': 'Bedingungen der Werbemailingliste',
    'auth.register.adTermsLink': 'Bedingungen',
    'auth.register.adTermsSuffix': 'der Werbemailingliste',
    'auth.register.serviceMailSuffix': '.',
    'auth.register.fullPromotionTerms': 'Vollständige Aktionsbedingungen',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Geben Sie Ihre Telefonnummer ein',
    'auth.validation.phoneOrEmailRequired': 'Geben Sie E-Mail oder Telefon ein',
    'auth.validation.phoneInvalid': 'Geben Sie eine gültige Telefonnummer ein',
    'auth.validation.phoneExists': 'Diese Telefonnummer ist bereits registriert',
    'auth.validation.emailRequired': 'Geben Sie Ihre E-Mail-Adresse ein',
    'auth.validation.emailInvalid': 'Geben Sie eine gültige E-Mail-Adresse ein',
    'auth.validation.emailDomainInvalid': 'Verwenden Sie eine gültige E-Mail (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com usw.)',
    'auth.validation.emailExists': 'Diese E-Mail ist bereits registriert',
    'auth.validation.passwordRequired': 'Geben Sie Ihr Passwort ein',
    'auth.validation.passwordShort': 'Das Passwort muss mindestens 8 Zeichen lang sein',
    'auth.validation.registerFailed': 'Die Registrierung ist fehlgeschlagen. Bitte versuchen Sie es erneut.',
    'auth.validation.loginFieldsRequired': 'Füllen Sie alle Felder aus',
    'auth.validation.loginInvalid': 'Falscher Login oder Passwort',
    'auth.validation.accountRequired': 'Geben Sie Ihre Kontonummer ein',
    'auth.validation.accountShort': 'Die Kontonummer muss mindestens 6 Zeichen lang sein',
    'auth.validation.codeInvalid': 'Falscher Bestätigungscode',
    'auth.validation.codeRequired': 'Geben Sie den Bestätigungscode ein',
    'auth.validation.codeSendFailed': 'Code konnte nicht gesendet werden',
    'auth.validation.codeThrottled': 'Bitte warten Sie, bevor Sie einen weiteren Code anfordern',
    'auth.validation.challengeExpired': 'Die Verifizierung ist abgelaufen. Bitte melden Sie sich erneut an',
    'auth.validation.serverUnreachable': 'Server ist nicht erreichbar. Führen Sie npm run dev:server im Terminal aus.',
    'auth.validation.serverError': 'Fehler bei der Anmeldung. Überprüfen Sie den Server und die Datenbank.',
    'auth.tab.phone': 'Telefon',
    'auth.tab.email': 'E-Mail',
    'auth.tab.username': 'Benutzername',
    'auth.tab.account': 'Konto',
    'auth.label.phone': 'Telefonnummer',
    'auth.label.phoneOptional': 'Mobiltelefon (optional)',
    'auth.label.email': 'E-Mail',
    'auth.label.username': 'Benutzername',
    'auth.label.account': 'Kontonummer',
    'auth.label.password': 'Passwort',
    'auth.label.promo': 'Aktionscode',
    'auth.placeholder.account': 'Kontonummer',
    'auth.placeholder.username': 'Benutzername',
    'auth.forgot': 'Passwort vergessen?',
    'auth.noAccount': 'Sie haben noch kein Konto?',
    'auth.haveAccount': 'Sie haben bereits ein Konto?',
    'auth.login.pageTitle': 'Anmelden | VurgunBet',
    'auth.verify.info': 'Um Ihr Konto zu schützen, müssen wir sicherstellen, dass es sich wirklich um Sie handelt.',
    'auth.verify.caption': 'Bestätigungscode abrufen:',
    'auth.verify.methodPhone': 'Wir senden den Code per SMS oder per Telegram an Ihre Telefonnummer {contact}',
    'auth.verify.methodEmail': 'Wir senden den Code per E-Mail an {contact}',
    'auth.verify.getCode': 'Code abrufen',
    'auth.verify.cancel': 'Abbrechen',
    'auth.verify.noAccess': 'Ich habe keinen Zugriff auf die Telefonnummer',
    'auth.verify.enterCode': 'Bestätigungscode eingeben:',
    'auth.verify.confirm': 'Bestätigen',
    'auth.verify.continue': 'Weiter',
    'auth.verify.codeInfoPhone': 'Geben Sie den Bestätigungscode ein. Wir haben es per SMS oder per Telegram an Ihre Telefonnummer {contact} gesendet.',
    'auth.verify.codeInfoEmail': 'Geben Sie den Bestätigungscode ein. Wir haben es per E-Mail an {contact} gesendet.',
    'auth.verify.neverReceived': 'Ich habe nie einen Code erhalten',
    'auth.verify.resend': 'Code erneut senden',
    'auth.verify.noAccessEmail': 'Ich habe keinen Zugriff auf E-Mail',
    'auth.verify.help.title': 'Wenn kein Bestätigungscode eingetroffen ist',
    'auth.verify.help.bodyPhone': 'Stellen Sie sicher, dass die Telefonnummer korrekt ist und Ihr Gerät über genügend freien Speicher verfügt. Überprüfen Sie, ob die Nachricht im Spam-Ordner gelandet ist.',
    'auth.verify.help.bodyEmail': 'Stellen Sie sicher, dass die E-Mail-Adresse korrekt ist. Überprüfen Sie, ob die Nachricht im Spam-Ordner gelandet ist.',
    'auth.verify.help.step1': 'Öffnen Sie die Nachrichten-App',
    'auth.verify.help.step2': 'Drücken Sie die Schaltfläche in der oberen rechten Ecke',
    'auth.verify.help.step3': 'Wählen Sie „Spam und blockiert“',
    'auth.verify.help.understood': 'Verstanden',
    'auth.recover.title': 'Passwortwiederherstellung',
    'auth.recover.pageTitle': 'Passwortwiederherstellung | VurgunBet',
    'auth.recover.continue': 'Weiter',
    'auth.recover.noAccess': 'Ich habe keinen Zugriff auf Telefonnummer/E-Mail',
    'auth.recover.noAccessPhone': 'Ich habe keinen Zugriff auf die Telefonnummer',
    'auth.recover.noAccessEmail': 'Ich habe keinen Zugriff auf E-Mail',
    'auth.recover.newPassword': 'Neues Passwort',
    'auth.recover.confirmPassword': 'Bestätigen Sie das neue Passwort',
    'auth.recover.passwordMismatch': 'Passwörter stimmen nicht überein',
    'auth.recover.save': 'Passwort speichern',
    'auth.recover.success': 'Ihr Passwort wurde aktualisiert. Sie können sich mit Ihrem neuen Passwort anmelden.',
    'auth.recover.notFound': 'Mit diesen Angaben wurde kein Konto gefunden',
    'auth.verify.expiredTitle': 'Die für diesen Vorgang vorgesehene Zeit ist abgelaufen.',
    'auth.verify.retry': 'Wiederholen',
    'welcome.stepLabel': 'Schritt 1 von 3: Registrierung',
    'welcome.title': 'Holen Sie sich einen Willkommensbonus von bis zu 100 TL + 300 FS!',
    'welcome.step1.title': 'Registrieren',
    'welcome.step1.sub': 'Auf der Website oder in der App',
    'welcome.step2.title': 'Schließen Sie die Verifizierung ab',
    'welcome.step2.sub': 'Es dauert nur ein paar Minuten',
    'welcome.step3.title': 'Machen Sie eine Einzahlung',
    'welcome.step3.sub': 'Größere Einzahlung – größerer Bonus!',
    'welcome.start': 'Start',
    'welcome.rules': 'Vollständige Aktionsbedingungen',
    'account.loading': 'Laden...',
    'account.save': 'Speichern',
    'account.empty': 'Keine Datensätze gefunden',
    'account.nav.overview': 'Überblick',
    'account.nav.profile': 'Persönliche Daten',
    'account.nav.verification': 'Überprüfung',
    'account.nav.cashier': 'Kasse',
    'account.nav.bets': 'Meine Wetten',
    'account.nav.bonuses': 'Boni',
    'account.nav.notifications': 'Benachrichtigungen',
    'account.nav.security': 'Sicherheit',
    'account.nav.support': 'Support',
    'account.menu.profile': 'Mein Profil',
    'account.menu.payments': 'Ein- und Auszahlungen',
    'account.menu.history': 'Wett- und Transaktionsverlauf',
    'account.menu.requests': 'Anfragen',
    'account.menu.responsible': 'Verantwortungsvolles Spielen',
    'account.menu.vip': 'Ihr VIP-Status',
    'support.liveChat': 'Live-Support',
    'account.menu.deposit': 'Machen Sie eine Einzahlung',
    'account.overview.title': 'Kontozusammenfassung',
    'account.overview.balance': 'Guthaben',
    'account.overview.bonusBalance': 'Bonusguthaben',
    'account.overview.accountNo': 'Konto-Nr.',
    'account.overview.verification': 'Überprüfung',
    'account.overview.totalBets': 'Gesamteinsätze',
    'account.profile.name': 'Vollständiger Name',
    'account.profile.saved': 'Ihre Angaben wurden gespeichert',
    'account.profile.marketingEmail': 'Ich möchte Werbe-E-Mails erhalten',
    'account.profile.marketingSms': 'Ich möchte Werbe-SMS erhalten',
    'account.profile.tab.details': 'Persönliche Daten',
    'account.profile.tab.phone': 'Telefonnummer ändern',
    'account.profile.tab.phoneAdd': 'Telefonnummer hinzufügen',
    'account.profile.tab.phoneVerify': 'Telefonnummer überprüfen',
    'account.profile.tab.email': 'E-Mail ändern',
    'account.profile.tab.emailAdd': 'E-Mail hinzufügen',
    'account.profile.tab.emailVerify': 'E-Mail bestätigen',
    'account.profile.tab.password': 'Kennwort ändern',
    'account.profile.section.personal': 'PERSÖNLICHE DATEN',
    'account.profile.section.lastLogin': 'LETZTE LOGIN-INFORMATIONEN',
    'account.profile.section.contacts': 'KONTAKTE',
    'account.profile.section.marketing': 'KONTAKTEINSTELLUNGEN',
    'account.profile.field.name': 'Name:',
    'account.profile.field.verification': 'Status der Identitätsüberprüfung:',
    'account.profile.field.accountNo': 'Kontonummer:',
    'account.profile.field.currency': 'Währung:',
    'account.profile.field.phone': 'Telefonnummer:',
    'account.profile.field.email': 'E-Mail:',
    'account.profile.field.time': 'Zeit:',
    'account.profile.field.ip': 'IP-Adresse:',
    'account.profile.change': 'Ändern',
    'account.profile.add': 'Hinzufügen',
    'account.profile.status.verified': 'Verifiziert',
    'account.profile.status.unverified': 'Nicht bestätigt',
    'account.profile.marketingIntro': 'Erhalten Sie Benachrichtigungen über Aktionen und Neuigkeiten:',
    'account.profile.marketing.email': 'E-Mail',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Push-Benachrichtigungen',
    'account.profile.marketing.web': 'Website-Benachrichtigungen',
    'account.profile.verification.basic': 'Nicht bestätigt',
    'account.profile.verification.verified': 'Verifiziert',
    'account.profile.verification.pending': 'Ausstehend',
    'account.profile.verify': 'Verifizieren',
    'account.profile.tab.kyc': 'Identitätsprüfung',
    'account.profile.kyc.title': 'Identitätsprüfung',
    'account.profile.kyc.intro': 'Reichen Sie Ihre Personalausweisnummer, Stadt, Adresse und Ausweisfotos ein. Ihr Konto wird nach der Überprüfung verifiziert.',
    'account.profile.kyc.tcLabel': 'Nationale ID-Nummer',
    'account.profile.kyc.tcInvalid': 'Geben Sie eine gültige 11-stellige nationale ID-Nummer ein',
    'account.profile.kyc.cityLabel': 'Stadt',
    'account.profile.kyc.cityPlaceholder': 'Wählen Sie eine Stadt aus',
    'account.profile.kyc.cityRequired': 'Stadtauswahl ist erforderlich',
    'account.profile.kyc.addressLabel': 'Adresse',
    'account.profile.kyc.addressHint': 'Geben Sie Ihre vollständige Adresse ein. Bearbeiten Sie es, wenn es falsch ist.',
    'account.profile.kyc.addressRequired': 'Die Adresse muss mindestens 5 Zeichen lang sein',
    'account.profile.kyc.frontLabel': 'Ausweis vorne',
    'account.profile.kyc.frontHint': 'Laden Sie ein Foto der Vorderseite Ihres Ausweises hoch',
    'account.profile.kyc.backLabel': 'Ausweis zurück',
    'account.profile.kyc.backHint': 'Laden Sie ein Foto der Rückseite Ihres Ausweises hoch',
    'account.profile.kyc.photoRequired': 'Ein Lichtbild auf der Vorderseite des Personalausweises ist erforderlich',
    'account.profile.kyc.backRequired': 'Ein Lichtbild auf der Rückseite des Personalausweises ist erforderlich',
    'account.profile.kyc.submit': 'Einreichen',
    'account.profile.kyc.submitted': 'Ihre Verifizierungsanfrage ist eingegangen und wird derzeit überprüft',
    'account.profile.kyc.pendingMessage': 'Ihre Verifizierungsanfrage wird derzeit geprüft. Sie können keine neuen Dokumente einreichen, bis das Problem geklärt ist.',
    'account.profile.kyc.alreadyVerified': 'Ihr Konto ist bereits verifiziert.',
    'account.profile.todayAt': 'Heute um',
    'account.profile.mobile.personalData': 'Persönliche Daten',
    'account.profile.mobile.aboutAccount': 'Über Konto',
    'account.profile.mobile.passwordChange': 'Passwortänderung',
    'account.profile.next': 'Nächste',
    'account.profile.changeEmailTitle': 'Neue E-Mail-Adresse',
    'account.profile.changePhoneTitle': 'Neue Telefonnummer',
    'account.profile.addEmailTitle': 'E-Mail-Adresse hinzufügen',
    'account.profile.addPhoneTitle': 'Telefonnummer hinzufügen',
    'account.profile.verifyEmailTitle': 'E-Mail-Adresse bestätigen',
    'account.profile.verifyPhoneTitle': 'Telefonnummer überprüfen',
    'account.profile.contactSupport': 'Bitte wenden Sie sich an den Support, um Ihre Daten zu ändern.',
    'account.profile.contactSupportAddPhone': 'Erstellen Sie eine Supportanfrage, um eine Telefonnummer hinzuzufügen.',
    'account.profile.contactSupportChangePhone': 'Erstellen Sie eine Supportanfrage, um Ihre Telefonnummer zu ändern.',
    'account.profile.contactSupportVerifyPhone': 'Erstellen Sie eine Supportanfrage, um Ihre Telefonnummer zu bestätigen.',
    'account.profile.contactSupportAddEmail': 'Erstellen Sie eine Supportanfrage, um eine E-Mail-Adresse hinzuzufügen.',
    'account.profile.contactSupportChangeEmail': 'Erstellen Sie eine Supportanfrage, um Ihre E-Mail-Adresse zu ändern.',
    'account.profile.step.support': 'Erstellen Sie eine Supportanfrage',
    'account.profile.step.sharePhone': 'Teilen Sie Ihre Telefonnummer mit',
    'account.profile.step.shareNewPhone': 'Teilen Sie Ihre neue Telefonnummer mit',
    'account.profile.step.requestVerify': 'Senden Sie Ihre Verifizierungsanfrage',
    'account.profile.step.confirmSms': 'Bestätigen Sie mit dem SMS-Code',
    'account.profile.step.shareEmail': 'Teilen Sie Ihre E-Mail-Adresse',
    'account.profile.step.shareNewEmail': 'Teilen Sie Ihre neue E-Mail-Adresse',
    'account.profile.step.confirmEmail': 'Vollständige E-Mail-Bestätigung',
    'account.profile.contactSupportBtn': 'Kontaktieren Sie den Support',
    'account.profile.otp.addPhoneHint': 'Geben Sie Ihre Telefonnummer ein. Wir senden Ihnen einen Bestätigungscode per SMS.',
    'account.profile.otp.changePhoneHint': 'Geben Sie Ihre neue Telefonnummer ein. Die Änderung wird mit einem SMS-Code bestätigt.',
    'account.profile.otp.verifyPhoneHint': 'Wir senden Ihnen einen Code zur Verifizierung Ihrer Telefonnummer.',
    'account.profile.otp.addEmailHint': 'Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Bestätigungscode per E-Mail.',
    'account.profile.otp.verifyEmailHint': 'Wir senden Ihnen einen Code zur Verifizierung Ihrer E-Mail-Adresse.',
    'account.profile.otp.changeEmailHint': 'Geben Sie Ihre neue E-Mail-Adresse ein. Die Änderung wird mit einem E-Mail-Code bestätigt.',
    'account.profile.otp.codeSentPhone': 'Wir haben einen Bestätigungscode gesendet an:',
    'account.profile.otp.codeSentEmail': 'Wir haben einen Bestätigungscode gesendet an:',
    'account.profile.otp.codeSent': 'Bestätigungscode gesendet',
    'account.profile.otp.codeLabel': 'Bestätigungscode',
    'account.profile.otp.resend': 'Code erneut senden',
    'account.profile.otp.phoneRequired': 'Telefonnummer ist erforderlich',
    'account.profile.otp.emailRequired': 'E-Mail-Adresse ist erforderlich',
    'account.profile.otp.codeRequired': 'Ein Bestätigungscode ist erforderlich',
    'account.profile.otp.sessionMissing': 'Verifizierungssitzung nicht gefunden',
    'account.profile.otp.saved': 'Ihre Kontaktdaten wurden aktualisiert',
    'account.profile.passwordConfirm': 'Bestätigen Sie das neue Passwort',
    'account.profile.passwordRequired': 'Füllen Sie alle Passwortfelder aus',
    'account.profile.passwordMismatch': 'Neue Passwörter stimmen nicht überein',
    'account.profile.passwordSame': 'Das neue Passwort darf nicht mit Ihrem aktuellen Passwort identisch sein',
    'account.profile.send': 'Schicken',
    'account.profile.passwordHint': 'Verwenden Sie den Sicherheitsbereich, um Ihr Passwort zu ändern.',
    'account.verification.desc': 'Für Auszahlungen und vollständigen Kontozugriff ist eine Identitätsprüfung erforderlich.',
    'account.verification.verified': 'Verifiziert',
    'account.verification.pending': 'Ausstehend',
    'account.verification.rejected': 'Abgelehnt',
    'account.verification.step1': 'Laden Sie ein Foto Ihres Reisepasses oder Personalausweises hoch',
    'account.verification.step2': 'Fügen Sie ein Selfie hinzu, das das Dokument hält',
    'account.verification.step3': 'Die Überprüfung wird in der Regel innerhalb von 24 Stunden abgeschlossen',
    'account.verification.submit': 'Verifizierung starten',
    'account.verification.submitted': 'Ihre Unterlagen werden geprüft',
    'account.cashier.deposit': 'Einzahlen',
    'account.cashier.withdraw': 'Auszahlen',
    'account.cashier.amount': 'Betrag (TL)',
    'account.cashier.balance': 'Aktueller Kontostand: {amount}',
    'account.cashier.history': 'Transaktionsverlauf',
    'account.cashier.type': 'Typ',
    'account.cashier.date': 'Datum',
    'account.payments.title': 'Ein- und Auszahlungen',
    'account.payments.back': 'Zurück',
    'account.payments.selectMethod': 'Wählen Sie eine Methode aus',
    'account.payments.group.havale': 'Überweisung',
    'account.payments.group.card': 'Kreditkarte',
    'account.payments.group.crypto': 'Krypto',
    'account.payments.group.other': 'Sonstige',
    'account.payments.noMethods': 'Derzeit sind keine Zahlungsmethoden verfügbar.',
    'account.payments.from': 'von {amount} TL',
    'account.payments.depositTitle': 'Guthaben aufladen mit {method}',
    'account.payments.withdrawTitle': 'Abheben mit {method}',
    'account.payments.depositNotice': 'Aufmerksamkeit! Die Bankkarte muss auf den Namen des Kontoinhabers registriert sein. Zahlungen mit Karten Dritter werden abgelehnt.',
    'account.payments.withdrawNotice': 'Auszahlungsanfragen werden entsprechend Ihrem Verifizierungsstatus bearbeitet.',
    'account.payments.addAmount': 'Einzahlen',
    'account.payments.withdrawSubmit': '{amount} TL abheben',
    'account.payments.requests': 'Ihre Wünsche',
    'account.payments.insufficientBalance': 'Unzureichendes Gleichgewicht',
    'account.payments.minWithdrawNotice': 'Erforderlicher Mindestbetrag zum Abheben von Gewinnen: {amount}',
    'account.payments.withdrawGoDeposit': 'Einzahlen',
    'account.payments.selectAnotherMethod': 'Wählen Sie eine andere Methode',
    'account.payments.requestsTitle': 'Transaktionsanfragen',
    'account.payments.requestsEmpty': 'Sie haben noch keine Transaktionsanfragen.',
    'account.payments.filterAll': 'Alle',
    'account.payments.filterCompleted': 'Vollendet',
    'account.payments.filterProcessing': 'Verarbeitung',
    'account.payments.filterCancelled': 'Abgesagt',
    'account.payments.colNumber': 'NUMMER',
    'account.payments.colDate': 'DATUM',
    'account.payments.colType': 'TYP',
    'account.payments.colMethod': 'VERFAHREN',
    'account.payments.colAmount': 'MENGE',
    'account.payments.status': 'Status',
    'account.payments.status_completed': 'Vollendet',
    'account.payments.status_pending': 'Ausstehend',
    'account.payments.status_processing': 'Verarbeitung',
    'account.payments.status_cancelled': 'Abgesagt',
    'account.payments.status_rejected': 'Abgelehnt',
    'account.payments.status_failed': 'Fehlgeschlagen',
    'account.payments.status_approved': 'Genehmigt',
    'account.payments.status_expired': 'Abgelaufen',
    'account.payments.goToRequests': 'Meine Wünsche',
    'account.payments.method.crypto': 'Krypto',
    'account.payments.method.maxhavale': 'Max Havale',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Geschwindigkeit Havale',
    'account.payments.havalespeed.depositPending': 'Schließen Sie Ihre Speed ​​Havale-Einzahlung ab',
    'account.payments.havalespeed.withdrawPending': 'Ihre Speed ​​Havale-Auszahlung wird bearbeitet',
    'account.payments.havalespeed.processing': 'Übrige Zeit',
    'account.payments.havalespeed.confirmPaid': 'Ich habe umgezogen, benachrichtigen',
    'account.payments.havalespeed.confirming': 'Benachrichtigung wird gesendet…',
    'account.payments.havalespeed.confirmSent': 'Benachrichtigung erhalten. Warten auf Genehmigung.',
    'account.payments.havalespeed.cancelDeposit': 'Anfrage abbrechen',
    'account.payments.havalespeed.cancelling': 'Stornieren…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Vollständiger Name',
    'account.payments.havale.amountLabel': 'Betrag',
    'account.payments.havalespeed.approvedHint': '{amount} wurde Ihrem Guthaben hinzugefügt.',
    'account.payments.havalespeed.approvedHintGeneric': 'Ihre Einzahlung wurde genehmigt und Ihrem Guthaben hinzugefügt.',
    'account.payments.havalespeed.rejectedHint': 'Ihre Speed ​​Havale-Anfrage wurde abgelehnt. Sie können eine neue Einzahlung versuchen.',
    'account.payments.maxhavale.depositPending': 'Schließen Sie Ihre Max Havale-Einzahlung ab',
    'account.payments.maxhavale.withdrawPending': 'Ihre Max Havale-Auszahlung wird bearbeitet',
    'account.payments.maxhavale.processing': 'Übrige Zeit',
    'account.payments.maxhavale.cancelDeposit': 'Anfrage abbrechen',
    'account.payments.maxhavale.cancelling': 'Stornieren…',
    'account.payments.maxhavale.openPayment': 'Einzahlungsseite öffnen',
    'account.payments.maxhavale.urlMissing': 'Zahlungsdetails konnten nicht geladen werden. Sie können diese Anfrage abbrechen und es erneut versuchen.',
    'account.payments.maxhavale.bankName': 'Bank',
    'account.payments.havaleBtq.depositPending': 'Schließen Sie Ihre Havale-Einzahlung ab',
    'account.payments.havaleBtq.withdrawPending': 'Ihre Havale-Auszahlung wird bearbeitet',
    'account.payments.havaleBtq.processing': 'Übrige Zeit',
    'account.payments.havaleBtq.cancelDeposit': 'Anfrage abbrechen',
    'account.payments.havaleBtq.cancelling': 'Stornieren…',
    'account.payments.havaleBtq.openPayment': 'Einzahlungsseite öffnen',
    'account.payments.havaleBtq.urlMissing': 'Zahlungsdetails konnten nicht geladen werden.',
    'account.payments.havaleBtq.bankName': 'Bank',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'PayUrus-Wallet-ID',
    'account.payments.payurus.walletName': 'Name des Wallet-Inhabers',
    'account.payments.payurus.openPayment': 'Einzahlungsseite erneut öffnen',
    'account.payments.payurus.reopenPayment': 'Einzahlungsseite erneut öffnen',
    'account.payments.payurus.urlMissing': 'Der Link zur Zahlungsseite konnte nicht geladen werden. Sie können diese Anfrage abbrechen und es erneut versuchen.',
    'account.payments.payurus.cancelDeposit': 'Anfrage abbrechen',
    'account.payments.payurus.cancelling': 'Stornieren…',
    'account.payments.payurus.depositPending': 'Schließen Sie Ihre PayUrus-Zahlung ab',
    'account.payments.payurus.withdrawPending': 'Ihre PayUrus-Auszahlung wird bearbeitet',
    'account.payments.payurus.processing': 'Übrige Zeit',
    'account.payments.payurus.depositSuccess': 'Zahlung erfolgreich',
    'account.payments.payurus.depositSuccessHint': '{amount} wurde Ihrem Guthaben hinzugefügt.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Ihre {provider}-Einzahlung wurde Ihrem Guthaben hinzugefügt.',
    'account.payments.payurus.depositProcessing': 'Zahlungsabwicklung',
    'account.payments.payurus.depositProcessingHint': 'Ihre {provider}-Zahlung wird überprüft. Bitte warten.',
    'account.payments.payurus.depositFailed': 'Die Zahlung ist fehlgeschlagen',
    'account.payments.payurus.depositFailedHint': 'Ihre {provider}-Zahlung konnte nicht abgeschlossen werden. Sie können eine neue Einzahlung versuchen.',
    'account.payments.payurus.continue': 'Weiter',
    'account.payments.payurus.nameMismatch': 'Ihr Vor- und Nachname stimmen nicht überein',
    'account.payments.payurus.nameMismatchDetail': 'Der Name des Kontoinhabers stimmt nicht mit dem vom Anbieter zurückgegebenen Namen überein. PayUrus-Kontoinhaber: {name}',
    'account.payments.payurus.rateLimit': 'Eine weitere Auszahlung auf dieses Wallet ist noch nicht erlaubt',
    'account.payments.payurus.rateLimitDetail': 'PayUrus begrenzt, wie oft Sie auf dieselbe Wallet abheben können. Bitte versuchen Sie es später noch einmal.',
    'account.payments.payurus.walletInvalid': 'Die PayUrus-Wallet-Details konnten nicht überprüft werden',
    'account.payments.payurus.walletInvalidDetail': 'Bitte überprüfen Sie die Wallet-ID oder den Namen des Wallet-Inhabers und versuchen Sie es erneut.',
    'account.payments.method.oplati': 'Papara',
    'account.payments.method.raschet': 'Zahlungssystem «Raschet»',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'Nationaler Ausweis (TC)',
    'account.payments.havale.firstName': 'Vorname',
    'account.payments.havale.lastName': 'Nachname',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Bank',
    'account.payments.havale.transferTo': 'Überweisen Sie auf das untenstehende Konto',
    'account.payments.havale.accountName': 'Kontoname',
    'account.payments.havale.copyIban': 'Kopie',
    'account.payments.havale.copyName': 'Kopie',
    'account.payments.havale.copyAmount': 'Kopierbetrag',
    'account.payments.havale.copyBank': 'Bank kopieren',
    'account.payments.havale.copied': 'Kopiert',
    'account.payments.havale.countdown': 'Übrige Zeit',
    'account.payments.havale.activeNotice': 'Sie haben eine aktive Anfrage. Bis der Timer abgelaufen ist, kann kein neues erstellt werden.',
    'account.payments.havale.amountDue': 'Einzuzahlender Betrag',
    'account.payments.havale.waitNew': 'Warten Sie, bis Sie eine neue Anfrage erstellen',
    'account.payments.havale.resultApproved': 'Anzahlung genehmigt',
    'account.payments.havale.resultApprovedHint': '{amount} wurde Ihrem Guthaben hinzugefügt.',
    'account.payments.havale.resultRejected': 'Anzahlung abgelehnt',
    'account.payments.havale.resultRejectedHint': 'Ihre Anfrage wurde nicht genehmigt. Sie können es noch einmal versuchen.',
    'account.payments.havale.resultExpired': 'Anfrage abgelaufen',
    'account.payments.havale.resultExpiredHint': 'Das Zahlungsfenster {provider} ist beendet. Sie können eine neue Anfrage erstellen.',
    'account.payments.havale.withdrawReceived': 'Auszahlungsantrag erhalten',
    'account.payments.havale.withdrawReceivedHint': 'Ihre Auszahlung von {amount} ist eingegangen und wird derzeit geprüft.',
    'account.payments.havale.withdrawApproved': 'Rückzug genehmigt',
    'account.payments.havale.withdrawApprovedHint': 'Ihre Auszahlung von {amount} ist abgeschlossen.',
    'account.payments.havale.withdrawRejected': 'Widerruf abgelehnt',
    'account.payments.havale.withdrawRejectedHint': 'Ihre Auszahlung wurde nicht genehmigt. Bei Bedarf können Sie eine neue Anfrage erstellen.',
    'account.payments.havale.tryAgain': 'Versuchen Sie es erneut',
    'account.payments.crypto.selectCoin': 'Wählen Sie Kryptowährung aus',
    'account.payments.crypto.selectNetwork': 'Netzwerk auswählen',
    'account.payments.crypto.network': 'Netzwerk',
    'account.payments.crypto.selectedNetwork': 'Ausgewähltes Netzwerk',
    'account.payments.crypto.networkWarning': 'Senden Sie nur im {network}-Netzwerk. Über das falsche Netzwerk gesendete Gelder können verloren gehen.',
    'account.payments.crypto.coin': 'Münze',
    'account.payments.crypto.depositAddress': 'Einzahlungsadresse',
    'account.payments.crypto.copyAddress': 'Adresse kopieren',
    'account.payments.crypto.yourAddress': 'Ihre Wallet-Adresse',
    'account.payments.crypto.estimated': 'Geschätzter Betrag',
    'account.payments.crypto.txHashOptional': 'TX-Hash (optional)',
    'account.payments.crypto.submitTxHash': 'Senden Sie den TX-Hash',
    'account.payments.crypto.continueToWallet': 'Einzahlungsadresse anzeigen',
    'account.payments.crypto.txHashError': 'Der TX-Hash konnte nicht gespeichert werden',
    'account.payments.crypto.confirmations': 'Netzwerkbestätigungen',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': 'von {amount}',
    'account.cashier.amountUsd': 'Betrag (USD)',
    'account.payments.addAmountUsd': 'Anzahlung {amount}',
    'account.payments.crypto.activeNotice': 'Senden Sie Ihre Überweisung. Netzwerkbestätigungen werden automatisch verfolgt; Saldoaktualisierungen, wenn erforderliche Bestätigungen vorliegen.',
    'account.payments.crypto.noAssets': 'Derzeit sind keine aktiven Krypto-Netzwerke vorhanden. Bitte versuchen Sie es später noch einmal.',
    'account.bets.stake': 'Einsatz',
    'account.bets.odds': 'Quote',
    'account.bets.win': 'Gewinnen',
    'account.bets.status': 'Status',
    'account.bets.status_pending': 'Ausstehend',
    'account.bets.status_won': 'Gewonnen',
    'account.bets.status_lost': 'Verloren',
    'account.history.tabBets': 'Wetten',
    'account.history.tabTransactions': 'Transaktionsverlauf',
    'account.history.filters': 'Filter',
    'account.history.filterGroupBetType': 'Wettart',
    'account.history.filterGroupResult': 'Wettergebnisse',
    'account.history.filterBetType_all': 'Alle',
    'account.history.filterBetType_bets': 'Wetten',
    'account.history.filterBetType_slot': 'Slot-Spiel',
    'account.history.filterBetType_dice_live': 'Würfelspiel im Live-Modus',
    'account.history.filterBetType_card_live': 'Kartenspiel im Live-Modus',
    'account.history.filterBetType_cylinder_live': 'Roulette-Spiel im Live-Modus',
    'account.history.filterBetType_online_game': 'Online-Spiel des Buchmachers',
    'account.history.filterResult_all': 'Alle',
    'account.history.filterResult_not_settled': 'Nicht geklärt',
    'account.history.filterResult_win': 'Gewinnen',
    'account.history.filterResult_loss': 'Verlust',
    'account.history.filterResult_cashed_out': 'Ausgezahlt',
    'account.history.filterResult_void': 'Leere',
    'account.history.filterResult_return': 'Zurückkehren',
    'account.history.colDate': 'DATUM',
    'account.history.colTime': 'ZEIT',
    'account.history.colBetNo': 'WETTE №',
    'account.history.colCoupon': 'COUPON',
    'account.history.colStake': 'EINSATZ',
    'account.history.colPotential': 'POTENZIAL',
    'account.history.details': 'Details',
    'account.history.colTransactionNo': 'TRANSAKTION №',
    'account.history.colNumber': 'NUMMER',
    'account.history.colTransaction': 'TRANSAKTION',
    'account.history.colAmountBonuses': 'BETRAG / BONI',
    'account.history.colBalanceBonuses': 'GUTHABEN / BONI',
    'account.history.operation_deposit': 'Einzahlen',
    'account.history.operation_deposit_pending': 'Warten auf die Einzahlungsbestätigung',
    'account.history.operation_withdrawal_pending': 'Warten auf Auszahlungsbestätigung',
    'account.history.operation_withdrawal_cancelled': 'Auszahlung storniert',
    'account.history.operation_withdrawal_rejected': 'Widerruf abgelehnt',
    'account.history.operation_withdrawal_approved': 'Rückzug genehmigt',
    'account.history.operation_withdrawal_completed': 'Auszahlung abgeschlossen',
    'account.history.operation_bet_placed': 'Wette platziert',
    'account.history.operation_bet_settled': 'Wette entschieden',
    'account.history.operation_bet_lost': 'Wette verloren',
    'account.history.operation_slot_bet_settled': 'Wette auf Slot-Spiel abgerechnet',
    'account.history.operation_slot_bet_placed': 'Wette auf Slot-Spiel platziert',
    'account.history.operation_accrual_bonus_account': 'Gutschrift auf Bonuskonto',
    'account.history.operation_close_bonus_account': 'Bonuskonto schließen',
    'account.history.operation_bonus_conversion': 'Bonusumwandlung',
    'account.history.filterOperation_close_bonus_account': 'Bonuskonto schließen',
    'account.history.filterOperation_accrual_bonus_account': 'Gutschrift auf Bonuskonto',
    'account.history.filterOperation_slot_bet_settled': 'Wette auf Slot-Spiel abgerechnet',
    'account.history.filterOperation_slot_bet_placed': 'Wette auf Slot-Spiel platziert',
    'account.history.filterOperation_withdrawal_cancelled': 'Auszahlung storniert',
    'account.history.filterOperation_withdrawal_rejected': 'Widerruf abgelehnt',
    'account.history.filterOperation_withdrawal_approved': 'Rückzug genehmigt',
    'account.history.filterOperation_withdrawal_completed': 'Auszahlung abgeschlossen',
    'account.history.filterOperation_withdrawal_pending': 'Warten auf Auszahlungsbestätigung',
    'account.history.filterOperation_bonus_conversion': 'Bonusumwandlung',
    'account.history.filterOperation_bet_lost': 'Wette verloren',
    'account.history.filterOperation_bet_placed': 'Wette platziert',
    'account.history.filterOperation_bet_settled': 'Wette entschieden',
    'account.history.filterOperation_deposit': 'Einzahlen',
    'account.history.filterOperation_deposit_pending': 'Warten auf die Einzahlungsbestätigung',
    'account.history.colBetType': 'WETTYP',
    'account.history.colType': 'TYP',
    'account.history.colDescription': 'BESCHREIBUNG',
    'account.history.colOdds': 'CHANCEN',
    'account.history.colResult': 'ERGEBNIS',
    'account.history.colAmount': 'MENGE',
    'account.history.colStatus': 'STATUS',
    'account.history.betTypeSlot': 'Slot-Spiel',
    'account.history.betTypeSportsbook': 'Sportwetten',
    'account.history.betTypeSingle': 'Einzel',
    'account.history.betTypeExpress': 'Äußern',
    'account.history.result_pending': 'Nicht geklärt',
    'account.history.result_won': 'Gewinnen',
    'account.history.result_lost': 'Verlust',
    'account.history.result_completed': 'Vollendet',
    'account.history.betsEmpty': 'Sie haben noch keinen Wettverlauf.',
    'account.history.transactionsEmpty': 'Sie haben noch keinen Transaktionsverlauf.',
    'account.bonuses.welcomeTitle': 'Willkommensbonus',
    'account.bonuses.welcomeDesc': 'Verpassen Sie keine Bonusangebote für Ihre erste Einzahlung.',
    'account.bonuses.viewPromos': 'Sonderangebote ansehen',
    'account.bonuses.freeSpinsTitle': 'Deine kostenlosen Spiele',
    'account.bonuses.freeSpinsEmpty': 'Sie haben noch keine kostenlosen Spiele.',
    'account.bonuses.viewFreeSpins': 'Sehen Sie sich meine Boni an',
    'account.vip.title': 'VIP Cashback',
    'account.vip.subtitleLine1': 'Nutzen Sie Ihre Privilegien',
    'account.vip.subtitleLine2': 'und jede Woche Cashback erhalten!',
    'account.vip.yourStatus': 'Ihr Status',
    'account.vip.yourCashback': 'Ihr Cashback',
    'account.vip.promotionRules': 'Werberegeln',
    'account.vip.stillQuestions': 'Sie haben noch Fragen?',
    'account.vip.cardCashbackFreeAndBonus': 'Cashback in free bets und in Boni',
    'account.vip.cardCashbackBonusOnly': 'Cashback in Boni',
    'account.vip.cardCashbackTail': 'bis zu',
    'account.vip.tierCashbackDesc': '{metal} – Cashback in free bets und in Boni bis zu {percent} %',
    'account.vip.fromAmount': 'aus',
    'account.vip.betAmountWeeks': 'Wettbetrag für 4 Wochen',
    'account.vip.yourStatusBadge': 'IHR VIP-STATUS',
    'account.vip.targetStatus': 'SOLL-STATUS',
    'account.vip.cashbackLabel': 'CASHBACK',
    'account.vip.needToBet': 'Sie müssen wetten',
    'account.vip.totalSettled': 'Gesamtzahl der abgerechneten Wetten',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback free bets für Sportwetten, Boni – für Wetten in Casino-Slot-Spielen',
    'account.vip.prev': 'Vorherige',
    'account.vip.next': 'Nächste',
    'account.vip.rulesLoadError': 'Werberegeln können nicht geladen werden.',
    'account.vip.faqLoadError': 'FAQ konnte nicht geladen werden.',
    'account.vip.cashbackHistoryTitle': 'Cashback-Rückstellungshistorie',
    'account.vip.cashbackHistoryDesc': 'Der Cashback für die Vorwoche wird jeden Montag bis 18:00 Uhr gutgeschrieben. Wir benachrichtigen Sie per SMS über den Status Ihrer Cashback-Ansammlung.',
    'account.vip.cashbackHistoryDate': 'Datum',
    'account.vip.cashbackHistoryStatus': 'Status',
    'account.vip.cashbackHistoryAmount': 'Cashback-Betrag',
    'account.vip.cashbackCalculating': 'Berechnen',
    'account.vip.pendingCashback': 'Diese Woche Rückstellung',
    'common.close': 'Schließen',
    'appUpdate.title': 'Update herunterladen',
    'appUpdate.text': 'um auf neue Funktionen zuzugreifen',
    'appUpdate.action': 'Aktualisieren',
    'account.notifications.readAll': 'Alle als gelesen markieren',
    'account.notifications.empty': 'Keine Benachrichtigungen',
    'account.notifications.emptyUnread': 'Keine ungelesenen Benachrichtigungen',
    'account.notifications.filterAll': 'Alle',
    'account.notifications.filterUnread': 'Ungelesen ({count})',
    'account.notifications.viewAll': 'Alle Benachrichtigungen',
    'account.notifications.details': 'Details',
    'account.security.current': 'Aktuelles Passwort',
    'account.security.enterCurrent': 'Geben Sie das aktuelle Passwort ein',
    'account.security.new': 'Neues Passwort',
    'account.security.saved': 'Passwort aktualisiert',
    'account.responsible.tabDeposit': 'Einzahlungslimits',
    'account.responsible.tabSession': 'Limits für Spielsitzungen',
    'account.responsible.depositDescription': 'Legen Sie das Einzahlungslimit fest. Wenn das Limit erreicht ist, können Sie bis zum Ende des angegebenen Zeitraums kein Geld auf Ihr Konto einzahlen. Das Limit kann sofort gesenkt oder aufgehoben werden. Die Erhöhung eines Limits erfordert eine 24-stündige Bedenkzeit.',
    'account.responsible.sessionDescription': 'Legen Sie das Spielsitzungslimit fest. Geben Sie die maximale Zeit an, die Sie pro Tag, Woche oder Monat mit Spielen verbringen können. Wenn das Limit erreicht ist, werden Sie abgemeldet und können sich bis zum Ende des angegebenen Zeitraums nicht mehr anmelden. Das Limit kann sofort gesenkt oder aufgehoben werden. Die Erhöhung eines Limits erfordert eine 24-stündige Bedenkzeit.',
    'account.responsible.currentRestrictions': 'Aktuelle Einschränkungen',
    'account.responsible.futureRestrictions': 'Zukünftige Einschränkungen',
    'account.responsible.limitNotSet': 'Limit nicht festgelegt',
    'account.responsible.notSet': 'Nicht festgelegt',
    'account.responsible.dailyLimit': 'Tageslimit',
    'account.responsible.weeklyLimit': 'Wöchentliches Limit',
    'account.responsible.monthlyLimit': 'Monatliches Limit',
    'account.responsible.hoursShort': 'H',
    'account.responsible.saved': 'Grenzwerte aktualisiert',
    'account.responsible.timeLimitsTitle': 'Fristen',
    'account.responsible.timeDescription': 'Sobald das Limit abgelaufen ist, werden Sie von Ihrem Konto abgemeldet und können sich erst zu Beginn des nächsten Zeitraums wieder anmelden.',
    'account.responsible.sessionLimitMinutes': 'Sitzungslimit (in Minuten)',
    'account.responsible.install': 'Installieren',
    'account.responsible.confirmTitle': 'Limit setzen?',
    'account.responsible.confirmRemoveOrLower': 'Wenn Sie das Limit erhöhen, wird es nach 24 Stunden wirksam. Die Absenkung gilt ab sofort.',
    'account.responsible.confirmTightenImmediately': 'Eine Untergrenze gilt unmittelbar nach der Bestätigung.',
    'account.responsible.confirmSet': 'Satz',
    'account.responsible.confirmCancel': 'Abbrechen',
    'account.responsible.currentLimits': 'Aktuelle Grenzwerte',
    'account.responsible.sessionLimit': 'Sitzungslimit',
    'account.responsible.timeRemaining': 'Verbleibende Zeit',
    'account.responsible.delete': 'Löschen',
    'account.responsible.confirmChangeTitle': 'Sind Sie sicher, dass Sie die Grenzwerte ändern möchten?',
    'account.responsible.confirmDeleteTitle': 'Sind Sie sicher, dass Sie das Limit entfernen möchten?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Maximale Sitzungszeit – 1.440 Minuten (24 Stunden)',
    'account.responsible.limitBlocked': 'Sitzungslimit erreicht. Sie wurden abgemeldet.',
    'account.requests.title': 'Anfragen',
    'account.requests.newRequest': 'Neue Anfrage',
    'account.requests.empty': 'Keine aktuellen Anfragen',
    'account.requests.chooseType': 'Wählen Sie den Anfragetyp',
    'account.requests.cancel': 'Abbrechen',
    'account.requests.sendRequest': 'Anfrage senden',
    'account.requests.submit': 'Einreichen',
    'account.requests.error': 'Anfrage konnte nicht gesendet werden',
    'account.requests.notFound': 'Anfragetyp nicht gefunden',
    'account.requests.type.sport_bet_settlement': 'Abwicklung von Sportwetten',
    'account.requests.type.casino_bet_settlement': 'Abrechnung von Casino-Wetten',
    'account.requests.type.hotline': 'Frage zur Hotline',
    'account.requests.type.deposit': 'Frage zur Einzahlung',
    'account.requests.type.withdrawal': 'Auszahlungsfrage',
    'account.requests.type.website_app': 'Frage zur Nutzung der Website oder mobilen App',
    'account.requests.type.admin': 'Frage an den Admin',
    'account.requests.type.verification': 'Verifizierungsfrage',
    'account.requests.type.bonus': 'Bonusfrage',
    'account.requests.mobile.title': 'Irgendwelche Probleme?',
    'account.requests.mobile.desc': 'Erstellen Sie eine neue Anfrage oder finden Sie Antworten in unserem Hilfecenter',
    'account.requests.mobile.create': 'Erstellen Sie eine neue Anfrage',
    'account.requests.mobile.helpCentre': 'Gehen Sie zum Hilfecenter',
    'account.requests.group.deposit': 'FRAGE ZUR EINZAHLUNG',
    'account.requests.group.withdrawal': 'Widerrufsfrage',
    'account.requests.group.other': 'ANDERE',
    'account.requests.template.depositBankCard': 'Bankkarte',
    'account.requests.template.depositRaschet': 'Einheitliches Zahlungssystem „Raschet“.',
    'account.requests.template.depositQiwi': 'QIWI-Terminal',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'Oplati',
    'account.requests.template.withdrawalOplati': 'Oplati',
    'account.requests.template.withdrawalBank': 'Bankkarte / Überweisung',
    'account.requests.form.operationDate': 'Datum und Uhrzeit der Operation',
    'account.requests.form.amount': 'Transaktionsbetrag',
    'account.requests.form.selectOperationDesc': 'Wählen Sie den Vorgang aus, zu dem Sie eine Frage haben',
    'account.requests.form.selectOperationBtn': 'Vorgang auswählen',
    'account.requests.form.selectedOperation': 'Ausgewählter Vorgang',
    'account.requests.form.noOperations': 'Keine passenden Vorgänge gefunden',
    'account.requests.form.messagePlaceholder': 'Beschreiben Sie Ihre Frage oder Ihr Problem',
    'account.requests.form.symbolsRemaining': '{count} Symbole übrig',
    'account.requests.form.choose': 'Wählen',
    'account.requests.form.dragOrUpload': 'Hierher ziehen oder Dateien hochladen',
    'account.requests.form.attachFile': 'Datei anhängen',
    'account.requests.form.attachHint': 'Bis zu 5 Dateien. Format: jpg, jpeg, png, pdf. Bis zu 7 MB.',
    'account.requests.form.attachments': 'Anhänge',
    'account.helpCentre.title': 'Hilfecenter',
    'account.helpCentre.text1': 'Hier finden Sie Informationen',
    'account.helpCentre.text2': 'und Anwendungstipps',
    'account.helpCentre.faq': 'FAQ',
    'account.helpCentre.instructions': 'Anweisungen',
    'account.helpCentre.strategies': 'Wettstrategien',
    'account.helpCentre.glossary': 'Glossar',
    'account.helpCentre.go': 'Gehen Sie zum Hilfecenter',
    'account.support.subject': 'Thema',
    'account.support.message': 'Nachricht',
    'account.support.send': 'Schicken',
    'account.support.sent': 'Ihre Anfrage ist eingegangen',
    'account.support.history': 'Frühere Anfragen',
    'account.support.status_open': 'Offen',
    'account.support.status_closed': 'Geschlossen',
    'account.support.status_pending': 'Ausstehend',
    'account.support.status_waiting': 'Ausstehend',
    'account.support.status_answered': 'Beantwortet',
    'account.support.status_replied': 'Beantwortet',
    'account.support.status_in_progress': 'Im Gange',
    'account.support.status_resolved': 'Gelöst',
    'account.pageTitle': 'Mein Konto | VurgunBet',
    'sport.filter.allTime': 'Alle Zeiten',
    'sport.filter.allEvents': 'Alle Veranstaltungen',
    'sport.filter.live': 'Live',
    'sport.filter.prematch': 'Vor dem Spiel',
    'sport.filter.all': 'Alle',
    'betslip.title': 'Wettschein',
    'betslip.empty': 'Der Wettschein ist leer',
    'betslip.stake': 'Einsatz',
    'betslip.totalOdds': 'Gesamtquote',
    'betslip.potentialWin': 'Möglicher Gewinn',
    'betslip.place': 'Wette platzieren',
    'betslip.clear': 'Klar',
    'betslip.accepted': 'Wette angenommen',
    'betslip.login': 'Melden Sie sich an, um eine Wette zu platzieren',
    'betslip.emptyHint': 'Wählen Sie den Ausgang des Ereignisses aus, um eine Wette zu platzieren',
    'betslip.amount': 'Betrag, TL',
    'betslip.promos': 'Promos',
    'betslip.active': 'Aktiv',
    'betslip.popular': 'Beliebte Veranstaltungen',
    'footer.about': 'Über uns',
    'footer.basinda': 'In der Presse',
    'footer.licence': 'Lizenz',
    'footer.privacy': 'Datenschutzrichtlinie',
    'footer.responsible': 'Verantwortungsvolles Spielen',
    'footer.rules': 'Geschäftsbedingungen',
    'footer.financial': 'Finanzdienstleistungen',
    'footer.vip': 'VIP-Programm',
    'footer.help': 'Hilfecenter',
    'footer.payments': 'Zahlungen',
    'footer.company': 'Firmendetails',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Regeln für Wettbüros',
    'footer.appCaption': 'Anwendung',
    'footer.appIos': 'für iOS',
    'footer.appIosLong': 'Anwendung für iOS',
    'footer.appAndroidLong': 'Anwendung für Android',
    'footer.appAndroid': 'für Android',
    'footer.appMaintenance': 'Wartung',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Glücksspiel ist für Personen unter 18 Jahren illegal. VurgunBet ist ein internationaler Online-Gaming-Anbieter.',
    'footer.legal': 'VurgunBet bietet Sportwetten, Slot-Spiele, Live-Casino und verwandte Gaming-Produkte für Benutzer ab 18 Jahren. Benutzer müssen die an ihrem Standort geltenden gesetzlichen Beschränkungen einhalten.',
    'footer.legal1': 'Glücksspiel ist für Personen unter 18 Jahren sowie für Personen, denen der Besuch von Glücksspieleinrichtungen und virtuellen Glücksspieleinrichtungen und/oder die Teilnahme an Glücksspielen untersagt ist, verboten.',
    'footer.legal2': 'VurgunBet bietet Online-Sportwetten, Spielautomaten, Live-Casino und verwandte Gaming-Produkte. Die Nutzung der Dienste ist nur im gesetzlich zulässigen Rahmen gestattet.',
    'help.title': 'Hilfecenter',
    'help.searchPlaceholder': 'Suchen Sie nach Ihrer Frage',
    'help.searchSheetTitle': 'Hilfecenter: Suche',
    'help.searchSheetDesc': 'Finden Sie die Antwort auf Ihre Frage',
    'help.popularSearches': 'BELIEBTE SUCHEN',
    'help.popular.identification': 'So vervollständigen Sie die Identifizierung',
    'help.popular.deposit': 'So laden Sie Ihr Guthaben auf',
    'help.popular.win': 'Wie man einen Sieg erringt',
    'help.askQuestion': 'Eine Frage stellen',
    'help.views': 'Ansichten',
    'help.back': 'Zurück',
    'help.noResults': 'Keine Ergebnisse gefunden',
    'help.goToFaq': 'Gehen Sie zu FAQ',
    'help.instructions': 'Anweisungen',
    'help.training': 'Ausbildung',
    'help.glossary': 'Glossar',
    'help.notFound.code': '404',
    'help.notFound.title': 'Seite nicht gefunden',
    'help.notFound.description': 'Hoppla! Die gesuchte Seite existiert nicht. Möglicherweise wurde es verschoben oder gelöscht.',
    'help.notFound.home': 'Startseite',
    'help.feedback.review': 'Schreiben Sie eine Rezension',
    'help.feedback.helpful': 'Waren diese Informationen hilfreich?',
    'help.feedback.yes': 'Ja, danke',
    'help.feedback.no': 'NEIN',
    'promos.tab.actions': 'Promos',
    'promos.tab.tournaments': 'Turniere',
    'promos.tab.actionsDesc': 'Werde ein Champion',
    'promos.tab.tournamentsDesc': 'Nehmen Sie an Turnieren teil',
    'promos.tab.actionsTitle': 'Promos',
    'promos.tab.tournamentsTitle': 'Turniere',
    'promos.tab.bonuses': 'Boni',
    'promos.tab.bonusesDesc': 'Verfolgen Sie Ihre Boni',
    'promos.tab.bonusesTitle': 'Ihre Boni',
    'promos.tab.promoCode': 'Aktionscode',
    'promos.tab.promoCodeDesc': 'Jetzt aktivieren',
    'promos.tab.promoCodeTitle': 'Haben Sie einen Promo-Code?',
    'promos.tournamentsIntro': 'Nehmen Sie an Turnieren teil und kämpfen Sie um wertvolle Preise',
    'promos.filter.all': 'Alle',
    'promos.filter.sport': 'Sport',
    'promos.filter.casino': 'Casino',
    'promos.timer.ended': 'Beendet',
    'promos.timer.daysLeft': 'Links: {count} Tag(e)',
    'promos.timer.hoursLeft': 'Links: {count} Stunde(n)',
    'promos.timer.minutesLeft': 'Links: {count} min',
    'promos.tournament.active': 'Aktiv',
    'promos.tournament.bonusFund': 'Bonusfonds',
    'promos.tournament.participants': 'Teilnehmer',
    'promos.tournament.places': 'Orte',
    'promos.tournament.untilCompletion': 'Bis zur Fertigstellung',
    'promos.tournament.untilStart': 'Bis zum Start',
    'promos.tournament.upcoming': 'Demnächst',
    'promos.tournament.startsIn': 'Beginnt in',
    'promos.tournament.joinWhenLive': 'Treten Sie live bei',
    'promos.tournament.tab.rating': 'Bewertung',
    'promos.tournament.tab.terms': 'Bedingungen',
    'promos.tournament.tab.games': 'Spiele',
    'promos.tournament.col.participant': 'Teilnehmer',
    'promos.tournament.col.points': 'Punkte',
    'promos.tournament.col.bonuses': 'Boni',
    'promos.tournament.participate': 'Teilnehmen',
    'promos.tournament.optOut': 'Opt-out',
    'promos.tournament.loginToJoin': 'Melden Sie sich an, um beizutreten',
    'promos.tournament.promoRules': 'Werberegeln',
    'promos.tournament.questions': 'Sie haben noch Fragen?',
    'promos.tournament.close': 'Schließen',
    'promos.tournament.loading': 'Bestenliste wird geladen…',
    'promos.tournament.emptyBoard': 'Noch keine Rangliste. Seien Sie der Erste, der mitmacht!',
    'promos.tournament.noTerms': 'Regeln werden in Kürze hinzugefügt.',
    'promos.tournament.noGames': 'Die teilnahmeberechtigten Spiele werden in Kürze aufgelistet.',
    'promos.tournament.joinedOk': 'Du bist dem Turnier beigetreten',
    'promos.tournament.leftOk': 'Du hast das Turnier verlassen',
    'promos.tournament.actionError': 'Die Aktion konnte nicht abgeschlossen werden',
    'promos.tournament.working': 'Arbeiten…',
    'promos.tournament.gameBadge': 'TURNIER',
    'promos.tournament.showAllGames': 'Alle Spiele anzeigen',
    'promos.tournament.askQuestion': 'Eine Frage stellen',
    'promos.tournament.faq.participate.q': 'So nehmen Sie am Turnier teil',
    'promos.tournament.faq.participate.a': 'Gehen Sie zum Abschnitt „Turniere“, öffnen Sie das gewünschte Turnier und klicken Sie auf die Schaltfläche „Teilnehmen“.',
    'promos.tournament.faq.deposit.q': 'Muss ich eine Einzahlung tätigen, um am Turnier teilzunehmen?',
    'promos.tournament.faq.deposit.a': 'Nein – die Teilnahme ist kostenlos. Sammeln Sie Punkte mit Echtgeld-Wetten (mindestens 5 TL) auf Spielautomaten. Wetten mit Bonusguthaben werden nicht gewertet.',
    'promos.tournament.faq.multiple.q': 'Kann ich an mehreren Turnieren gleichzeitig teilnehmen?',
    'promos.tournament.faq.multiple.a': 'Ja. Sie können an mehreren aktiven Turnieren gleichzeitig teilnehmen; Jedes Turnier führt seine eigene Rangliste.',
    'promos.tournament.faq.terms.q': 'Wo kann ich die Turnierbedingungen einsehen?',
    'promos.tournament.faq.terms.a': 'Öffnen Sie im Turnierfenster die Registerkarte „Bedingungen“ oder tippen Sie auf „Aktionsregeln“, um die vollständigen Bedingungen anzuzeigen.',
    'promos.tournament.faq.games.q': 'Welche Slot-Spiele sind im Turnier enthalten?',
    'promos.tournament.faq.games.a': 'Berechtigte Spiele werden auf der Registerkarte „Spiele“ aufgeführt. Nur Wetten auf diese Spiele zählen für das Turnierergebnis.',
    'promos.tournament.faq.bonuses.q': 'Welche Boni kann ich für die Teilnahme und den Gewinn von Turnieren erhalten?',
    'promos.tournament.faq.bonuses.a': 'Je nach Rang erhalten Sie Geld- und Free-Spin-Preise (FS). Die Preise werden innerhalb von 48 Stunden nach Ende des Turniers gutgeschrieben; FS bleiben 7 Tage lang gültig und Geldpreise erfordern nur einen 2-fachen Einsatz.',
    'promos.tournament.faq.timed.q': 'Sind Turniere zeitlich begrenzt?',
    'promos.tournament.faq.timed.a': 'Ja. VURGUN VAKTİ läuft wöchentlich von Montag 11:00 Uhr bis Sonntag 23:59 Uhr und verlängert sich dann automatisch.',
    'promos.tournament.faq.track.q': 'Wie kann ich meine Turnierergebnisse und Fortschritte verfolgen?',
    'promos.tournament.faq.track.a': 'Öffnen Sie im Turnierfenster die Registerkarte „Bewertung“, um Ihre Live-Punkte und Ihren Platz anzuzeigen. Die Ergebnisse werden direkt nach Echtgeld-Wetten aktualisiert.',
    'promos.tournament.faq.more.q': 'Ich habe noch Fragen.',
    'promos.tournament.faq.more.a': 'Tippen Sie unten auf „Frage stellen“, um eine Supportanfrage zu öffnen. Unser Team wird sich in Kürze bei Ihnen melden.',
    'promos.tournament.ask.title': 'Neue Anfrage',
    'promos.tournament.ask.subtitle': 'Bonusfrage',
    'promos.tournament.ask.placeholder': 'Geben Sie Ihre Frage ein oder beschreiben Sie das Problem',
    'promos.tournament.ask.charsLeft': '{count} verbleibende Zeichen',
    'promos.tournament.ask.attach': 'Datei anhängen',
    'promos.tournament.ask.attachHint': 'Bis zu 5 Dateien. Format: jpg, jpeg, png, pdf. Bis zu 7 MB.',
    'promos.tournament.ask.cancel': 'Abbrechen',
    'promos.tournament.ask.send': 'Anfrage senden',
    'promos.tournament.ask.sending': 'Senden…',
    'promos.tournament.ask.sent': 'Ihre Anfrage ist eingegangen. Wir werden uns in Kürze bei Ihnen melden.',
    'promos.tournament.ask.loginRequired': 'Melden Sie sich an, um eine Anfrage zu senden',
    'promos.tournament.ask.error': 'Die Anfrage konnte nicht gesendet werden',
    'promos.tournament.terms.periodTitle': 'Wöchentlicher Turnierzeitraum',
    'promos.tournament.terms.pointsTitle': 'Bedingungen für die Vergabe von Punkten',
    'promos.tournament.terms.points1': 'Der Mindesteinsatz beträgt nur 5 TL – die Teilnahme ist kostenlos; Spielen Sie mit echtem Guthaben, um Punkte zu sammeln.',
    'promos.tournament.terms.points2': 'Jeder 1-TL-Real-Balance-Einsatz = 2 Punkte. Von Freitag bis Sonntag gibt es einen Punktebonus von 20 %!',
    'promos.tournament.terms.points3': 'Alle Echtgeldwetten auf Spielautomaten werden sofort gutgeschrieben. Bonus-Guthaben-Wetten zählen nicht.',
    'promos.tournament.terms.bonusesTitle': 'Nutzungsbedingungen für Boni',
    'promos.tournament.terms.bonuses1': 'Bargeld- und FS-Preise werden innerhalb von 48 Stunden nach Ende des Turniers gutgeschrieben; FS bleiben 7 Tage gültig.',
    'promos.tournament.terms.bonuses2': 'Für Preisgewinne ist nur ein zweifacher Wetteinsatz erforderlich – weit unter dem Branchendurchschnitt.',
    'promos.tournament.terms.bonuses3': 'Das Turnier verlängert sich automatisch jeden Montag um 11:00 Uhr; Die Bestenliste wird für eine neue Woche zurückgesetzt.',
    'promos.bonuses.title': 'Ihre Boni',
    'promos.promocode.title': 'Haben Sie einen Promo-Code?',
    'promos.promocode.desc': 'Geben Sie unten Ihren Promo-Code ein und wählen Sie Aktivieren',
    'promos.promocode.placeholder': 'Geben Sie den Aktionscode ein',
    'promos.promocode.activate': 'Aktivieren',
    'promos.promocode.activating': 'Bewerben…',
    'promos.promocode.success': 'Aktionscode erfolgreich angewendet',
    'promos.promocode.error': 'Aktionscode konnte nicht angewendet werden',
    'promos.promocode.loginRequired': 'Melden Sie sich an, um einen Aktionscode einzulösen',
    'promos.bonuses.loading': 'Ihre Boni werden geladen …',
    'promos.bonuses.empty': 'Sie haben noch keine Boni.',
    'promos.bonuses.emptyCaption': 'Keine aktiven Boni',
    'promos.bonuses.emptyDescription': 'Nehmen Sie an Werbeaktionen teil und erhalten Sie neue Boni!',
    'promos.bonuses.emptyButton': 'Gehen Sie zu den Werbeaktionen',
    'promos.bonuses.emptyArchiveCaption': 'Keine archivierten Boni',
    'promos.bonuses.emptyArchiveDescription': 'Nehmen Sie an Werbeaktionen teil und erhalten Sie neue Boni!',
    'promos.bonuses.kindFilterBonuses': 'Boni',
    'promos.bonuses.kindFilterFreeSpins': 'Freispiele',
    'promos.bonuses.kindFilterAll': 'Alle',
    'promos.bonuses.kindFreeSpin': 'Kostenloses Spiel',
    'promos.bonuses.fieldNominal': 'Nominell',
    'promos.bonuses.fieldStatus': 'Status',
    'promos.bonuses.fieldExpires': 'Läuft ab',
    'promos.bonuses.fieldReceived': 'Erhalten',
    'promos.bonuses.tabActive': 'Aktiv',
    'promos.bonuses.tabArchive': 'Archiv',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'Ihr Fortschritt:',
    'promos.bonuses.statusWagering': 'Wetten läuft',
    'promos.bonuses.moreInfo': 'Weitere Informationen',
    'promos.bonuses.detailTitle': 'Bonus aktiviert',
    'promos.bonuses.leftDays': 'verbleibende {n} Tage',
    'promos.bonuses.leftDay': 'übrig {n} Tag',
    'promos.bonuses.detailLead': 'Erfüllen Sie die Umsatzbedingungen und erhalten Sie den Bonus auf Ihrem Hauptkonto',
    'promos.bonuses.placeBets': 'Platzieren Sie Wetten im Gesamtwert von {amount}',
    'promos.bonuses.rulesTitle': 'Wettregeln für das Bonuskonto',
    'promos.bonuses.rule1': 'Dem Bonuskontoguthaben hinzugefügte Gewinne werden auf dem Hauptkonto verfügbar, nachdem der Betrag um den Faktor 25 umgesetzt wurde. Der Einsatz kann bei allen Spielautomaten aller Casino-Anbieter abgeschlossen werden, mit Ausnahme bestimmter, vom Veranstalter festgelegter Spielautomaten.',
    'promos.bonuses.rule2': 'Beim Einsatz von Geldern aus dem Bonuskontoguthaben werden die Gelder zuerst vom Hauptkonto und dann vom Bonuskontoguthaben gutgeschrieben.',
    'promos.bonuses.rule3': 'Wenn Gelder vom Bonuskontostand gutgeschrieben werden, werden Gewinne dem Bonuskontostand gutgeschrieben.',
    'promos.bonuses.rule4': 'Nach Abschluss des Wetteinsatzes wird der verbleibende Betrag des Bonuskontos auf das Hauptguthaben übertragen, darf jedoch das Dreifache des ursprünglich dem Bonuskontoguthaben gutgeschriebenen Betrags nicht überschreiten.',
    'promos.bonuses.rule5': 'Der Wettzeitraum beträgt 3 Tage ab Aktivierung des Bonuskontos.',
    'promos.bonuses.rule6': 'Jeder weitere Bonus wird automatisch aktiviert, nachdem der vorherige Bonus umgesetzt wurde.',
    'promos.bonuses.rule7': 'Wenn auf dem Bonuskonto Guthaben vorhanden ist, ist eine Auszahlung vom Hauptkonto nicht möglich.',
    'promos.bonuses.promotionRules': 'Werberegeln',
    'promos.bonuses.askQuestion': 'Frage stellen',
    'promos.bonuses.cancelBonus': 'Stornieren Sie den Bonus',
    'promos.bonuses.cancelConfirm': 'Ihr Bonusguthaben wird entfernt und die Wetteinsätze werden storniert. Weitermachen?',
    'promos.bonuses.cancelBusy': 'Stornieren…',
    'promos.bonuses.cancelTitle': 'Möchten Sie sich wirklich abmelden?',
    'promos.bonuses.cancelBody': 'Im Falle einer Ablehnung werden die Boni verbrannt.\nSie können jederzeit kündigen.',
    'promos.bonuses.cancelRefuse': 'Ich möchte ablehnen',
    'promos.bonuses.cancelBack': 'Überzeugt! Zurück',
    'promos.bonuses.askClose': 'Schließen',
    'promos.bonuses.askFileBadType': 'Nicht unterstütztes Dateiformat.',
    'promos.bonuses.askFileTooBig': 'Die Datei ist größer als 7 MB.',
    'promos.bonuses.askError': 'Anfrage konnte nicht gesendet werden',
    'promos.bonuses.askSent': 'Ihre Anfrage wurde gesendet.',
    'promos.bonuses.askSending': 'Senden…',
    'promos.bonuses.askSend': 'Anfrage senden',
    'promos.bonuses.askCancel': 'Abbrechen',
    'promos.bonuses.askFilesSize': 'Bis zu 7 MB.',
    'promos.bonuses.askFilesMax': 'Bis zu 5 Dateien.',
    'promos.bonuses.askAttach': 'Datei anhängen',
    'promos.bonuses.askCharsLeft': '{n} verbleibende Zeichen',
    'promos.bonuses.askPlaceholder': 'Geben Sie Ihre Frage ein oder beschreiben Sie das Problem',
    'promos.bonuses.askNewRequest': 'Neue Anfrage',
    'promos.bonuses.askBonusQuestion': 'Bonusfrage',
    'promos.bonuses.askHint': 'Senden Sie eine Frage zu Ihrem Bonus an den Support',
    'promos.bonuses.fieldWagering': 'Wetten',
    'promos.bonuses.fieldWageringTime': 'Wettzeit',
    'promos.bonuses.fieldMaxWithdrawal': 'Max. Rückzug',
    'promos.bonuses.fieldUsed': 'Gebraucht',
    'promos.bonuses.statusAvailable': 'Verfügbar',
    'promos.bonuses.statusUsed': 'Gebraucht',
    'promos.bonuses.activate': 'Aktivieren',
    'promos.bonuses.days': 'Tage',
    'promos.bonuses.games': 'Spiele',
    'promos.bonuses.noGames': 'Keine Spielinformationen',
    'promos.bonuses.play': 'Spielen',
    'home.showcase.slots.title': 'Casino',
    'home.showcase.slots.count': '{count} Spiele',
    'home.showcase.slots.link': 'Spiele ansehen →',
    'home.showcase.live.title': 'Live-Casino',
    'home.showcase.live.count': '{count} Spiele',
    'home.showcase.live.link': 'Jetzt spielen →',
    'home.showcase.tv.title': 'TV-Spiele',
    'home.showcase.tv.count': '{count} Spiele',
    'home.showcase.fast.title': 'Schnellspiele',
    'home.showcase.fast.count': '{count} Spiele',
    'home.showcase.fast.link': 'Jetzt spielen →',
    'home.showcase.virtual.title': 'Virtueller Sport',
    'home.showcase.virtual.count': '{count} Spiele',
    'home.showcase.virtual.link': 'Jetzt spielen →',
    'home.showcase.gamesCount': '{count} Spiele',
    'home.showcase.tv.link': 'Jetzt spielen →',
    'home.showcase.sport.title': 'Sport',
    'home.showcase.sport.count': '3380 Ereignisse',
    'home.showcase.sport.link': 'Jetzt wetten →',
    'home.promo.category.promotions': 'Aktionen',
    'home.promo.category.tournaments': 'Turniere',
    'home.promo.filter.all': 'Alle',
    'home.promo.filter.sport': 'Sport (5)',
    'home.promo.filter.casino': 'Kasino (5)',
    'home.promo.showAll': 'Alle anzeigen →',
    'home.promo.allPromotions': 'Alle Aktionen',
    'home.promo.cta.play': 'Spielen',
    'home.promo.cta.join': 'Registrieren',
    'home.promo.cta.details': 'Details',
    'home.promo.cta.signup': 'Melden Sie sich an',
    'home.sport.searchEvents': 'Suche nach Ereignissen',
    'footer.contactUs': 'Kontaktieren Sie uns',
    'footer.usefulInfo': 'Nützliche Informationen',
    'footer.socialMedia': 'Soziale Medien',
    'footer.partners': 'Offizieller Partner',
    'footer.officialPartner': 'Offizieller\nPartner',
    'home.casino.loading': 'Spiele werden geladen…',
    'home.casino.noGames': 'Keine Spiele verfügbar',
    'home.casino.viewAllMobile': '{count}-Spiele ansehen',
    'home.shuffle.title': 'Sie sind sich nicht sicher, welches Spiel Sie als nächstes spielen sollen?',
    'home.shuffle.cta': 'Jetzt drehen',
    'home.shuffle.modalTitle': 'Lassen Sie uns das perfekte Spiel für Sie finden!',
    'home.shuffle.respin': 'Noch einmal drehen',
    'home.shuffle.close': 'Schließen',
    'home.jackpot.casinoTitle': 'Casino Jackpot',
    'home.jackpot.title': 'VURGUN GROSSER JACKPOT',
    'home.jackpot.badgeRest': 'GROSSER JACKPOT',
    'home.jackpot.winners': 'Gesamtgewinner: {count}',
    'home.jackpot.largest': 'Größter Gewinn',
    'home.jackpot.last': 'Letzter Sieg',
    'home.jackpot.onSlots': 'Auf allen Slots',
    'home.jackpot.play': 'Jackpot Spiele',
    'home.liveWins.title': 'Live gewinnt',
    'home.liveWins.heated': 'Vurgun',
    'home.topWins.title': 'Top-Siege',
    'home.topWins.week': 'Diese Woche',
    'home.topWins.month': 'Diesen Monat',
    'home.topWins.day': 'Heute',
    'home.topWins.play': 'Spielen',
    'home.topWins.prev': 'Vorherige',
    'home.topWins.next': 'Nächste',
    'home.popularSlots.title': 'Beliebte Slots',
    'home.hotSlots.title': 'Spitzenverdiener',
    'home.hotSlots.badge': 'HEISS',
    'home.matchCarousel.title': 'Streichhölzer',
    'home.matchCarousel.liveTv': 'Live-TV',
    'home.slotsCarousel.showAll': 'Alle anzeigen',
    'home.slotsCarousel.prev': 'Vorherige',
    'home.slotsCarousel.next': 'Nächste',
    'home.jackpot.grand': 'GROSSARTIG',
    'home.jackpot.major': 'WESENTLICH',
    'home.jackpot.minor': 'UNERHEBLICH',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Club',
    'home.heroSide.vipSub': 'Exklusive Vergünstigungen',
    'home.heroSide.promosTitle': 'Boni',
    'home.heroSide.promosSub': 'Aktuelle Aktionen',
    'home.heroSide.sportTitle': 'Sport',
    'home.heroSide.sportSub': 'Live-Wetten',
    'header.support': 'Support',
    'home.topEvents.showAll': 'Alle anzeigen',
    'betslip.bonusFund': 'Bonusfonds',
    'betslip.participants': '{count} Teilnehmer',
    'betslip.hoursLeft': 'Noch {hours} Stunden übrig',
    'betslip.details': 'Details',
    'casino.viewAllCaption': 'Alle anzeigen →',
    'casino.bside.promos': 'Promos',
    'casino.bside.showAll': 'Alle anzeigen →',
    'casino.lobby.slots': 'Slots',
    'casino.lobby.live': 'Live-Casino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'TV-Spiele',
    'casino.lobby.fast': 'Schnellspiele',
    'casino.lobby.virtual': 'Virtueller Sport',
    'casino.tab.review': 'Rezension',
    'casino.tab.favourites': 'Favoriten',
    'casino.tab.top': 'Top-Spiele',
    'casino.tab.peter': 'Peter & Sons Hits',
    'casino.tab.free-spins': 'Mit free spins',
    'casino.tab.all': 'Alle Spiele',
    'casino.tab.tournaments': 'Turniere',
    'casino.tab.jackpot-cards': 'Jackpot Karten',
    'casino.tab.new': 'NEU',
    'casino.tab.world-cup': 'Weltmeisterschaft 2026',
    'casino.tab.buy-bonus': 'Kaufbonus',
    'casino.tab.exclusive': 'Exklusiv',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Pragmatisches Spiel',
    'casino.tab.coins-link-vip': 'Münzen-Link VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'Kaskade',
    'casino.tab.megaways': 'Megaways',
    'casino.tab.collect': 'Sammeln',
    'casino.tab.wild': 'Wild',
    'casino.tab.double': 'Doppelte Chance',
    'casino.tab.megax': 'Mega X',
    'casino.tab.respin': 'Respin',
    'casino.tab.retro': 'Retro',
    'casino.tab.fruits': 'Früchte',
    'casino.tab.books': 'Bücher',
    'casino.tab.fast-football': 'Schneller Fußball',
    'casino.tab.holdem': 'Hold\'em',
    'casino.tab.caribbean': 'Karibik',
    'casino.tab.video-poker': 'Videopoker',
    'casino.tab.crash': 'Crash-Spiele',
    'casino.tab.table-games': 'Tischspiele',
    'casino.tab.mines': 'Minen',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Würfel',
    'casino.tab.scratch': 'Rubbelspiele',
    'casino.tab.other': 'Andere',
    'casino.tab.football': 'Fußball',
    'casino.tab.horse-racing': 'Pferderennen',
    'casino.tab.recommended': 'Empfohlen',
    'casino.topProviders': 'Beste Anbieter',
    'casino.groupsAll': 'Alle',
    'casino.groupsNew': 'Neue Spiele',
    'casino.groupsTop': 'Beste Spiele',
    'casino.groupsWager': 'Zum Wetten',
    'casino.groupsFreebonus': 'Für Gratisbonus',
    'casino.lobbyHome': 'Lobby-Startseite',
    'casino.groups': 'Gruppen',
    'casino.providers': 'Anbieter',
    'casino.search': 'Suchen',
    'casino.play': 'Spielen',
    'casino.demo': 'Demo',
    'casino.searchModal.title': 'Suchen',
    'casino.searchModal.placeholder': 'Suchspiele',
    'casino.filters': 'Filter',
    'casino.filtersCount': 'Filter ({count})',
    'casino.filter.section.functions': 'Funktionen',
    'casino.filter.section.themes': 'Themen',
    'casino.filter.bonusGame': 'Bonusspiel',
    'casino.filter.buyFeature': 'Funktion kaufen',
    'casino.filter.expandingSymbols': 'Erweiternde Symbole',
    'casino.filter.freeSpins': 'Free Spins',
    'casino.filter.multiplier': 'Multiplikator',
    'casino.filter.respins': 'Antworten',
    'casino.filter.symbolsCollection': 'Symbolsammlung',
    'casino.filter.animals': 'Tiere',
    'casino.filter.books': 'Bücher',
    'casino.filter.classic777': 'Klassisch & 777',
    'casino.filter.coins': 'Münzen',
    'casino.filter.egypt': 'Ägypten',
    'casino.filter.fruits': 'Früchte',
    'casino.filter.gods': 'Götter',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Alle Anbieter',
    'casino.selectProvider': 'Anbieter auswählen',
    'casino.searchProviders': 'Suchanbieter',
    'casino.loading': 'Spiele werden geladen…',
    'casino.noGames': 'Keine Spiele gefunden',
    'casino.lucky': 'Ich habe Glück',
    'casino.sortBy': 'Sortieren nach',
    'casino.sort.popular': 'Am beliebtesten',
    'casino.sort.default': 'Standard',
    'casino.sort.az': 'A bis Z',
    'casino.sort.za': 'Z bis A',
    'casino.sort.new': 'Neueste',
    'casino.sort.provider': 'Nach Anbieter',
    'casino.sort.name': 'Mit Namen',
    'casino.showMore': 'Mehr anzeigen',
    'casino.viewAll': 'Alle',
    'casino.games': 'Spiele',
    'casino.side.games': 'Spiele',
    'casino.side.tournament': 'Turnier',
    'casino.side.search': 'Suchspiele',
    'casino.side.recommended': 'Empfohlene Spiele',
    'casino.side.noGames': 'Keine Spiele gefunden',
    'casino.side.noTournaments': 'Keine aktiven Turniere',
    'casino.side.loading': 'Laden…',
    'casino.game.play': 'Spielen',
    'casino.game.demo': 'Demo',
    'casino.game.favorite': 'Zu Favoriten hinzufügen',
    'casino.game.fullscreen': 'Vollbild',
    'casino.game.noFreeSpins': 'Kein free spins zum Hinzufügen zu diesem Spiel',
    'casino.game.linkCopied': 'Link kopiert',
    'casino.game.closeConfirmTitle': 'Knappes Spiel?',
    'casino.game.closeConfirmText': 'Das Spiel wird beendet. Möchten Sie fortfahren?',
    'casino.game.closeConfirmOk': 'Schließen',
    'casino.game.closeConfirmCancel': 'Abbrechen',
    'casino.game.popout': 'In neuem Fenster öffnen',
    'casino.game.playReal': 'Spielen Sie um echtes Geld',
    'casino.game.addFreeSpins': 'free spins hinzufügen',
    'casino.game.addFreeSpinsToGame': 'free spins zum Spiel hinzufügen',
    'casino.game.fsBet': 'Wette',
    'casino.game.fsExpiresIn': 'Läuft ab in',
    'casino.game.fsAdd': 'Hinzufügen',
    'casino.game.fsBackToGame': 'Zurück zum Spiel',
    'casino.game.fsNewAvailable': 'Neues free spins verfügbar',
    'casino.game.fsUpdateRequired': 'Spiel-Update erforderlich',
    'casino.game.fsUpdate': 'Aktualisieren',
    'casino.game.insufficientBalance': 'Unzureichendes Gleichgewicht',
    'casino.game.insufficientBalanceHint': 'Laden Sie Ihr Guthaben auf, um um echtes Geld zu spielen',
    'casino.game.insufficientContinue': 'Weiter',
    'casino.game.makeDeposit': 'Machen Sie eine Einzahlung',
    'casino.game.bonusInsufficientHint': 'Ihr Bonusguthaben reicht für diesen Einsatz nicht aus. Der Wechsel zum Echtgeld-Konto storniert den Bonus.',
    'casino.game.switchToCash': 'Zum Echtgeld wechseln',
    'casino.game.demoMode': 'Demo-Modus',
    'casino.game.signIn': 'Melden Sie sich an, um um echtes Geld zu spielen.',
    'casino.game.tryDemo': 'Demo ausprobieren',
    'casino.game.loading': 'Spiel wird geladen…',
    'casino.game.notFound': 'Spiel nicht gefunden',
    'casino.game.launchFailed': 'Spiel konnte nicht gestartet werden',
    'casino.game.demoUnavailable': 'Demo ist für dieses Spiel nicht verfügbar.',
    'casino.game.unavailable': 'Das Spiel kann derzeit nicht gestartet werden. Bitte später erneut versuchen.',
    'casino.game.demoSuffix': '(Demo)',
    'casino.badge.top': 'En İyi',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Turnier',
    'casino.badge.new': 'NEU',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'exklusiv',
    'casino.badge.jackpot': 'Jackpot',
    'casino.bside.tournaments': 'Turniere',
  },
  nl: {
    'nav.home': 'Home',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Sport',
    'nav.sportLive': 'Live wedden',
    'nav.liveCasino': 'Live Casino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slots',
    'nav.virtual': 'Virtuele sport',
    'nav.fast': 'Snelle spellen',
    'nav.tv': 'TV-spellen',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Bekijk live wedstrijdstreams',
    'vtv.live': 'Live',
    'vtv.upcoming': 'Aankomend',
    'vtv.search': 'Zoeken',
    'vtv.searchPh': 'Zoek teams, competities…',
    'vtv.allSports': 'Alle sporten',
    'vtv.loading': 'Streams laden…',
    'vtv.empty': 'Geen wedstrijden beschikbaar',
    'vtv.error': 'Streams konden niet worden geladen',
    'vtv.pick': 'Kies een wedstrijd om te kijken',
    'vtv.streamError': 'Stream kon niet worden geopend',
    'vtv.liveBadge': 'LIVE',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'NIEUW',
    'nav.newGames': 'Nieuwe spellen',
    'nav.newPromos': 'Nieuwe promoties',
    'nav.promos': 'Promoties',
    'nav.casino': 'Casino',
    'nav.apps': 'Apps',
    'nav.results': 'Uitslagen',
    'header.promos': 'Promoties',
    'header.help': 'Hulp',
    'header.search': 'Zoeken',
    'header.settings': 'Instellingen',
    'header.login': 'Inloggen',
    'header.join': 'Registreren',
    'header.logout': 'Uitloggen',
    'header.account': 'Mijn account',
    'header.deposit': 'Storten',
    'header.hideBalance': 'Saldo verbergen',
    'header.showBalance': 'Saldo tonen',
    'header.notifications': 'Meldingen',
    'mobile.menu': 'Menu',
    'mobile.home': 'Home',
    'mobile.myBets': 'Mijn weddenschappen',
    'mobile.navigation': 'Navigatie',
    'mobile.menu.loginTitle': 'Log in op uw account',
    'mobile.menu.loginText': 'om volledige toegang te krijgen tot alle serviceopties',
    'mobile.menu.tournaments': 'Toernooien',
    'mobile.menu.helpNote': 'FAQ, leren, woordenboek',
    'mobile.menu.appsNote': 'Voor Android, iOS',
    'mobile.menu.about': 'Over VurgunBet',
    'mobile.menu.aboutNote': 'Informatie, licenties',
    'basinda.title': 'In de pers',
    'basinda.lead': 'Momenten uit VurgunBet stadion- en veldsponsoring.',
    'basinda.menuNote': 'Sponsoring, pers',
    'basinda.item1': 'Sassuolo-Pisa',
    'basinda.item2': 'Turijn-Atalanta',
    'basinda.item3': 'Alavés - Elche',
    'basinda.item4': 'Levante-Alaves',
    'basinda.item5': 'Fenerbahçe-Pogon Szczecin',
    'mobile.menu.siteTour': 'Rondleiding ter plaatse',
    'mobile.menu.siteTourText': 'duurt slechts 2 minuten →',
    'mobile.menu.history': 'Geschiedenis bekijken',
    'mobile.menu.historyEmpty': 'Nog geen browsegeschiedenis',
    'mobile.menu.historyEmptyText': 'Hier vindt u alle rubrieken en sportevenementen die u heeft bekeken',
    'mobile.menu.clearHistory': 'Geschiedenis wissen',
    'mobile.menu.openPromos': 'Promoties',
    'mobile.menu.searchGames': 'Zoek spellen',
    'mobile.menu.responsibleGaming': 'Verantwoord gamen',
    'mobile.account.number': 'Account: {id}',
    'mobile.account.copy': 'Rekeningnummer kopiëren',
    'mobile.account.copied': 'Gekopieerd',
    'mobile.account.balance': 'Saldo: {amount}',
    'settings.section.sport': 'Sport',
    'settings.section.casino': 'Casino',
    'settings.section.interface': 'Interface',
    'settings.section.navigation': 'Navigatie',
    'settings.eventDisplay': 'Gebeurtenisweergave',
    'settings.eventDisplay.table': 'Tafel',
    'settings.eventDisplay.list': 'Lijst',
    'settings.betSlipLocation': 'Locatie van het wedstrookje',
    'settings.betSlipLocation.bottom': 'In het onderste paneel',
    'settings.betSlipLocation.above': 'Boven het paneel',
    'settings.betSlipSettings': 'Instellingen wedstrookje',
    'settings.betSlip.showLiveTimer': 'Toon live-evenementtimer in wedstrookje',
    'settings.betSlip.showEventTime': 'Toon de tijd en startdatum van het evenement op het wedstrookje',
    'settings.betSlip.skipClearConfirm': 'Vraag niet om bevestiging om wedstrookjes te wissen',
    'settings.betSlip.view': 'Wedstrookje bekijken',
    'settings.betSlip.view.auto': 'Automatisch kiezen',
    'settings.betSlip.view.narrow': 'Smal',
    'settings.betSlip.view.wide': 'Breed',
    'settings.odds.title': 'Kansen',
    'settings.odds.boosted': 'Toegenomen',
    'settings.odds.on': 'op',
    'settings.odds.off': 'uit',
    'settings.odds.hideBoosted': 'Geef geen verhoogde odds weer in Sports',
    'settings.odds.european': 'Europese',
    'settings.odds.american': 'Amerikaans',
    'settings.odds.hongkong': 'Hongkong',
    'settings.odds.indonesian': 'Indonesisch',
    'settings.odds.malaysian': 'Maleisisch',
    'settings.favouriteSports': 'Favoriete sporten',
    'settings.favouriteSports.empty': 'Geen',
    'settings.favouriteSports.desc': 'Voeg favoriete sporten toe om ze als eerste weer te geven in het gedeelte Sport.',
    'settings.casinoProMode': 'Pro-modus',
    'settings.casinoProMode.desc': 'Geef de volatiliteit van de gokkast en andere waarden weer op de spelkaart',
    'settings.casinoView.standard': 'Standaard weergave',
    'settings.casinoView.pro': 'Pro-modus',
    'settings.theme.title': 'Website-thema',
    'settings.theme.auto': 'Auto',
    'settings.theme.light': 'Licht',
    'settings.theme.dark': 'Donker',
    'settings.hideBalance': 'Saldo verbergen',
    'settings.hideBalance.desc': 'Veeg over uw saldo in de koptekst om het te verbergen',
    'settings.showUpButton': 'Knop \'Omhoog\' weergeven',
    'settings.language': 'Taal',
    'settings.nav.sportSection': 'In de rubriek Sport',
    'settings.nav.casinoSection': 'In de Casino-sectie',
    'settings.nav.menu': 'In Menu',
    'settings.title': 'Website-instellingen',
    'settings.reset': 'Standaard retourneren',
    'settings.betSlip.title': 'Weddenschapsbriefje',
    'settings.nav.betAcceptance': 'Acceptatie van weddenschappen',
    'settings.nav.cashOut': 'Uitbetalen',
    'settings.nav.favouriteBets': 'Favoriete weddenschappen',
    'settings.nav.betSlip': 'Wedstrookje bekijken',
    'settings.navigation.auto': 'Auto',
    'settings.navigation.left': 'Aan de linkerkant',
    'settings.navigation.top': 'Bovenkant',
    'settings.eventList.title': 'Evenementenlijst',
    'settings.eventList.minimised': 'Alle gebeurtenissen worden standaard geminimaliseerd',
    'settings.eventPage.title': 'Evenementpagina',
    'settings.view.large': 'Groot uitzicht',
    'settings.view.compact': 'Compacte weergave',
    'settings.favouriteSports.descLong': 'Voeg je favoriete sporten toe om ze als eerste weer te geven in het gedeelte Sport. Je kunt de volgorde wijzigen door ze te slepen',
    'settings.favouriteSports.hint': 'Druk op ★ om de sport aan je favorieten toe te voegen',
    'settings.sport.football': 'Voetbal',
    'settings.sport.hockey': 'Hockey',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basketbal',
    'settings.sport.esports': 'Esports',
    'settings.sport.tableTennis': 'Tafeltennis',
    'settings.sport.volleyball': 'Volleybal',
    'settings.sport.handball': 'Handbal',
    'settings.sport.mixFights': 'Mengen. Gevechten',
    'settings.sport.boxing': 'Boksen',
    'settings.sport.futsal': 'Zaalvoetbal',
    'settings.sport.baseball': 'Honkbal',
    'settings.sport.americanFootball': 'Amerikaans voetbal',
    'settings.sport.rugby': 'Rugby',
    'settings.sport.waterPolo': 'Waterpolo',
    'settings.sport.fieldHockey': 'Hockey',
    'settings.sport.racing': 'Racen',
    'settings.sport.cycling': 'Fietsen',
    'settings.sport.sports': 'Sport',
    'settings.sport.beachSoccer': 'Strandvoetbal',
    'settings.sport.basketball3x3': 'Basketbal 3x3',
    'settings.sport.lacrosse': 'Lacrosse',
    'settings.sport.australianFootball': 'Australisch voetbal',
    'settings.sport.cricket': 'Krekel',
    'settings.sport.snooker': 'Snooker',
    'settings.sport.darts': 'Darts',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet — Online sportweddenschappen',
    'auth.login.title': 'Inloggen',
    'auth.login.submit': 'Inloggen',
    'auth.login.link': 'Inloggen',
    'auth.register.title': 'Registreren',
    'auth.register.bannerHighlight': '100% TOT',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPINS',
    'auth.register.bannerDesc': '+5 FREE BETS',
    'auth.register.perkFast': 'Anoniem',
    'auth.register.perkSafe': 'Geen kosten',
    'auth.register.perkBonus': 'VPN-vriendelijk',
    'auth.register.orSignUpWith': 'OF meld je aan bij',
    'auth.login.orSignInWith': 'OF LOG IN MET',
    'auth.webauthn.login': 'Log in met Face ID/Touch ID',
    'auth.webauthn.offerTitle': 'Sla Face ID op dit apparaat op',
    'auth.webauthn.offerBody': 'De volgende keer kunt u zich snel aanmelden met Face ID, Touch ID of Windows Hello.',
    'auth.webauthn.offerConfirm': 'Bespaar op dit apparaat',
    'auth.webauthn.offerSkip': 'Niet nu',
    'auth.webauthn.needRegister': 'Sla Face ID / Touch ID eerst op in uw profiel',
    'auth.webauthn.failed': 'Biometrische aanmelding mislukt',
    'auth.webauthn.unsupported': 'Face ID/Touch ID is niet beschikbaar op dit apparaat',
    'auth.webauthn.registerFailed': 'Kan biometrische login niet opslaan',
    'auth.webauthn.alreadyRegistered': 'Dit apparaat is al geregistreerd',
    'auth.webauthn.thisDevice': 'Dit apparaat',
    'auth.webauthn.manageTitle': 'Face-ID / Touch-ID',
    'auth.webauthn.manageDesc': 'Registreer een toegangssleutel om in te loggen met Face ID, Touch ID of Windows Hello op dit apparaat.',
    'auth.webauthn.empty': 'Geen biometrische logins opgeslagen',
    'auth.webauthn.add': 'Bespaar op dit apparaat',
    'auth.webauthn.remove': 'Verwijderen',
    'auth.webauthn.removed': 'Wachtwoord verwijderd',
    'auth.webauthn.registered': 'Biometrische login opgeslagen',
    'auth.webauthn.loadFailed': 'Kan de toegangscodes niet laden',
    'auth.webauthn.removeFailed': 'Kan de toegangssleutel niet verwijderen',
    'account.profile.tab.passkeys': 'Face-ID / Touch-ID',
    'account.profile.mobile.passkeys': 'Face-ID / Touch-ID',
    'account.profile.mobile.passkeysHint': 'Snel inloggen',
    'auth.register.socialNotConfigured': 'Deze methode is nog niet geconfigureerd',
    'auth.register.pageTitle': 'Registratie | VurgunBet',
    'auth.register.submit': 'Registreren',
    'auth.register.link': 'Registreren',
    'guestPopup.title': 'Free bet 100 TL + 300 free spins',
    'guestPopup.subtitle': 'voor nieuwe klanten',
    'guestPopup.cta': 'Registratie',
    'language.choose': 'Kies taal',
    'auth.register.slogan': 'DICHTER BIJ HET SPEL',
    'auth.register.smsHint': 'De sms-code wordt naar dit nummer verzonden',
    'auth.register.promoToggle': 'Ik heb een promotiecode',
    'auth.register.rules': 'Ik ben 18 jaar oud en ik accepteer de Algemene Voorwaarden en het Privacybeleid *',
    'auth.register.rulesBefore': 'Ik ben 18 jaar oud en ik accepteer de',
    'auth.register.termsLink': 'Algemene voorwaarden',
    'auth.register.rulesAnd': 'En',
    'auth.register.privacyLink': 'Privacybeleid',
    'auth.register.rulesAfter': ' *',
    'auth.register.rulesLink': 'Algemene voorwaarden',
    'auth.register.rulesRequired': 'U moet de Algemene Voorwaarden en het Privacybeleid accepteren',
    'auth.register.serviceMail': 'Ik ga akkoord met het ontvangen van servicenieuwsbrieven.',
    'auth.register.serviceMail2': 'U kunt het beleid voor de verwerking van persoonsgegevens lezen',
    'auth.register.here': 'hier',
    'auth.register.adMail': 'Ik ga akkoord met de',
    'auth.register.adTerms': 'voorwaarden van de reclame-mailinglijst',
    'auth.register.adTermsLink': 'voorwaarden',
    'auth.register.adTermsSuffix': 'van de reclame-mailinglijst',
    'auth.register.serviceMailSuffix': '.',
    'auth.register.fullPromotionTerms': 'Volledige promotievoorwaarden',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Voer uw telefoonnummer in',
    'auth.validation.phoneOrEmailRequired': 'Voer e-mailadres of telefoon in',
    'auth.validation.phoneInvalid': 'Voer een geldig telefoonnummer in',
    'auth.validation.phoneExists': 'Dit telefoonnummer is al geregistreerd',
    'auth.validation.emailRequired': 'Voer uw e-mailadres in',
    'auth.validation.emailInvalid': 'Voer een geldig e-mailadres in',
    'auth.validation.emailDomainInvalid': 'Gebruik een geldig e-mailadres (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com enz.)',
    'auth.validation.emailExists': 'Deze e-mail is al geregistreerd',
    'auth.validation.passwordRequired': 'Voer uw wachtwoord in',
    'auth.validation.passwordShort': 'Wachtwoord moet minimaal 8 tekens lang zijn',
    'auth.validation.registerFailed': 'Registratie mislukt. Probeer het opnieuw.',
    'auth.validation.loginFieldsRequired': 'Vul alle velden in',
    'auth.validation.loginInvalid': 'Onjuiste login of wachtwoord',
    'auth.validation.accountRequired': 'Voer uw rekeningnummer in',
    'auth.validation.accountShort': 'Het rekeningnummer moet minimaal 6 tekens lang zijn',
    'auth.validation.codeInvalid': 'Onjuiste bevestigingscode',
    'auth.validation.codeRequired': 'Voer de bevestigingscode in',
    'auth.validation.codeSendFailed': 'Kan code niet verzenden',
    'auth.validation.codeThrottled': 'Wacht even voordat u een nieuwe code aanvraagt',
    'auth.validation.challengeExpired': 'Verificatie verlopen, log opnieuw in',
    'auth.validation.serverUnreachable': 'Kan de server niet bereiken. Voer npm run dev:server uit in de terminal.',
    'auth.validation.serverError': 'Inloggen mislukt. Controleer de server en database.',
    'auth.tab.phone': 'Telefoon',
    'auth.tab.email': 'E-mail',
    'auth.tab.username': 'Gebruikersnaam',
    'auth.tab.account': 'Rekening',
    'auth.label.phone': 'Telefoonnummer',
    'auth.label.phoneOptional': 'Mobiele telefoon (optioneel)',
    'auth.label.email': 'E-mail',
    'auth.label.username': 'Gebruikersnaam',
    'auth.label.account': 'Rekeningnummer',
    'auth.label.password': 'Wachtwoord',
    'auth.label.promo': 'Promotiecode',
    'auth.placeholder.account': 'Rekeningnummer',
    'auth.placeholder.username': 'Gebruikersnaam',
    'auth.forgot': 'Wachtwoord vergeten?',
    'auth.noAccount': 'Heeft u geen account?',
    'auth.haveAccount': 'Heeft u al een account?',
    'auth.login.pageTitle': 'Inloggen | VurgunBet',
    'auth.verify.info': 'Om uw account te beschermen, moeten we er zeker van zijn dat u dit echt bent.',
    'auth.verify.caption': 'Bevestigingscode ontvangen:',
    'auth.verify.methodPhone': 'we sturen de code per sms of via Telegram naar uw telefoonnummer {contact}',
    'auth.verify.methodEmail': 'we sturen de code per e-mail naar {contact}',
    'auth.verify.getCode': 'Ontvang code',
    'auth.verify.cancel': 'Annuleren',
    'auth.verify.noAccess': 'Ik heb geen toegang tot het telefoonnummer',
    'auth.verify.enterCode': 'Voer bevestigingscode in:',
    'auth.verify.confirm': 'Bevestigen',
    'auth.verify.continue': 'Doorgaan',
    'auth.verify.codeInfoPhone': 'Voer de verificatiecode in. We hebben het per sms of via Telegram naar uw telefoonnummer {contact} gestuurd.',
    'auth.verify.codeInfoEmail': 'Voer de verificatiecode in. We hebben het per e-mail verzonden naar {contact}.',
    'auth.verify.neverReceived': 'Ik heb nooit een code ontvangen',
    'auth.verify.resend': 'Code opnieuw verzenden',
    'auth.verify.noAccessEmail': 'Ik heb geen toegang tot e-mail',
    'auth.verify.help.title': 'Als er nooit een bevestigingscode is ontvangen',
    'auth.verify.help.bodyPhone': 'Zorg ervoor dat het telefoonnummer correct is en dat uw apparaat voldoende vrij geheugen heeft. Controleer of het bericht in de spammap is terechtgekomen.',
    'auth.verify.help.bodyEmail': 'Zorg ervoor dat het e-mailadres correct is. Controleer of het bericht in de spammap is terechtgekomen.',
    'auth.verify.help.step1': 'Open de Berichten-app',
    'auth.verify.help.step2': 'Druk op de knop in de rechterbovenhoek',
    'auth.verify.help.step3': 'Selecteer \'Spam en geblokkeerd\'',
    'auth.verify.help.understood': 'Begrepen',
    'auth.recover.title': 'Wachtwoordherstel',
    'auth.recover.pageTitle': 'Wachtwoordherstel | VurgunBet',
    'auth.recover.continue': 'Doorgaan',
    'auth.recover.noAccess': 'Ik heb geen toegang tot telefoonnummer/e-mailadres',
    'auth.recover.noAccessPhone': 'Ik heb geen toegang tot het telefoonnummer',
    'auth.recover.noAccessEmail': 'Ik heb geen toegang tot e-mail',
    'auth.recover.newPassword': 'Nieuw wachtwoord',
    'auth.recover.confirmPassword': 'Bevestig nieuw wachtwoord',
    'auth.recover.passwordMismatch': 'Wachtwoorden komen niet overeen',
    'auth.recover.save': 'Wachtwoord opslaan',
    'auth.recover.success': 'Uw wachtwoord is bijgewerkt. U kunt inloggen met uw nieuwe wachtwoord.',
    'auth.recover.notFound': 'Er is geen account gevonden met deze gegevens',
    'auth.verify.expiredTitle': 'De toegestane tijd voor dit proces is verstreken.',
    'auth.verify.retry': 'Opnieuw proberen',
    'welcome.stepLabel': 'Stap 1 van 3: Registratie',
    'welcome.title': 'Ontvang een welkomstbonus tot 100 TL + 300 FS!',
    'welcome.step1.title': 'Registreren',
    'welcome.step1.sub': 'Op de website of in de app',
    'welcome.step2.title': 'Voltooi de verificatie',
    'welcome.step2.sub': 'Het duurt slechts een paar minuten',
    'welcome.step3.title': 'Doe een aanbetaling',
    'welcome.step3.sub': 'Grotere storting – grotere bonus!',
    'welcome.start': 'Begin',
    'welcome.rules': 'Volledige promotievoorwaarden',
    'account.loading': 'Laden...',
    'account.save': 'Opslaan',
    'account.empty': 'Geen gegevens gevonden',
    'account.nav.overview': 'Overzicht',
    'account.nav.profile': 'Persoonlijke gegevens',
    'account.nav.verification': 'Verificatie',
    'account.nav.cashier': 'Kassa',
    'account.nav.bets': 'Mijn weddenschappen',
    'account.nav.bonuses': 'Bonussen',
    'account.nav.notifications': 'Meldingen',
    'account.nav.security': 'Beveiliging',
    'account.nav.support': 'Support',
    'account.menu.profile': 'Mijn profiel',
    'account.menu.payments': 'Stortingen en opnames',
    'account.menu.history': 'Inzet- en transactiegeschiedenis',
    'account.menu.requests': 'Verzoeken',
    'account.menu.responsible': 'Verantwoord gamen',
    'account.menu.vip': 'Uw VIP-status',
    'support.liveChat': 'Live-ondersteuning',
    'account.menu.deposit': 'Doe een aanbetaling',
    'account.overview.title': 'Rekeningoverzicht',
    'account.overview.balance': 'Saldo',
    'account.overview.bonusBalance': 'Bonussaldo',
    'account.overview.accountNo': 'Rekeningnr.',
    'account.overview.verification': 'Verificatie',
    'account.overview.totalBets': 'Totaal weddenschappen',
    'account.profile.name': 'Volledige naam',
    'account.profile.saved': 'Uw gegevens zijn opgeslagen',
    'account.profile.marketingEmail': 'Ik wil promo-e-mails ontvangen',
    'account.profile.marketingSms': 'Ik wil promo-sms ontvangen',
    'account.profile.tab.details': 'Persoonlijke gegevens',
    'account.profile.tab.phone': 'Telefoonnummer wijzigen',
    'account.profile.tab.phoneAdd': 'Telefoonnummer toevoegen',
    'account.profile.tab.phoneVerify': 'Telefoonnummer verifiëren',
    'account.profile.tab.email': 'Wijzig e-mailadres',
    'account.profile.tab.emailAdd': 'E-mailadres toevoegen',
    'account.profile.tab.emailVerify': 'E-mail verifiëren',
    'account.profile.tab.password': 'Wachtwoord wijzigen',
    'account.profile.section.personal': 'PERSOONLIJKE GEGEVENS',
    'account.profile.section.lastLogin': 'LAATSTE INLOGGEGEVENS',
    'account.profile.section.contacts': 'CONTACTEN',
    'account.profile.section.marketing': 'CONTACT-VOORKEUREN',
    'account.profile.field.name': 'Naam:',
    'account.profile.field.verification': 'Status van identiteitsverificatie:',
    'account.profile.field.accountNo': 'Rekeningnummer:',
    'account.profile.field.currency': 'Munteenheid:',
    'account.profile.field.phone': 'Telefoonnummer:',
    'account.profile.field.email': 'E-mail:',
    'account.profile.field.time': 'Tijd:',
    'account.profile.field.ip': 'IP-adres:',
    'account.profile.change': 'Wijziging',
    'account.profile.add': 'Toevoegen',
    'account.profile.status.verified': 'Geverifieerd',
    'account.profile.status.unverified': 'Niet geverifieerd',
    'account.profile.marketingIntro': 'Ontvang meldingen over promoties en nieuws:',
    'account.profile.marketing.email': 'E-mail',
    'account.profile.marketing.sms': 'Sms',
    'account.profile.marketing.push': 'Pushmeldingen',
    'account.profile.marketing.web': 'Website-meldingen',
    'account.profile.verification.basic': 'Niet geverifieerd',
    'account.profile.verification.verified': 'Geverifieerd',
    'account.profile.verification.pending': 'In behandeling',
    'account.profile.verify': 'Verifiëren',
    'account.profile.tab.kyc': 'Identiteitsverificatie',
    'account.profile.kyc.title': 'Identiteitsverificatie',
    'account.profile.kyc.intro': 'Dien uw nationaal identiteitsnummer, stad, adres en identiteitsfoto\'s in. Uw account wordt na beoordeling geverifieerd.',
    'account.profile.kyc.tcLabel': 'Nationaal ID-nummer',
    'account.profile.kyc.tcInvalid': 'Voer een geldig nationaal ID-nummer van 11 cijfers in',
    'account.profile.kyc.cityLabel': 'Stad',
    'account.profile.kyc.cityPlaceholder': 'Selecteer een stad',
    'account.profile.kyc.cityRequired': 'Stadselectie is vereist',
    'account.profile.kyc.addressLabel': 'Adres',
    'account.profile.kyc.addressHint': 'Voer uw volledige adres in. Bewerk het als het onjuist is.',
    'account.profile.kyc.addressRequired': 'Adres moet minimaal 5 tekens lang zijn',
    'account.profile.kyc.frontLabel': 'Identiteitsvoorzijde',
    'account.profile.kyc.frontHint': 'Upload een foto van de voorkant van uw identiteitsbewijs',
    'account.profile.kyc.backLabel': 'Identiteitskaart terug',
    'account.profile.kyc.backHint': 'Upload een foto van de achterkant van uw identiteitsbewijs',
    'account.profile.kyc.photoRequired': 'ID-voorfoto is vereist',
    'account.profile.kyc.backRequired': 'ID-achterfoto is vereist',
    'account.profile.kyc.submit': 'Indienen',
    'account.profile.kyc.submitted': 'Uw verificatieverzoek is ontvangen en wordt beoordeeld',
    'account.profile.kyc.pendingMessage': 'Uw verificatieverzoek wordt beoordeeld. U kunt pas nieuwe documenten indienen als het probleem is opgelost.',
    'account.profile.kyc.alreadyVerified': 'Uw account is al geverifieerd.',
    'account.profile.todayAt': 'Vandaag om',
    'account.profile.mobile.personalData': 'Persoonlijke gegevens',
    'account.profile.mobile.aboutAccount': 'Over rekening',
    'account.profile.mobile.passwordChange': 'Wachtwoord wijzigen',
    'account.profile.next': 'Volgende',
    'account.profile.changeEmailTitle': 'Nieuw e-mailadres',
    'account.profile.changePhoneTitle': 'Nieuw telefoonnummer',
    'account.profile.addEmailTitle': 'E-mailadres toevoegen',
    'account.profile.addPhoneTitle': 'Telefoonnummer toevoegen',
    'account.profile.verifyEmailTitle': 'Controleer het e-mailadres',
    'account.profile.verifyPhoneTitle': 'Telefoonnummer verifiëren',
    'account.profile.contactSupport': 'Neem contact op met de ondersteuning om uw gegevens te wijzigen.',
    'account.profile.contactSupportAddPhone': 'Maak een ondersteuningsverzoek aan om een ​​telefoonnummer toe te voegen.',
    'account.profile.contactSupportChangePhone': 'Maak een ondersteuningsverzoek aan om uw telefoonnummer te wijzigen.',
    'account.profile.contactSupportVerifyPhone': 'Maak een ondersteuningsverzoek aan om uw telefoonnummer te verifiëren.',
    'account.profile.contactSupportAddEmail': 'Maak een ondersteuningsverzoek aan om een ​​e-mailadres toe te voegen.',
    'account.profile.contactSupportChangeEmail': 'Maak een ondersteuningsverzoek aan om uw e-mailadres te wijzigen.',
    'account.profile.step.support': 'Maak een ondersteuningsverzoek aan',
    'account.profile.step.sharePhone': 'Deel uw telefoonnummer',
    'account.profile.step.shareNewPhone': 'Deel uw nieuwe telefoonnummer',
    'account.profile.step.requestVerify': 'Dien uw verificatieverzoek in',
    'account.profile.step.confirmSms': 'Bevestig met de sms-code',
    'account.profile.step.shareEmail': 'Deel uw e-mailadres',
    'account.profile.step.shareNewEmail': 'Deel uw nieuwe e-mailadres',
    'account.profile.step.confirmEmail': 'Volledige e-mailbevestiging',
    'account.profile.contactSupportBtn': 'Neem contact op met ondersteuning',
    'account.profile.otp.addPhoneHint': 'Voer uw telefoonnummer in. Wij sturen u per sms een verificatiecode.',
    'account.profile.otp.changePhoneHint': 'Voer uw nieuwe telefoonnummer in. De wijziging wordt bevestigd met een sms-code.',
    'account.profile.otp.verifyPhoneHint': 'We sturen een code om uw telefoonnummer te verifiëren.',
    'account.profile.otp.addEmailHint': 'Voer uw e-mailadres in. Wij sturen u per e-mail een verificatiecode.',
    'account.profile.otp.verifyEmailHint': 'We sturen een code om uw e-mailadres te verifiëren.',
    'account.profile.otp.changeEmailHint': 'Voer uw nieuwe e-mailadres in. De wijziging wordt bevestigd met een e-mailcode.',
    'account.profile.otp.codeSentPhone': 'We hebben een verificatiecode verzonden naar:',
    'account.profile.otp.codeSentEmail': 'We hebben een verificatiecode verzonden naar:',
    'account.profile.otp.codeSent': 'Verificatiecode verzonden',
    'account.profile.otp.codeLabel': 'Verificatiecode',
    'account.profile.otp.resend': 'Code opnieuw verzenden',
    'account.profile.otp.phoneRequired': 'Telefoonnummer is vereist',
    'account.profile.otp.emailRequired': 'E-mailadres is vereist',
    'account.profile.otp.codeRequired': 'Verificatiecode is vereist',
    'account.profile.otp.sessionMissing': 'Verificatiesessie niet gevonden',
    'account.profile.otp.saved': 'Uw contactgegevens zijn bijgewerkt',
    'account.profile.passwordConfirm': 'Bevestig nieuw wachtwoord',
    'account.profile.passwordRequired': 'Vul alle wachtwoordvelden in',
    'account.profile.passwordMismatch': 'Nieuwe wachtwoorden komen niet overeen',
    'account.profile.passwordSame': 'Het nieuwe wachtwoord mag niet hetzelfde zijn als uw huidige wachtwoord',
    'account.profile.send': 'Versturen',
    'account.profile.passwordHint': 'Gebruik het beveiligingsgedeelte om uw wachtwoord te wijzigen.',
    'account.verification.desc': 'Identiteitsverificatie is vereist voor opnames en volledige accounttoegang.',
    'account.verification.verified': 'Geverifieerd',
    'account.verification.pending': 'In behandeling',
    'account.verification.rejected': 'Afgewezen',
    'account.verification.step1': 'Upload een foto van uw paspoort of identiteitsbewijs',
    'account.verification.step2': 'Voeg een selfie toe terwijl je het document vasthoudt',
    'account.verification.step3': 'De beoordeling wordt doorgaans binnen 24 uur voltooid',
    'account.verification.submit': 'Verificatie starten',
    'account.verification.submitted': 'Uw documenten worden beoordeeld',
    'account.cashier.deposit': 'Storten',
    'account.cashier.withdraw': 'Opnemen',
    'account.cashier.amount': 'Bedrag (TL)',
    'account.cashier.balance': 'Huidig ​​saldo: {amount}',
    'account.cashier.history': 'Transactiegeschiedenis',
    'account.cashier.type': 'Type',
    'account.cashier.date': 'Datum',
    'account.payments.title': 'Stortingen en opnames',
    'account.payments.back': 'Terug',
    'account.payments.selectMethod': 'Selecteer een methode',
    'account.payments.group.havale': 'Überweisung',
    'account.payments.group.card': 'Kreditkarte',
    'account.payments.group.crypto': 'Krypto',
    'account.payments.group.other': 'Sonstige',
    'account.payments.noMethods': 'Er zijn momenteel geen betaalmethoden beschikbaar.',
    'account.payments.from': 'van {amount} TL',
    'account.payments.depositTitle': 'Saldo opwaarderen met {method}',
    'account.payments.withdrawTitle': 'Opnemen met {method}',
    'account.payments.depositNotice': 'Aandacht! De bankkaart moet op naam van de rekeninghouder staan. Betalingen met kaarten van derden worden afgewezen.',
    'account.payments.withdrawNotice': 'Opnameverzoeken worden verwerkt op basis van uw verificatiestatus.',
    'account.payments.addAmount': 'Storten',
    'account.payments.withdrawSubmit': '{amount} TL intrekken',
    'account.payments.requests': 'Uw verzoeken',
    'account.payments.insufficientBalance': 'Onvoldoende evenwicht',
    'account.payments.minWithdrawNotice': 'Minimumbedrag vereist om winsten op te nemen: {amount}',
    'account.payments.withdrawGoDeposit': 'Storten',
    'account.payments.selectAnotherMethod': 'Selecteer een andere methode',
    'account.payments.requestsTitle': 'Transactieverzoeken',
    'account.payments.requestsEmpty': 'U heeft nog geen transactieverzoeken.',
    'account.payments.filterAll': 'Alle',
    'account.payments.filterCompleted': 'Voltooid',
    'account.payments.filterProcessing': 'Verwerking',
    'account.payments.filterCancelled': 'Geannuleerd',
    'account.payments.colNumber': 'NUMMER',
    'account.payments.colDate': 'DATUM',
    'account.payments.colType': 'TYPE',
    'account.payments.colMethod': 'METHODE',
    'account.payments.colAmount': 'HOEVEELHEID',
    'account.payments.status': 'Status',
    'account.payments.status_completed': 'Voltooid',
    'account.payments.status_pending': 'In behandeling',
    'account.payments.status_processing': 'Verwerking',
    'account.payments.status_cancelled': 'Geannuleerd',
    'account.payments.status_rejected': 'Afgewezen',
    'account.payments.status_failed': 'Mislukt',
    'account.payments.status_approved': 'Goedgekeurd',
    'account.payments.status_expired': 'Verlopen',
    'account.payments.goToRequests': 'Mijn verzoeken',
    'account.payments.method.crypto': 'Crypto',
    'account.payments.method.maxhavale': 'Max Havale',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Snelheid Havale',
    'account.payments.havalespeed.depositPending': 'Voltooi uw Speed ​​Havale-aanbetaling',
    'account.payments.havalespeed.withdrawPending': 'Uw Speed ​​Havale-opname wordt verwerkt',
    'account.payments.havalespeed.processing': 'Nog tijd over',
    'account.payments.havalespeed.confirmPaid': 'Ik ben overgestapt, informeer',
    'account.payments.havalespeed.confirming': 'Melding verzenden…',
    'account.payments.havalespeed.confirmSent': 'Kennisgeving ontvangen. Wachten op goedkeuring.',
    'account.payments.havalespeed.cancelDeposit': 'Aanvraag annuleren',
    'account.payments.havalespeed.cancelling': 'Annuleren…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Volledige naam',
    'account.payments.havale.amountLabel': 'Bedrag',
    'account.payments.havalespeed.approvedHint': '{amount} is aan uw saldo toegevoegd.',
    'account.payments.havalespeed.approvedHintGeneric': 'Uw storting is goedgekeurd en toegevoegd aan uw saldo.',
    'account.payments.havalespeed.rejectedHint': 'Uw Speed ​​Havale-verzoek is afgewezen. U kunt een nieuwe storting proberen.',
    'account.payments.maxhavale.depositPending': 'Voltooi uw Max Havale-storting',
    'account.payments.maxhavale.withdrawPending': 'Uw Max Havale-opname wordt verwerkt',
    'account.payments.maxhavale.processing': 'Nog tijd over',
    'account.payments.maxhavale.cancelDeposit': 'Aanvraag annuleren',
    'account.payments.maxhavale.cancelling': 'Annuleren…',
    'account.payments.maxhavale.openPayment': 'Open de stortingspagina',
    'account.payments.maxhavale.urlMissing': 'Betalingsgegevens konden niet worden geladen. U kunt dit verzoek annuleren en het opnieuw proberen.',
    'account.payments.maxhavale.bankName': 'Bank',
    'account.payments.havaleBtq.depositPending': 'Voltooi uw Havale-storting',
    'account.payments.havaleBtq.withdrawPending': 'Uw Havale-opname wordt verwerkt',
    'account.payments.havaleBtq.processing': 'Nog tijd over',
    'account.payments.havaleBtq.cancelDeposit': 'Aanvraag annuleren',
    'account.payments.havaleBtq.cancelling': 'Annuleren…',
    'account.payments.havaleBtq.openPayment': 'Open de stortingspagina',
    'account.payments.havaleBtq.urlMissing': 'Betalingsgegevens konden niet worden geladen.',
    'account.payments.havaleBtq.bankName': 'Bank',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'BetaalUrus',
    'account.payments.payurus.walletId': 'PayUrus portemonnee-ID',
    'account.payments.payurus.walletName': 'Naam portemonneehouder',
    'account.payments.payurus.openPayment': 'Heropen de stortingspagina',
    'account.payments.payurus.reopenPayment': 'Heropen de stortingspagina',
    'account.payments.payurus.urlMissing': 'De link naar de betalingspagina kan niet worden geladen. U kunt dit verzoek annuleren en het opnieuw proberen.',
    'account.payments.payurus.cancelDeposit': 'Aanvraag annuleren',
    'account.payments.payurus.cancelling': 'Annuleren…',
    'account.payments.payurus.depositPending': 'Rond uw PayUrus-betaling af',
    'account.payments.payurus.withdrawPending': 'Uw PayUrus-opname wordt verwerkt',
    'account.payments.payurus.processing': 'Nog tijd over',
    'account.payments.payurus.depositSuccess': 'Betaling succesvol',
    'account.payments.payurus.depositSuccessHint': '{amount} is aan uw saldo toegevoegd.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Uw storting {provider} is aan uw saldo toegevoegd.',
    'account.payments.payurus.depositProcessing': 'Betalingsverwerking',
    'account.payments.payurus.depositProcessingHint': 'Uw {provider}-betaling wordt geverifieerd. Wacht alstublieft.',
    'account.payments.payurus.depositFailed': 'Betaling mislukt',
    'account.payments.payurus.depositFailedHint': 'Uw {provider}-betaling kon niet worden voltooid. U kunt een nieuwe storting proberen.',
    'account.payments.payurus.continue': 'Doorgaan',
    'account.payments.payurus.nameMismatch': 'Je voor- en achternaam komen niet overeen',
    'account.payments.payurus.nameMismatchDetail': 'De naam van de rekeninghouder komt niet overeen met de naam die de aanbieder retourneert. PayUrus-rekeninghouder: {name}',
    'account.payments.payurus.rateLimit': 'Nog een opname naar deze portemonnee is nog niet toegestaan',
    'account.payments.payurus.rateLimitDetail': 'PayUrus beperkt hoe vaak u kunt opnemen in dezelfde portemonnee. Probeer het later opnieuw.',
    'account.payments.payurus.walletInvalid': 'PayUrus-portemonneegegevens konden niet worden geverifieerd',
    'account.payments.payurus.walletInvalidDetail': 'Controleer de portemonnee-ID of de naam van de portemonneehouder en probeer het opnieuw.',
    'account.payments.method.oplati': 'Papara',
    'account.payments.method.raschet': 'Betalingssysteem «Raschet»',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'Nationaal identiteitsbewijs (TC)',
    'account.payments.havale.firstName': 'Voornaam',
    'account.payments.havale.lastName': 'Achternaam',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Bank',
    'account.payments.havale.transferTo': 'Maak over naar onderstaande rekening',
    'account.payments.havale.accountName': 'Accountnaam',
    'account.payments.havale.copyIban': 'Kopiëren',
    'account.payments.havale.copyName': 'Kopiëren',
    'account.payments.havale.copyAmount': 'Kopieer bedrag',
    'account.payments.havale.copyBank': 'Bank kopiëren',
    'account.payments.havale.copied': 'Gekopieerd',
    'account.payments.havale.countdown': 'Nog tijd over',
    'account.payments.havale.activeNotice': 'U heeft een actief verzoek. Er kan pas een nieuwe worden gemaakt als de timer afloopt.',
    'account.payments.havale.amountDue': 'Te storten bedrag',
    'account.payments.havale.waitNew': 'Wacht met het maken van een nieuw verzoek',
    'account.payments.havale.resultApproved': 'Aanbetaling goedgekeurd',
    'account.payments.havale.resultApprovedHint': '{amount} is aan uw saldo toegevoegd.',
    'account.payments.havale.resultRejected': 'Aanbetaling afgewezen',
    'account.payments.havale.resultRejectedHint': 'Uw verzoek is niet goedgekeurd. Je kunt het opnieuw proberen.',
    'account.payments.havale.resultExpired': 'Verzoek verlopen',
    'account.payments.havale.resultExpiredHint': 'Het betalingsvenster {provider} is geëindigd. U kunt een nieuwe aanvraag aanmaken.',
    'account.payments.havale.withdrawReceived': 'Intrekkingsverzoek ontvangen',
    'account.payments.havale.withdrawReceivedHint': 'Uw opname van {amount} is ontvangen en wordt beoordeeld.',
    'account.payments.havale.withdrawApproved': 'Intrekking goedgekeurd',
    'account.payments.havale.withdrawApprovedHint': 'Uw opname van {amount} is voltooid.',
    'account.payments.havale.withdrawRejected': 'Intrekking afgewezen',
    'account.payments.havale.withdrawRejectedHint': 'Uw opname is niet goedgekeurd. Indien nodig kunt u een nieuw verzoek aanmaken.',
    'account.payments.havale.tryAgain': 'Probeer het opnieuw',
    'account.payments.crypto.selectCoin': 'Selecteer cryptovaluta',
    'account.payments.crypto.selectNetwork': 'Selecteer netwerk',
    'account.payments.crypto.network': 'Netwerk',
    'account.payments.crypto.selectedNetwork': 'Geselecteerd netwerk',
    'account.payments.crypto.networkWarning': 'Alleen verzenden via het {network} netwerk. Geld dat via het verkeerde netwerk is verzonden, kan verloren gaan.',
    'account.payments.crypto.coin': 'Munt',
    'account.payments.crypto.depositAddress': 'Stortingsadres',
    'account.payments.crypto.copyAddress': 'Kopieer adres',
    'account.payments.crypto.yourAddress': 'Uw portemonnee-adres',
    'account.payments.crypto.estimated': 'Geschat bedrag',
    'account.payments.crypto.txHashOptional': 'TX-hash (optioneel)',
    'account.payments.crypto.submitTxHash': 'Verzend TX-hash',
    'account.payments.crypto.continueToWallet': 'Toon stortingsadres',
    'account.payments.crypto.txHashError': 'Kan TX-hash niet opslaan',
    'account.payments.crypto.confirmations': 'Netwerkbevestigingen',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': 'vanaf {amount}',
    'account.cashier.amountUsd': 'Bedrag (USD)',
    'account.payments.addAmountUsd': 'Storting {amount}',
    'account.payments.crypto.activeNotice': 'Verstuur uw overschrijving. Netwerkbevestigingen worden automatisch bijgehouden; saldo-updates wanneer de vereiste bevestigingen zijn bereikt.',
    'account.payments.crypto.noAssets': 'Er zijn momenteel geen actieve cryptonetwerken. Probeer het later opnieuw.',
    'account.bets.stake': 'Inzet',
    'account.bets.odds': 'Kansen',
    'account.bets.win': 'Winnen',
    'account.bets.status': 'Status',
    'account.bets.status_pending': 'In behandeling',
    'account.bets.status_won': 'Gewonnen',
    'account.bets.status_lost': 'Verloren',
    'account.history.tabBets': 'Weddenschappen',
    'account.history.tabTransactions': 'Transactiegeschiedenis',
    'account.history.filters': 'Filters',
    'account.history.filterGroupBetType': 'Soort weddenschap',
    'account.history.filterGroupResult': 'Resultaten van weddenschappen',
    'account.history.filterBetType_all': 'Alle',
    'account.history.filterBetType_bets': 'Weddenschappen',
    'account.history.filterBetType_slot': 'Slotspel',
    'account.history.filterBetType_dice_live': 'Dobbelspel in Live-modus',
    'account.history.filterBetType_card_live': 'Kaartspel in Live-modus',
    'account.history.filterBetType_cylinder_live': 'Roulettespel in Live-modus',
    'account.history.filterBetType_online_game': 'Online spel van bookmaker',
    'account.history.filterResult_all': 'Alle',
    'account.history.filterResult_not_settled': 'Niet geregeld',
    'account.history.filterResult_win': 'Winnen',
    'account.history.filterResult_loss': 'Verlies',
    'account.history.filterResult_cashed_out': 'Uitbetaald',
    'account.history.filterResult_void': 'Leegte',
    'account.history.filterResult_return': 'Opbrengst',
    'account.history.colDate': 'DATUM',
    'account.history.colTime': 'TIJD',
    'account.history.colBetNo': 'INZET №',
    'account.history.colCoupon': 'COUPON',
    'account.history.colStake': 'INZET',
    'account.history.colPotential': 'POTENTIEEL',
    'account.history.details': 'Details',
    'account.history.colTransactionNo': 'TRANSACTIE №',
    'account.history.colNumber': 'NUMMER',
    'account.history.colTransaction': 'TRANSACTIE',
    'account.history.colAmountBonuses': 'BEDRAG / BONUSSEN',
    'account.history.colBalanceBonuses': 'SALDO / BONUSSEN',
    'account.history.operation_deposit': 'Storten',
    'account.history.operation_deposit_pending': 'Wachten op bevestiging van de storting',
    'account.history.operation_withdrawal_pending': 'Wachten op bevestiging van opname',
    'account.history.operation_withdrawal_cancelled': 'Intrekking geannuleerd',
    'account.history.operation_withdrawal_rejected': 'Intrekking afgewezen',
    'account.history.operation_withdrawal_approved': 'Intrekking goedgekeurd',
    'account.history.operation_withdrawal_completed': 'Intrekking voltooid',
    'account.history.operation_bet_placed': 'Inzet geplaatst',
    'account.history.operation_bet_settled': 'Weddenschap afgehandeld',
    'account.history.operation_bet_lost': 'Inzet verloren',
    'account.history.operation_slot_bet_settled': 'Weddenschap op slotspel afgehandeld',
    'account.history.operation_slot_bet_placed': 'Inzet op slotspel geplaatst',
    'account.history.operation_accrual_bonus_account': 'Opbouw naar bonusaccount',
    'account.history.operation_close_bonus_account': 'Bonusaccount sluiten',
    'account.history.operation_bonus_conversion': 'Bonusconversie',
    'account.history.filterOperation_close_bonus_account': 'Bonusaccount sluiten',
    'account.history.filterOperation_accrual_bonus_account': 'Opbouw naar bonusaccount',
    'account.history.filterOperation_slot_bet_settled': 'Weddenschap op slotspel afgehandeld',
    'account.history.filterOperation_slot_bet_placed': 'Inzet op slotspel geplaatst',
    'account.history.filterOperation_withdrawal_cancelled': 'Intrekking geannuleerd',
    'account.history.filterOperation_withdrawal_rejected': 'Intrekking afgewezen',
    'account.history.filterOperation_withdrawal_approved': 'Intrekking goedgekeurd',
    'account.history.filterOperation_withdrawal_completed': 'Intrekking voltooid',
    'account.history.filterOperation_withdrawal_pending': 'Wachten op bevestiging van opname',
    'account.history.filterOperation_bonus_conversion': 'Bonusconversie',
    'account.history.filterOperation_bet_lost': 'Inzet verloren',
    'account.history.filterOperation_bet_placed': 'Inzet geplaatst',
    'account.history.filterOperation_bet_settled': 'Weddenschap afgehandeld',
    'account.history.filterOperation_deposit': 'Storten',
    'account.history.filterOperation_deposit_pending': 'Wachten op bevestiging van de storting',
    'account.history.colBetType': 'INZETTYPE',
    'account.history.colType': 'TYPE',
    'account.history.colDescription': 'BESCHRIJVING',
    'account.history.colOdds': 'KANSEN',
    'account.history.colResult': 'RESULTAAT',
    'account.history.colAmount': 'HOEVEELHEID',
    'account.history.colStatus': 'STATUS',
    'account.history.betTypeSlot': 'Slotspel',
    'account.history.betTypeSportsbook': 'Sportweddenschappen',
    'account.history.betTypeSingle': 'Enkel',
    'account.history.betTypeExpress': 'Nadrukkelijk',
    'account.history.result_pending': 'Niet geregeld',
    'account.history.result_won': 'Winnen',
    'account.history.result_lost': 'Verlies',
    'account.history.result_completed': 'Voltooid',
    'account.history.betsEmpty': 'Je hebt nog geen wedgeschiedenis.',
    'account.history.transactionsEmpty': 'U heeft nog geen transactiegeschiedenis.',
    'account.bonuses.welcomeTitle': 'Welkomstbonus',
    'account.bonuses.welcomeDesc': 'Mis geen bonusaanbiedingen bij uw eerste storting.',
    'account.bonuses.viewPromos': 'Bekijk promo\'s',
    'account.bonuses.freeSpinsTitle': 'Jouw gratis spellen',
    'account.bonuses.freeSpinsEmpty': 'Je hebt nog geen gratis spellen.',
    'account.bonuses.viewFreeSpins': 'Bekijk mijn bonussen',
    'account.vip.title': 'VIP Cashback',
    'account.vip.subtitleLine1': 'Profiteer van uw privileges',
    'account.vip.subtitleLine2': 'en ontvang elke week cashback!',
    'account.vip.yourStatus': 'Jouw status',
    'account.vip.yourCashback': 'Uw cashback',
    'account.vip.promotionRules': 'Promotieregels',
    'account.vip.stillQuestions': 'Heeft u nog vragen?',
    'account.vip.cardCashbackFreeAndBonus': 'Cashback in free bets en in bonussen',
    'account.vip.cardCashbackBonusOnly': 'Cashback in bonussen',
    'account.vip.cardCashbackTail': 'tot',
    'account.vip.tierCashbackDesc': '{metal} — Cashback in free bets en in bonussen tot {percent}%',
    'account.vip.fromAmount': 'van',
    'account.vip.betAmountWeeks': 'inzetbedrag voor 4 weken',
    'account.vip.yourStatusBadge': 'UW VIP STATUS',
    'account.vip.targetStatus': 'DOELSTATUS',
    'account.vip.cashbackLabel': 'CASHBACK',
    'account.vip.needToBet': 'Je moet inzetten vanaf',
    'account.vip.totalSettled': 'Totaal afgehandelde weddenschappen',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback free bets voor weddenschappen op sport, bonussen — voor weddenschappen op casinogokspellen',
    'account.vip.prev': 'Vorig',
    'account.vip.next': 'Volgende',
    'account.vip.rulesLoadError': 'Kan promotieregels niet laden.',
    'account.vip.faqLoadError': 'Kan veelgestelde vragen niet laden.',
    'account.vip.cashbackHistoryTitle': 'Cashback opbouwgeschiedenis',
    'account.vip.cashbackHistoryDesc': 'De cashback van de voorgaande week wordt iedere maandag tot 18.00 uur bijgeschreven. Wij houden u via SMS op de hoogte van de status van uw cashback-opbouw.',
    'account.vip.cashbackHistoryDate': 'Datum',
    'account.vip.cashbackHistoryStatus': 'Status',
    'account.vip.cashbackHistoryAmount': 'Cashback-bedrag',
    'account.vip.cashbackCalculating': 'Berekenen',
    'account.vip.pendingCashback': 'Deze week opbouw',
    'common.close': 'Sluiten',
    'appUpdate.title': 'Update downloaden',
    'appUpdate.text': 'om toegang te krijgen tot nieuwe functies',
    'appUpdate.action': 'Update',
    'account.notifications.readAll': 'Markeer alles als gelezen',
    'account.notifications.empty': 'Geen meldingen',
    'account.notifications.emptyUnread': 'Geen ongelezen meldingen',
    'account.notifications.filterAll': 'Alle',
    'account.notifications.filterUnread': 'Ongelezen ({count})',
    'account.notifications.viewAll': 'Alle meldingen',
    'account.notifications.details': 'Details',
    'account.security.current': 'Huidig ​​wachtwoord',
    'account.security.enterCurrent': 'Voer het huidige wachtwoord in',
    'account.security.new': 'Nieuw wachtwoord',
    'account.security.saved': 'Wachtwoord bijgewerkt',
    'account.responsible.tabDeposit': 'Stortingslimieten',
    'account.responsible.tabSession': 'Limieten voor gamesessies',
    'account.responsible.depositDescription': 'Stel de stortingslimiet in. Wanneer de limiet is bereikt, kunt u tot het einde van de aangegeven periode geen geld op uw rekening storten. De limiet kan onmiddellijk worden verlaagd of verwijderd. Voor het verhogen van een limiet is een bedenktijd van 24 uur nodig.',
    'account.responsible.sessionDescription': 'Stel de limiet voor de spelsessie in. Geef de maximale speeltijd op per dag, week of maand. Wanneer de limiet is bereikt, wordt u uitgelogd en kunt u pas aan het einde van de aangegeven periode inloggen. De limiet kan onmiddellijk worden verlaagd of verwijderd. Voor het verhogen van een limiet is een bedenktijd van 24 uur nodig.',
    'account.responsible.currentRestrictions': 'Huidige beperkingen',
    'account.responsible.futureRestrictions': 'Toekomstige beperkingen',
    'account.responsible.limitNotSet': 'Limiet niet ingesteld',
    'account.responsible.notSet': 'Niet ingesteld',
    'account.responsible.dailyLimit': 'Dagelijkse limiet',
    'account.responsible.weeklyLimit': 'Wekelijkse limiet',
    'account.responsible.monthlyLimit': 'Maandelijkse limiet',
    'account.responsible.hoursShort': 'H',
    'account.responsible.saved': 'Limieten bijgewerkt',
    'account.responsible.timeLimitsTitle': 'Tijdslimieten',
    'account.responsible.timeDescription': 'Zodra de limiet afloopt, wordt u uitgelogd bij uw account en kunt u pas aan het begin van de volgende periode opnieuw inloggen.',
    'account.responsible.sessionLimitMinutes': 'Sessielimiet (in minuten)',
    'account.responsible.install': 'Installeren',
    'account.responsible.confirmTitle': 'Limiet instellen?',
    'account.responsible.confirmRemoveOrLower': 'Als u de limiet verhoogt, wordt deze na 24 uur van kracht. Verlaging is per direct van toepassing.',
    'account.responsible.confirmTightenImmediately': 'Direct na bevestiging geldt een ondergrens.',
    'account.responsible.confirmSet': 'Set',
    'account.responsible.confirmCancel': 'Annuleren',
    'account.responsible.currentLimits': 'Huidige limieten',
    'account.responsible.sessionLimit': 'Sessielimiet',
    'account.responsible.timeRemaining': 'Resterende tijd',
    'account.responsible.delete': 'Verwijderen',
    'account.responsible.confirmChangeTitle': 'Weet u zeker dat u de grenswaarden wilt wijzigen?',
    'account.responsible.confirmDeleteTitle': 'Weet u zeker dat u de limiet wilt verwijderen?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Maximale sessietijd – 1.440 minuten (24 uur)',
    'account.responsible.limitBlocked': 'Sessielimiet bereikt. U bent uitgelogd.',
    'account.requests.title': 'Verzoeken',
    'account.requests.newRequest': 'Nieuw verzoek',
    'account.requests.empty': 'Geen lopende verzoeken',
    'account.requests.chooseType': 'Kies het verzoektype',
    'account.requests.cancel': 'Annuleren',
    'account.requests.sendRequest': 'Verzoek verzenden',
    'account.requests.submit': 'Indienen',
    'account.requests.error': 'Kan verzoek niet verzenden',
    'account.requests.notFound': 'Verzoektype niet gevonden',
    'account.requests.type.sport_bet_settlement': 'Afhandeling van sportweddenschappen',
    'account.requests.type.casino_bet_settlement': 'Afhandeling van casinoweddenschappen',
    'account.requests.type.hotline': 'Vraag over hotline',
    'account.requests.type.deposit': 'Vraag over storting',
    'account.requests.type.withdrawal': 'Intrekkingsvraag',
    'account.requests.type.website_app': 'Vraag over het gebruik van de website of mobiele app',
    'account.requests.type.admin': 'Vraag voor de beheerder',
    'account.requests.type.verification': 'Verificatievraag',
    'account.requests.type.bonus': 'Bonusvraag',
    'account.requests.mobile.title': 'Zijn er problemen?',
    'account.requests.mobile.desc': 'Maak een nieuw verzoek aan of u kunt antwoorden vinden in ons Helpcentrum',
    'account.requests.mobile.create': 'Maak een nieuw verzoek aan',
    'account.requests.mobile.helpCentre': 'Ga naar het Helpcentrum',
    'account.requests.group.deposit': 'AANBETALINGSVRAAG',
    'account.requests.group.withdrawal': 'INTREKKINGSVRAAG',
    'account.requests.group.other': 'ANDER',
    'account.requests.template.depositBankCard': 'Bankkaart',
    'account.requests.template.depositRaschet': '"Raschet" uniform betalingssysteem',
    'account.requests.template.depositQiwi': 'QIWI-terminal',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'Oplati',
    'account.requests.template.withdrawalOplati': 'Oplati',
    'account.requests.template.withdrawalBank': 'Bankkaart/overschrijving',
    'account.requests.form.operationDate': 'Datum en tijd van operatie',
    'account.requests.form.amount': 'Transactiebedrag',
    'account.requests.form.selectOperationDesc': 'Kies de handeling waar u een vraag over heeft',
    'account.requests.form.selectOperationBtn': 'Selecteer bediening',
    'account.requests.form.selectedOperation': 'Geselecteerde bewerking',
    'account.requests.form.noOperations': 'Geen overeenkomende bewerkingen gevonden',
    'account.requests.form.messagePlaceholder': 'Beschrijf uw vraag of probleem',
    'account.requests.form.symbolsRemaining': '{count} resterende symbolen',
    'account.requests.form.choose': 'Kiezen',
    'account.requests.form.dragOrUpload': 'Sleep hierheen of upload bestanden',
    'account.requests.form.attachFile': 'Bestand bijvoegen',
    'account.requests.form.attachHint': 'Maximaal 5 bestanden. Formaat: jpg, jpeg, png, pdf. Maximaal 7 MB.',
    'account.requests.form.attachments': 'Bijlagen',
    'account.helpCentre.title': 'Helpcentrum',
    'account.helpCentre.text1': 'Hier kunt u informatie vinden',
    'account.helpCentre.text2': 'en gebruikstips',
    'account.helpCentre.faq': 'Veelgestelde vragen',
    'account.helpCentre.instructions': 'Instructies',
    'account.helpCentre.strategies': 'Inzetstrategieën',
    'account.helpCentre.glossary': 'Glossarium',
    'account.helpCentre.go': 'Ga naar Helpcentrum',
    'account.support.subject': 'Onderwerp',
    'account.support.message': 'Bericht',
    'account.support.send': 'Versturen',
    'account.support.sent': 'Uw verzoek is ontvangen',
    'account.support.history': 'Eerdere verzoeken',
    'account.support.status_open': 'Open',
    'account.support.status_closed': 'Gesloten',
    'account.support.status_pending': 'In behandeling',
    'account.support.status_waiting': 'In behandeling',
    'account.support.status_answered': 'Beantwoord',
    'account.support.status_replied': 'Beantwoord',
    'account.support.status_in_progress': 'In uitvoering',
    'account.support.status_resolved': 'Opgelost',
    'account.pageTitle': 'Mijn account | VurgunBet',
    'sport.filter.allTime': 'Altijd',
    'sport.filter.allEvents': 'Alle evenementen',
    'sport.filter.live': 'Live',
    'sport.filter.prematch': 'Voorwedstrijd',
    'sport.filter.all': 'Alle',
    'betslip.title': 'Weddenschapsbriefje',
    'betslip.empty': 'Wedstrookje is leeg',
    'betslip.stake': 'Inzet',
    'betslip.totalOdds': 'Totale kansen',
    'betslip.potentialWin': 'Potentiële overwinning',
    'betslip.place': 'Plaats een weddenschap',
    'betslip.clear': 'Duidelijk',
    'betslip.accepted': 'Weddenschap geaccepteerd',
    'betslip.login': 'Log in om een ​​weddenschap te plaatsen',
    'betslip.emptyHint': 'Selecteer de uitkomst van het evenement om een ​​weddenschap te plaatsen',
    'betslip.amount': 'Bedrag, TL',
    'betslip.promos': 'Promo\'s',
    'betslip.active': 'Actief',
    'betslip.popular': 'Populaire evenementen',
    'footer.about': 'Over ons',
    'footer.basinda': 'In de pers',
    'footer.licence': 'Licentie',
    'footer.privacy': 'Privacybeleid',
    'footer.responsible': 'Verantwoord spelen',
    'footer.rules': 'Algemene voorwaarden',
    'footer.financial': 'Financiële diensten',
    'footer.vip': 'VIP programma',
    'footer.help': 'Helpcentrum',
    'footer.payments': 'Betalingen',
    'footer.company': 'Bedrijfsgegevens',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Regels voor gokwinkels',
    'footer.appCaption': 'Sollicitatie',
    'footer.appIos': 'voor iOS',
    'footer.appIosLong': 'Applicatie voor iOS',
    'footer.appAndroidLong': 'Applicatie voor Android',
    'footer.appAndroid': 'voor Android',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Gokken is illegaal voor personen jonger dan 18 jaar. VurgunBet opereert als een internationale online gamingoperator.',
    'footer.legal': 'VurgunBet biedt sportweddenschappen, gokspellen, live casino en gerelateerde spelproducten aan gebruikers van 18 jaar en ouder. Gebruikers moeten voldoen aan de wettelijke beperkingen die op hun locatie van toepassing zijn.',
    'footer.legal1': 'Gokken is illegaal voor personen jonger dan 18 jaar, evenals voor personen die beperkt zijn in het bezoeken van kansspelinrichtingen en virtuele kansspelinrichtingen en/of het deelnemen aan kansspelen.',
    'footer.legal2': 'VurgunBet biedt online sportweddenschappen, gokspellen, live casino en gerelateerde spelproducten. Diensten mogen alleen worden gebruikt als dit wettelijk is toegestaan.',
    'help.title': 'Helpcentrum',
    'help.searchPlaceholder': 'Zoek uw vraag',
    'help.searchSheetTitle': 'Helpcentrum: zoeken',
    'help.searchSheetDesc': 'Vind het antwoord op uw vraag',
    'help.popularSearches': 'POPULAIRE ZOEKOPDRACHTEN',
    'help.popular.identification': 'Hoe de identificatie te voltooien',
    'help.popular.deposit': 'Hoe u uw saldo kunt opwaarderen',
    'help.popular.win': 'Hoe je een overwinning kunt behalen',
    'help.askQuestion': 'Stel een vraag',
    'help.views': 'bekeken',
    'help.back': 'Terug',
    'help.noResults': 'Geen resultaten gevonden',
    'help.goToFaq': 'Ga naar Veelgestelde vragen',
    'help.instructions': 'Instructies',
    'help.training': 'Opleiding',
    'help.glossary': 'Glossarium',
    'help.notFound.code': '404',
    'help.notFound.title': 'Pagina niet gevonden',
    'help.notFound.description': 'Oeps! De pagina die u zoekt bestaat niet. Mogelijk is deze verplaatst of verwijderd.',
    'help.notFound.home': 'Home',
    'help.feedback.review': 'Schrijf een recensie',
    'help.feedback.helpful': 'Was deze informatie nuttig?',
    'help.feedback.yes': 'Ja, dank je',
    'help.feedback.no': 'Nee',
    'promos.tab.actions': 'Promo\'s',
    'promos.tab.tournaments': 'Toernooien',
    'promos.tab.actionsDesc': 'Word een kampioen',
    'promos.tab.tournamentsDesc': 'Doe mee aan toernooien',
    'promos.tab.actionsTitle': 'Promo\'s',
    'promos.tab.tournamentsTitle': 'Toernooien',
    'promos.tab.bonuses': 'Bonussen',
    'promos.tab.bonusesDesc': 'Volg uw bonussen',
    'promos.tab.bonusesTitle': 'Jouw bonussen',
    'promos.tab.promoCode': 'Promotiecode',
    'promos.tab.promoCodeDesc': 'Activeer nu',
    'promos.tab.promoCodeTitle': 'Heb je een promotiecode?',
    'promos.tournamentsIntro': 'Doe mee aan toernooien en strijd om waardevolle prijzen',
    'promos.filter.all': 'Alle',
    'promos.filter.sport': 'Sport',
    'promos.filter.casino': 'Casino',
    'promos.timer.ended': 'Beëindigd',
    'promos.timer.daysLeft': 'Links: {count} dag(en)',
    'promos.timer.hoursLeft': 'Links: {count} uur(en)',
    'promos.timer.minutesLeft': 'Links: {count} min',
    'promos.tournament.active': 'Actief',
    'promos.tournament.bonusFund': 'Bonusfonds',
    'promos.tournament.participants': 'Deelnemers',
    'promos.tournament.places': 'Plaatsen',
    'promos.tournament.untilCompletion': 'Tot voltooiing',
    'promos.tournament.untilStart': 'Tot begin',
    'promos.tournament.upcoming': 'Aankomend',
    'promos.tournament.startsIn': 'Begint binnen',
    'promos.tournament.joinWhenLive': 'Doe mee als je live bent',
    'promos.tournament.tab.rating': 'Beoordeling',
    'promos.tournament.tab.terms': 'Voorwaarden',
    'promos.tournament.tab.games': 'Spellen',
    'promos.tournament.col.participant': 'Deelnemer',
    'promos.tournament.col.points': 'Punten',
    'promos.tournament.col.bonuses': 'Bonussen',
    'promos.tournament.participate': 'Deelnemen',
    'promos.tournament.optOut': 'Afmelden',
    'promos.tournament.loginToJoin': 'Log in om mee te doen',
    'promos.tournament.promoRules': 'Promotieregels',
    'promos.tournament.questions': 'Heeft u nog vragen?',
    'promos.tournament.close': 'Sluiten',
    'promos.tournament.loading': 'Leaderboard laden…',
    'promos.tournament.emptyBoard': 'Nog geen ranglijst. Wees de eerste die meedoet!',
    'promos.tournament.noTerms': 'Regels worden binnenkort toegevoegd.',
    'promos.tournament.noGames': 'In aanmerking komende games worden binnenkort vermeld.',
    'promos.tournament.joinedOk': 'Je hebt meegedaan aan het toernooi',
    'promos.tournament.leftOk': 'Je hebt het toernooi verlaten',
    'promos.tournament.actionError': 'Kan de actie niet voltooien',
    'promos.tournament.working': 'Werken…',
    'promos.tournament.gameBadge': 'TOERNOOI',
    'promos.tournament.showAllGames': 'Toon alle spellen',
    'promos.tournament.askQuestion': 'Stel een vraag',
    'promos.tournament.faq.participate.q': 'Hoe deel te nemen aan het toernooi',
    'promos.tournament.faq.participate.a': 'Ga naar de sectie Toernooien, open het gewenste toernooi en druk op de knop Deelnemen.',
    'promos.tournament.faq.deposit.q': 'Moet ik een storting doen om aan het toernooi deel te nemen?',
    'promos.tournament.faq.deposit.a': 'Nee, deelname is gratis. Verdien punten met weddenschappen op echt saldo (min. 5 TL) op slots op het tabblad Games. Bonus-saldo weddenschappen scoren niet.',
    'promos.tournament.faq.multiple.q': 'Kan ik tegelijkertijd aan meerdere toernooien deelnemen?',
    'promos.tournament.faq.multiple.a': 'Ja. Je kunt tegelijkertijd aan meerdere actieve toernooien deelnemen; elk toernooi houdt zijn eigen klassement.',
    'promos.tournament.faq.terms.q': 'Waar kan ik de toernooivoorwaarden raadplegen?',
    'promos.tournament.faq.terms.a': 'Open het tabblad Voorwaarden in het toernooivenster of tik op Promotieregels om de volledige voorwaarden te bekijken.',
    'promos.tournament.faq.games.q': 'Welke gokspellen zijn bij het toernooi inbegrepen?',
    'promos.tournament.faq.games.a': 'In aanmerking komende games worden vermeld onder het tabblad Games. Alleen weddenschappen op deze spellen tellen mee voor de toernooiscore.',
    'promos.tournament.faq.bonuses.q': 'Welke bonussen kan ik krijgen als ik deelneem aan toernooien en deze win?',
    'promos.tournament.faq.bonuses.a': 'Je verdient contant geld en gratis spins (FS) prijzen per rang. Prijzen worden binnen 48 uur na afloop van het toernooi bijgeschreven; FS blijft 7 dagen geldig en geldprijzen hoeven slechts ×2 ingezet te worden.',
    'promos.tournament.faq.timed.q': 'Zijn toernooien beperkt in de tijd?',
    'promos.tournament.faq.timed.a': 'Ja. VURGUN VAKTİ loopt wekelijks van maandag 11:00 uur tot zondag 23:59 uur en wordt daarna automatisch verlengd.',
    'promos.tournament.faq.track.q': 'Hoe kan ik mijn toernooiresultaten en voortgang volgen?',
    'promos.tournament.faq.track.a': 'Open het tabblad Beoordeling in het toernooivenster om uw livepunten en plaats te bekijken. Scores worden direct bijgewerkt na weddenschappen op echt saldo.',
    'promos.tournament.faq.more.q': 'Ik heb nog steeds vragen.',
    'promos.tournament.faq.more.a': 'Tik hieronder op Stel een vraag om een ​​ondersteuningsverzoek te openen. Ons team neemt zo snel mogelijk contact met u op.',
    'promos.tournament.ask.title': 'Nieuw verzoek',
    'promos.tournament.ask.subtitle': 'Bonusvraag',
    'promos.tournament.ask.placeholder': 'Vul uw vraag in of beschrijf het probleem',
    'promos.tournament.ask.charsLeft': '{count} tekens resterend',
    'promos.tournament.ask.attach': 'Bestand bijvoegen',
    'promos.tournament.ask.attachHint': 'Maximaal 5 bestanden. Formaat: jpg, jpeg, png, pdf. Tot 7 MB.',
    'promos.tournament.ask.cancel': 'Annuleren',
    'promos.tournament.ask.send': 'Verzoek verzenden',
    'promos.tournament.ask.sending': 'Verzenden…',
    'promos.tournament.ask.sent': 'Uw verzoek is ontvangen. We nemen zo snel mogelijk contact met u op.',
    'promos.tournament.ask.loginRequired': 'Meld u aan om een ​​verzoek te verzenden',
    'promos.tournament.ask.error': 'Kan het verzoek niet verzenden',
    'promos.tournament.terms.periodTitle': 'Wekelijkse toernooiperiode',
    'promos.tournament.terms.pointsTitle': 'Voorwaarden voor het toekennen van punten',
    'promos.tournament.terms.points1': 'Minimale inzet is slechts 5 TL – meedoen is gratis; speel met echt saldo om punten te verdienen.',
    'promos.tournament.terms.points2': 'Elke weddenschap van 1 TL op echt saldo = 2 punten. Vrijdag t/m zondag krijgt een puntenboost van 20%!',
    'promos.tournament.terms.points3': 'Alle weddenschappen met een echt saldo op slots op de Games-tab worden onmiddellijk bijgeschreven. Bonus-saldo weddenschappen tellen niet mee.',
    'promos.tournament.terms.bonusesTitle': 'Bonussen gebruiken voorwaarden',
    'promos.tournament.terms.bonuses1': 'Geld- en FS-prijzen worden binnen 48 uur na afloop van het toernooi bijgeschreven; FS blijft 7 dagen geldig.',
    'promos.tournament.terms.bonuses2': 'Voor prijswinsten is slechts een inzet van ×2 nodig – ver onder het sectorgemiddelde.',
    'promos.tournament.terms.bonuses3': 'Het toernooi wordt elke maandag om 11:00 uur automatisch verlengd; het klassement wordt opnieuw ingesteld voor een nieuwe week.',
    'promos.bonuses.title': 'Jouw bonussen',
    'promos.promocode.title': 'Heb je een promotiecode?',
    'promos.promocode.desc': 'Voer hieronder uw promotiecode in en selecteer Activeren',
    'promos.promocode.placeholder': 'Voer promotiecode in',
    'promos.promocode.activate': 'Activeren',
    'promos.promocode.activating': 'Toepassen…',
    'promos.promocode.success': 'Promotiecode succesvol toegepast',
    'promos.promocode.error': 'Kan promotiecode niet toepassen',
    'promos.promocode.loginRequired': 'Log in om een ​​promotiecode in te wisselen',
    'promos.bonuses.loading': 'Uw bonussen laden…',
    'promos.bonuses.empty': 'Je hebt nog geen bonussen.',
    'promos.bonuses.emptyCaption': 'Geen actieve bonussen',
    'promos.bonuses.emptyDescription': 'Neem deel aan promo\'s en ontvang nieuwe bonussen!',
    'promos.bonuses.emptyButton': 'Ga naar promo\'s',
    'promos.bonuses.emptyArchiveCaption': 'Geen gearchiveerde bonussen',
    'promos.bonuses.emptyArchiveDescription': 'Neem deel aan promo\'s en ontvang nieuwe bonussen!',
    'promos.bonuses.kindFilterBonuses': 'Bonussen',
    'promos.bonuses.kindFilterFreeSpins': 'Gratis spins',
    'promos.bonuses.kindFilterAll': 'Alle',
    'promos.bonuses.kindFreeSpin': 'Gratis spel',
    'promos.bonuses.fieldNominal': 'Nominaal',
    'promos.bonuses.fieldStatus': 'Status',
    'promos.bonuses.fieldExpires': 'Verloopt',
    'promos.bonuses.fieldReceived': 'Ontvangen',
    'promos.bonuses.tabActive': 'Actief',
    'promos.bonuses.tabArchive': 'Archief',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'Jouw voortgang:',
    'promos.bonuses.statusWagering': 'Bezig met inzetten',
    'promos.bonuses.moreInfo': 'Meer informatie',
    'promos.bonuses.detailTitle': 'Bonus geactiveerd',
    'promos.bonuses.leftDays': 'nog {n} dagen over',
    'promos.bonuses.leftDay': 'links {n} dag',
    'promos.bonuses.detailLead': 'Voldoe aan de inzetvereiste en ontvang de bonus op uw hoofdaccount',
    'promos.bonuses.placeBets': 'Plaats weddenschappen met een totaalbedrag van {amount}',
    'promos.bonuses.rulesTitle': 'BONUS ACCOUNT INZETREGELS',
    'promos.bonuses.rule1': 'Winsten die aan het saldo van de bonusrekening worden toegevoegd, komen beschikbaar op de hoofdrekening nadat het bedrag met een factor 25 is ingezet. Inzetten kan worden gedaan op alle gokspellen van alle casino-aanbieders, met uitzondering van bepaalde gokspellen zoals vastgesteld door de Organisator.',
    'promos.bonuses.rule2': 'Wanneer u geld inzet van het saldo van de bonusrekening, wordt het geld eerst bijgeschreven van de hoofdrekening en vervolgens van het saldo van de bonusrekening.',
    'promos.bonuses.rule3': 'Wanneer geld wordt bijgeschreven op het saldo van de bonusrekening, worden de winsten teruggestort op het saldo van de bonusrekening.',
    'promos.bonuses.rule4': 'Nadat het inzetten is voltooid, wordt het resterende bedrag van de bonusrekening overgezet naar het hoofdsaldo, maar kan niet meer bedragen dan x3 van het bedrag dat aanvankelijk op het saldo van de bonusrekening is bijgeschreven.',
    'promos.bonuses.rule5': 'De inzetperiode bedraagt ​​3 dagen vanaf het moment dat het bonusaccount wordt geactiveerd.',
    'promos.bonuses.rule6': 'Elke volgende bonus wordt automatisch geactiveerd na het inzetten van de vorige bonus.',
    'promos.bonuses.rule7': 'Als er geld op de bonusrekening staat, is het opnemen van geld van de hoofdrekening niet mogelijk.',
    'promos.bonuses.promotionRules': 'Promotieregels',
    'promos.bonuses.askQuestion': 'Stel een vraag',
    'promos.bonuses.cancelBonus': 'Annuleer de bonus',
    'promos.bonuses.cancelConfirm': 'Uw bonussaldo wordt verwijderd en de inzet wordt geannuleerd. Doorgaan?',
    'promos.bonuses.cancelBusy': 'Annuleren…',
    'promos.bonuses.cancelTitle': 'Wilt u zich echt afmelden?',
    'promos.bonuses.cancelBody': 'In geval van weigering worden de bonussen verbrand.\nU kunt op elk moment opzeggen.',
    'promos.bonuses.cancelRefuse': 'Ik wil weigeren',
    'promos.bonuses.cancelBack': 'Overtuigd! Rug',
    'promos.bonuses.askClose': 'Sluiten',
    'promos.bonuses.askFileBadType': 'Niet-ondersteunde bestandsindeling.',
    'promos.bonuses.askFileTooBig': 'Bestand is groter dan 7 MB.',
    'promos.bonuses.askError': 'Kan verzoek niet verzenden',
    'promos.bonuses.askSent': 'Uw aanvraag is verzonden.',
    'promos.bonuses.askSending': 'Verzenden…',
    'promos.bonuses.askSend': 'Verzoek verzenden',
    'promos.bonuses.askCancel': 'Annuleren',
    'promos.bonuses.askFilesSize': 'Tot 7 MB.',
    'promos.bonuses.askFilesMax': 'Maximaal 5 bestanden.',
    'promos.bonuses.askAttach': 'Bestand bijvoegen',
    'promos.bonuses.askCharsLeft': '{n} tekens resterend',
    'promos.bonuses.askPlaceholder': 'Vul uw vraag in of beschrijf het probleem',
    'promos.bonuses.askNewRequest': 'Nieuw verzoek',
    'promos.bonuses.askBonusQuestion': 'Bonusvraag',
    'promos.bonuses.askHint': 'Stuur een vraag over uw bonus naar ondersteuning',
    'promos.bonuses.fieldWagering': 'Inzetten',
    'promos.bonuses.fieldWageringTime': 'Inzet tijd',
    'promos.bonuses.fieldMaxWithdrawal': 'Max. opname',
    'promos.bonuses.fieldUsed': 'Gebruikt',
    'promos.bonuses.statusAvailable': 'Beschikbaar',
    'promos.bonuses.statusUsed': 'Gebruikt',
    'promos.bonuses.activate': 'Activeren',
    'promos.bonuses.days': 'dagen',
    'promos.bonuses.games': 'Spellen',
    'promos.bonuses.noGames': 'Geen spelinfo',
    'promos.bonuses.play': 'Toneelstuk',
    'home.showcase.slots.title': 'Casino',
    'home.showcase.slots.count': '{count}-spellen',
    'home.showcase.slots.link': 'Bekijk spellen →',
    'home.showcase.live.title': 'Live casino',
    'home.showcase.live.count': '{count}-spellen',
    'home.showcase.live.link': 'Speel nu →',
    'home.showcase.tv.title': 'TV-spellen',
    'home.showcase.tv.count': '{count}-spellen',
    'home.showcase.fast.title': 'Snelle spellen',
    'home.showcase.fast.count': '{count}-spellen',
    'home.showcase.fast.link': 'Speel nu →',
    'home.showcase.virtual.title': 'Virtuele sport',
    'home.showcase.virtual.count': '{count}-spellen',
    'home.showcase.virtual.link': 'Speel nu →',
    'home.showcase.gamesCount': '{count}-spellen',
    'home.showcase.tv.link': 'Speel nu →',
    'home.showcase.sport.title': 'Sport',
    'home.showcase.sport.count': '3380 evenementen',
    'home.showcase.sport.link': 'Zet nu in →',
    'home.promo.category.promotions': 'Promoties',
    'home.promo.category.tournaments': 'Toernooien',
    'home.promo.filter.all': 'Alle',
    'home.promo.filter.sport': 'Sporten (5)',
    'home.promo.filter.casino': 'Casino (5)',
    'home.promo.showAll': 'Toon alles →',
    'home.promo.allPromotions': 'Alle promoties',
    'home.promo.cta.play': 'Toneelstuk',
    'home.promo.cta.join': 'Registreren',
    'home.promo.cta.details': 'Details',
    'home.promo.cta.signup': 'Aanmelden',
    'home.sport.searchEvents': 'Zoek op evenementen',
    'footer.contactUs': 'Neem contact met ons op',
    'footer.usefulInfo': 'Nuttige informatie',
    'footer.socialMedia': 'Sociale media',
    'footer.partners': 'Official Partner',
    'footer.officialPartner': 'Official\nPartner',
    'home.casino.loading': 'Spellen laden…',
    'home.casino.noGames': 'Geen spellen beschikbaar',
    'home.casino.viewAllMobile': 'Bekijk {count}-spellen',
    'home.shuffle.title': 'Weet je niet zeker welk spel je hierna moet spelen?',
    'home.shuffle.cta': 'Draai nu',
    'home.shuffle.modalTitle': 'Laat ons het perfecte spel voor jou vinden!',
    'home.shuffle.respin': 'Draai opnieuw',
    'home.shuffle.close': 'Sluiten',
    'home.jackpot.casinoTitle': 'Casino Jackpot',
    'home.jackpot.title': 'VURGUN GROTE JACKPOT',
    'home.jackpot.badgeRest': 'GROTE JACKPOT',
    'home.jackpot.winners': 'Totaal aantal winnaars: {count}',
    'home.jackpot.largest': 'Grootste overwinning',
    'home.jackpot.last': 'Laatste overwinning',
    'home.jackpot.onSlots': 'Op alle slots',
    'home.jackpot.play': 'Jackpot-spellen',
    'home.liveWins.title': 'Levende overwinningen',
    'home.liveWins.heated': 'Vurgun',
    'home.topWins.title': 'Topoverwinningen',
    'home.topWins.week': 'Deze week',
    'home.topWins.month': 'Deze maand',
    'home.topWins.day': 'Vandaag',
    'home.topWins.play': 'Toneelstuk',
    'home.topWins.prev': 'Vorig',
    'home.topWins.next': 'Volgende',
    'home.popularSlots.title': 'Populaire speelautomaten',
    'home.hotSlots.title': 'Topverdieners',
    'home.hotSlots.badge': 'HEET',
    'home.matchCarousel.title': 'Wedstrijden',
    'home.matchCarousel.liveTv': 'Live TV',
    'home.slotsCarousel.showAll': 'Toon alles',
    'home.slotsCarousel.prev': 'Vorig',
    'home.slotsCarousel.next': 'Volgende',
    'home.jackpot.grand': 'GROOT',
    'home.jackpot.major': 'BELANGRIJK',
    'home.jackpot.minor': 'MINDERJARIGE',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Club',
    'home.heroSide.vipSub': 'Exclusieve voordelen',
    'home.heroSide.promosTitle': 'Bonussen',
    'home.heroSide.promosSub': 'Laatste promo\'s',
    'home.heroSide.sportTitle': 'Sport',
    'home.heroSide.sportSub': 'Live wedden',
    'header.support': 'Support',
    'home.topEvents.showAll': 'Toon alles',
    'betslip.bonusFund': 'Bonusfonds',
    'betslip.participants': '{count} deelnemers',
    'betslip.hoursLeft': '{hours} uur resterend',
    'betslip.details': 'Details',
    'casino.viewAllCaption': 'Bekijk alles →',
    'casino.bside.promos': 'Promo\'s',
    'casino.bside.showAll': 'Toon alles →',
    'casino.lobby.slots': 'Slots',
    'casino.lobby.live': 'Live casino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'TV-spellen',
    'casino.lobby.fast': 'Snelle spellen',
    'casino.lobby.virtual': 'Virtuele sport',
    'casino.tab.review': 'Beoordeling',
    'casino.tab.favourites': 'Favorieten',
    'casino.tab.top': 'Topspellen',
    'casino.tab.peter': 'Peter & Sons-hits',
    'casino.tab.free-spins': 'Met free spins',
    'casino.tab.all': 'Alle spellen',
    'casino.tab.tournaments': 'Toernooien',
    'casino.tab.jackpot-cards': 'Jackpot Kaarten',
    'casino.tab.new': 'NIEUW',
    'casino.tab.world-cup': 'Wereldkampioenschap 2026',
    'casino.tab.buy-bonus': 'Koopbonus',
    'casino.tab.exclusive': 'Exclusief',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Pragmatisch spelen',
    'casino.tab.coins-link-vip': 'Muntenlink VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'Cascade',
    'casino.tab.megaways': 'Megaways',
    'casino.tab.collect': 'Verzamelen',
    'casino.tab.wild': 'Wild',
    'casino.tab.double': 'Dubbele kans',
    'casino.tab.megax': 'Mega X',
    'casino.tab.respin': 'Reageer',
    'casino.tab.retro': 'Retro',
    'casino.tab.fruits': 'Vruchten',
    'casino.tab.books': 'Boeken',
    'casino.tab.fast-football': 'Snel voetbal',
    'casino.tab.holdem': 'Houd ze vast',
    'casino.tab.caribbean': 'Caribisch gebied',
    'casino.tab.video-poker': 'Videopoker',
    'casino.tab.crash': 'Crash-spellen',
    'casino.tab.table-games': 'Tafelspellen',
    'casino.tab.mines': 'Mijnen',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Dobbelsteen',
    'casino.tab.scratch': 'Krasspellen',
    'casino.tab.other': 'Ander',
    'casino.tab.football': 'Voetbal',
    'casino.tab.horse-racing': 'Paardenrennen',
    'casino.tab.recommended': 'Aanbevolen',
    'casino.topProviders': 'Beste aanbieders',
    'casino.groupsAll': 'Alle',
    'casino.groupsNew': 'Nieuwe spellen',
    'casino.groupsTop': 'Beste spellen',
    'casino.groupsWager': 'Voor weddenschappen',
    'casino.groupsFreebonus': 'Voor gratis bonus',
    'casino.lobbyHome': 'Lobby Thuis',
    'casino.groups': 'Groepen',
    'casino.providers': 'Aanbieders',
    'casino.search': 'Zoeken',
    'casino.play': 'Toneelstuk',
    'casino.demo': 'Demo',
    'casino.searchModal.title': 'Zoeken',
    'casino.searchModal.placeholder': 'Zoek spellen',
    'casino.filters': 'Filters',
    'casino.filtersCount': 'Filters ({count})',
    'casino.filter.section.functions': 'Functies',
    'casino.filter.section.themes': 'Thema\'s',
    'casino.filter.bonusGame': 'Bonusspel',
    'casino.filter.buyFeature': 'Koop functie',
    'casino.filter.expandingSymbols': 'Symbolen uitbreiden',
    'casino.filter.freeSpins': 'Free Spins',
    'casino.filter.multiplier': 'Vermenigvuldiger',
    'casino.filter.respins': 'Reageert',
    'casino.filter.symbolsCollection': 'Symbolen collectie',
    'casino.filter.animals': 'Dieren',
    'casino.filter.books': 'Boeken',
    'casino.filter.classic777': 'Klassiek & 777',
    'casino.filter.coins': 'Munten',
    'casino.filter.egypt': 'Egypte',
    'casino.filter.fruits': 'Vruchten',
    'casino.filter.gods': 'Goden',
    'casino.filter.joker': 'grappenmaker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Alle aanbieders',
    'casino.selectProvider': 'Aanbieder selecteren',
    'casino.searchProviders': 'Zoekaanbieders',
    'casino.loading': 'Spellen laden…',
    'casino.noGames': 'Geen spellen gevonden',
    'casino.lucky': 'Ik heb geluk',
    'casino.sortBy': 'Sorteer op',
    'casino.sort.popular': 'Meest populair',
    'casino.sort.default': 'Standaard',
    'casino.sort.az': 'A tot Z',
    'casino.sort.za': 'Z tot A',
    'casino.sort.new': 'Nieuwste',
    'casino.sort.provider': 'Per aanbieder',
    'casino.sort.name': 'Op naam',
    'casino.showMore': 'Laat meer zien',
    'casino.viewAll': 'Alle',
    'casino.games': 'spellen',
    'casino.side.games': 'Spellen',
    'casino.side.tournament': 'Toernooi',
    'casino.side.search': 'Zoek spellen',
    'casino.side.recommended': 'Aanbevolen spellen',
    'casino.side.noGames': 'Geen spellen gevonden',
    'casino.side.noTournaments': 'Geen actieve toernooien',
    'casino.side.loading': 'Laden…',
    'casino.game.play': 'Toneelstuk',
    'casino.game.demo': 'Demo',
    'casino.game.favorite': 'Toevoegen aan favorieten',
    'casino.game.fullscreen': 'Volledig scherm',
    'casino.game.noFreeSpins': 'Geen free spins om aan dit spel toe te voegen',
    'casino.game.linkCopied': 'Link gekopieerd',
    'casino.game.closeConfirmTitle': 'Spel sluiten?',
    'casino.game.closeConfirmText': 'Het spel wordt afgesloten. Wil je doorgaan?',
    'casino.game.closeConfirmOk': 'Sluiten',
    'casino.game.closeConfirmCancel': 'Annuleren',
    'casino.game.popout': 'Openen in nieuw venster',
    'casino.game.playReal': 'Speel voor echt geld',
    'casino.game.addFreeSpins': 'Voeg free spins toe',
    'casino.game.addFreeSpinsToGame': 'Voeg free spins toe aan het spel',
    'casino.game.fsBet': 'Inzet',
    'casino.game.fsExpiresIn': 'Verloopt over',
    'casino.game.fsAdd': 'Toevoegen',
    'casino.game.fsBackToGame': 'Terug naar het spel',
    'casino.game.fsNewAvailable': 'Nieuwe free spins beschikbaar',
    'casino.game.fsUpdateRequired': 'Game-update vereist',
    'casino.game.fsUpdate': 'Update',
    'casino.game.insufficientBalance': 'Onvoldoende evenwicht',
    'casino.game.insufficientBalanceHint': 'Vul uw saldo aan om voor echt geld te spelen',
    'casino.game.insufficientContinue': 'Doorgaan',
    'casino.game.makeDeposit': 'Doe een aanbetaling',
    'casino.game.bonusInsufficientHint': 'Uw bonus saldo is te laag voor deze inzet. Overstappen naar contant geld annuleert de bonus.',
    'casino.game.switchToCash': 'Naar contant geld',
    'casino.game.demoMode': 'Demomodus',
    'casino.game.signIn': 'Log in om voor echt geld te spelen.',
    'casino.game.tryDemo': 'Probeer de demo',
    'casino.game.loading': 'Spel laden…',
    'casino.game.notFound': 'Spel niet gevonden',
    'casino.game.launchFailed': 'Spel kon niet worden gestart',
    'casino.game.demoUnavailable': 'Demo is niet beschikbaar voor dit spel.',
    'casino.game.unavailable': 'Dit spel kan nu niet worden gestart. Probeer het later opnieuw.',
    'casino.game.demoSuffix': '(demo)',
    'casino.badge.top': 'En İyi',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Toernooi',
    'casino.badge.new': 'NIEUW',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'exclusief',
    'casino.badge.jackpot': 'jackpot',
    'casino.bside.tournaments': 'Toernooien',
  },
  ru: {
    'nav.home': 'Главная',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Спорт',
    'nav.sportLive': 'Live-ставки',
    'nav.liveCasino': 'Live-казино',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Слоты',
    'nav.virtual': 'Виртуальный спорт',
    'nav.fast': 'Быстрые игры',
    'nav.tv': 'ТВ-игры',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Смотрите прямые трансляции матчей',
    'vtv.live': 'В эфире',
    'vtv.upcoming': 'Скоро',
    'vtv.search': 'Поиск',
    'vtv.searchPh': 'Поиск команд, лиг…',
    'vtv.allSports': 'Все виды спорта',
    'vtv.loading': 'Загрузка трансляций…',
    'vtv.empty': 'Матчи не найдены',
    'vtv.error': 'Не удалось загрузить трансляции',
    'vtv.pick': 'Выберите матч для просмотра',
    'vtv.streamError': 'Не удалось открыть трансляцию',
    'vtv.liveBadge': 'LIVE',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Покер',
    'nav.new': 'НОВОЕ',
    'nav.newGames': 'Новые игры',
    'nav.newPromos': 'Новые акции',
    'nav.promos': 'Акции',
    'nav.casino': 'Казино',
    'nav.apps': 'Приложения',
    'nav.results': 'Результаты',
    'header.promos': 'Акции',
    'header.help': 'Помощь',
    'header.search': 'Поиск',
    'header.settings': 'Настройки',
    'header.login': 'Войти',
    'header.join': 'Регистрация',
    'header.logout': 'Выйти',
    'header.account': 'Мой аккаунт',
    'header.deposit': 'Пополнить',
    'header.hideBalance': 'Скрыть баланс',
    'header.showBalance': 'Показать баланс',
    'header.notifications': 'Уведомления',
    'mobile.menu': 'Меню',
    'mobile.home': 'Главная',
    'mobile.myBets': 'Мои ставки',
    'mobile.navigation': 'Навигация',
    'mobile.menu.loginTitle': 'Войдите в свою учетную запись',
    'mobile.menu.loginText': 'чтобы получить полный доступ ко всем возможностям сервиса',
    'mobile.menu.tournaments': 'Турниры',
    'mobile.menu.helpNote': 'Часто задаваемые вопросы, обучение, словарь',
    'mobile.menu.appsNote': 'Для Android, iOS',
    'mobile.menu.about': 'О VurgunBet',
    'mobile.menu.aboutNote': 'Информация, лицензии',
    'basinda.title': 'В прессе',
    'basinda.lead': 'Моменты спонсорства стадиона и поля VurgunBet.',
    'basinda.menuNote': 'Спонсорство, пресса',
    'basinda.item1': 'Сассуоло - Пиза',
    'basinda.item2': 'Турин - Аталанта',
    'basinda.item3': 'Алавес - Эльче',
    'basinda.item4': 'Леванте - Алавес',
    'basinda.item5': 'Фенербахче - Погонь Щецин',
    'mobile.menu.siteTour': 'Экскурсия по сайту',
    'mobile.menu.siteTourText': 'займет всего 2 минуты →',
    'mobile.menu.history': 'Посмотреть историю',
    'mobile.menu.historyEmpty': 'Истории посещений пока нет',
    'mobile.menu.historyEmptyText': 'Здесь вы можете найти все разделы и спортивные события, которые вы просмотрели.',
    'mobile.menu.clearHistory': 'Очистить историю',
    'mobile.menu.openPromos': 'Акции',
    'mobile.menu.searchGames': 'Поиск игр',
    'mobile.menu.responsibleGaming': 'Ответственная игра',
    'mobile.account.number': 'Аккаунт: {id}',
    'mobile.account.copy': 'Скопировать номер счета',
    'mobile.account.copied': 'Скопировано',
    'mobile.account.balance': 'Баланс: {amount}',
    'settings.section.sport': 'Спорт',
    'settings.section.casino': 'Казино',
    'settings.section.interface': 'Интерфейс',
    'settings.section.navigation': 'Навигация',
    'settings.eventDisplay': 'Отображение событий',
    'settings.eventDisplay.table': 'Стол',
    'settings.eventDisplay.list': 'Список',
    'settings.betSlipLocation': 'Место купона ставки',
    'settings.betSlipLocation.bottom': 'В нижней панели',
    'settings.betSlipLocation.above': 'Над панелью',
    'settings.betSlipSettings': 'Настройки купона ставки',
    'settings.betSlip.showLiveTimer': 'Показывать таймер Live-событий в купоне ставки',
    'settings.betSlip.showEventTime': 'Показывать время и дату начала события в купоне ставки',
    'settings.betSlip.skipClearConfirm': 'Не запрашивайте подтверждение для очистки купонов ставок',
    'settings.betSlip.view': 'Просмотр купона ставки',
    'settings.betSlip.view.auto': 'Автоматический выбор',
    'settings.betSlip.view.narrow': 'Узкий',
    'settings.betSlip.view.wide': 'Широкий',
    'settings.odds.title': 'Шансы',
    'settings.odds.boosted': 'Повысился',
    'settings.odds.on': 'на',
    'settings.odds.off': 'выключенный',
    'settings.odds.hideBoosted': 'Не отображать повышенные коэффициенты в разделе «Спорт»',
    'settings.odds.european': 'Европейский',
    'settings.odds.american': 'Американский',
    'settings.odds.hongkong': 'Гонконг',
    'settings.odds.indonesian': 'индонезийский',
    'settings.odds.malaysian': 'Малазийский',
    'settings.favouriteSports': 'Любимые виды спорта',
    'settings.favouriteSports.empty': 'Никто',
    'settings.favouriteSports.desc': 'Добавьте любимые виды спорта, чтобы они отображались первыми в разделе «Спорт».',
    'settings.casinoProMode': 'Профессиональный режим',
    'settings.casinoProMode.desc': 'Отображение волатильности слота и других значений на игровой карте.',
    'settings.casinoView.standard': 'Стандартный вид',
    'settings.casinoView.pro': 'Профессиональный режим',
    'settings.theme.title': 'Тема сайта',
    'settings.theme.auto': 'Авто',
    'settings.theme.light': 'Свет',
    'settings.theme.dark': 'Темный',
    'settings.hideBalance': 'Скрыть баланс',
    'settings.hideBalance.desc': 'Проведите пальцем по балансу в заголовке, чтобы скрыть его.',
    'settings.showUpButton': 'Показать кнопку «Вверх»',
    'settings.language': 'Язык',
    'settings.nav.sportSection': 'В разделе Спорт',
    'settings.nav.casinoSection': 'В разделе Казино',
    'settings.nav.menu': 'В меню',
    'settings.title': 'Настройки сайта',
    'settings.reset': 'Возврат по умолчанию',
    'settings.betSlip.title': 'Купон ставки',
    'settings.nav.betAcceptance': 'Принятие ставок',
    'settings.nav.cashOut': 'Вывод средств',
    'settings.nav.favouriteBets': 'Любимые ставки',
    'settings.nav.betSlip': 'Просмотр купона ставки',
    'settings.navigation.auto': 'Авто',
    'settings.navigation.left': 'Слева',
    'settings.navigation.top': 'Вершина',
    'settings.eventList.title': 'Список событий',
    'settings.eventList.minimised': 'По умолчанию все события свернуты',
    'settings.eventPage.title': 'Страница мероприятия',
    'settings.view.large': 'Большой вид',
    'settings.view.compact': 'Компактный вид',
    'settings.favouriteSports.descLong': 'Добавьте свои любимые виды спорта, чтобы они отображались первыми в разделе «Спорт». Вы можете изменить их порядок, перетащив их.',
    'settings.favouriteSports.hint': 'Нажмите ★, чтобы добавить вид спорта в избранное.',
    'settings.sport.football': 'Футбол',
    'settings.sport.hockey': 'Хоккей',
    'settings.sport.tennis': 'Теннис',
    'settings.sport.basketball': 'Баскетбол',
    'settings.sport.esports': 'Киберспорт',
    'settings.sport.tableTennis': 'Настольный теннис',
    'settings.sport.volleyball': 'Волейбол',
    'settings.sport.handball': 'Гандбол',
    'settings.sport.mixFights': 'Смешивание. Бои',
    'settings.sport.boxing': 'Бокс',
    'settings.sport.futsal': 'футзал',
    'settings.sport.baseball': 'Бейсбол',
    'settings.sport.americanFootball': 'американский футбол',
    'settings.sport.rugby': 'Регби',
    'settings.sport.waterPolo': 'Водное поло',
    'settings.sport.fieldHockey': 'Хоккей на траве',
    'settings.sport.racing': 'Гонки',
    'settings.sport.cycling': 'Велоспорт',
    'settings.sport.sports': 'Спорт',
    'settings.sport.beachSoccer': 'Пляжный футбол',
    'settings.sport.basketball3x3': 'Баскетбол 3х3',
    'settings.sport.lacrosse': 'Лакросс',
    'settings.sport.australianFootball': 'Австралийский футбол',
    'settings.sport.cricket': 'Крикет',
    'settings.sport.snooker': 'Снукер',
    'settings.sport.darts': 'Дартс',
    'settings.sport.badminton': 'Бадминтон',
    'page.title': 'VurgunBet — Ставки на спорт онлайн',
    'auth.login.title': 'Вход',
    'auth.login.submit': 'Войти',
    'auth.login.link': 'Войти',
    'auth.register.title': 'Регистрация',
    'auth.register.bannerHighlight': '100% ДО',
    'auth.register.bannerTitle': 'БОНУС +100 FREE SPIN',
    'auth.register.bannerDesc': '+5 FREE BETS',
    'auth.register.perkFast': 'Анонимный',
    'auth.register.perkSafe': 'Нулевые комиссии',
    'auth.register.perkBonus': 'Поддержка VPN',
    'auth.register.orSignUpWith': 'ИЛИ ЗАРЕГИСТРИРУЙТЕСЬ',
    'auth.login.orSignInWith': 'ИЛИ ВОЙТИ С помощью',
    'auth.webauthn.login': 'Войдите с помощью Face ID/Touch ID',
    'auth.webauthn.offerTitle': 'Сохранить Face ID на этом устройстве',
    'auth.webauthn.offerBody': 'В следующий раз вы сможете быстро войти в систему с помощью Face ID, Touch ID или Windows Hello.',
    'auth.webauthn.offerConfirm': 'Сохранить на этом устройстве',
    'auth.webauthn.offerSkip': 'Не сейчас',
    'auth.webauthn.needRegister': 'Сначала сохраните Face ID/Touch ID в своем профиле.',
    'auth.webauthn.failed': 'Не удалось войти в систему с помощью биометрических данных.',
    'auth.webauthn.unsupported': 'Face ID/Touch ID недоступен на этом устройстве.',
    'auth.webauthn.registerFailed': 'Не удалось сохранить биометрический логин.',
    'auth.webauthn.alreadyRegistered': 'Это устройство уже зарегистрировано',
    'auth.webauthn.thisDevice': 'Это устройство',
    'auth.webauthn.manageTitle': 'Идентификатор лица / Touch ID',
    'auth.webauthn.manageDesc': 'Зарегистрируйте ключ доступа для входа в систему с помощью Face ID, Touch ID или Windows Hello на этом устройстве.',
    'auth.webauthn.empty': 'Биометрические данные для входа не сохранены.',
    'auth.webauthn.add': 'Сохранить на этом устройстве',
    'auth.webauthn.remove': 'Удалять',
    'auth.webauthn.removed': 'Ключ доступа удален.',
    'auth.webauthn.registered': 'Биометрический вход сохранен.',
    'auth.webauthn.loadFailed': 'Не удалось загрузить ключи доступа',
    'auth.webauthn.removeFailed': 'Не удалось удалить ключ доступа',
    'account.profile.tab.passkeys': 'Идентификатор лица / Touch ID',
    'account.profile.mobile.passkeys': 'Идентификатор лица / Touch ID',
    'account.profile.mobile.passkeysHint': 'Быстрый вход',
    'auth.register.socialNotConfigured': 'Этот метод еще не настроен',
    'auth.register.pageTitle': 'Регистрация | ⟦ВУРГУНБЕТХ100⟧',
    'auth.register.submit': 'Регистрация',
    'auth.register.link': 'Регистрация',
    'guestPopup.title': 'Free bet 100 TL + 300 free spins',
    'guestPopup.subtitle': 'для новых клиентов',
    'guestPopup.cta': 'Регистрация',
    'language.choose': 'Выберите язык',
    'auth.register.slogan': 'БЛИЖЕ К ИГРЕ',
    'auth.register.smsHint': 'На этот номер будет отправлено текстовое сообщение с кодом',
    'auth.register.promoToggle': 'У меня есть промокод',
    'auth.register.rules': 'Мне 18 лет, и я принимаю Условия использования и Политику конфиденциальности *',
    'auth.register.rulesBefore': 'Мне 18 лет и я принимаю',
    'auth.register.termsLink': 'Условия и положения',
    'auth.register.rulesAnd': 'и',
    'auth.register.privacyLink': 'политика конфиденциальности',
    'auth.register.rulesAfter': ' *',
    'auth.register.rulesLink': 'Условия и положения',
    'auth.register.rulesRequired': 'Вы должны принять Условия использования и Политику конфиденциальности.',
    'auth.register.serviceMail': 'Я согласен получать информационные бюллетени по обслуживанию.',
    'auth.register.serviceMail2': 'Вы можете ознакомиться с политикой обработки персональных данных',
    'auth.register.here': 'здесь',
    'auth.register.adMail': 'Я согласен на',
    'auth.register.adTerms': 'условия рекламной рассылки',
    'auth.register.adTermsLink': 'условия',
    'auth.register.adTermsSuffix': 'рекламного списка рассылки',
    'auth.register.serviceMailSuffix': '.',
    'auth.register.fullPromotionTerms': 'Полные условия акции',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Введите свой номер телефона',
    'auth.validation.phoneOrEmailRequired': 'Введите адрес электронной почты или телефон',
    'auth.validation.phoneInvalid': 'Введите действительный номер телефона',
    'auth.validation.phoneExists': 'Этот номер телефона уже зарегистрирован',
    'auth.validation.emailRequired': 'Введите адрес электронной почты',
    'auth.validation.emailInvalid': 'Введите действительный адрес электронной почты',
    'auth.validation.emailDomainInvalid': 'Используйте действительный email (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com и т.д.)',
    'auth.validation.emailExists': 'Этот адрес уже зарегистрирован',
    'auth.validation.passwordRequired': 'Введите свой пароль',
    'auth.validation.passwordShort': 'Пароль должен быть не менее 8 символов',
    'auth.validation.registerFailed': 'Регистрация не удалась. Пожалуйста, попробуйте еще раз.',
    'auth.validation.loginFieldsRequired': 'Заполните все поля',
    'auth.validation.loginInvalid': 'Неверный логин или пароль',
    'auth.validation.accountRequired': 'Введите номер вашего счета',
    'auth.validation.accountShort': 'Номер счета должен содержать не менее 6 символов.',
    'auth.validation.codeInvalid': 'Неверный код подтверждения',
    'auth.validation.codeRequired': 'Введите код подтверждения',
    'auth.validation.codeSendFailed': 'Не удалось отправить код',
    'auth.validation.codeThrottled': 'Пожалуйста, подождите, прежде чем запрашивать другой код.',
    'auth.validation.challengeExpired': 'Срок проверки истек, пожалуйста, войдите снова',
    'auth.validation.serverUnreachable': 'Невозможно получить доступ к серверу. Запустите npm run dev:server в терминале.',
    'auth.validation.serverError': 'Ошибка входа. Проверьте сервер и базу данных.',
    'auth.tab.phone': 'Телефон',
    'auth.tab.email': 'Email',
    'auth.tab.username': 'Имя пользователя',
    'auth.tab.account': 'Счет',
    'auth.label.phone': 'Номер телефона',
    'auth.label.phoneOptional': 'Мобильный телефон (по желанию)',
    'auth.label.email': 'Email',
    'auth.label.username': 'Имя пользователя',
    'auth.label.account': 'Номер счета',
    'auth.label.password': 'Пароль',
    'auth.label.promo': 'Промо-код',
    'auth.placeholder.account': 'Номер счета',
    'auth.placeholder.username': 'Имя пользователя',
    'auth.forgot': 'Забыли пароль?',
    'auth.noAccount': 'У вас нет учетной записи?',
    'auth.haveAccount': 'У вас уже есть аккаунт?',
    'auth.login.pageTitle': 'Войти | ⟦ВУРГУНБЕТХ100⟧',
    'auth.verify.info': 'Чтобы защитить вашу учетную запись, нам необходимо убедиться, что это действительно вы.',
    'auth.verify.caption': 'Получить код подтверждения:',
    'auth.verify.methodPhone': 'мы отправим код текстовым сообщением или Telegram на ваш номер телефона {contact}',
    'auth.verify.methodEmail': 'мы отправим код по электронной почте на адрес {contact}',
    'auth.verify.getCode': 'Получить код',
    'auth.verify.cancel': 'Отмена',
    'auth.verify.noAccess': 'У меня нет доступа к номеру телефона',
    'auth.verify.enterCode': 'Введите код подтверждения:',
    'auth.verify.confirm': 'Подтвердить',
    'auth.verify.continue': 'Продолжить',
    'auth.verify.codeInfoPhone': 'Введите код подтверждения. Мы отправили его текстовым сообщением или Telegram на ваш номер телефона {contact}.',
    'auth.verify.codeInfoEmail': 'Введите код подтверждения. Мы отправили его по электронной почте на адрес {contact}.',
    'auth.verify.neverReceived': 'Я никогда не получал код',
    'auth.verify.resend': 'Отправить код повторно',
    'auth.verify.noAccessEmail': 'У меня нет доступа к электронной почте',
    'auth.verify.help.title': 'Если код подтверждения так и не пришел',
    'auth.verify.help.bodyPhone': 'Убедитесь, что номер телефона указан правильно и на вашем устройстве достаточно свободной памяти. Проверьте, не попало ли письмо в папку «Спам».',
    'auth.verify.help.bodyEmail': 'Убедитесь, что адрес электронной почты правильный. Проверьте, не попало ли письмо в папку «Спам».',
    'auth.verify.help.step1': 'Откройте приложение «Сообщения».',
    'auth.verify.help.step2': 'Нажмите кнопку в правом верхнем углу',
    'auth.verify.help.step3': 'Выберите «Спам и заблокировано».',
    'auth.verify.help.understood': 'Понял',
    'auth.recover.title': 'Восстановление пароля',
    'auth.recover.pageTitle': 'Восстановление пароля | ⟦ВУРГУНБЕТХ100⟧',
    'auth.recover.continue': 'Продолжить',
    'auth.recover.noAccess': 'У меня нет доступа к номеру телефона/электронной почте',
    'auth.recover.noAccessPhone': 'У меня нет доступа к номеру телефона',
    'auth.recover.noAccessEmail': 'У меня нет доступа к электронной почте',
    'auth.recover.newPassword': 'Новый пароль',
    'auth.recover.confirmPassword': 'Подтвердите новый пароль',
    'auth.recover.passwordMismatch': 'Пароли не совпадают',
    'auth.recover.save': 'Сохранить пароль',
    'auth.recover.success': 'Ваш пароль обновлен. Вы можете войти в систему с новым паролем.',
    'auth.recover.notFound': 'Аккаунт с такими данными не найден',
    'auth.verify.expiredTitle': 'Время, отведенное на этот процесс, истекло.',
    'auth.verify.retry': 'Повторить попытку',
    'welcome.stepLabel': 'Шаг 1 из 3: Регистрация',
    'welcome.title': 'Получите приветственный бонус до 100 TL + 300 FS!',
    'welcome.step1.title': 'Регистрация',
    'welcome.step1.sub': 'На сайте или в приложении',
    'welcome.step2.title': 'Завершить проверку',
    'welcome.step2.sub': 'Это займет всего несколько минут',
    'welcome.step3.title': 'Внести депозит',
    'welcome.step3.sub': 'Больший депозит – больший бонус!',
    'welcome.start': 'Начинать',
    'welcome.rules': 'Полные условия акции',
    'account.loading': 'Загрузка...',
    'account.save': 'Сохранить',
    'account.empty': 'Записи не найдены',
    'account.nav.overview': 'Обзор',
    'account.nav.profile': 'Персональные данные',
    'account.nav.verification': 'Проверка',
    'account.nav.cashier': 'Касса',
    'account.nav.bets': 'Мои ставки',
    'account.nav.bonuses': 'Бонусы',
    'account.nav.notifications': 'Уведомления',
    'account.nav.security': 'Безопасность',
    'account.nav.support': 'Поддержка',
    'account.menu.profile': 'Мой профиль',
    'account.menu.payments': 'Депозиты и выводы',
    'account.menu.history': 'История ставок и транзакций',
    'account.menu.requests': 'Запросы',
    'account.menu.responsible': 'Ответственная игра',
    'account.menu.vip': 'Ваш статус VIP',
    'support.liveChat': 'Живая поддержка',
    'account.menu.deposit': 'Внести депозит',
    'account.overview.title': 'Сводка по аккаунту',
    'account.overview.balance': 'Баланс',
    'account.overview.bonusBalance': 'Бонусный баланс',
    'account.overview.accountNo': 'Номер счета.',
    'account.overview.verification': 'Проверка',
    'account.overview.totalBets': 'Всего ставок',
    'account.profile.name': 'Полное имя',
    'account.profile.saved': 'Ваши данные сохранены',
    'account.profile.marketingEmail': 'Я хочу получать промо-рассылки',
    'account.profile.marketingSms': 'Я хочу получать промо-СМС',
    'account.profile.tab.details': 'Личные данные',
    'account.profile.tab.phone': 'Изменить номер телефона',
    'account.profile.tab.phoneAdd': 'Добавить номер телефона',
    'account.profile.tab.phoneVerify': 'Подтвердить номер телефона',
    'account.profile.tab.email': 'Изменить адрес электронной почты',
    'account.profile.tab.emailAdd': 'Добавить адрес электронной почты',
    'account.profile.tab.emailVerify': 'Подтвердите адрес электронной почты',
    'account.profile.tab.password': 'Изменить пароль',
    'account.profile.section.personal': 'ПЕРСОНАЛЬНЫЕ ДАННЫЕ',
    'account.profile.section.lastLogin': 'ПОСЛЕДНЯЯ ИНФОРМАЦИЯ ДЛЯ ВХОДА',
    'account.profile.section.contacts': 'КОНТАКТЫ',
    'account.profile.section.marketing': 'КОНТАКТНЫЕ ПРЕДПОЧТЕНИЯ',
    'account.profile.field.name': 'Имя:',
    'account.profile.field.verification': 'Статус проверки личности:',
    'account.profile.field.accountNo': 'Номер счета:',
    'account.profile.field.currency': 'Валюта:',
    'account.profile.field.phone': 'Номер телефона:',
    'account.profile.field.email': 'Электронная почта:',
    'account.profile.field.time': 'Время:',
    'account.profile.field.ip': 'IP-адрес:',
    'account.profile.change': 'Изменять',
    'account.profile.add': 'Добавлять',
    'account.profile.status.verified': 'Проверено',
    'account.profile.status.unverified': 'Непроверенный',
    'account.profile.marketingIntro': 'Получайте уведомления об акциях и новостях:',
    'account.profile.marketing.email': 'Email',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Push-уведомления',
    'account.profile.marketing.web': 'Уведомления веб-сайта',
    'account.profile.verification.basic': 'Непроверенный',
    'account.profile.verification.verified': 'Проверено',
    'account.profile.verification.pending': 'В ожидании',
    'account.profile.verify': 'Проверять',
    'account.profile.tab.kyc': 'Проверка личности',
    'account.profile.kyc.title': 'Проверка личности',
    'account.profile.kyc.intro': 'Отправьте свой национальный идентификационный номер, город, адрес и фотографии на удостоверение личности. Ваша учетная запись будет подтверждена после проверки.',
    'account.profile.kyc.tcLabel': 'Национальный идентификационный номер',
    'account.profile.kyc.tcInvalid': 'Введите действительный 11-значный национальный идентификационный номер.',
    'account.profile.kyc.cityLabel': 'Город',
    'account.profile.kyc.cityPlaceholder': 'Выберите город',
    'account.profile.kyc.cityRequired': 'Необходимо выбрать город',
    'account.profile.kyc.addressLabel': 'Адрес',
    'account.profile.kyc.addressHint': 'Введите свой полный адрес. Отредактируйте его, если оно неверно.',
    'account.profile.kyc.addressRequired': 'Адрес должен содержать не менее 5 символов.',
    'account.profile.kyc.frontLabel': 'удостоверение личности спереди',
    'account.profile.kyc.frontHint': 'Загрузите фотографию лицевой стороны вашего удостоверения личности.',
    'account.profile.kyc.backLabel': 'ID обратно',
    'account.profile.kyc.backHint': 'Загрузите фотографию обратной стороны вашего удостоверения личности.',
    'account.profile.kyc.photoRequired': 'Требуется фото на лицевой стороне удостоверения личности.',
    'account.profile.kyc.backRequired': 'Требуется фото на оборотной стороне удостоверения личности.',
    'account.profile.kyc.submit': 'Представлять на рассмотрение',
    'account.profile.kyc.submitted': 'Ваш запрос на проверку получен и находится на рассмотрении.',
    'account.profile.kyc.pendingMessage': 'Ваш запрос на проверку находится на рассмотрении. Вы не можете подать новые документы, пока проблема не будет решена.',
    'account.profile.kyc.alreadyVerified': 'Ваш аккаунт уже подтвержден.',
    'account.profile.todayAt': 'Сегодня в',
    'account.profile.mobile.personalData': 'Персональные данные',
    'account.profile.mobile.aboutAccount': 'Об аккаунте',
    'account.profile.mobile.passwordChange': 'Изменение пароля',
    'account.profile.next': 'Следующий',
    'account.profile.changeEmailTitle': 'Новый адрес электронной почты',
    'account.profile.changePhoneTitle': 'Новый номер телефона',
    'account.profile.addEmailTitle': 'Добавить адрес электронной почты',
    'account.profile.addPhoneTitle': 'Добавить номер телефона',
    'account.profile.verifyEmailTitle': 'Подтвердите адрес электронной почты',
    'account.profile.verifyPhoneTitle': 'Подтвердить номер телефона',
    'account.profile.contactSupport': 'Пожалуйста, свяжитесь со службой поддержки, чтобы изменить свои данные.',
    'account.profile.contactSupportAddPhone': 'Создайте запрос в службу поддержки, чтобы добавить номер телефона.',
    'account.profile.contactSupportChangePhone': 'Создайте запрос в службу поддержки, чтобы изменить номер телефона.',
    'account.profile.contactSupportVerifyPhone': 'Создайте запрос в службу поддержки, чтобы подтвердить свой номер телефона.',
    'account.profile.contactSupportAddEmail': 'Создайте запрос в службу поддержки, чтобы добавить адрес электронной почты.',
    'account.profile.contactSupportChangeEmail': 'Создайте запрос в службу поддержки, чтобы изменить свой адрес электронной почты.',
    'account.profile.step.support': 'Создать запрос в службу поддержки',
    'account.profile.step.sharePhone': 'Поделитесь своим номером телефона',
    'account.profile.step.shareNewPhone': 'Поделитесь своим новым номером телефона',
    'account.profile.step.requestVerify': 'Отправьте запрос на проверку',
    'account.profile.step.confirmSms': 'Подтвердите с помощью SMS-кода',
    'account.profile.step.shareEmail': 'Поделитесь своим адресом электронной почты',
    'account.profile.step.shareNewEmail': 'Поделитесь своим новым адресом электронной почты',
    'account.profile.step.confirmEmail': 'Полное подтверждение по электронной почте',
    'account.profile.contactSupportBtn': 'Связаться со службой поддержки',
    'account.profile.otp.addPhoneHint': 'Введите свой номер телефона. Мы отправим код подтверждения по SMS.',
    'account.profile.otp.changePhoneHint': 'Введите новый номер телефона. Изменение подтверждается SMS-кодом.',
    'account.profile.otp.verifyPhoneHint': 'Мы вышлем код для подтверждения вашего номера телефона.',
    'account.profile.otp.addEmailHint': 'Введите свой адрес электронной почты. Мы отправим код подтверждения по электронной почте.',
    'account.profile.otp.verifyEmailHint': 'Мы вышлем код для подтверждения вашего адреса электронной почты.',
    'account.profile.otp.changeEmailHint': 'Введите новый адрес электронной почты. Изменение подтверждается кодом электронной почты.',
    'account.profile.otp.codeSentPhone': 'Мы отправили код подтверждения на адрес:',
    'account.profile.otp.codeSentEmail': 'Мы отправили код подтверждения на адрес:',
    'account.profile.otp.codeSent': 'Код подтверждения отправлен',
    'account.profile.otp.codeLabel': 'Проверочный код',
    'account.profile.otp.resend': 'Отправить код повторно',
    'account.profile.otp.phoneRequired': 'Требуется номер телефона',
    'account.profile.otp.emailRequired': 'Требуется адрес электронной почты',
    'account.profile.otp.codeRequired': 'Требуется код подтверждения',
    'account.profile.otp.sessionMissing': 'Сеанс проверки не найден',
    'account.profile.otp.saved': 'Ваши контактные данные обновлены',
    'account.profile.passwordConfirm': 'Подтвердите новый пароль',
    'account.profile.passwordRequired': 'Заполните все поля пароля',
    'account.profile.passwordMismatch': 'Новые пароли не совпадают',
    'account.profile.passwordSame': 'Новый пароль не может совпадать с вашим текущим паролем.',
    'account.profile.send': 'Отправлять',
    'account.profile.passwordHint': 'Используйте раздел безопасности, чтобы изменить свой пароль.',
    'account.verification.desc': 'Проверка личности необходима для вывода средств и полного доступа к счету.',
    'account.verification.verified': 'Проверено',
    'account.verification.pending': 'В ожидании',
    'account.verification.rejected': 'Отклоненный',
    'account.verification.step1': 'Загрузите фотографию своего паспорта или удостоверения личности',
    'account.verification.step2': 'Добавьте селфи с документом',
    'account.verification.step3': 'Проверка обычно завершается в течение 24 часов.',
    'account.verification.submit': 'Начать проверку',
    'account.verification.submitted': 'Ваши документы находятся на рассмотрении',
    'account.cashier.deposit': 'Пополнить',
    'account.cashier.withdraw': 'Вывести',
    'account.cashier.amount': 'Сумма (TL)',
    'account.cashier.balance': 'Текущий баланс: {amount}',
    'account.cashier.history': 'История транзакций',
    'account.cashier.type': 'Тип',
    'account.cashier.date': 'Дата',
    'account.payments.title': 'Депозиты и выводы',
    'account.payments.back': 'Назад',
    'account.payments.selectMethod': 'Выберите метод',
    'account.payments.group.havale': 'Перевод',
    'account.payments.group.card': 'Кредитная карта',
    'account.payments.group.crypto': 'Крипто',
    'account.payments.group.other': 'Другое',
    'account.payments.noMethods': 'На данный момент нет доступных способов оплаты.',
    'account.payments.from': 'от {amount} TL',
    'account.payments.depositTitle': 'Пополните баланс с помощью {method}',
    'account.payments.withdrawTitle': 'Вывод средств с помощью {method}',
    'account.payments.depositNotice': 'Внимание! Банковская карта должна быть зарегистрирована на имя владельца счета. Платежи, совершенные с использованием сторонних карт, будут отклонены.',
    'account.payments.withdrawNotice': 'Запросы на вывод средств обрабатываются в соответствии с вашим статусом проверки.',
    'account.payments.addAmount': 'Пополнить',
    'account.payments.withdrawSubmit': 'Вывести {amount} TL',
    'account.payments.requests': 'Ваши запросы',
    'account.payments.insufficientBalance': 'Недостаточный баланс',
    'account.payments.minWithdrawNotice': 'Минимальная сумма, необходимая для вывода выигрыша: {amount}',
    'account.payments.withdrawGoDeposit': 'Пополнить',
    'account.payments.selectAnotherMethod': 'Выберите другой метод',
    'account.payments.requestsTitle': 'Запросы транзакций',
    'account.payments.requestsEmpty': 'У вас пока нет запросов на транзакцию.',
    'account.payments.filterAll': 'Все',
    'account.payments.filterCompleted': 'Завершенный',
    'account.payments.filterProcessing': 'Обработка',
    'account.payments.filterCancelled': 'Отменено',
    'account.payments.colNumber': 'ЧИСЛО',
    'account.payments.colDate': 'ДАТА',
    'account.payments.colType': 'ТИП',
    'account.payments.colMethod': 'МЕТОД',
    'account.payments.colAmount': 'КОЛИЧЕСТВО',
    'account.payments.status': 'Статус',
    'account.payments.status_completed': 'Завершенный',
    'account.payments.status_pending': 'В ожидании',
    'account.payments.status_processing': 'Обработка',
    'account.payments.status_cancelled': 'Отменено',
    'account.payments.status_rejected': 'Отклоненный',
    'account.payments.status_failed': 'Неуспешный',
    'account.payments.status_approved': 'Одобренный',
    'account.payments.status_expired': 'Истекший',
    'account.payments.goToRequests': 'Мои запросы',
    'account.payments.method.crypto': 'Крипто',
    'account.payments.method.maxhavale': 'Макс Хавале',
    'account.payments.method.havale': 'Хавале',
    'account.payments.method.havalespeed': 'Скорость Хавале',
    'account.payments.havalespeed.depositPending': 'Пополните депозит Speed ​​Havale',
    'account.payments.havalespeed.withdrawPending': 'Ваш вывод средств Speed ​​Havale обрабатывается',
    'account.payments.havalespeed.processing': 'Оставшееся время',
    'account.payments.havalespeed.confirmPaid': 'Я перевел, сообщите',
    'account.payments.havalespeed.confirming': 'Отправка уведомления…',
    'account.payments.havalespeed.confirmSent': 'Уведомление получено. Ждем одобрения.',
    'account.payments.havalespeed.cancelDeposit': 'Отменить запрос',
    'account.payments.havalespeed.cancelling': 'Отмена…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Полное имя',
    'account.payments.havale.amountLabel': 'Сумма',
    'account.payments.havalespeed.approvedHint': '{amount} был добавлен на ваш баланс.',
    'account.payments.havalespeed.approvedHintGeneric': 'Ваш депозит был одобрен и добавлен на ваш баланс.',
    'account.payments.havalespeed.rejectedHint': 'Ваш запрос на Speed ​​Havale был отклонен. Вы можете попробовать новый депозит.',
    'account.payments.maxhavale.depositPending': 'Пополните свой депозит Max Havale',
    'account.payments.maxhavale.withdrawPending': 'Вывод средств с Max Havale обрабатывается',
    'account.payments.maxhavale.processing': 'Оставшееся время',
    'account.payments.maxhavale.cancelDeposit': 'Отменить запрос',
    'account.payments.maxhavale.cancelling': 'Отмена…',
    'account.payments.maxhavale.openPayment': 'Страница открытия депозита',
    'account.payments.maxhavale.urlMissing': 'Не удалось загрузить платежные реквизиты. Вы можете отменить этот запрос и повторить попытку.',
    'account.payments.maxhavale.bankName': 'Банк',
    'account.payments.havaleBtq.depositPending': 'Завершите депозит Havale',
    'account.payments.havaleBtq.withdrawPending': 'Вывод Havale обрабатывается',
    'account.payments.havaleBtq.processing': 'Оставшееся время',
    'account.payments.havaleBtq.cancelDeposit': 'Отменить запрос',
    'account.payments.havaleBtq.cancelling': 'Отмена…',
    'account.payments.havaleBtq.openPayment': 'Открыть страницу депозита',
    'account.payments.havaleBtq.urlMissing': 'Не удалось загрузить платежные реквизиты.',
    'account.payments.havaleBtq.bankName': 'Банк',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'Идентификатор кошелька PayUrus',
    'account.payments.payurus.walletName': 'Имя владельца кошелька',
    'account.payments.payurus.openPayment': 'Открыть страницу депозита заново',
    'account.payments.payurus.reopenPayment': 'Открыть страницу депозита заново',
    'account.payments.payurus.urlMissing': 'Ссылка на страницу оплаты не может быть загружена. Вы можете отменить этот запрос и повторить попытку.',
    'account.payments.payurus.cancelDeposit': 'Отменить запрос',
    'account.payments.payurus.cancelling': 'Отмена…',
    'account.payments.payurus.depositPending': 'Завершите оплату PayUrus',
    'account.payments.payurus.withdrawPending': 'Вывод средств через PayUrus обрабатывается',
    'account.payments.payurus.processing': 'Оставшееся время',
    'account.payments.payurus.depositSuccess': 'Платеж успешен',
    'account.payments.payurus.depositSuccessHint': '{amount} был добавлен на ваш баланс.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Ваш депозит {provider} был добавлен на ваш баланс.',
    'account.payments.payurus.depositProcessing': 'Обработка платежей',
    'account.payments.payurus.depositProcessingHint': 'Ваш платеж {provider} проверяется. Пожалуйста, подождите.',
    'account.payments.payurus.depositFailed': 'Платеж не выполнен',
    'account.payments.payurus.depositFailedHint': 'Ваш платеж {provider} не может быть завершен. Вы можете попробовать новый депозит.',
    'account.payments.payurus.continue': 'Продолжить',
    'account.payments.payurus.nameMismatch': 'Ваше имя и фамилия не совпадают',
    'account.payments.payurus.nameMismatchDetail': 'Имя владельца учетной записи не соответствует имени, возвращенному провайдером. Владелец счета PayUrus: {name}',
    'account.payments.payurus.rateLimit': 'Повторный вывод на этот кошелек пока невозможен.',
    'account.payments.payurus.rateLimitDetail': 'PayUrus ограничивает частоту вывода средств на один и тот же кошелек. Пожалуйста, повторите попытку позже.',
    'account.payments.payurus.walletInvalid': 'Не удалось проверить данные кошелька PayUrus.',
    'account.payments.payurus.walletInvalidDetail': 'Пожалуйста, проверьте идентификатор кошелька или имя владельца кошелька и повторите попытку.',
    'account.payments.method.oplati': 'Папара',
    'account.payments.method.raschet': 'Платежная система «Расчет»',
    'account.payments.method.qiwi': 'КИВИ',
    'account.payments.havale.tc': 'Национальный идентификатор (TC)',
    'account.payments.havale.firstName': 'Имя',
    'account.payments.havale.lastName': 'Фамилия',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Банк',
    'account.payments.havale.transferTo': 'Перевести на счет ниже',
    'account.payments.havale.accountName': 'Имя учетной записи',
    'account.payments.havale.copyIban': 'Копировать',
    'account.payments.havale.copyName': 'Копировать',
    'account.payments.havale.copyAmount': 'Сумма копирования',
    'account.payments.havale.copyBank': 'Копировать банк',
    'account.payments.havale.copied': 'Скопировано',
    'account.payments.havale.countdown': 'Оставшееся время',
    'account.payments.havale.activeNotice': 'У вас есть активный запрос. Новый нельзя создать, пока не закончится таймер.',
    'account.payments.havale.amountDue': 'Сумма депозита',
    'account.payments.havale.waitNew': 'Подождите, чтобы создать новый запрос',
    'account.payments.havale.resultApproved': 'Депозит одобрен',
    'account.payments.havale.resultApprovedHint': '{amount} был добавлен на ваш баланс.',
    'account.payments.havale.resultRejected': 'Депозит отклонен',
    'account.payments.havale.resultRejectedHint': 'Ваш запрос не был одобрен. Вы можете попробовать еще раз.',
    'account.payments.havale.resultExpired': 'Срок действия запроса истек',
    'account.payments.havale.resultExpiredHint': 'Окно оплаты {provider} закончилось. Вы можете создать новый запрос.',
    'account.payments.havale.withdrawReceived': 'Запрос на вывод получен',
    'account.payments.havale.withdrawReceivedHint': 'Ваш вывод {amount} был получен и находится на рассмотрении.',
    'account.payments.havale.withdrawApproved': 'Вывод одобрен',
    'account.payments.havale.withdrawApprovedHint': 'Вывод {amount} завершен.',
    'account.payments.havale.withdrawRejected': 'Вывод отклонен',
    'account.payments.havale.withdrawRejectedHint': 'Ваш вывод не был одобрен. При необходимости вы можете создать новый запрос.',
    'account.payments.havale.tryAgain': 'Попробуйте еще раз',
    'account.payments.crypto.selectCoin': 'Выберите криптовалюту',
    'account.payments.crypto.selectNetwork': 'Выберите сеть',
    'account.payments.crypto.network': 'Сеть',
    'account.payments.crypto.selectedNetwork': 'Выбранная сеть',
    'account.payments.crypto.networkWarning': 'Отправлять только в сети {network}. Средства, отправленные не в ту сеть, могут быть потеряны.',
    'account.payments.crypto.coin': 'Монета',
    'account.payments.crypto.depositAddress': 'Адрес депозита',
    'account.payments.crypto.copyAddress': 'Копировать адрес',
    'account.payments.crypto.yourAddress': 'Адрес вашего кошелька',
    'account.payments.crypto.estimated': 'Ориентировочная сумма',
    'account.payments.crypto.txHashOptional': 'Хэш передачи (необязательно)',
    'account.payments.crypto.submitTxHash': 'Отправить хэш передачи',
    'account.payments.crypto.continueToWallet': 'Показать адрес депозита',
    'account.payments.crypto.txHashError': 'Не удалось сохранить хэш TX.',
    'account.payments.crypto.confirmations': 'Сетевые подтверждения',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': 'из {amount}',
    'account.cashier.amountUsd': 'Сумма (долл. США)',
    'account.payments.addAmountUsd': 'Депозит {amount}',
    'account.payments.crypto.activeNotice': 'Отправьте свой перевод. Подтверждения сети отслеживаются автоматически; обновления баланса при получении необходимых подтверждений.',
    'account.payments.crypto.noAssets': 'На данный момент нет активных криптосетей. Пожалуйста, повторите попытку позже.',
    'account.bets.stake': 'Ставка',
    'account.bets.odds': 'Шансы',
    'account.bets.win': 'Победить',
    'account.bets.status': 'Статус',
    'account.bets.status_pending': 'В ожидании',
    'account.bets.status_won': 'Выигрыш',
    'account.bets.status_lost': 'Проигрыш',
    'account.history.tabBets': 'Ставки',
    'account.history.tabTransactions': 'История транзакций',
    'account.history.filters': 'Фильтры',
    'account.history.filterGroupBetType': 'Тип ставки',
    'account.history.filterGroupResult': 'Результаты ставок',
    'account.history.filterBetType_all': 'Все',
    'account.history.filterBetType_bets': 'Ставки',
    'account.history.filterBetType_slot': 'Слот-игра',
    'account.history.filterBetType_dice_live': 'Игра в кости в режиме Live',
    'account.history.filterBetType_card_live': 'Карточная игра в режиме Live',
    'account.history.filterBetType_cylinder_live': 'Игра в рулетку в режиме Live',
    'account.history.filterBetType_online_game': 'Онлайн-игра букмекерской конторы',
    'account.history.filterResult_all': 'Все',
    'account.history.filterResult_not_settled': 'Не урегулировано',
    'account.history.filterResult_win': 'Победить',
    'account.history.filterResult_loss': 'Потеря',
    'account.history.filterResult_cashed_out': 'Обналичены',
    'account.history.filterResult_void': 'Пустота',
    'account.history.filterResult_return': 'Возвращаться',
    'account.history.colDate': 'ДАТА',
    'account.history.colTime': 'ВРЕМЯ',
    'account.history.colBetNo': 'СТАВКА №',
    'account.history.colCoupon': 'КУПОН',
    'account.history.colStake': 'СТАВКА',
    'account.history.colPotential': 'ПОТЕНЦИАЛ',
    'account.history.details': 'Подробности',
    'account.history.colTransactionNo': '№ СДЕЛКИ',
    'account.history.colNumber': 'ЧИСЛО',
    'account.history.colTransaction': 'СДЕЛКА',
    'account.history.colAmountBonuses': 'СУММА / БОНУСЫ',
    'account.history.colBalanceBonuses': 'БАЛАНС / БОНУСЫ',
    'account.history.operation_deposit': 'Пополнить',
    'account.history.operation_deposit_pending': 'Ждем подтверждения депозита',
    'account.history.operation_withdrawal_pending': 'Ожидание подтверждения вывода',
    'account.history.operation_withdrawal_cancelled': 'Вывод отменен',
    'account.history.operation_withdrawal_rejected': 'Вывод отклонен',
    'account.history.operation_withdrawal_approved': 'Вывод одобрен',
    'account.history.operation_withdrawal_completed': 'Вывод завершен',
    'account.history.operation_bet_placed': 'Ставка сделана',
    'account.history.operation_bet_settled': 'Ставка рассчитана',
    'account.history.operation_bet_lost': 'Ставка проиграна',
    'account.history.operation_slot_bet_settled': 'Ставка на слот-игру рассчитана',
    'account.history.operation_slot_bet_placed': 'Ставка на слот-игру сделана',
    'account.history.operation_accrual_bonus_account': 'Начисление на бонусный счет',
    'account.history.operation_close_bonus_account': 'Закрыть бонусный счет',
    'account.history.operation_bonus_conversion': 'Бонусная конверсия',
    'account.history.filterOperation_close_bonus_account': 'Закрыть бонусный счет',
    'account.history.filterOperation_accrual_bonus_account': 'Начисление на бонусный счет',
    'account.history.filterOperation_slot_bet_settled': 'Ставка на слот-игру рассчитана',
    'account.history.filterOperation_slot_bet_placed': 'Ставка на слот-игру сделана',
    'account.history.filterOperation_withdrawal_cancelled': 'Вывод отменен',
    'account.history.filterOperation_withdrawal_rejected': 'Вывод отклонен',
    'account.history.filterOperation_withdrawal_approved': 'Вывод одобрен',
    'account.history.filterOperation_withdrawal_completed': 'Вывод завершен',
    'account.history.filterOperation_withdrawal_pending': 'Ожидание подтверждения вывода',
    'account.history.filterOperation_bonus_conversion': 'Бонусная конверсия',
    'account.history.filterOperation_bet_lost': 'Ставка проиграна',
    'account.history.filterOperation_bet_placed': 'Ставка сделана',
    'account.history.filterOperation_bet_settled': 'Ставка рассчитана',
    'account.history.filterOperation_deposit': 'Пополнить',
    'account.history.filterOperation_deposit_pending': 'Ждем подтверждения депозита',
    'account.history.colBetType': 'ТИП СТАВКИ',
    'account.history.colType': 'ТИП',
    'account.history.colDescription': 'ОПИСАНИЕ',
    'account.history.colOdds': 'ШАНСЫ',
    'account.history.colResult': 'РЕЗУЛЬТАТ',
    'account.history.colAmount': 'КОЛИЧЕСТВО',
    'account.history.colStatus': 'СТАТУС',
    'account.history.betTypeSlot': 'Слот-игра',
    'account.history.betTypeSportsbook': 'Ставки на спорт',
    'account.history.betTypeSingle': 'Одинокий',
    'account.history.betTypeExpress': 'Выражать',
    'account.history.result_pending': 'Не урегулировано',
    'account.history.result_won': 'Победить',
    'account.history.result_lost': 'Потеря',
    'account.history.result_completed': 'Завершенный',
    'account.history.betsEmpty': 'У вас еще нет истории ставок.',
    'account.history.transactionsEmpty': 'У вас еще нет истории транзакций.',
    'account.bonuses.welcomeTitle': 'Приветственный бонус',
    'account.bonuses.welcomeDesc': 'Не пропустите бонусные предложения на первый депозит.',
    'account.bonuses.viewPromos': 'Посмотреть промо',
    'account.bonuses.freeSpinsTitle': 'Ваши бесплатные игры',
    'account.bonuses.freeSpinsEmpty': 'У вас пока нет бесплатных игр.',
    'account.bonuses.viewFreeSpins': 'Посмотреть мои бонусы',
    'account.vip.title': 'VIP Кэшбэк',
    'account.vip.subtitleLine1': 'Воспользуйтесь своими привилегиями',
    'account.vip.subtitleLine2': 'и получай кэшбэк каждую неделю!',
    'account.vip.yourStatus': 'Ваш статус',
    'account.vip.yourCashback': 'Ваш кэшбэк',
    'account.vip.promotionRules': 'Правила акции',
    'account.vip.stillQuestions': 'Остались вопросы?',
    'account.vip.cardCashbackFreeAndBonus': 'Кэшбэк в free bets и в бонусах',
    'account.vip.cardCashbackBonusOnly': 'Кэшбэк в виде бонусов',
    'account.vip.cardCashbackTail': 'до',
    'account.vip.tierCashbackDesc': '{metal} — Кэшбэк в free bets и в бонусах до {percent}%',
    'account.vip.fromAmount': 'от',
    'account.vip.betAmountWeeks': 'сумма ставки на 4 недели',
    'account.vip.yourStatusBadge': 'ВАШ VIP СТАТУС',
    'account.vip.targetStatus': 'ЦЕЛЕВОЙ СТАТУС',
    'account.vip.cashbackLabel': 'КЭШБЭК',
    'account.vip.needToBet': 'Вам нужно сделать ставку от',
    'account.vip.totalSettled': 'Всего рассчитанных ставок',
    'account.vip.currency': 'ТЛ',
    'account.vip.footnote': '*Кэшбэк free bets для ставок на спорт, бонусы — для ставок в игровых автоматах казино.',
    'account.vip.prev': 'Предыдущий',
    'account.vip.next': 'Следующий',
    'account.vip.rulesLoadError': 'Не удалось загрузить правила продвижения.',
    'account.vip.faqLoadError': 'Не удалось загрузить FAQ.',
    'account.vip.cashbackHistoryTitle': 'История начисления кэшбэка',
    'account.vip.cashbackHistoryDesc': 'Кэшбэк за предыдущую неделю начисляется каждый понедельник до 18:00. Мы оповестим вас о статусе начисления кэшбэка по SMS.',
    'account.vip.cashbackHistoryDate': 'Дата',
    'account.vip.cashbackHistoryStatus': 'Статус',
    'account.vip.cashbackHistoryAmount': 'Сумма кэшбэка',
    'account.vip.cashbackCalculating': 'Расчет',
    'account.vip.pendingCashback': 'Начисление на этой неделе',
    'common.close': 'Закрыть',
    'appUpdate.title': 'Скачать обновление',
    'appUpdate.text': 'для доступа к новым функциям',
    'appUpdate.action': 'Обновлять',
    'account.notifications.readAll': 'Отметить все как прочитанное',
    'account.notifications.empty': 'Нет уведомлений',
    'account.notifications.emptyUnread': 'Нет непрочитанных уведомлений',
    'account.notifications.filterAll': 'Все',
    'account.notifications.filterUnread': 'Непрочитано ({count})',
    'account.notifications.viewAll': 'Все уведомления',
    'account.notifications.details': 'Подробности',
    'account.security.current': 'Текущий пароль',
    'account.security.enterCurrent': 'Введите текущий пароль',
    'account.security.new': 'Новый пароль',
    'account.security.saved': 'Пароль обновлен',
    'account.responsible.tabDeposit': 'Лимиты депозита',
    'account.responsible.tabSession': 'Ограничения игровых сессий',
    'account.responsible.depositDescription': 'Установите лимит депозита. При достижении лимита вы не сможете внести деньги на свой счет до конца указанного периода. Лимит можно мгновенно снизить или снять. Увеличение лимита требует 24-часового периода обдумывания.',
    'account.responsible.sessionDescription': 'Установите лимит игровых сессий. Укажите максимальное время, которое вы можете проводить за игрой в день, неделю или месяц. При достижении лимита вы выйдете из системы и не сможете войти в систему до окончания указанного периода. Лимит можно мгновенно снизить или снять. Увеличение лимита требует 24-часового периода обдумывания.',
    'account.responsible.currentRestrictions': 'Текущие ограничения',
    'account.responsible.futureRestrictions': 'Будущие ограничения',
    'account.responsible.limitNotSet': 'Лимит не установлен',
    'account.responsible.notSet': 'Не установлено',
    'account.responsible.dailyLimit': 'Дневной лимит',
    'account.responsible.weeklyLimit': 'Недельный лимит',
    'account.responsible.monthlyLimit': 'Ежемесячный лимит',
    'account.responsible.hoursShort': 'час',
    'account.responsible.saved': 'Лимиты обновлены',
    'account.responsible.timeLimitsTitle': 'Сроки',
    'account.responsible.timeDescription': 'Как только лимит закончится, вы выйдете из своей учетной записи и не сможете войти снова до начала следующего периода.',
    'account.responsible.sessionLimitMinutes': 'Лимит сеансов (в минутах)',
    'account.responsible.install': 'Установить',
    'account.responsible.confirmTitle': 'Установить лимит?',
    'account.responsible.confirmRemoveOrLower': 'Если вы увеличите лимит, он вступит в силу через 24 часа. Понижение вступает в силу немедленно.',
    'account.responsible.confirmTightenImmediately': 'Нижний лимит будет применен сразу после подтверждения.',
    'account.responsible.confirmSet': 'Набор',
    'account.responsible.confirmCancel': 'Отмена',
    'account.responsible.currentLimits': 'Текущие лимиты',
    'account.responsible.sessionLimit': 'Лимит сеансов',
    'account.responsible.timeRemaining': 'Оставшееся время',
    'account.responsible.delete': 'Удалить',
    'account.responsible.confirmChangeTitle': 'Вы уверены, что хотите изменить предельные значения?',
    'account.responsible.confirmDeleteTitle': 'Вы уверены, что хотите снять ограничение?',
    'account.responsible.minutesShort': 'мин',
    'account.responsible.sessionMaxTip': 'Максимальное время сеанса – 1440 минут (24 часа)',
    'account.responsible.limitBlocked': 'Достигнут лимит сеансов. Вы вышли из системы.',
    'account.requests.title': 'Запросы',
    'account.requests.newRequest': 'Новый запрос',
    'account.requests.empty': 'Нет текущих запросов',
    'account.requests.chooseType': 'Выберите тип запроса',
    'account.requests.cancel': 'Отмена',
    'account.requests.sendRequest': 'Отправить запрос',
    'account.requests.submit': 'Представлять на рассмотрение',
    'account.requests.error': 'Не удалось отправить запрос',
    'account.requests.notFound': 'Тип запроса не найден',
    'account.requests.type.sport_bet_settlement': 'Расчет ставок на спорт',
    'account.requests.type.casino_bet_settlement': 'Расчет ставок в казино',
    'account.requests.type.hotline': 'Вопрос по горячей линии',
    'account.requests.type.deposit': 'Вопрос о депозите',
    'account.requests.type.withdrawal': 'Вопрос о выводе средств',
    'account.requests.type.website_app': 'Вопрос по использованию сайта или мобильного приложения',
    'account.requests.type.admin': 'Вопрос к Админу',
    'account.requests.type.verification': 'Контрольный вопрос',
    'account.requests.type.bonus': 'Бонусный вопрос',
    'account.requests.mobile.title': 'Есть проблемы?',
    'account.requests.mobile.desc': 'Создайте новый запрос или найдите ответы в нашем Справочном центре.',
    'account.requests.mobile.create': 'Создать новый запрос',
    'account.requests.mobile.helpCentre': 'Перейти в Справочный центр',
    'account.requests.group.deposit': 'ВОПРОС О ДЕПОЗИТЕ',
    'account.requests.group.withdrawal': 'ВОПРОС НА ОТЗЫВ',
    'account.requests.group.other': 'ДРУГОЙ',
    'account.requests.template.depositBankCard': 'Банковская карта',
    'account.requests.template.depositRaschet': 'Единая платежная система «Расчет»',
    'account.requests.template.depositQiwi': 'КИВИ терминал',
    'account.requests.template.depositWebmoney': 'Вебмани',
    'account.requests.template.depositOplati': 'Оплати',
    'account.requests.template.withdrawalOplati': 'Оплати',
    'account.requests.template.withdrawalBank': 'Банковская карта/перевод',
    'account.requests.form.operationDate': 'Дата и время операции',
    'account.requests.form.amount': 'Сумма транзакции',
    'account.requests.form.selectOperationDesc': 'Выберите операцию, по поводу которой у вас есть вопрос',
    'account.requests.form.selectOperationBtn': 'Выберите операцию',
    'account.requests.form.selectedOperation': 'Выбранная операция',
    'account.requests.form.noOperations': 'Соответствующие операции не найдены',
    'account.requests.form.messagePlaceholder': 'Опишите свой вопрос или проблему',
    'account.requests.form.symbolsRemaining': 'Осталось символов {count}',
    'account.requests.form.choose': 'Выбирать',
    'account.requests.form.dragOrUpload': 'Перетащите сюда или загрузите файлы',
    'account.requests.form.attachFile': 'Прикрепить файл',
    'account.requests.form.attachHint': 'До 5 файлов. Формат: JPG, JPEG, PNG, PDF. До 7 МБ.',
    'account.requests.form.attachments': 'Вложения',
    'account.helpCentre.title': 'Справочный центр',
    'account.helpCentre.text1': 'Здесь вы можете найти информацию',
    'account.helpCentre.text2': 'и советы по использованию',
    'account.helpCentre.faq': 'Часто задаваемые вопросы',
    'account.helpCentre.instructions': 'Инструкции',
    'account.helpCentre.strategies': 'Стратегии ставок',
    'account.helpCentre.glossary': 'Глоссарий',
    'account.helpCentre.go': 'Перейти в Справочный центр',
    'account.support.subject': 'Предмет',
    'account.support.message': 'Сообщение',
    'account.support.send': 'Отправлять',
    'account.support.sent': 'Ваш запрос получен',
    'account.support.history': 'Предыдущие запросы',
    'account.support.status_open': 'Открыть',
    'account.support.status_closed': 'Закрыто',
    'account.support.status_pending': 'В ожидании',
    'account.support.status_waiting': 'В ожидании',
    'account.support.status_answered': 'Ответил',
    'account.support.status_replied': 'Ответил',
    'account.support.status_in_progress': 'В ходе выполнения',
    'account.support.status_resolved': 'Решено',
    'account.pageTitle': 'Мой аккаунт | ⟦ВУРГУНБЕТХ100⟧',
    'sport.filter.allTime': 'Все время',
    'sport.filter.allEvents': 'Все события',
    'sport.filter.live': 'Жить',
    'sport.filter.prematch': 'Предматчевая',
    'sport.filter.all': 'Все',
    'betslip.title': 'Купон ставки',
    'betslip.empty': 'Купон ставки пуст',
    'betslip.stake': 'Ставка',
    'betslip.totalOdds': 'Общие шансы',
    'betslip.potentialWin': 'Потенциальная победа',
    'betslip.place': 'Сделать ставку',
    'betslip.clear': 'Прозрачный',
    'betslip.accepted': 'Ставка принята',
    'betslip.login': 'Войдите, чтобы сделать ставку',
    'betslip.emptyHint': 'Выберите исход события, чтобы сделать ставку',
    'betslip.amount': 'Сумма, TL',
    'betslip.promos': 'Промоакции',
    'betslip.active': 'Активный',
    'betslip.popular': 'Популярные события',
    'footer.about': 'О нас',
    'footer.basinda': 'В прессе',
    'footer.licence': 'Лицензия',
    'footer.privacy': 'политика конфиденциальности',
    'footer.responsible': 'Ответственная игра',
    'footer.rules': 'Условия и положения',
    'footer.financial': 'Финансовые услуги',
    'footer.vip': 'Программа VIP',
    'footer.help': 'Справочный центр',
    'footer.payments': 'Платежи',
    'footer.company': 'Подробности о компании',
    'footer.mtd': 'МТД',
    'footer.shopRules': 'Правила букмекерской конторы',
    'footer.appCaption': 'Приложение',
    'footer.appIos': 'для iOS',
    'footer.appIosLong': 'Приложение для iOS',
    'footer.appAndroidLong': 'Приложение для Android',
    'footer.appAndroid': 'для Android',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Азартные игры запрещены для лиц младше 18 лет. VurgunBet действует как международный оператор онлайн-игр.',
    'footer.legal': 'VurgunBet предлагает ставки на спорт, игровые автоматы, живое казино и сопутствующие игровые продукты для пользователей в возрасте 18+. Пользователи должны соблюдать правовые ограничения, действующие в их регионе.',
    'footer.legal1': 'Азартные игры являются незаконными для лиц, не достигших 18-летнего возраста, а также для лиц, которым ограничено посещение игорных заведений и виртуальных игорных заведений и/или участие в азартных играх.',
    'footer.legal2': 'VurgunBet предлагает онлайн-ставки на спорт, игровые автоматы, живое казино и сопутствующие игровые продукты. Услугами можно пользоваться только там, где это разрешено законом.',
    'help.title': 'Справочный центр',
    'help.searchPlaceholder': 'Найдите свой вопрос',
    'help.searchSheetTitle': 'Справочный центр: поиск',
    'help.searchSheetDesc': 'Найдите ответ на свой вопрос',
    'help.popularSearches': 'ПОПУЛЯРНЫЕ ЗАПРОСЫ',
    'help.popular.identification': 'Как пройти идентификацию',
    'help.popular.deposit': 'Как пополнить баланс',
    'help.popular.win': 'Как получить выигрыш',
    'help.askQuestion': 'Задать вопрос',
    'help.views': 'просмотры',
    'help.back': 'Назад',
    'help.noResults': 'Результаты не найдены',
    'help.goToFaq': 'Перейти к часто задаваемым вопросам',
    'help.instructions': 'Инструкции',
    'help.training': 'Обучение',
    'help.glossary': 'Глоссарий',
    'help.notFound.code': '404',
    'help.notFound.title': 'Страница не найдена',
    'help.notFound.description': 'Упс! Страница, которую вы ищете, не существует. Возможно, оно было перемещено или удалено.',
    'help.notFound.home': 'Главная',
    'help.feedback.review': 'Написать отзыв',
    'help.feedback.helpful': 'Была ли эта информация полезна?',
    'help.feedback.yes': 'Да, спасибо',
    'help.feedback.no': 'Нет',
    'promos.tab.actions': 'Промоакции',
    'promos.tab.tournaments': 'Турниры',
    'promos.tab.actionsDesc': 'Стать чемпионом',
    'promos.tab.tournamentsDesc': 'Присоединяйтесь к турнирам',
    'promos.tab.actionsTitle': 'Промоакции',
    'promos.tab.tournamentsTitle': 'Турниры',
    'promos.tab.bonuses': 'Бонусы',
    'promos.tab.bonusesDesc': 'Отслеживайте свои бонусы',
    'promos.tab.bonusesTitle': 'Ваши бонусы',
    'promos.tab.promoCode': 'Промо-код',
    'promos.tab.promoCodeDesc': 'Активировать сейчас',
    'promos.tab.promoCodeTitle': 'Есть промокод?',
    'promos.tournamentsIntro': 'Участвуйте в турнирах и соревнуйтесь за ценные призы',
    'promos.filter.all': 'Все',
    'promos.filter.sport': 'Спорт',
    'promos.filter.casino': 'Казино',
    'promos.timer.ended': 'Закончено',
    'promos.timer.daysLeft': 'Слева: {count} день(а)',
    'promos.timer.hoursLeft': 'Слева: {count} час(а)',
    'promos.timer.minutesLeft': 'Слева: {count} мин.',
    'promos.tournament.active': 'Активный',
    'promos.tournament.bonusFund': 'Бонусный фонд',
    'promos.tournament.participants': 'Участники',
    'promos.tournament.places': 'Места',
    'promos.tournament.untilCompletion': 'До завершения',
    'promos.tournament.untilStart': 'До начала',
    'promos.tournament.upcoming': 'Предстоящие',
    'promos.tournament.startsIn': 'Начинается через',
    'promos.tournament.joinWhenLive': 'Присоединяйтесь в прямом эфире',
    'promos.tournament.tab.rating': 'Рейтинг',
    'promos.tournament.tab.terms': 'Условия',
    'promos.tournament.tab.games': 'Игры',
    'promos.tournament.col.participant': 'Участник',
    'promos.tournament.col.points': 'Очки',
    'promos.tournament.col.bonuses': 'Бонусы',
    'promos.tournament.participate': 'Участвовать',
    'promos.tournament.optOut': 'Уклоняться',
    'promos.tournament.loginToJoin': 'Войдите, чтобы присоединиться',
    'promos.tournament.promoRules': 'Правила акции',
    'promos.tournament.questions': 'Остались вопросы?',
    'promos.tournament.close': 'Закрыть',
    'promos.tournament.loading': 'Загрузка таблицы лидеров…',
    'promos.tournament.emptyBoard': 'Рейтингов пока нет. Будьте первым, кто присоединится!',
    'promos.tournament.noTerms': 'Правила будут добавлены в ближайшее время.',
    'promos.tournament.noGames': 'Список подходящих игр будет опубликован в ближайшее время.',
    'promos.tournament.joinedOk': 'Вы присоединились к турниру',
    'promos.tournament.leftOk': 'Вы покинули турнир',
    'promos.tournament.actionError': 'Не удалось завершить действие',
    'promos.tournament.working': 'Работающий…',
    'promos.tournament.gameBadge': 'ТУРНИР',
    'promos.tournament.showAllGames': 'Показать все игры',
    'promos.tournament.askQuestion': 'Задать вопрос',
    'promos.tournament.faq.participate.q': 'Как принять участие в турнире',
    'promos.tournament.faq.participate.a': 'Перейдите в раздел «Турниры», откройте нужный турнир и нажмите кнопку «Принять участие».',
    'promos.tournament.faq.deposit.q': 'Нужно ли мне вносить депозит для участия в турнире?',
    'promos.tournament.faq.deposit.a': 'Нет, участие бесплатное. Зарабатывайте очки, делая ставки на реальный баланс (минимум 5 TL) в слотах на вкладке «Игры». Ставки на бонус-баланс не засчитываются.',
    'promos.tournament.faq.multiple.q': 'Могу ли я участвовать в нескольких турнирах одновременно?',
    'promos.tournament.faq.multiple.a': 'Да. Вы можете присоединиться сразу к нескольким активным турнирам; каждый турнир ведет свою таблицу лидеров.',
    'promos.tournament.faq.terms.q': 'Где я могу ознакомиться с условиями турнира?',
    'promos.tournament.faq.terms.a': 'Откройте вкладку «Условия» в окне турнира или нажмите «Правила акции», чтобы ознакомиться с полными условиями.',
    'promos.tournament.faq.games.q': 'Какие игровые автоматы включены в турнир?',
    'promos.tournament.faq.games.a': 'Подходящие игры перечислены на вкладке «Игры». В турнирный счет засчитываются только ставки на эти игры.',
    'promos.tournament.faq.bonuses.q': 'Какие бонусы я могу получить за участие и победу в турнирах?',
    'promos.tournament.faq.bonuses.a': 'Вы зарабатываете денежные призы и призы бесплатных вращений (FS) в зависимости от ранга. Призы начисляются в течение 48 часов после окончания турнира; FS действительны в течение 7 дней, а для получения денежных призов требуется отыграть только ×2.',
    'promos.tournament.faq.timed.q': 'Ограничено ли время турниров?',
    'promos.tournament.faq.timed.a': 'Да. VURGUN VAKTİ работает еженедельно с понедельника 11:00 по воскресенье 23:59, затем автоматически продлевается.',
    'promos.tournament.faq.track.q': 'Как я могу отслеживать свои турнирные результаты и прогресс?',
    'promos.tournament.faq.track.a': 'Откройте вкладку «Рейтинг» в окне турнира, чтобы увидеть свои текущие очки и место. Результаты обновляются сразу после ставок на реальный баланс.',
    'promos.tournament.faq.more.q': 'У меня все еще есть вопросы.',
    'promos.tournament.faq.more.a': 'Нажмите «Задать вопрос» ниже, чтобы открыть запрос в службу поддержки. Наша команда свяжется с вами в ближайшее время.',
    'promos.tournament.ask.title': 'Новый запрос',
    'promos.tournament.ask.subtitle': 'Бонусный вопрос',
    'promos.tournament.ask.placeholder': 'Введите вопрос или опишите проблему',
    'promos.tournament.ask.charsLeft': 'Осталось {count} символов',
    'promos.tournament.ask.attach': 'Прикрепить файл',
    'promos.tournament.ask.attachHint': 'До 5 файлов. Формат: JPG, JPEG, PNG, PDF. До 7Мб.',
    'promos.tournament.ask.cancel': 'Отмена',
    'promos.tournament.ask.send': 'Отправить запрос',
    'promos.tournament.ask.sending': 'Отправка…',
    'promos.tournament.ask.sent': 'Ваш запрос получен. Мы свяжемся с вами в ближайшее время.',
    'promos.tournament.ask.loginRequired': 'Войдите, чтобы отправить запрос',
    'promos.tournament.ask.error': 'Не удалось отправить запрос',
    'promos.tournament.terms.periodTitle': 'Еженедельный период турнира',
    'promos.tournament.terms.pointsTitle': 'Условия начисления баллов',
    'promos.tournament.terms.points1': 'Минимальная ставка всего 5 TL — участие бесплатное; играйте с реальным балансом, чтобы заработать очки.',
    'promos.tournament.terms.points2': 'Каждая ставка на реальный баланс в размере 1 TL = 2 очка. Пятница–воскресенье — бонус 20 %!',
    'promos.tournament.terms.points3': 'Все ставки на реальный баланс в слотах на вкладке «Игры» зачисляются мгновенно. Ставки на бонус-баланс не учитываются.',
    'promos.tournament.terms.bonusesTitle': 'Условия использования бонусов',
    'promos.tournament.terms.bonuses1': 'Денежные призы и призы FS начисляются в течение 48 часов после окончания турнира; FS остается действительным в течение 7 дней.',
    'promos.tournament.terms.bonuses2': 'Для выигрыша призов требуется всего лишь ставка ×2, что намного ниже среднего показателя по отрасли.',
    'promos.tournament.terms.bonuses3': 'Турнир автоматически продлевается каждый понедельник в 11:00; Таблица лидеров сбрасывается на новую неделю.',
    'promos.bonuses.title': 'Ваши бонусы',
    'promos.promocode.title': 'Есть промокод?',
    'promos.promocode.desc': 'Введите промокод ниже и выберите «Активировать».',
    'promos.promocode.placeholder': 'Введите промокод',
    'promos.promocode.activate': 'Активировать',
    'promos.promocode.activating': 'Применение…',
    'promos.promocode.success': 'Промокод успешно применен',
    'promos.promocode.error': 'Не удалось применить промокод',
    'promos.promocode.loginRequired': 'Войдите, чтобы активировать промокод',
    'promos.bonuses.loading': 'Загрузка бонусов…',
    'promos.bonuses.empty': 'У вас еще нет бонусов.',
    'promos.bonuses.emptyCaption': 'Нет активных бонусов',
    'promos.bonuses.emptyDescription': 'Участвуйте в акциях и получайте новые бонусы!',
    'promos.bonuses.emptyButton': 'Перейти к промо',
    'promos.bonuses.emptyArchiveCaption': 'Нет архивированных бонусов',
    'promos.bonuses.emptyArchiveDescription': 'Участвуйте в акциях и получайте новые бонусы!',
    'promos.bonuses.kindFilterBonuses': 'Бонусы',
    'promos.bonuses.kindFilterFreeSpins': 'Фриспины',
    'promos.bonuses.kindFilterAll': 'Все',
    'promos.bonuses.kindFreeSpin': 'Бесплатная игра',
    'promos.bonuses.fieldNominal': 'Номинальный',
    'promos.bonuses.fieldStatus': 'Статус',
    'promos.bonuses.fieldExpires': 'Срок действия истекает',
    'promos.bonuses.fieldReceived': 'Полученный',
    'promos.bonuses.tabActive': 'Активный',
    'promos.bonuses.tabArchive': 'Архив',
    'promos.bonuses.kindBonus': 'БОНУС',
    'promos.bonuses.yourProgress': 'Ваш прогресс:',
    'promos.bonuses.statusWagering': 'Делаются ставки',
    'promos.bonuses.moreInfo': 'Дополнительная информация',
    'promos.bonuses.detailTitle': 'Бонус активирован',
    'promos.bonuses.leftDays': 'осталось {n} дней',
    'promos.bonuses.leftDay': 'остался {n} день',
    'promos.bonuses.detailLead': 'Выполните требования по отыгрышу и получите бонус на свой основной счет.',
    'promos.bonuses.placeBets': 'Сделайте ставки на общую сумму {amount}',
    'promos.bonuses.rulesTitle': 'ПРАВИЛА РАЗЫГРЫША БОНУСНОГО СЧЕТА',
    'promos.bonuses.rule1': 'Выигрыши, добавленные к балансу бонусного счета, станут доступны на основном счете после того, как сумма будет отыграна с коэффициентом 25. Отыгрыш может быть осуществлен во всех игровых автоматах всех провайдеров казино, за исключением определенных игровых автоматов, установленных Организатором.',
    'promos.bonuses.rule2': 'При отыгрыше средств с баланса бонусного счета сначала средства зачисляются с основного счета, затем с баланса бонусного счета.',
    'promos.bonuses.rule3': 'При зачислении средств с баланса бонусного счета выигрыши возвращаются на баланс бонусного счета.',
    'promos.bonuses.rule4': 'После завершения отыгрыша оставшаяся сумма бонусного счета переводится на основной баланс, но не может превышать х3 суммы, изначально зачисленной на баланс бонусного счета.',
    'promos.bonuses.rule5': 'Период отыгрыша составляет 3 дня с момента активации бонусного счета.',
    'promos.bonuses.rule6': 'Каждый последующий бонус активируется автоматически после отыгрыша предыдущего бонуса.',
    'promos.bonuses.rule7': 'При наличии средств на бонусном счете вывод средств с основного счета недоступен.',
    'promos.bonuses.promotionRules': 'Правила акции',
    'promos.bonuses.askQuestion': 'Задать вопрос',
    'promos.bonuses.cancelBonus': 'Отменить бонус',
    'promos.bonuses.cancelConfirm': 'Ваш бонусный баланс будет удален, а ставки отменены. Продолжать?',
    'promos.bonuses.cancelBusy': 'Отмена…',
    'promos.bonuses.cancelTitle': 'Вы действительно хотите отказаться?',
    'promos.bonuses.cancelBody': 'В случае отказа бонусы сгорают.\nВы можете отменить подписку в любое время.',
    'promos.bonuses.cancelRefuse': 'Я хочу отказаться',
    'promos.bonuses.cancelBack': 'Убежденный! Назад',
    'promos.bonuses.askClose': 'Закрыть',
    'promos.bonuses.askFileBadType': 'Неподдерживаемый формат файла.',
    'promos.bonuses.askFileTooBig': 'Размер файла превышает 7 Мб.',
    'promos.bonuses.askError': 'Не удалось отправить запрос',
    'promos.bonuses.askSent': 'Ваш запрос отправлен.',
    'promos.bonuses.askSending': 'Отправка…',
    'promos.bonuses.askSend': 'Отправить запрос',
    'promos.bonuses.askCancel': 'Отмена',
    'promos.bonuses.askFilesSize': 'До 7Мб.',
    'promos.bonuses.askFilesMax': 'До 5 файлов.',
    'promos.bonuses.askAttach': 'Прикрепить файл',
    'promos.bonuses.askCharsLeft': 'Осталось {n} символов',
    'promos.bonuses.askPlaceholder': 'Введите вопрос или опишите проблему',
    'promos.bonuses.askNewRequest': 'Новый запрос',
    'promos.bonuses.askBonusQuestion': 'Бонусный вопрос',
    'promos.bonuses.askHint': 'Отправьте вопрос о бонусе в поддержку',
    'promos.bonuses.fieldWagering': 'Ставки',
    'promos.bonuses.fieldWageringTime': 'Время отыгрыша',
    'promos.bonuses.fieldMaxWithdrawal': 'Макс. снятие',
    'promos.bonuses.fieldUsed': 'Использовал',
    'promos.bonuses.statusAvailable': 'Доступный',
    'promos.bonuses.statusUsed': 'Использовал',
    'promos.bonuses.activate': 'Активировать',
    'promos.bonuses.days': 'дни',
    'promos.bonuses.games': 'Игры',
    'promos.bonuses.noGames': 'Нет информации об игре',
    'promos.bonuses.play': 'Играть',
    'home.showcase.slots.title': 'Казино',
    'home.showcase.slots.count': '{count} игры',
    'home.showcase.slots.link': 'Посмотреть игры →',
    'home.showcase.live.title': 'Live-казино',
    'home.showcase.live.count': '{count} игры',
    'home.showcase.live.link': 'Играть сейчас →',
    'home.showcase.tv.title': 'ТВ-игры',
    'home.showcase.tv.count': '{count} игры',
    'home.showcase.fast.title': 'Быстрые игры',
    'home.showcase.fast.count': '{count} игры',
    'home.showcase.fast.link': 'Играть сейчас →',
    'home.showcase.virtual.title': 'Виртуальный спорт',
    'home.showcase.virtual.count': '{count} игры',
    'home.showcase.virtual.link': 'Играть сейчас →',
    'home.showcase.gamesCount': '{count} игры',
    'home.showcase.tv.link': 'Играть сейчас →',
    'home.showcase.sport.title': 'Спорт',
    'home.showcase.sport.count': '3380 событий',
    'home.showcase.sport.link': 'Сделать ставку →',
    'home.promo.category.promotions': 'Акции',
    'home.promo.category.tournaments': 'Турниры',
    'home.promo.filter.all': 'Все',
    'home.promo.filter.sport': 'Спорт (5)',
    'home.promo.filter.casino': 'Казино (5)',
    'home.promo.showAll': 'Показать все →',
    'home.promo.allPromotions': 'Все акции',
    'home.promo.cta.play': 'Играть',
    'home.promo.cta.join': 'Регистрация',
    'home.promo.cta.details': 'Подробности',
    'home.promo.cta.signup': 'Зарегистрироваться',
    'home.sport.searchEvents': 'Поиск по событиям',
    'footer.contactUs': 'Связаться с нами',
    'footer.usefulInfo': 'Полезная информация',
    'footer.socialMedia': 'Социальные сети',
    'footer.partners': 'Официальный партнёр',
    'footer.officialPartner': 'Официальный\nпартнёр',
    'home.casino.loading': 'Загрузка игр…',
    'home.casino.noGames': 'Нет доступных игр',
    'home.casino.viewAllMobile': 'Посмотреть игры {count}',
    'home.shuffle.title': 'Не знаете, в какую игру играть дальше?',
    'home.shuffle.cta': 'Крутить сейчас',
    'home.shuffle.modalTitle': 'Позвольте нам найти для вас идеальную игру!',
    'home.shuffle.respin': 'Покрутить еще раз',
    'home.shuffle.close': 'Закрыть',
    'home.jackpot.casinoTitle': 'Казино Jackpot',
    'home.jackpot.title': 'VURGUN БОЛЬШОЙ ДЖЕКПОТ',
    'home.jackpot.badgeRest': 'ГРАНД ДЖЕКПОТ',
    'home.jackpot.winners': 'Всего победителей: {count}',
    'home.jackpot.largest': 'Самый крупный выигрыш',
    'home.jackpot.last': 'Последняя победа',
    'home.jackpot.onSlots': 'Во всех слотах',
    'home.jackpot.play': 'Jackpot игры',
    'home.liveWins.title': 'Живые победы',
    'home.liveWins.heated': 'Вургун',
    'home.topWins.title': 'Топ побед',
    'home.topWins.week': 'На этой неделе',
    'home.topWins.month': 'В этом месяце',
    'home.topWins.day': 'Сегодня',
    'home.topWins.play': 'Играть',
    'home.topWins.prev': 'Предыдущий',
    'home.topWins.next': 'Следующий',
    'home.popularSlots.title': 'Популярные слоты',
    'home.hotSlots.title': 'Самые прибыльные',
    'home.hotSlots.badge': 'ГОРЯЧИЙ',
    'home.matchCarousel.title': 'Матчи',
    'home.matchCarousel.liveTv': 'Живое ТВ',
    'home.slotsCarousel.showAll': 'Показать все',
    'home.slotsCarousel.prev': 'Предыдущий',
    'home.slotsCarousel.next': 'Следующий',
    'home.jackpot.grand': 'ГРАНД',
    'home.jackpot.major': 'ГЛАВНЫЙ',
    'home.jackpot.minor': 'НЕЗНАЧИТЕЛЬНЫЙ',
    'home.jackpot.mini': 'МИНИ',
    'home.heroSide.vipTitle': 'VIP Club',
    'home.heroSide.vipSub': 'Эксклюзивные привилегии',
    'home.heroSide.promosTitle': 'Бонусы',
    'home.heroSide.promosSub': 'Последние акции',
    'home.heroSide.sportTitle': 'Спорт',
    'home.heroSide.sportSub': 'Live-ставки',
    'header.support': 'Поддержка',
    'home.topEvents.showAll': 'Показать все',
    'betslip.bonusFund': 'Бонусный фонд',
    'betslip.participants': '{count} участники',
    'betslip.hoursLeft': '{hours} часов осталось',
    'betslip.details': 'Подробности',
    'casino.viewAllCaption': 'Посмотреть все →',
    'casino.bside.promos': 'Промоакции',
    'casino.bside.showAll': 'Показать все →',
    'casino.lobby.slots': 'Слоты',
    'casino.lobby.live': 'Live-казино',
    'casino.lobby.poker': 'Покер',
    'casino.lobby.tv': 'ТВ-игры',
    'casino.lobby.fast': 'Быстрые игры',
    'casino.lobby.virtual': 'Виртуальный спорт',
    'casino.tab.review': 'Обзор',
    'casino.tab.favourites': 'Избранное',
    'casino.tab.top': 'Лучшие игры',
    'casino.tab.peter': 'Питер и сыновья Хиты',
    'casino.tab.free-spins': 'С free spins',
    'casino.tab.all': 'Все игры',
    'casino.tab.tournaments': 'Турниры',
    'casino.tab.jackpot-cards': 'Jackpot Карты',
    'casino.tab.new': 'НОВЫЙ',
    'casino.tab.world-cup': 'Чемпионат мира 2026 года',
    'casino.tab.buy-bonus': 'Купить бонус',
    'casino.tab.exclusive': 'Эксклюзивный',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Амуснет',
    'casino.tab.pragmatic-play': 'Прагматичная игра',
    'casino.tab.coins-link-vip': 'Ссылка на монеты VIP',
    'casino.tab.jackpot': 'Джекпот',
    'casino.tab.cascade': 'Каскад',
    'casino.tab.megaways': 'Мегавейсы',
    'casino.tab.collect': 'Собирать',
    'casino.tab.wild': 'Дикий',
    'casino.tab.double': 'Двойной шанс',
    'casino.tab.megax': 'Мега Икс',
    'casino.tab.respin': 'Респин',
    'casino.tab.retro': 'Ретро',
    'casino.tab.fruits': 'Фрукты',
    'casino.tab.books': 'Книги',
    'casino.tab.fast-football': 'Быстрый футбол',
    'casino.tab.holdem': 'Холдем',
    'casino.tab.caribbean': 'Карибский бассейн',
    'casino.tab.video-poker': 'Видео-покер',
    'casino.tab.crash': 'Краш-игры',
    'casino.tab.table-games': 'Настольные игры',
    'casino.tab.mines': 'Мины',
    'casino.tab.plinko': 'Плинко',
    'casino.tab.dice': 'Кости',
    'casino.tab.scratch': 'Царапины игры',
    'casino.tab.other': 'Другой',
    'casino.tab.football': 'Футбол',
    'casino.tab.horse-racing': 'Скачки',
    'casino.tab.recommended': 'Рекомендуется',
    'casino.topProviders': 'Лучшие провайдеры',
    'casino.groupsAll': 'Все',
    'casino.groupsNew': 'Новые игры',
    'casino.groupsTop': 'Лучшие игры',
    'casino.groupsWager': 'Для ставок',
    'casino.groupsFreebonus': 'Для бесплатного бонуса',
    'casino.lobbyHome': 'Лобби Главная',
    'casino.groups': 'Группы',
    'casino.providers': 'Провайдеры',
    'casino.search': 'Поиск',
    'casino.play': 'Играть',
    'casino.demo': 'Демо',
    'casino.searchModal.title': 'Поиск',
    'casino.searchModal.placeholder': 'Поиск игр',
    'casino.filters': 'Фильтры',
    'casino.filtersCount': 'Фильтры ({count})',
    'casino.filter.section.functions': 'Функции',
    'casino.filter.section.themes': 'Темы',
    'casino.filter.bonusGame': 'Бонусная игра',
    'casino.filter.buyFeature': 'Купить функцию',
    'casino.filter.expandingSymbols': 'Расширяющиеся символы',
    'casino.filter.freeSpins': 'Free Spins',
    'casino.filter.multiplier': 'Множитель',
    'casino.filter.respins': 'Респины',
    'casino.filter.symbolsCollection': 'Коллекция символов',
    'casino.filter.animals': 'Животные',
    'casino.filter.books': 'Книги',
    'casino.filter.classic777': 'Классика и 777',
    'casino.filter.coins': 'Монеты',
    'casino.filter.egypt': 'Египет',
    'casino.filter.fruits': 'Фрукты',
    'casino.filter.gods': 'Боги',
    'casino.filter.joker': 'Джокер',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Все провайдеры',
    'casino.selectProvider': 'Выберите провайдера',
    'casino.searchProviders': 'Поиск поставщиков',
    'casino.loading': 'Загрузка игр…',
    'casino.noGames': 'Игры не найдены',
    'casino.lucky': 'мне повезло',
    'casino.sortBy': 'Сортировать по',
    'casino.sort.popular': 'Самый популярный',
    'casino.sort.default': 'По умолчанию',
    'casino.sort.az': 'от А до Я',
    'casino.sort.za': 'от Я до А',
    'casino.sort.new': 'Новейший',
    'casino.sort.provider': 'По провайдеру',
    'casino.sort.name': 'По имени',
    'casino.showMore': 'Показать больше',
    'casino.viewAll': 'Все',
    'casino.games': 'игры',
    'casino.side.games': 'Игры',
    'casino.side.tournament': 'Турнир',
    'casino.side.search': 'Поиск игр',
    'casino.side.recommended': 'Рекомендуемые игры',
    'casino.side.noGames': 'Игры не найдены',
    'casino.side.noTournaments': 'Нет активных турниров',
    'casino.side.loading': 'Загрузка…',
    'casino.game.play': 'Играть',
    'casino.game.demo': 'Демо',
    'casino.game.favorite': 'Добавить в избранное',
    'casino.game.fullscreen': 'Полноэкранный',
    'casino.game.noFreeSpins': 'Нет free spins для добавления в эту игру.',
    'casino.game.linkCopied': 'Ссылка скопирована',
    'casino.game.closeConfirmTitle': 'Закрыть игру?',
    'casino.game.closeConfirmText': 'Игра закроется. Хотите продолжить?',
    'casino.game.closeConfirmOk': 'Закрыть',
    'casino.game.closeConfirmCancel': 'Отмена',
    'casino.game.popout': 'Открыть в новом окне',
    'casino.game.playReal': 'Играйте на реальные деньги',
    'casino.game.addFreeSpins': 'Добавьте free spins',
    'casino.game.addFreeSpinsToGame': 'Добавьте free spins в игру.',
    'casino.game.fsBet': 'Ставка',
    'casino.game.fsExpiresIn': 'Срок действия истекает через',
    'casino.game.fsAdd': 'Добавлять',
    'casino.game.fsBackToGame': 'Вернуться в игру',
    'casino.game.fsNewAvailable': 'Доступен новый free spins',
    'casino.game.fsUpdateRequired': 'Требуется обновление игры',
    'casino.game.fsUpdate': 'Обновлять',
    'casino.game.insufficientBalance': 'Недостаточный баланс',
    'casino.game.insufficientBalanceHint': 'Пополните свой баланс, чтобы играть на реальные деньги',
    'casino.game.insufficientContinue': 'Продолжить',
    'casino.game.makeDeposit': 'Внести депозит',
    'casino.game.bonusInsufficientHint': 'Бонусного баланса недостаточно для этой ставки. Переход на основной счёт отменит бонус.',
    'casino.game.switchToCash': 'На основной счёт',
    'casino.game.demoMode': 'Демо-режим',
    'casino.game.signIn': 'Войдите, чтобы играть на реальные деньги.',
    'casino.game.tryDemo': 'Попробуйте демо',
    'casino.game.loading': 'Загрузка игры…',
    'casino.game.notFound': 'Игра не найдена',
    'casino.game.launchFailed': 'Не удалось запустить игру',
    'casino.game.demoUnavailable': 'Демо для этой игры недоступно.',
    'casino.game.unavailable': 'Сейчас игру запустить нельзя. Попробуйте позже.',
    'casino.game.demoSuffix': '(Демо)',
    'casino.badge.top': 'Эн Ийи',
    'casino.badge.fs': 'ФС',
    'casino.badge.tournament': 'Турнир',
    'casino.badge.new': 'НОВЫЙ',
    'casino.badge.hits': 'ХИТЫ',
    'casino.badge.exclusive': 'эксклюзивный',
    'casino.badge.jackpot': 'джекпот',
    'casino.bside.tournaments': 'Турниры',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Sport',
    'nav.sportLive': 'Paris en direct',
    'nav.liveCasino': 'Casino en direct',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Machines à sous',
    'nav.virtual': 'Sport virtuel',
    'nav.fast': 'Jeux rapides',
    'nav.tv': 'Jeux TV',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Regardez les matchs en direct',
    'vtv.live': 'En direct',
    'vtv.upcoming': 'À venir',
    'vtv.search': 'Rechercher',
    'vtv.searchPh': 'Rechercher équipes, ligues…',
    'vtv.allSports': 'Tous les sports',
    'vtv.loading': 'Chargement des flux…',
    'vtv.empty': 'Aucun match disponible',
    'vtv.error': 'Impossible de charger les flux',
    'vtv.pick': 'Choisissez un match à regarder',
    'vtv.streamError': 'Impossible d’ouvrir le flux',
    'vtv.liveBadge': 'LIVE',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'NOUVEAU',
    'nav.newGames': 'Nouveaux jeux',
    'nav.newPromos': 'Nouvelles promotions',
    'nav.promos': 'Promotions',
    'nav.casino': 'Casino',
    'nav.apps': 'Applications',
    'nav.results': 'Résultats',
    'header.promos': 'Promotions',
    'header.help': 'Aide',
    'header.search': 'Rechercher',
    'header.settings': 'Paramètres',
    'header.login': 'Connexion',
    'header.join': 'S\'inscrire',
    'header.logout': 'Déconnexion',
    'header.account': 'Mon compte',
    'header.deposit': 'Dépôt',
    'header.hideBalance': 'Masquer le solde',
    'header.showBalance': 'Afficher le solde',
    'header.notifications': 'Notifications',
    'mobile.menu': 'Menu',
    'mobile.home': 'Accueil',
    'mobile.myBets': 'Mes paris',
    'mobile.navigation': 'Navigation',
    'mobile.menu.loginTitle': 'Connectez-vous à votre compte',
    'mobile.menu.loginText': 'pour obtenir un accès complet à toutes les options de service',
    'mobile.menu.tournaments': 'Tournois',
    'mobile.menu.helpNote': 'FAQ, apprentissage, dictionnaire',
    'mobile.menu.appsNote': 'Pour Android, iOS',
    'mobile.menu.about': 'À propos de VurgunBet',
    'mobile.menu.aboutNote': 'Informations, licences',
    'basinda.title': 'Dans la presse',
    'basinda.lead': 'Moments des parrainages du stade et du terrain VurgunBet.',
    'basinda.menuNote': 'Parrainages, presse',
    'basinda.item1': 'Sassuolo - Pise',
    'basinda.item2': 'Turin - Atalante',
    'basinda.item3': 'Alavés - Elche',
    'basinda.item4': 'Levante - Alavés',
    'basinda.item5': 'Fenerbahçe - Pogon Szczecin',
    'mobile.menu.siteTour': 'Visite des lieux',
    'mobile.menu.siteTourText': 'ne prend que 2 minutes →',
    'mobile.menu.history': 'Afficher l\'historique',
    'mobile.menu.historyEmpty': 'Pas encore d\'historique de navigation',
    'mobile.menu.historyEmptyText': 'Vous trouverez ici toutes les sections et événements sportifs que vous avez consultés',
    'mobile.menu.clearHistory': 'Effacer l\'historique',
    'mobile.menu.openPromos': 'Promotions',
    'mobile.menu.searchGames': 'Rechercher des jeux',
    'mobile.menu.responsibleGaming': 'Jeu responsable',
    'mobile.account.number': 'Compte : {id}',
    'mobile.account.copy': 'Copier le numéro de compte',
    'mobile.account.copied': 'Copié',
    'mobile.account.balance': 'Solde : {amount}',
    'settings.section.sport': 'Sport',
    'settings.section.casino': 'Casino',
    'settings.section.interface': 'Interface',
    'settings.section.navigation': 'Navigation',
    'settings.eventDisplay': 'Affichage des événements',
    'settings.eventDisplay.table': 'Tableau',
    'settings.eventDisplay.list': 'Liste',
    'settings.betSlipLocation': 'Emplacement du coupon de pari',
    'settings.betSlipLocation.bottom': 'Dans le panneau inférieur',
    'settings.betSlipLocation.above': 'Au dessus du panneau',
    'settings.betSlipSettings': 'Paramètres du coupon de pari',
    'settings.betSlip.showLiveTimer': 'Afficher le chronomètre de l\'événement en direct dans le coupon de pari',
    'settings.betSlip.showEventTime': 'Afficher l\'heure et la date de début de l\'événement dans le coupon de pari',
    'settings.betSlip.skipClearConfirm': 'Ne demandez pas de confirmation pour effacer les bulletins de pari',
    'settings.betSlip.view': 'Vue du coupon de pari',
    'settings.betSlip.view.auto': 'Sélection automatique',
    'settings.betSlip.view.narrow': 'Étroit',
    'settings.betSlip.view.wide': 'Large',
    'settings.odds.title': 'Chances',
    'settings.odds.boosted': 'Augmenté',
    'settings.odds.on': 'sur',
    'settings.odds.off': 'désactivé',
    'settings.odds.hideBoosted': 'Ne pas afficher les cotes augmentées dans les sports',
    'settings.odds.european': 'européen',
    'settings.odds.american': 'Américain',
    'settings.odds.hongkong': 'Hong Kong',
    'settings.odds.indonesian': 'indonésien',
    'settings.odds.malaysian': 'Malaisien',
    'settings.favouriteSports': 'Sports préférés',
    'settings.favouriteSports.empty': 'Aucun',
    'settings.favouriteSports.desc': 'Ajoutez des sports favoris pour les afficher en premier dans la section Sports.',
    'settings.casinoProMode': 'Mode Pro',
    'settings.casinoProMode.desc': 'Afficher la volatilité de la machine à sous et d\'autres valeurs sur la carte de jeu',
    'settings.casinoView.standard': 'Vue standard',
    'settings.casinoView.pro': 'Mode Pro',
    'settings.theme.title': 'Thème du site Web',
    'settings.theme.auto': 'Auto',
    'settings.theme.light': 'Lumière',
    'settings.theme.dark': 'Sombre',
    'settings.hideBalance': 'Masquer le solde',
    'settings.hideBalance.desc': 'Faites glisser votre solde dans l\'en-tête pour le masquer',
    'settings.showUpButton': 'Afficher le bouton "Haut"',
    'settings.language': 'Langue',
    'settings.nav.sportSection': 'Dans la rubrique Sports',
    'settings.nav.casinoSection': 'Dans la rubrique Casino',
    'settings.nav.menu': 'Dans le menu',
    'settings.title': 'Paramètres du site Web',
    'settings.reset': 'Retour par défaut',
    'settings.betSlip.title': 'Coupon de pari',
    'settings.nav.betAcceptance': 'Acceptation du pari',
    'settings.nav.cashOut': 'Encaissement',
    'settings.nav.favouriteBets': 'Paris favoris',
    'settings.nav.betSlip': 'Vue du coupon de pari',
    'settings.navigation.auto': 'Auto',
    'settings.navigation.left': 'A gauche',
    'settings.navigation.top': 'Haut',
    'settings.eventList.title': 'Liste des événements',
    'settings.eventList.minimised': 'Tous les événements sont minimisés par défaut',
    'settings.eventPage.title': 'Page de l\'événement',
    'settings.view.large': 'Grande vue',
    'settings.view.compact': 'Vue compacte',
    'settings.favouriteSports.descLong': 'Ajoutez vos sports préférés pour les afficher en premier dans la section Sports. Vous pouvez modifier leur ordre en les faisant glisser',
    'settings.favouriteSports.hint': 'Appuyez sur ★ pour ajouter le sport à vos favoris',
    'settings.sport.football': 'Football',
    'settings.sport.hockey': 'Hockey',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basket-ball',
    'settings.sport.esports': 'E-sport',
    'settings.sport.tableTennis': 'Tennis de table',
    'settings.sport.volleyball': 'Volley-ball',
    'settings.sport.handball': 'Handball',
    'settings.sport.mixFights': 'Mélanger. Combats',
    'settings.sport.boxing': 'Boxe',
    'settings.sport.futsal': 'Futsal',
    'settings.sport.baseball': 'Base-ball',
    'settings.sport.americanFootball': 'Football américain',
    'settings.sport.rugby': 'Rugby',
    'settings.sport.waterPolo': 'Water polo',
    'settings.sport.fieldHockey': 'Hockey sur gazon',
    'settings.sport.racing': 'Courses',
    'settings.sport.cycling': 'Vélo',
    'settings.sport.sports': 'Sport',
    'settings.sport.beachSoccer': 'Football de plage',
    'settings.sport.basketball3x3': 'Basket-ball 3x3',
    'settings.sport.lacrosse': 'Lacrosse',
    'settings.sport.australianFootball': 'Football australien',
    'settings.sport.cricket': 'Cricket',
    'settings.sport.snooker': 'Billard',
    'settings.sport.darts': 'Fléchettes',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet — Paris sportifs en ligne',
    'auth.login.title': 'Connexion',
    'auth.login.submit': 'Se connecter',
    'auth.login.link': 'Se connecter',
    'auth.register.title': 'Inscription',
    'auth.register.bannerHighlight': '100 % JUSQU\'À',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPINS',
    'auth.register.bannerDesc': '+5 FREE BETS',
    'auth.register.perkFast': 'Anonyme',
    'auth.register.perkSafe': 'Zéro frais',
    'auth.register.perkBonus': 'Compatible VPN',
    'auth.register.orSignUpWith': 'OU INSCRIVEZ-VOUS AVEC',
    'auth.login.orSignInWith': 'OU CONNECTEZ-VOUS AVEC',
    'auth.webauthn.login': 'Connectez-vous avec Face ID / Touch ID',
    'auth.webauthn.offerTitle': 'Enregistrer Face ID sur cet appareil',
    'auth.webauthn.offerBody': 'La prochaine fois, vous pourrez vous connecter rapidement avec Face ID, Touch ID ou Windows Hello.',
    'auth.webauthn.offerConfirm': 'Enregistrer sur cet appareil',
    'auth.webauthn.offerSkip': 'Pas maintenant',
    'auth.webauthn.needRegister': 'Enregistrez d\'abord Face ID / Touch ID dans votre profil',
    'auth.webauthn.failed': 'Échec de la connexion biométrique',
    'auth.webauthn.unsupported': 'Face ID / Touch ID n\'est pas disponible sur cet appareil',
    'auth.webauthn.registerFailed': 'Impossible d\'enregistrer la connexion biométrique',
    'auth.webauthn.alreadyRegistered': 'Cet appareil est déjà enregistré',
    'auth.webauthn.thisDevice': 'Cet appareil',
    'auth.webauthn.manageTitle': 'ID de visage / ID tactile',
    'auth.webauthn.manageDesc': 'Enregistrez un mot de passe pour vous connecter avec Face ID, Touch ID ou Windows Hello sur cet appareil.',
    'auth.webauthn.empty': 'Aucune connexion biométrique enregistrée',
    'auth.webauthn.add': 'Enregistrer sur cet appareil',
    'auth.webauthn.remove': 'Retirer',
    'auth.webauthn.removed': 'Clé d\'accès supprimée',
    'auth.webauthn.registered': 'Connexion biométrique enregistrée',
    'auth.webauthn.loadFailed': 'Impossible de charger les clés d\'accès',
    'auth.webauthn.removeFailed': 'Impossible de supprimer le mot de passe',
    'account.profile.tab.passkeys': 'ID de visage / ID tactile',
    'account.profile.mobile.passkeys': 'ID de visage / ID tactile',
    'account.profile.mobile.passkeysHint': 'Connexion rapide',
    'auth.register.socialNotConfigured': 'Cette méthode n\'est pas encore configurée',
    'auth.register.pageTitle': 'Inscription | VurgunBet',
    'auth.register.submit': 'S\'inscrire',
    'auth.register.link': 'S\'inscrire',
    'guestPopup.title': 'Free bet 100 TL + 300 free spins',
    'guestPopup.subtitle': 'pour les nouveaux clients',
    'guestPopup.cta': 'Inscription',
    'language.choose': 'Choisir la langue',
    'auth.register.slogan': 'PLUS PROCHE DU JEU',
    'auth.register.smsHint': 'Le code du message texte sera envoyé à ce numéro',
    'auth.register.promoToggle': 'J\'ai un code promo',
    'auth.register.rules': 'J\'ai 18 ans et j\'accepte les Conditions Générales et la Politique de Confidentialité *',
    'auth.register.rulesBefore': 'J\'ai 18 ans et j\'accepte le',
    'auth.register.termsLink': 'Termes et conditions',
    'auth.register.rulesAnd': 'et',
    'auth.register.privacyLink': 'politique de confidentialité',
    'auth.register.rulesAfter': ' *',
    'auth.register.rulesLink': 'Termes et conditions',
    'auth.register.rulesRequired': 'Vous devez accepter les conditions générales et la politique de confidentialité',
    'auth.register.serviceMail': 'J\'accepte de recevoir les newsletters du service.',
    'auth.register.serviceMail2': 'Vous pouvez lire la politique de traitement des données personnelles',
    'auth.register.here': 'ici',
    'auth.register.adMail': 'J\'accepte le',
    'auth.register.adTerms': 'termes de la liste de diffusion publicitaire',
    'auth.register.adTermsLink': 'termes',
    'auth.register.adTermsSuffix': 'de la liste de diffusion publicitaire',
    'auth.register.serviceMailSuffix': '.',
    'auth.register.fullPromotionTerms': 'Conditions complètes de la promotion',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Entrez votre numéro de téléphone',
    'auth.validation.phoneOrEmailRequired': 'Entrez votre e-mail ou votre téléphone',
    'auth.validation.phoneInvalid': 'Entrez un numéro de téléphone valide',
    'auth.validation.phoneExists': 'Ce numéro de téléphone est déjà enregistré',
    'auth.validation.emailRequired': 'Entrez votre email',
    'auth.validation.emailInvalid': 'Entrez une adresse e-mail valide',
    'auth.validation.emailDomainInvalid': 'Utilisez un e-mail valide (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com, etc.)',
    'auth.validation.emailExists': 'Cet e-mail est déjà enregistré',
    'auth.validation.passwordRequired': 'Entrez votre mot de passe',
    'auth.validation.passwordShort': 'Le mot de passe doit contenir au moins 8 caractères',
    'auth.validation.registerFailed': 'L\'enregistrement a échoué. Veuillez réessayer.',
    'auth.validation.loginFieldsRequired': 'Remplissez tous les champs',
    'auth.validation.loginInvalid': 'Identifiant ou mot de passe incorrect',
    'auth.validation.accountRequired': 'Entrez votre numéro de compte',
    'auth.validation.accountShort': 'Le numéro de compte doit comporter au moins 6 caractères',
    'auth.validation.codeInvalid': 'Code de confirmation incorrect',
    'auth.validation.codeRequired': 'Entrez le code de confirmation',
    'auth.validation.codeSendFailed': 'Impossible d\'envoyer le code',
    'auth.validation.codeThrottled': 'Veuillez patienter avant de demander un autre code',
    'auth.validation.challengeExpired': 'Vérification expirée, veuillez vous reconnecter',
    'auth.validation.serverUnreachable': 'Ne peut pas atteindre le serveur. Exécutez npm run dev:server dans le terminal.',
    'auth.validation.serverError': 'La connexion a échoué. Vérifiez le serveur et la base de données.',
    'auth.tab.phone': 'Téléphone',
    'auth.tab.email': 'E-mail',
    'auth.tab.username': "Nom d'utilisateur",
    'auth.tab.account': 'Compte',
    'auth.label.phone': 'Numéro de téléphone',
    'auth.label.phoneOptional': 'Téléphone portable (facultatif)',
    'auth.label.email': 'E-mail',
    'auth.label.username': "Nom d'utilisateur",
    'auth.label.account': 'Numéro de compte',
    'auth.label.password': 'Mot de passe',
    'auth.label.promo': 'Code promotionnel',
    'auth.placeholder.account': 'Numéro de compte',
    'auth.placeholder.username': "Nom d'utilisateur",
    'auth.forgot': 'Mot de passe oublié ?',
    'auth.noAccount': 'Vous n\'avez pas de compte ?',
    'auth.haveAccount': 'Vous avez déjà un compte ?',
    'auth.login.pageTitle': 'Connectez-vous | VurgunBet',
    'auth.verify.info': 'Pour protéger votre compte, nous devons nous assurer qu\'il s\'agit bien de vous.',
    'auth.verify.caption': 'Obtenez le code de confirmation :',
    'auth.verify.methodPhone': 'nous vous enverrons le code par SMS ou par Telegram à votre numéro de téléphone {contact}',
    'auth.verify.methodEmail': 'nous enverrons le code par email à {contact}',
    'auth.verify.getCode': 'Obtenir le code',
    'auth.verify.cancel': 'Annuler',
    'auth.verify.noAccess': 'Je n\'ai pas accès au numéro de téléphone',
    'auth.verify.enterCode': 'Entrez le code de confirmation:',
    'auth.verify.confirm': 'Confirmer',
    'auth.verify.continue': 'Continuer',
    'auth.verify.codeInfoPhone': 'Entrez le code de vérification. Nous l\'avons envoyé par SMS ou par Telegram à votre numéro de téléphone {contact}.',
    'auth.verify.codeInfoEmail': 'Entrez le code de vérification. Nous l\'avons envoyé par email à {contact}.',
    'auth.verify.neverReceived': 'Je n\'ai jamais reçu de code',
    'auth.verify.resend': 'Renvoyer le code',
    'auth.verify.noAccessEmail': 'Je n\'ai pas accès au courrier électronique',
    'auth.verify.help.title': 'Si un code de confirmation n\'est jamais arrivé',
    'auth.verify.help.bodyPhone': 'Assurez-vous que le numéro de téléphone est correct et que votre appareil dispose de suffisamment de mémoire libre. Vérifiez si le message s\'est retrouvé dans le dossier spam.',
    'auth.verify.help.bodyEmail': 'Assurez-vous que l\'adresse e-mail est correcte. Vérifiez si le message s\'est retrouvé dans le dossier spam.',
    'auth.verify.help.step1': 'Ouvrez l\'application Messages',
    'auth.verify.help.step2': 'Appuyez sur le bouton dans le coin supérieur droit',
    'auth.verify.help.step3': 'Sélectionnez "Spam et bloqué"',
    'auth.verify.help.understood': 'Compris',
    'auth.recover.title': 'Récupération de mot de passe',
    'auth.recover.pageTitle': 'Récupération de mot de passe | VurgunBet',
    'auth.recover.continue': 'Continuer',
    'auth.recover.noAccess': 'Je n\'ai pas accès au numéro de téléphone/e-mail',
    'auth.recover.noAccessPhone': 'Je n\'ai pas accès au numéro de téléphone',
    'auth.recover.noAccessEmail': 'Je n\'ai pas accès au courrier électronique',
    'auth.recover.newPassword': 'Nouveau mot de passe',
    'auth.recover.confirmPassword': 'Confirmer le nouveau mot de passe',
    'auth.recover.passwordMismatch': 'Les mots de passe ne correspondent pas',
    'auth.recover.save': 'Enregistrer le mot de passe',
    'auth.recover.success': 'Votre mot de passe a été mis à jour. Vous pouvez vous connecter avec votre nouveau mot de passe.',
    'auth.recover.notFound': 'Aucun compte trouvé avec ces informations',
    'auth.verify.expiredTitle': 'Le temps imparti pour ce processus est expiré.',
    'auth.verify.retry': 'Réessayer',
    'welcome.stepLabel': 'Étape 1 sur 3 : Inscription',
    'welcome.title': 'Obtenez un bonus de bienvenue jusqu\'à 100 TL + 300 FS !',
    'welcome.step1.title': 'S\'inscrire',
    'welcome.step1.sub': 'Sur le site Internet ou dans l\'application',
    'welcome.step2.title': 'Terminez la vérification',
    'welcome.step2.sub': 'Cela ne prendra que quelques minutes',
    'welcome.step3.title': 'Faire un dépôt',
    'welcome.step3.sub': 'Un dépôt plus important – un bonus plus important !',
    'welcome.start': 'Commencer',
    'welcome.rules': 'Conditions complètes de la promotion',
    'account.loading': 'Chargement...',
    'account.save': 'Enregistrer',
    'account.empty': 'Aucun enregistrement trouvé',
    'account.nav.overview': 'Aperçu',
    'account.nav.profile': 'Données personnelles',
    'account.nav.verification': 'Vérification',
    'account.nav.cashier': 'Caisse',
    'account.nav.bets': 'Mes paris',
    'account.nav.bonuses': 'Bonus',
    'account.nav.notifications': 'Notifications',
    'account.nav.security': 'Sécurité',
    'account.nav.support': 'Support',
    'account.menu.profile': 'Mon profil',
    'account.menu.payments': 'Dépôts et retraits',
    'account.menu.history': 'Historique des paris et des transactions',
    'account.menu.requests': 'Demandes',
    'account.menu.responsible': 'Jeu responsable',
    'account.menu.vip': 'Votre statut VIP',
    'support.liveChat': 'Assistance en direct',
    'account.menu.deposit': 'Faire un dépôt',
    'account.overview.title': 'Sommaire du compte',
    'account.overview.balance': 'Solde',
    'account.overview.bonusBalance': 'Solde bonus',
    'account.overview.accountNo': 'Numéro de compte',
    'account.overview.verification': 'Vérification',
    'account.overview.totalBets': 'Paris totaux',
    'account.profile.name': 'Nom et prénom',
    'account.profile.saved': 'Vos coordonnées ont été enregistrées',
    'account.profile.marketingEmail': 'Je souhaite recevoir des emails promotionnels',
    'account.profile.marketingSms': 'Je souhaite recevoir des SMS promotionnels',
    'account.profile.tab.details': 'Données personnelles',
    'account.profile.tab.phone': 'Changer de numéro de téléphone',
    'account.profile.tab.phoneAdd': 'Ajouter un numéro de téléphone',
    'account.profile.tab.phoneVerify': 'Vérifier le numéro de téléphone',
    'account.profile.tab.email': 'Changer d\'e-mail',
    'account.profile.tab.emailAdd': 'Ajouter un e-mail',
    'account.profile.tab.emailVerify': 'Vérifier l\'e-mail',
    'account.profile.tab.password': 'Changer le mot de passe',
    'account.profile.section.personal': 'DONNÉES PERSONNELLES',
    'account.profile.section.lastLogin': 'DERNIÈRES INFORMATIONS DE CONNEXION',
    'account.profile.section.contacts': 'CONTACTS',
    'account.profile.section.marketing': 'PRÉFÉRENCES DE CONTACT',
    'account.profile.field.name': 'Nom:',
    'account.profile.field.verification': 'Statut de vérification d\'identité :',
    'account.profile.field.accountNo': 'Numéro de compte:',
    'account.profile.field.currency': 'Devise:',
    'account.profile.field.phone': 'Numéro de téléphone:',
    'account.profile.field.email': 'E-mail:',
    'account.profile.field.time': 'Temps:',
    'account.profile.field.ip': 'Adresse IP :',
    'account.profile.change': 'Changement',
    'account.profile.add': 'Ajouter',
    'account.profile.status.verified': 'Vérifié',
    'account.profile.status.unverified': 'Non vérifié',
    'account.profile.marketingIntro': 'Recevez des notifications sur les promotions et les actualités :',
    'account.profile.marketing.email': 'E-mail',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Notifications poussées',
    'account.profile.marketing.web': 'Notifications du site Web',
    'account.profile.verification.basic': 'Non vérifié',
    'account.profile.verification.verified': 'Vérifié',
    'account.profile.verification.pending': 'En attente',
    'account.profile.verify': 'Vérifier',
    'account.profile.tab.kyc': 'Vérification d\'identité',
    'account.profile.kyc.title': 'Vérification d\'identité',
    'account.profile.kyc.intro': 'Soumettez votre numéro d\'identification national, votre ville, votre adresse et vos photos d\'identité. Votre compte sera vérifié après examen.',
    'account.profile.kyc.tcLabel': 'Numéro d\'identification nationale',
    'account.profile.kyc.tcInvalid': 'Entrez un numéro d\'identification national valide à 11 chiffres',
    'account.profile.kyc.cityLabel': 'Ville',
    'account.profile.kyc.cityPlaceholder': 'Sélectionnez une ville',
    'account.profile.kyc.cityRequired': 'La sélection de la ville est obligatoire',
    'account.profile.kyc.addressLabel': 'Adresse',
    'account.profile.kyc.addressHint': 'Entrez votre adresse complète. Modifiez-le s\'il est incorrect.',
    'account.profile.kyc.addressRequired': 'L\'adresse doit comporter au moins 5 caractères',
    'account.profile.kyc.frontLabel': 'Face d\'identification',
    'account.profile.kyc.frontHint': 'Téléchargez une photo du recto de votre pièce d\'identité',
    'account.profile.kyc.backLabel': 'pièce d\'identité',
    'account.profile.kyc.backHint': 'Téléchargez une photo du dos de votre pièce d\'identité',
    'account.profile.kyc.photoRequired': 'Une photo d\'identité sur le devant est requise',
    'account.profile.kyc.backRequired': 'Une photo d\'identité au dos est requise',
    'account.profile.kyc.submit': 'Soumettre',
    'account.profile.kyc.submitted': 'Votre demande de vérification a été reçue et est en cours d\'examen',
    'account.profile.kyc.pendingMessage': 'Votre demande de vérification est en cours d\'examen. Vous ne pouvez pas soumettre de nouveaux documents tant que le problème n\'est pas résolu.',
    'account.profile.kyc.alreadyVerified': 'Votre compte est déjà vérifié.',
    'account.profile.todayAt': 'Aujourd\'hui à',
    'account.profile.mobile.personalData': 'Données personnelles',
    'account.profile.mobile.aboutAccount': 'À propos du compte',
    'account.profile.mobile.passwordChange': 'Changement de mot de passe',
    'account.profile.next': 'Suivant',
    'account.profile.changeEmailTitle': 'Nouvelle adresse e-mail',
    'account.profile.changePhoneTitle': 'Nouveau numéro de téléphone',
    'account.profile.addEmailTitle': 'Ajouter une adresse e-mail',
    'account.profile.addPhoneTitle': 'Ajouter un numéro de téléphone',
    'account.profile.verifyEmailTitle': 'Vérifier l\'adresse e-mail',
    'account.profile.verifyPhoneTitle': 'Vérifier le numéro de téléphone',
    'account.profile.contactSupport': 'Veuillez contacter le support pour modifier vos coordonnées.',
    'account.profile.contactSupportAddPhone': 'Créez une demande d\'assistance pour ajouter un numéro de téléphone.',
    'account.profile.contactSupportChangePhone': 'Créez une demande d\'assistance pour modifier votre numéro de téléphone.',
    'account.profile.contactSupportVerifyPhone': 'Créez une demande d\'assistance pour vérifier votre numéro de téléphone.',
    'account.profile.contactSupportAddEmail': 'Créez une demande d\'assistance pour ajouter une adresse e-mail.',
    'account.profile.contactSupportChangeEmail': 'Créez une demande d\'assistance pour modifier votre adresse e-mail.',
    'account.profile.step.support': 'Créer une demande d\'assistance',
    'account.profile.step.sharePhone': 'Partagez votre numéro de téléphone',
    'account.profile.step.shareNewPhone': 'Partagez votre nouveau numéro de téléphone',
    'account.profile.step.requestVerify': 'Soumettez votre demande de vérification',
    'account.profile.step.confirmSms': 'Confirmez avec le code SMS',
    'account.profile.step.shareEmail': 'Partagez votre adresse e-mail',
    'account.profile.step.shareNewEmail': 'Partagez votre nouvelle adresse e-mail',
    'account.profile.step.confirmEmail': 'Confirmation complète par e-mail',
    'account.profile.contactSupportBtn': 'Contacter l\'assistance',
    'account.profile.otp.addPhoneHint': 'Entrez votre numéro de téléphone. Nous vous enverrons un code de vérification par SMS.',
    'account.profile.otp.changePhoneHint': 'Entrez votre nouveau numéro de téléphone. Le changement est confirmé par un code SMS.',
    'account.profile.otp.verifyPhoneHint': 'Nous vous enverrons un code pour vérifier votre numéro de téléphone.',
    'account.profile.otp.addEmailHint': 'Entrez votre adresse e-mail. Nous vous enverrons un code de vérification par e-mail.',
    'account.profile.otp.verifyEmailHint': 'Nous vous enverrons un code pour vérifier votre adresse e-mail.',
    'account.profile.otp.changeEmailHint': 'Entrez votre nouvelle adresse e-mail. Le changement est confirmé par un code email.',
    'account.profile.otp.codeSentPhone': 'Nous avons envoyé un code de vérification à :',
    'account.profile.otp.codeSentEmail': 'Nous avons envoyé un code de vérification à :',
    'account.profile.otp.codeSent': 'Code de vérification envoyé',
    'account.profile.otp.codeLabel': 'Le code de vérification',
    'account.profile.otp.resend': 'Renvoyer le code',
    'account.profile.otp.phoneRequired': 'Le numéro de téléphone est requis',
    'account.profile.otp.emailRequired': 'L\'adresse e-mail est requise',
    'account.profile.otp.codeRequired': 'Un code de vérification est requis',
    'account.profile.otp.sessionMissing': 'Session de vérification introuvable',
    'account.profile.otp.saved': 'Vos coordonnées ont été mises à jour',
    'account.profile.passwordConfirm': 'Confirmer le nouveau mot de passe',
    'account.profile.passwordRequired': 'Remplissez tous les champs de mot de passe',
    'account.profile.passwordMismatch': 'Les nouveaux mots de passe ne correspondent pas',
    'account.profile.passwordSame': 'Le nouveau mot de passe ne peut pas être le même que votre mot de passe actuel',
    'account.profile.send': 'Envoyer',
    'account.profile.passwordHint': 'Utilisez la section de sécurité pour modifier votre mot de passe.',
    'account.verification.desc': 'Une vérification d\'identité est requise pour les retraits et l\'accès complet au compte.',
    'account.verification.verified': 'Vérifié',
    'account.verification.pending': 'En attente',
    'account.verification.rejected': 'Rejeté',
    'account.verification.step1': 'Téléchargez une photo de votre passeport ou de votre pièce d\'identité',
    'account.verification.step2': 'Ajouter un selfie tenant le document',
    'account.verification.step3': 'L\'examen est généralement terminé dans les 24 heures',
    'account.verification.submit': 'Commencer la vérification',
    'account.verification.submitted': 'Vos documents sont en cours de révision',
    'account.cashier.deposit': 'Dépôt',
    'account.cashier.withdraw': 'Retrait',
    'account.cashier.amount': 'Montant (TL)',
    'account.cashier.balance': 'Solde actuel : {amount}',
    'account.cashier.history': 'Historique des transactions',
    'account.cashier.type': 'Taper',
    'account.cashier.date': 'Date',
    'account.payments.title': 'Dépôts et retraits',
    'account.payments.back': 'Retour',
    'account.payments.selectMethod': 'Sélectionnez une méthode',
    'account.payments.group.havale': 'Virement',
    'account.payments.group.card': 'Carte de crédit',
    'account.payments.group.crypto': 'Crypto',
    'account.payments.group.other': 'Autre',
    'account.payments.noMethods': 'Aucun mode de paiement disponible pour le moment.',
    'account.payments.from': 'à partir de {amount} TL',
    'account.payments.depositTitle': 'Rechargez le solde avec {method}',
    'account.payments.withdrawTitle': 'Retirez-vous avec {method}',
    'account.payments.depositNotice': 'Attention! La carte bancaire doit être enregistrée au nom du titulaire du compte. Les paiements effectués avec des cartes tierces seront rejetés.',
    'account.payments.withdrawNotice': 'Les demandes de retrait sont traitées en fonction de votre statut de vérification.',
    'account.payments.addAmount': 'Dépôt',
    'account.payments.withdrawSubmit': 'Retirer {amount} TL',
    'account.payments.requests': 'Vos demandes',
    'account.payments.insufficientBalance': 'Solde insuffisant',
    'account.payments.minWithdrawNotice': 'Montant minimum requis pour retirer les gains : {amount}',
    'account.payments.withdrawGoDeposit': 'Dépôt',
    'account.payments.selectAnotherMethod': 'Sélectionnez une autre méthode',
    'account.payments.requestsTitle': 'Demandes de transactions',
    'account.payments.requestsEmpty': 'Vous n\'avez pas encore de demandes de transaction.',
    'account.payments.filterAll': 'Tous',
    'account.payments.filterCompleted': 'Complété',
    'account.payments.filterProcessing': 'Traitement',
    'account.payments.filterCancelled': 'Annulé',
    'account.payments.colNumber': 'NOMBRE',
    'account.payments.colDate': 'DATE',
    'account.payments.colType': 'TAPER',
    'account.payments.colMethod': 'MÉTHODE',
    'account.payments.colAmount': 'MONTANT',
    'account.payments.status': 'Statut',
    'account.payments.status_completed': 'Complété',
    'account.payments.status_pending': 'En attente',
    'account.payments.status_processing': 'Traitement',
    'account.payments.status_cancelled': 'Annulé',
    'account.payments.status_rejected': 'Rejeté',
    'account.payments.status_failed': 'Échoué',
    'account.payments.status_approved': 'Approuvé',
    'account.payments.status_expired': 'Expiré',
    'account.payments.goToRequests': 'Mes demandes',
    'account.payments.method.crypto': 'Cryptomonnaie',
    'account.payments.method.maxhavale': 'Max Havale',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Vitesse Havale',
    'account.payments.havalespeed.depositPending': 'Complétez votre dépôt Speed ​​Havale',
    'account.payments.havalespeed.withdrawPending': 'Votre retrait Speed ​​Havale est en cours de traitement',
    'account.payments.havalespeed.processing': 'Temps restant',
    'account.payments.havalespeed.confirmPaid': 'J\'ai transféré, avertir',
    'account.payments.havalespeed.confirming': 'Envoi d\'une notification…',
    'account.payments.havalespeed.confirmSent': 'Notification reçue. En attente d\'approbation.',
    'account.payments.havalespeed.cancelDeposit': 'Annuler la demande',
    'account.payments.havalespeed.cancelling': 'Annulation…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Nom et prénom',
    'account.payments.havale.amountLabel': 'Montant',
    'account.payments.havalespeed.approvedHint': '{amount} a été ajouté à votre solde.',
    'account.payments.havalespeed.approvedHintGeneric': 'Votre dépôt a été approuvé et ajouté à votre solde.',
    'account.payments.havalespeed.rejectedHint': 'Votre demande Speed ​​Havale a été rejetée. Vous pouvez essayer un nouveau dépôt.',
    'account.payments.maxhavale.depositPending': 'Complétez votre dépôt Max Havale',
    'account.payments.maxhavale.withdrawPending': 'Votre retrait Max Havale est en cours de traitement',
    'account.payments.maxhavale.processing': 'Temps restant',
    'account.payments.maxhavale.cancelDeposit': 'Annuler la demande',
    'account.payments.maxhavale.cancelling': 'Annulation…',
    'account.payments.maxhavale.openPayment': 'Ouvrir la page de dépôt',
    'account.payments.maxhavale.urlMissing': 'Les détails du paiement n\'ont pas pu être chargés. Vous pouvez annuler cette demande et réessayer.',
    'account.payments.maxhavale.bankName': 'Banque',
    'account.payments.havaleBtq.depositPending': 'Complétez votre dépôt Havale',
    'account.payments.havaleBtq.withdrawPending': 'Votre retrait Havale est en cours',
    'account.payments.havaleBtq.processing': 'Temps restant',
    'account.payments.havaleBtq.cancelDeposit': 'Annuler la demande',
    'account.payments.havaleBtq.cancelling': 'Annulation…',
    'account.payments.havaleBtq.openPayment': 'Ouvrir la page de dépôt',
    'account.payments.havaleBtq.urlMissing': 'Les détails du paiement n\'ont pas pu être chargés.',
    'account.payments.havaleBtq.bankName': 'Banque',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'Identifiant du portefeuille PayUrus',
    'account.payments.payurus.walletName': 'Nom du titulaire du portefeuille',
    'account.payments.payurus.openPayment': 'Rouvrir la page de dépôt',
    'account.payments.payurus.reopenPayment': 'Rouvrir la page de dépôt',
    'account.payments.payurus.urlMissing': 'Le lien de la page de paiement n\'a pas pu être chargé. Vous pouvez annuler cette demande et réessayer.',
    'account.payments.payurus.cancelDeposit': 'Annuler la demande',
    'account.payments.payurus.cancelling': 'Annulation…',
    'account.payments.payurus.depositPending': 'Complétez votre paiement PayUrus',
    'account.payments.payurus.withdrawPending': 'Votre retrait PayUrus est en cours de traitement',
    'account.payments.payurus.processing': 'Temps restant',
    'account.payments.payurus.depositSuccess': 'Paiement réussi',
    'account.payments.payurus.depositSuccessHint': '{amount} a été ajouté à votre solde.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Votre dépôt {provider} a été ajouté à votre solde.',
    'account.payments.payurus.depositProcessing': 'Traitement des paiements',
    'account.payments.payurus.depositProcessingHint': 'Votre paiement {provider} est en cours de vérification. S\'il vous plaît, attendez.',
    'account.payments.payurus.depositFailed': 'Échec du paiement',
    'account.payments.payurus.depositFailedHint': 'Votre paiement {provider} n\'a pas pu être finalisé. Vous pouvez essayer un nouveau dépôt.',
    'account.payments.payurus.continue': 'Continuer',
    'account.payments.payurus.nameMismatch': 'Votre prénom et votre nom ne correspondent pas',
    'account.payments.payurus.nameMismatchDetail': 'Le nom du titulaire du compte ne correspond pas au nom renvoyé par le fournisseur. Titulaire du compte PayUrus : {name}',
    'account.payments.payurus.rateLimit': 'Un autre retrait sur ce portefeuille n\'est pas encore autorisé',
    'account.payments.payurus.rateLimitDetail': 'PayUrus limite la fréquence à laquelle vous pouvez retirer sur le même portefeuille. Veuillez réessayer plus tard.',
    'account.payments.payurus.walletInvalid': 'Les détails du portefeuille PayUrus n\'ont pas pu être vérifiés',
    'account.payments.payurus.walletInvalidDetail': 'Veuillez vérifier l\'identifiant du portefeuille ou le nom du titulaire du portefeuille et réessayer.',
    'account.payments.method.oplati': 'Papara',
    'account.payments.method.raschet': 'Système de paiement « Raschet »',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'Carte d\'identité nationale (TC)',
    'account.payments.havale.firstName': 'Prénom',
    'account.payments.havale.lastName': 'Nom de famille',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Banque',
    'account.payments.havale.transferTo': 'Virement sur le compte ci-dessous',
    'account.payments.havale.accountName': 'Nom du compte',
    'account.payments.havale.copyIban': 'Copie',
    'account.payments.havale.copyName': 'Copie',
    'account.payments.havale.copyAmount': 'Montant de la copie',
    'account.payments.havale.copyBank': 'Copier la banque',
    'account.payments.havale.copied': 'Copié',
    'account.payments.havale.countdown': 'Temps restant',
    'account.payments.havale.activeNotice': 'Vous avez une demande active. Un nouveau ne peut pas être créé avant la fin du minuteur.',
    'account.payments.havale.amountDue': 'Montant à déposer',
    'account.payments.havale.waitNew': 'Attendez de créer une nouvelle demande',
    'account.payments.havale.resultApproved': 'Dépôt approuvé',
    'account.payments.havale.resultApprovedHint': '{amount} a été ajouté à votre solde.',
    'account.payments.havale.resultRejected': 'Dépôt rejeté',
    'account.payments.havale.resultRejectedHint': 'Votre demande n\'a pas été approuvée. Vous pouvez réessayer.',
    'account.payments.havale.resultExpired': 'Demande expirée',
    'account.payments.havale.resultExpiredHint': 'La fenêtre de paiement {provider} est terminée. Vous pouvez créer une nouvelle demande.',
    'account.payments.havale.withdrawReceived': 'Demande de retrait reçue',
    'account.payments.havale.withdrawReceivedHint': 'Votre retrait de {amount} a été reçu et est en cours d\'examen.',
    'account.payments.havale.withdrawApproved': 'Retrait approuvé',
    'account.payments.havale.withdrawApprovedHint': 'Votre retrait de {amount} a été effectué.',
    'account.payments.havale.withdrawRejected': 'Retrait rejeté',
    'account.payments.havale.withdrawRejectedHint': 'Votre retrait n\'a pas été approuvé. Vous pouvez créer une nouvelle demande si nécessaire.',
    'account.payments.havale.tryAgain': 'Essayer à nouveau',
    'account.payments.crypto.selectCoin': 'Sélectionnez la crypto-monnaie',
    'account.payments.crypto.selectNetwork': 'Sélectionnez le réseau',
    'account.payments.crypto.network': 'Réseau',
    'account.payments.crypto.selectedNetwork': 'Réseau sélectionné',
    'account.payments.crypto.networkWarning': 'Envoyez uniquement sur le réseau {network}. Les fonds envoyés sur le mauvais réseau peuvent être perdus.',
    'account.payments.crypto.coin': 'Pièce de monnaie',
    'account.payments.crypto.depositAddress': 'Adresse de dépôt',
    'account.payments.crypto.copyAddress': 'Copier l\'adresse',
    'account.payments.crypto.yourAddress': 'L\'adresse de votre portefeuille',
    'account.payments.crypto.estimated': 'Montant estimé',
    'account.payments.crypto.txHashOptional': 'Hachage TX (facultatif)',
    'account.payments.crypto.submitTxHash': 'Soumettre le hachage TX',
    'account.payments.crypto.continueToWallet': 'Afficher l\'adresse de dépôt',
    'account.payments.crypto.txHashError': 'Impossible d\'enregistrer le hachage TX',
    'account.payments.crypto.confirmations': 'Confirmations du réseau',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': 'de {amount}',
    'account.cashier.amountUsd': 'Montant (USD)',
    'account.payments.addAmountUsd': 'Dépôt {amount}',
    'account.payments.crypto.activeNotice': 'Envoyez votre virement. Les confirmations réseau sont suivies automatiquement ; le solde est mis à jour lorsque les confirmations requises sont atteintes.',
    'account.payments.crypto.noAssets': 'Aucun réseau crypto actif pour le moment. Veuillez réessayer plus tard.',
    'account.bets.stake': 'Mise',
    'account.bets.odds': 'Chances',
    'account.bets.win': 'Gagner',
    'account.bets.status': 'Statut',
    'account.bets.status_pending': 'En attente',
    'account.bets.status_won': 'Gagné',
    'account.bets.status_lost': 'Perdu',
    'account.history.tabBets': 'Paris',
    'account.history.tabTransactions': 'Historique des transactions',
    'account.history.filters': 'Filtres',
    'account.history.filterGroupBetType': 'Type de pari',
    'account.history.filterGroupResult': 'Résultats des paris',
    'account.history.filterBetType_all': 'Tous',
    'account.history.filterBetType_bets': 'Paris',
    'account.history.filterBetType_slot': 'Jeu de machine à sous',
    'account.history.filterBetType_dice_live': 'Jeu de dés en mode Live',
    'account.history.filterBetType_card_live': 'Jeu de cartes en mode Live',
    'account.history.filterBetType_cylinder_live': 'Jeu de roulette en mode Live',
    'account.history.filterBetType_online_game': 'Le jeu en ligne du bookmaker',
    'account.history.filterResult_all': 'Tous',
    'account.history.filterResult_not_settled': 'Non réglé',
    'account.history.filterResult_win': 'Gagner',
    'account.history.filterResult_loss': 'Perte',
    'account.history.filterResult_cashed_out': 'Encaissé',
    'account.history.filterResult_void': 'Vide',
    'account.history.filterResult_return': 'Retour',
    'account.history.colDate': 'DATE',
    'account.history.colTime': 'TEMPS',
    'account.history.colBetNo': 'PARI №',
    'account.history.colCoupon': 'COUPON',
    'account.history.colStake': 'MISER',
    'account.history.colPotential': 'POTENTIEL',
    'account.history.details': 'Détails',
    'account.history.colTransactionNo': 'N° DE TRANSACTION',
    'account.history.colNumber': 'NOMBRE',
    'account.history.colTransaction': 'TRANSACTION',
    'account.history.colAmountBonuses': 'MONTANT / BONUS',
    'account.history.colBalanceBonuses': 'SOLDE / BONUS',
    'account.history.operation_deposit': 'Dépôt',
    'account.history.operation_deposit_pending': 'En attente de confirmation de dépôt',
    'account.history.operation_withdrawal_pending': 'En attente de confirmation de retrait',
    'account.history.operation_withdrawal_cancelled': 'Retrait annulé',
    'account.history.operation_withdrawal_rejected': 'Retrait rejeté',
    'account.history.operation_withdrawal_approved': 'Retrait approuvé',
    'account.history.operation_withdrawal_completed': 'Retrait terminé',
    'account.history.operation_bet_placed': 'Pari placé',
    'account.history.operation_bet_settled': 'Pari réglé',
    'account.history.operation_bet_lost': 'Pari perdu',
    'account.history.operation_slot_bet_settled': 'Pari sur les machines à sous réglé',
    'account.history.operation_slot_bet_placed': 'Pari placé sur une machine à sous',
    'account.history.operation_accrual_bonus_account': 'Accumulation sur le compte bonus',
    'account.history.operation_close_bonus_account': 'Fermer le compte bonus',
    'account.history.operation_bonus_conversion': 'Conversion de bonus',
    'account.history.filterOperation_close_bonus_account': 'Fermer le compte bonus',
    'account.history.filterOperation_accrual_bonus_account': 'Accumulation sur le compte bonus',
    'account.history.filterOperation_slot_bet_settled': 'Pari sur les machines à sous réglé',
    'account.history.filterOperation_slot_bet_placed': 'Pari placé sur une machine à sous',
    'account.history.filterOperation_withdrawal_cancelled': 'Retrait annulé',
    'account.history.filterOperation_withdrawal_rejected': 'Retrait rejeté',
    'account.history.filterOperation_withdrawal_approved': 'Retrait approuvé',
    'account.history.filterOperation_withdrawal_completed': 'Retrait terminé',
    'account.history.filterOperation_withdrawal_pending': 'En attente de confirmation de retrait',
    'account.history.filterOperation_bonus_conversion': 'Conversion de bonus',
    'account.history.filterOperation_bet_lost': 'Pari perdu',
    'account.history.filterOperation_bet_placed': 'Pari placé',
    'account.history.filterOperation_bet_settled': 'Pari réglé',
    'account.history.filterOperation_deposit': 'Dépôt',
    'account.history.filterOperation_deposit_pending': 'En attente de confirmation de dépôt',
    'account.history.colBetType': 'TYPE DE PARI',
    'account.history.colType': 'TAPER',
    'account.history.colDescription': 'DESCRIPTION',
    'account.history.colOdds': 'CHANCES',
    'account.history.colResult': 'RÉSULTAT',
    'account.history.colAmount': 'MONTANT',
    'account.history.colStatus': 'STATUT',
    'account.history.betTypeSlot': 'Jeu de machine à sous',
    'account.history.betTypeSportsbook': 'Paris sportifs',
    'account.history.betTypeSingle': 'Célibataire',
    'account.history.betTypeExpress': 'Exprimer',
    'account.history.result_pending': 'Non réglé',
    'account.history.result_won': 'Gagner',
    'account.history.result_lost': 'Perte',
    'account.history.result_completed': 'Complété',
    'account.history.betsEmpty': 'Vous n\'avez pas encore d\'historique de paris.',
    'account.history.transactionsEmpty': 'Vous n\'avez pas encore d\'historique de transactions.',
    'account.bonuses.welcomeTitle': 'Bonus de bienvenue',
    'account.bonuses.welcomeDesc': 'Ne manquez pas les offres de bonus sur votre premier dépôt.',
    'account.bonuses.viewPromos': 'Voir les promotions',
    'account.bonuses.freeSpinsTitle': 'Vos jeux gratuits',
    'account.bonuses.freeSpinsEmpty': 'Vous n\'avez pas encore de jeux gratuits.',
    'account.bonuses.viewFreeSpins': 'Voir mes bonus',
    'account.vip.title': 'VIP Remise en argent',
    'account.vip.subtitleLine1': 'Profitez de vos privilèges',
    'account.vip.subtitleLine2': 'et obtenez du cashback chaque semaine !',
    'account.vip.yourStatus': 'Votre statut',
    'account.vip.yourCashback': 'Votre remise en argent',
    'account.vip.promotionRules': 'Règles de promotion',
    'account.vip.stillQuestions': 'Vous avez encore des questions ?',
    'account.vip.cardCashbackFreeAndBonus': 'Cashback en free bets et en bonus',
    'account.vip.cardCashbackBonusOnly': 'Cashback en bonus',
    'account.vip.cardCashbackTail': 'jusqu\'à',
    'account.vip.tierCashbackDesc': '{metal} — Cashback en free bets et en bonus jusqu\'à {percent}%',
    'account.vip.fromAmount': 'depuis',
    'account.vip.betAmountWeeks': 'montant du pari pour 4 semaines',
    'account.vip.yourStatusBadge': 'VOTRE STATUT VIP',
    'account.vip.targetStatus': 'STATUT CIBLE',
    'account.vip.cashbackLabel': 'REMBOURSEMENT',
    'account.vip.needToBet': 'Vous devez parier depuis',
    'account.vip.totalSettled': 'Total des paris réglés',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback free bets pour les paris sportifs, bonus — pour les paris sur les jeux de machines à sous de casino',
    'account.vip.prev': 'Précédent',
    'account.vip.next': 'Suivant',
    'account.vip.rulesLoadError': 'Impossible de charger les règles de promotion.',
    'account.vip.faqLoadError': 'Impossible de charger la FAQ.',
    'account.vip.cashbackHistoryTitle': 'Historique d\'accumulation de cashback',
    'account.vip.cashbackHistoryDesc': 'Le cashback de la semaine précédente est crédité tous les lundis jusqu\'à 18h00. Nous vous informerons de l\'état de votre accumulation de cashback par SMS.',
    'account.vip.cashbackHistoryDate': 'Date',
    'account.vip.cashbackHistoryStatus': 'Statut',
    'account.vip.cashbackHistoryAmount': 'Montant du cashback',
    'account.vip.cashbackCalculating': 'Calculateur',
    'account.vip.pendingCashback': 'Accumulation de cette semaine',
    'common.close': 'Fermer',
    'appUpdate.title': 'Télécharger la mise à jour',
    'appUpdate.text': 'pour accéder aux nouvelles fonctionnalités',
    'appUpdate.action': 'Mise à jour',
    'account.notifications.readAll': 'Marquer tout comme lu',
    'account.notifications.empty': 'Aucune notification',
    'account.notifications.emptyUnread': 'Aucune notification non lue',
    'account.notifications.filterAll': 'Tous',
    'account.notifications.filterUnread': 'Non lu ({count})',
    'account.notifications.viewAll': 'Toutes les notifications',
    'account.notifications.details': 'Détails',
    'account.security.current': 'Mot de passe actuel',
    'account.security.enterCurrent': 'Entrez le mot de passe actuel',
    'account.security.new': 'Nouveau mot de passe',
    'account.security.saved': 'Mot de passe mis à jour',
    'account.responsible.tabDeposit': 'Limites de dépôt',
    'account.responsible.tabSession': 'Limites des sessions de jeu',
    'account.responsible.depositDescription': 'Fixez la limite de dépôt. Lorsque la limite est atteinte, vous ne pourrez déposer d\'argent sur votre compte qu\'à la fin de la période spécifiée. La limite peut être abaissée ou supprimée instantanément. L’augmentation d’une limite nécessite un délai de réflexion de 24 heures.',
    'account.responsible.sessionDescription': 'Définissez la limite de session de jeu. Spécifiez le temps maximum que vous pouvez passer à jouer par jour, semaine ou mois. Lorsque la limite est atteinte, vous serez déconnecté et ne pourrez plus vous connecter avant la fin de la période spécifiée. La limite peut être abaissée ou supprimée instantanément. L’augmentation d’une limite nécessite un délai de réflexion de 24 heures.',
    'account.responsible.currentRestrictions': 'Restrictions actuelles',
    'account.responsible.futureRestrictions': 'Restrictions futures',
    'account.responsible.limitNotSet': 'Limite non définie',
    'account.responsible.notSet': 'Non défini',
    'account.responsible.dailyLimit': 'Limite quotidienne',
    'account.responsible.weeklyLimit': 'Limite hebdomadaire',
    'account.responsible.monthlyLimit': 'Limite mensuelle',
    'account.responsible.hoursShort': 'h',
    'account.responsible.saved': 'Limites mises à jour',
    'account.responsible.timeLimitsTitle': 'Délais',
    'account.responsible.timeDescription': 'Une fois la limite expirée, vous serez déconnecté de votre compte et ne pourrez plus vous reconnecter avant le début de la période suivante.',
    'account.responsible.sessionLimitMinutes': 'Limite de session (en minutes)',
    'account.responsible.install': 'Installer',
    'account.responsible.confirmTitle': 'Fixer une limite ?',
    'account.responsible.confirmRemoveOrLower': 'Si vous augmentez la limite, cela prend effet après 24 heures. L\'abaissement s\'applique immédiatement.',
    'account.responsible.confirmTightenImmediately': 'Une limite inférieure s’appliquera immédiatement après confirmation.',
    'account.responsible.confirmSet': 'Ensemble',
    'account.responsible.confirmCancel': 'Annuler',
    'account.responsible.currentLimits': 'Limites actuelles',
    'account.responsible.sessionLimit': 'Limite de session',
    'account.responsible.timeRemaining': 'Temps restant',
    'account.responsible.delete': 'Supprimer',
    'account.responsible.confirmChangeTitle': 'Êtes-vous sûr de vouloir modifier les valeurs limites ?',
    'account.responsible.confirmDeleteTitle': 'Êtes-vous sûr de vouloir supprimer la limite ?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Durée maximale de la session – 1 440 minutes (24 heures)',
    'account.responsible.limitBlocked': 'Limite de session atteinte. Vous avez été déconnecté.',
    'account.requests.title': 'Demandes',
    'account.requests.newRequest': 'Nouvelle demande',
    'account.requests.empty': 'Aucune demande en cours',
    'account.requests.chooseType': 'Choisissez le type de demande',
    'account.requests.cancel': 'Annuler',
    'account.requests.sendRequest': 'Envoyer la demande',
    'account.requests.submit': 'Soumettre',
    'account.requests.error': 'Impossible d\'envoyer la demande',
    'account.requests.notFound': 'Type de demande introuvable',
    'account.requests.type.sport_bet_settlement': 'Règlement des paris sportifs',
    'account.requests.type.casino_bet_settlement': 'Règlement des paris de casino',
    'account.requests.type.hotline': 'Question sur la hotline',
    'account.requests.type.deposit': 'Question de dépôt',
    'account.requests.type.withdrawal': 'Question de retrait',
    'account.requests.type.website_app': 'Question sur l\'utilisation du site Web ou de l\'application mobile',
    'account.requests.type.admin': 'Question pour l\'administrateur',
    'account.requests.type.verification': 'Question de vérification',
    'account.requests.type.bonus': 'Question bonus',
    'account.requests.mobile.title': 'Des problèmes ?',
    'account.requests.mobile.desc': 'Créez une nouvelle demande ou vous pouvez trouver des réponses dans notre centre d\'aide',
    'account.requests.mobile.create': 'Créer une nouvelle demande',
    'account.requests.mobile.helpCentre': 'Accédez au centre d\'aide',
    'account.requests.group.deposit': 'QUESTION DE DÉPÔT',
    'account.requests.group.withdrawal': 'QUESTION DE RETRAIT',
    'account.requests.group.other': 'AUTRE',
    'account.requests.template.depositBankCard': 'Carte bancaire',
    'account.requests.template.depositRaschet': 'Système de paiement unifié "Raschet"',
    'account.requests.template.depositQiwi': 'Borne QIWI',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'Oplati',
    'account.requests.template.withdrawalOplati': 'Oplati',
    'account.requests.template.withdrawalBank': 'Carte bancaire / virement',
    'account.requests.form.operationDate': 'Date et heure de l\'opération',
    'account.requests.form.amount': 'Montant de la transaction',
    'account.requests.form.selectOperationDesc': 'Choisissez l\'opération sur laquelle vous avez une question',
    'account.requests.form.selectOperationBtn': 'Sélectionnez l\'opération',
    'account.requests.form.selectedOperation': 'Opération sélectionnée',
    'account.requests.form.noOperations': 'Aucune opération correspondante trouvée',
    'account.requests.form.messagePlaceholder': 'Décrivez votre question ou votre problème',
    'account.requests.form.symbolsRemaining': 'Symboles {count} restants',
    'account.requests.form.choose': 'Choisir',
    'account.requests.form.dragOrUpload': 'Faites glisser ici ou téléchargez des fichiers',
    'account.requests.form.attachFile': 'Joindre un fichier',
    'account.requests.form.attachHint': 'Jusqu\'à 5 fichiers. Formats : jpg, jpeg, png, pdf. Jusqu\'à 7 Mo.',
    'account.requests.form.attachments': 'Pièces jointes',
    'account.helpCentre.title': 'Centre d\'aide',
    'account.helpCentre.text1': 'Ici vous pouvez trouver des informations',
    'account.helpCentre.text2': 'et conseils d\'utilisation',
    'account.helpCentre.faq': 'FAQ',
    'account.helpCentre.instructions': 'Instructions',
    'account.helpCentre.strategies': 'Stratégies de pari',
    'account.helpCentre.glossary': 'Glossaire',
    'account.helpCentre.go': 'Aller au centre d\'aide',
    'account.support.subject': 'Sujet',
    'account.support.message': 'Message',
    'account.support.send': 'Envoyer',
    'account.support.sent': 'Votre demande a été reçue',
    'account.support.history': 'Demandes précédentes',
    'account.support.status_open': 'Ouvrir',
    'account.support.status_closed': 'Fermé',
    'account.support.status_pending': 'En attente',
    'account.support.status_waiting': 'En attente',
    'account.support.status_answered': 'Répondu',
    'account.support.status_replied': 'Répondu',
    'account.support.status_in_progress': 'En cours',
    'account.support.status_resolved': 'Résolu',
    'account.pageTitle': 'Mon compte | VurgunBet',
    'sport.filter.allTime': 'Tout le temps',
    'sport.filter.allEvents': 'Tous les événements',
    'sport.filter.live': 'En direct',
    'sport.filter.prematch': 'Avant-match',
    'sport.filter.all': 'Tous',
    'betslip.title': 'Coupon de pari',
    'betslip.empty': 'Le coupon de pari est vide',
    'betslip.stake': 'Mise',
    'betslip.totalOdds': 'Cotes totales',
    'betslip.potentialWin': 'Victoire potentielle',
    'betslip.place': 'Placer un pari',
    'betslip.clear': 'Clair',
    'betslip.accepted': 'Pari accepté',
    'betslip.login': 'Connectez-vous pour placer un pari',
    'betslip.emptyHint': 'Sélectionnez le résultat de l\'événement pour parier',
    'betslip.amount': 'Montant, TL',
    'betslip.promos': 'Promotions',
    'betslip.active': 'Actif',
    'betslip.popular': 'Événements populaires',
    'footer.about': 'À propos de nous',
    'footer.basinda': 'Dans la presse',
    'footer.licence': 'Licence',
    'footer.privacy': 'politique de confidentialité',
    'footer.responsible': 'Jeu responsable',
    'footer.rules': 'Termes et conditions',
    'footer.financial': 'Services financiers',
    'footer.vip': 'Programme VIP',
    'footer.help': 'Centre d\'aide',
    'footer.payments': 'Paiements',
    'footer.company': 'Détails de l\'entreprise',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Règles des boutiques de paris',
    'footer.appCaption': 'Application',
    'footer.appIos': 'pour iOS',
    'footer.appIosLong': 'Application pour iOS',
    'footer.appAndroidLong': 'Application pour Android',
    'footer.appAndroid': 'pour Android',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Le jeu est illégal pour les personnes de moins de 18 ans. VurgunBet fonctionne comme un opérateur international de jeux en ligne.',
    'footer.legal': 'VurgunBet propose des paris sportifs, des jeux de machines à sous, un casino en direct et des produits de jeux associés aux utilisateurs âgés de 18 ans et plus. Les utilisateurs doivent se conformer aux restrictions légales applicables dans leur région.',
    'footer.legal1': 'Le jeu est illégal pour les personnes de moins de 18 ans, ainsi que pour les personnes limitées dans la visite des établissements de jeux de hasard et des établissements de jeux virtuels et/ou dans la participation aux jeux de hasard.',
    'footer.legal2': 'VurgunBet propose des paris sportifs en ligne, des jeux de machines à sous, un casino en direct et des produits de jeux associés. Les services ne peuvent être utilisés que là où la loi le permet.',
    'help.title': 'Centre d\'aide',
    'help.searchPlaceholder': 'Recherchez votre question',
    'help.searchSheetTitle': 'Centre d\'aide : recherche',
    'help.searchSheetDesc': 'Trouvez la réponse à votre question',
    'help.popularSearches': 'RECHERCHES POPULAIRES',
    'help.popular.identification': 'Comment compléter l\'identification',
    'help.popular.deposit': 'Comment recharger votre solde',
    'help.popular.win': 'Comment gagner',
    'help.askQuestion': 'Poser une question',
    'help.views': 'vues',
    'help.back': 'Retour',
    'help.noResults': 'Aucun résultat trouvé',
    'help.goToFaq': 'Aller à la FAQ',
    'help.instructions': 'Instructions',
    'help.training': 'Entraînement',
    'help.glossary': 'Glossaire',
    'help.notFound.code': '404',
    'help.notFound.title': 'Page introuvable',
    'help.notFound.description': 'Oups ! La page que vous recherchez n\'existe pas. Il a peut-être été déplacé ou supprimé.',
    'help.notFound.home': 'Accueil',
    'help.feedback.review': 'Écrire un avis',
    'help.feedback.helpful': 'Est-ce que cette information a été utile?',
    'help.feedback.yes': 'Oui, merci',
    'help.feedback.no': 'Non',
    'promos.tab.actions': 'Promotions',
    'promos.tab.tournaments': 'Tournois',
    'promos.tab.actionsDesc': 'Devenez un champion',
    'promos.tab.tournamentsDesc': 'Rejoignez des tournois',
    'promos.tab.actionsTitle': 'Promotions',
    'promos.tab.tournamentsTitle': 'Tournois',
    'promos.tab.bonuses': 'Bonus',
    'promos.tab.bonusesDesc': 'Suivez vos bonus',
    'promos.tab.bonusesTitle': 'Vos bonus',
    'promos.tab.promoCode': 'Code promotionnel',
    'promos.tab.promoCodeDesc': 'Activer maintenant',
    'promos.tab.promoCodeTitle': 'Vous avez un code promo ?',
    'promos.tournamentsIntro': 'Rejoignez des tournois et concourez pour des prix précieux',
    'promos.filter.all': 'Tous',
    'promos.filter.sport': 'Sport',
    'promos.filter.casino': 'Casino',
    'promos.timer.ended': 'Terminé',
    'promos.timer.daysLeft': 'Gauche : {count} jour(s)',
    'promos.timer.hoursLeft': 'Gauche : {count} heure(s)',
    'promos.timer.minutesLeft': 'Gauche : {count} min',
    'promos.tournament.active': 'Actif',
    'promos.tournament.bonusFund': 'Fonds de bonus',
    'promos.tournament.participants': 'Participants',
    'promos.tournament.places': 'Lieux',
    'promos.tournament.untilCompletion': 'Jusqu\'à l\'achèvement',
    'promos.tournament.untilStart': 'Jusqu\'au début',
    'promos.tournament.upcoming': 'Prochain',
    'promos.tournament.startsIn': 'Commence dans',
    'promos.tournament.joinWhenLive': 'Rejoignez-nous en direct',
    'promos.tournament.tab.rating': 'Notation',
    'promos.tournament.tab.terms': 'Termes',
    'promos.tournament.tab.games': 'Jeux',
    'promos.tournament.col.participant': 'Participant',
    'promos.tournament.col.points': 'Points',
    'promos.tournament.col.bonuses': 'Bonus',
    'promos.tournament.participate': 'Participer',
    'promos.tournament.optOut': 'Se désengager',
    'promos.tournament.loginToJoin': 'Connectez-vous pour rejoindre',
    'promos.tournament.promoRules': 'Règles de promotion',
    'promos.tournament.questions': 'Vous avez encore des questions ?',
    'promos.tournament.close': 'Fermer',
    'promos.tournament.loading': 'Chargement du classement…',
    'promos.tournament.emptyBoard': 'Pas encore de classement. Soyez le premier à nous rejoindre !',
    'promos.tournament.noTerms': 'Des règles seront bientôt ajoutées.',
    'promos.tournament.noGames': 'Les jeux éligibles seront bientôt répertoriés.',
    'promos.tournament.joinedOk': 'Vous avez rejoint le tournoi',
    'promos.tournament.leftOk': 'Tu as quitté le tournoi',
    'promos.tournament.actionError': 'Impossible de terminer l\'action',
    'promos.tournament.working': 'Fonctionnement…',
    'promos.tournament.gameBadge': 'TOURNOI',
    'promos.tournament.showAllGames': 'Afficher tous les jeux',
    'promos.tournament.askQuestion': 'Poser une question',
    'promos.tournament.faq.participate.q': 'Comment participer au tournoi',
    'promos.tournament.faq.participate.a': 'Allez dans la section Tournois, ouvrez le tournoi souhaité et appuyez sur le bouton Participer.',
    'promos.tournament.faq.deposit.q': 'Dois-je effectuer un dépôt pour participer au tournoi ?',
    'promos.tournament.faq.deposit.a': 'Non, l\'adhésion est gratuite. Gagnez des points avec des paris avec solde réel (min. 5 TL) sur les machines à sous de l\'onglet Jeux. Les paris avec solde bonus ne rapportent pas de points.',
    'promos.tournament.faq.multiple.q': 'Puis-je participer à plusieurs tournois en même temps ?',
    'promos.tournament.faq.multiple.a': 'Oui. Vous pouvez rejoindre plusieurs tournois actifs à la fois ; chaque tournoi conserve son propre classement.',
    'promos.tournament.faq.terms.q': 'Où puis-je consulter les termes et conditions du tournoi ?',
    'promos.tournament.faq.terms.a': 'Ouvrez l\'onglet Conditions dans la fenêtre du tournoi ou appuyez sur Règles de promotion pour consulter les conditions complètes.',
    'promos.tournament.faq.games.q': 'Quels jeux de machines à sous sont inclus dans le tournoi ?',
    'promos.tournament.faq.games.a': 'Les jeux éligibles sont répertoriés sous l\'onglet Jeux. Seuls les paris sur ces jeux comptent dans le score du tournoi.',
    'promos.tournament.faq.bonuses.q': 'Quels bonus puis-je obtenir en participant et en gagnant des tournois ?',
    'promos.tournament.faq.bonuses.a': 'Vous gagnez des prix en espèces et des tours gratuits (FS) par rang. Les prix sont crédités dans les 48 heures suivant la fin du tournoi ; FS reste valable 7 jours et les prix en espèces ne nécessitent que des mises ×2.',
    'promos.tournament.faq.timed.q': 'La durée des tournois est-elle limitée ?',
    'promos.tournament.faq.timed.a': 'Oui. VURGUN VAKTİ fonctionne chaque semaine du lundi 11h00 au dimanche 23h59, puis se renouvelle automatiquement.',
    'promos.tournament.faq.track.q': 'Comment puis-je suivre les résultats et la progression de mon tournoi ?',
    'promos.tournament.faq.track.a': 'Ouvrez l\'onglet Classement dans la fenêtre du tournoi pour voir vos points en direct et votre place. Les scores sont mis à jour juste après les paris avec solde réel.',
    'promos.tournament.faq.more.q': 'J\'ai encore des questions.',
    'promos.tournament.faq.more.a': 'Appuyez sur Poser une question ci-dessous pour ouvrir une demande d\'assistance. Notre équipe vous répondra sous peu.',
    'promos.tournament.ask.title': 'Nouvelle demande',
    'promos.tournament.ask.subtitle': 'Question bonus',
    'promos.tournament.ask.placeholder': 'Entrez votre question ou décrivez le problème',
    'promos.tournament.ask.charsLeft': '{count} caractères restants',
    'promos.tournament.ask.attach': 'Joindre un fichier',
    'promos.tournament.ask.attachHint': 'Jusqu\'à 5 fichiers. Formats : jpg, jpeg, png, pdf. Jusqu\'à 7 Mo.',
    'promos.tournament.ask.cancel': 'Annuler',
    'promos.tournament.ask.send': 'Envoyer la demande',
    'promos.tournament.ask.sending': 'Envoi…',
    'promos.tournament.ask.sent': 'Votre demande a été reçue. Nous vous répondrons sous peu.',
    'promos.tournament.ask.loginRequired': 'Connectez-vous pour envoyer une demande',
    'promos.tournament.ask.error': 'Impossible d\'envoyer la demande',
    'promos.tournament.terms.periodTitle': 'Période de tournoi hebdomadaire',
    'promos.tournament.terms.pointsTitle': 'Conditions d\'attribution des points',
    'promos.tournament.terms.points1': 'La mise minimale est de seulement 5 TL — l\'adhésion est gratuite ; jouez avec un véritable équilibre pour gagner des points.',
    'promos.tournament.terms.points2': 'Chaque pari de solde réel de 1 TL = 2 points. Du vendredi au dimanche, vous bénéficiez d\'un bonus de points de 20 % !',
    'promos.tournament.terms.points3': 'Tous les paris en solde réel sur les machines à sous de l\'onglet Jeux sont crédités instantanément. Les paris sur le solde bonus ne comptent pas.',
    'promos.tournament.terms.bonusesTitle': 'Conditions d\'utilisation des bonus',
    'promos.tournament.terms.bonuses1': 'Les prix en cash et FS sont crédités dans les 48 heures suivant la fin du tournoi ; FS reste valable 7 jours.',
    'promos.tournament.terms.bonuses2': 'Les gains ne nécessitent que des mises ×2, soit bien en dessous de la moyenne du secteur.',
    'promos.tournament.terms.bonuses3': 'Le tournoi se renouvelle automatiquement tous les lundis à 11h00 ; le classement est réinitialisé pour une nouvelle semaine.',
    'promos.bonuses.title': 'Vos bonus',
    'promos.promocode.title': 'Vous avez un code promo ?',
    'promos.promocode.desc': 'Entrez votre code promotionnel ci-dessous et sélectionnez Activer',
    'promos.promocode.placeholder': 'Entrez le code promotionnel',
    'promos.promocode.activate': 'Activer',
    'promos.promocode.activating': 'Candidature…',
    'promos.promocode.success': 'Code promotionnel appliqué avec succès',
    'promos.promocode.error': 'Impossible d\'appliquer le code promotionnel',
    'promos.promocode.loginRequired': 'Connectez-vous pour utiliser un code promotionnel',
    'promos.bonuses.loading': 'Chargement de vos bonus…',
    'promos.bonuses.empty': 'Vous n\'avez pas encore de bonus.',
    'promos.bonuses.emptyCaption': 'Aucun bonus actif',
    'promos.bonuses.emptyDescription': 'Participez aux promotions et obtenez de nouveaux bonus !',
    'promos.bonuses.emptyButton': 'Aller aux promotions',
    'promos.bonuses.emptyArchiveCaption': 'Aucun bonus archivé',
    'promos.bonuses.emptyArchiveDescription': 'Participez aux promotions et obtenez de nouveaux bonus !',
    'promos.bonuses.kindFilterBonuses': 'Bonus',
    'promos.bonuses.kindFilterFreeSpins': 'Tours gratuits',
    'promos.bonuses.kindFilterAll': 'Tous',
    'promos.bonuses.kindFreeSpin': 'Jeu gratuit',
    'promos.bonuses.fieldNominal': 'Nominal',
    'promos.bonuses.fieldStatus': 'Statut',
    'promos.bonuses.fieldExpires': 'Expire',
    'promos.bonuses.fieldReceived': 'Reçu',
    'promos.bonuses.tabActive': 'Actif',
    'promos.bonuses.tabArchive': 'Archive',
    'promos.bonuses.kindBonus': 'PRIME',
    'promos.bonuses.yourProgress': 'Votre progression :',
    'promos.bonuses.statusWagering': 'Pari en cours',
    'promos.bonuses.moreInfo': 'Plus d\'informations',
    'promos.bonuses.detailTitle': 'Bonus activé',
    'promos.bonuses.leftDays': 'il reste {n} jours',
    'promos.bonuses.leftDay': 'il reste le jour {n}',
    'promos.bonuses.detailLead': 'Remplissez les conditions de mise et recevez le bonus sur votre compte principal',
    'promos.bonuses.placeBets': 'Placez des paris totalisant {amount}',
    'promos.bonuses.rulesTitle': 'RÈGLES DE MISE DU COMPTE BONUS',
    'promos.bonuses.rule1': 'Les gains ajoutés au solde du compte bonus deviendront disponibles sur le compte principal une fois que le montant aura été misé par un facteur de 25. Les paris peuvent être effectués dans toutes les machines à sous de tous les fournisseurs de casino, à l\'exception de certaines machines à sous établies par l\'Organisateur.',
    'promos.bonuses.rule2': 'Lorsque vous misez des fonds à partir du solde du compte bonus, les fonds sont d\'abord crédités à partir du compte principal, puis à partir du solde du compte bonus.',
    'promos.bonuses.rule3': 'Lorsque les fonds sont crédités sur le solde du compte bonus, les gains sont reversés sur le solde du compte bonus.',
    'promos.bonuses.rule4': 'Une fois la mise terminée, le montant restant du compte bonus est transféré sur le solde principal, mais ne peut pas dépasser x3 du montant initialement crédité sur le solde du compte bonus.',
    'promos.bonuses.rule5': 'La période de mise est de 3 jours à compter du moment où le compte bonus est activé.',
    'promos.bonuses.rule6': 'Chaque bonus suivant est activé automatiquement après avoir misé le bonus précédent.',
    'promos.bonuses.rule7': 'S\'il y a des fonds sur le compte bonus, le retrait des fonds du compte principal n\'est pas disponible.',
    'promos.bonuses.promotionRules': 'Règles de promotion',
    'promos.bonuses.askQuestion': 'Poser une question',
    'promos.bonuses.cancelBonus': 'Annuler le bonus',
    'promos.bonuses.cancelConfirm': 'Votre solde bonus sera supprimé et les paris annulés. Continuer?',
    'promos.bonuses.cancelBusy': 'Annulation…',
    'promos.bonuses.cancelTitle': 'Voulez-vous vraiment vous désinscrire ?',
    'promos.bonuses.cancelBody': 'En cas de refus, les bonus seront brûlés.\nVous pouvez annuler à tout moment.',
    'promos.bonuses.cancelRefuse': 'je veux refuser',
    'promos.bonuses.cancelBack': 'Convaincu! Dos',
    'promos.bonuses.askClose': 'Fermer',
    'promos.bonuses.askFileBadType': 'Format de fichier non pris en charge.',
    'promos.bonuses.askFileTooBig': 'Le fichier fait plus de 7 Mo.',
    'promos.bonuses.askError': 'Impossible d\'envoyer la demande',
    'promos.bonuses.askSent': 'Votre demande a été envoyée.',
    'promos.bonuses.askSending': 'Envoi…',
    'promos.bonuses.askSend': 'Envoyer la demande',
    'promos.bonuses.askCancel': 'Annuler',
    'promos.bonuses.askFilesSize': 'Jusqu\'à 7 Mo.',
    'promos.bonuses.askFilesMax': 'Jusqu\'à 5 fichiers.',
    'promos.bonuses.askAttach': 'Joindre un fichier',
    'promos.bonuses.askCharsLeft': '{n} caractères restants',
    'promos.bonuses.askPlaceholder': 'Entrez votre question ou décrivez le problème',
    'promos.bonuses.askNewRequest': 'Nouvelle demande',
    'promos.bonuses.askBonusQuestion': 'Question bonus',
    'promos.bonuses.askHint': 'Envoyez une question sur votre bonus au support',
    'promos.bonuses.fieldWagering': 'Paris',
    'promos.bonuses.fieldWageringTime': 'Temps de mise',
    'promos.bonuses.fieldMaxWithdrawal': 'Max. retrait',
    'promos.bonuses.fieldUsed': 'Utilisé',
    'promos.bonuses.statusAvailable': 'Disponible',
    'promos.bonuses.statusUsed': 'Utilisé',
    'promos.bonuses.activate': 'Activer',
    'promos.bonuses.days': 'jours',
    'promos.bonuses.games': 'Jeux',
    'promos.bonuses.noGames': 'Aucune information sur le jeu',
    'promos.bonuses.play': 'Jouer',
    'home.showcase.slots.title': 'Casino',
    'home.showcase.slots.count': 'Jeux {count}',
    'home.showcase.slots.link': 'Voir les jeux →',
    'home.showcase.live.title': 'Casino en direct',
    'home.showcase.live.count': 'Jeux {count}',
    'home.showcase.live.link': 'Jouez maintenant →',
    'home.showcase.tv.title': 'Jeux télé',
    'home.showcase.tv.count': 'Jeux {count}',
    'home.showcase.fast.title': 'Jeux rapides',
    'home.showcase.fast.count': 'Jeux {count}',
    'home.showcase.fast.link': 'Jouez maintenant →',
    'home.showcase.virtual.title': 'Sport virtuel',
    'home.showcase.virtual.count': 'Jeux {count}',
    'home.showcase.virtual.link': 'Jouez maintenant →',
    'home.showcase.gamesCount': 'Jeux {count}',
    'home.showcase.tv.link': 'Jouez maintenant →',
    'home.showcase.sport.title': 'Sport',
    'home.showcase.sport.count': '3380 événements',
    'home.showcase.sport.link': 'Pariez maintenant →',
    'home.promo.category.promotions': 'Promotions',
    'home.promo.category.tournaments': 'Tournois',
    'home.promo.filter.all': 'Tous',
    'home.promo.filter.sport': 'Sport (5)',
    'home.promo.filter.casino': 'Casino (5)',
    'home.promo.showAll': 'Afficher tout →',
    'home.promo.allPromotions': 'Toutes les promotions',
    'home.promo.cta.play': 'Jouer',
    'home.promo.cta.join': 'S\'inscrire',
    'home.promo.cta.details': 'Détails',
    'home.promo.cta.signup': 'S\'inscrire',
    'home.sport.searchEvents': 'Recherche par événements',
    'footer.contactUs': 'Contactez-nous',
    'footer.usefulInfo': 'Informations utiles',
    'footer.socialMedia': 'Réseaux sociaux',
    'footer.partners': 'Partenaire officiel',
    'footer.officialPartner': 'Partenaire\nofficiel',
    'home.casino.loading': 'Chargement des jeux…',
    'home.casino.noGames': 'Aucun jeu disponible',
    'home.casino.viewAllMobile': 'Voir les jeux {count}',
    'home.shuffle.title': 'Vous ne savez pas à quel jeu jouer ensuite ?',
    'home.shuffle.cta': 'Faites tourner maintenant',
    'home.shuffle.modalTitle': 'Laissez-nous trouver le jeu parfait pour vous !',
    'home.shuffle.respin': 'Tourne à nouveau',
    'home.shuffle.close': 'Fermer',
    'home.jackpot.casinoTitle': 'Casino Jackpot',
    'home.jackpot.title': 'VURGUN GRAND JACKPOT',
    'home.jackpot.badgeRest': 'GRAND JACKPOT',
    'home.jackpot.winners': 'Nombre total de gagnants : {count}',
    'home.jackpot.largest': 'La plus grande victoire',
    'home.jackpot.last': 'Dernière victoire',
    'home.jackpot.onSlots': 'Sur tous les emplacements',
    'home.jackpot.play': 'Jeux Jackpot',
    'home.liveWins.title': 'Victoires en direct',
    'home.liveWins.heated': 'Vurgoun',
    'home.topWins.title': 'Meilleures victoires',
    'home.topWins.week': 'Cette semaine',
    'home.topWins.month': 'Ce mois-ci',
    'home.topWins.day': 'Aujourd\'hui',
    'home.topWins.play': 'Jouer',
    'home.topWins.prev': 'Précédent',
    'home.topWins.next': 'Suivant',
    'home.popularSlots.title': 'Machines à sous populaires',
    'home.hotSlots.title': 'Meilleurs salariés',
    'home.hotSlots.badge': 'CHAUD',
    'home.matchCarousel.title': 'Matchs',
    'home.matchCarousel.liveTv': 'TV en direct',
    'home.slotsCarousel.showAll': 'Afficher tout',
    'home.slotsCarousel.prev': 'Précédent',
    'home.slotsCarousel.next': 'Suivant',
    'home.jackpot.grand': 'GRANDIOSE',
    'home.jackpot.major': 'MAJEUR',
    'home.jackpot.minor': 'MINEURE',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Club',
    'home.heroSide.vipSub': 'Avantages exclusifs',
    'home.heroSide.promosTitle': 'Bonus',
    'home.heroSide.promosSub': 'Dernières promotions',
    'home.heroSide.sportTitle': 'Sport',
    'home.heroSide.sportSub': 'Paris en direct',
    'header.support': 'Support',
    'home.topEvents.showAll': 'Afficher tout',
    'betslip.bonusFund': 'Fonds de bonus',
    'betslip.participants': '{count} participants',
    'betslip.hoursLeft': '{hours} heures restantes',
    'betslip.details': 'Détails',
    'casino.viewAllCaption': 'Voir tout →',
    'casino.bside.promos': 'Promotions',
    'casino.bside.showAll': 'Afficher tout →',
    'casino.lobby.slots': 'Machines à sous',
    'casino.lobby.live': 'Casino en direct',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'Jeux télé',
    'casino.lobby.fast': 'Jeux rapides',
    'casino.lobby.virtual': 'Sport virtuel',
    'casino.tab.review': 'Revoir',
    'casino.tab.favourites': 'Favoris',
    'casino.tab.top': 'Meilleurs jeux',
    'casino.tab.peter': 'Succès de Peter et fils',
    'casino.tab.free-spins': 'Avec free spins',
    'casino.tab.all': 'Tous les jeux',
    'casino.tab.tournaments': 'Tournois',
    'casino.tab.jackpot-cards': 'Jackpot Cartes',
    'casino.tab.new': 'NOUVEAU',
    'casino.tab.world-cup': 'Coupe du monde 2026',
    'casino.tab.buy-bonus': 'Acheter un bonus',
    'casino.tab.exclusive': 'Exclusif',
    'casino.tab.vip-egt': 'VIPEGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Jeu pragmatique',
    'casino.tab.coins-link-vip': 'Lien pièces VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'Cascade',
    'casino.tab.megaways': 'Mégaways',
    'casino.tab.collect': 'Collecter',
    'casino.tab.wild': 'Sauvage',
    'casino.tab.double': 'Double chance',
    'casino.tab.megax': 'Méga X',
    'casino.tab.respin': 'Respin',
    'casino.tab.retro': 'Rétro',
    'casino.tab.fruits': 'Fruits',
    'casino.tab.books': 'Livres',
    'casino.tab.fast-football': 'Football rapide',
    'casino.tab.holdem': 'Hold\'em',
    'casino.tab.caribbean': 'Caraïbes',
    'casino.tab.video-poker': 'Vidéo Poker',
    'casino.tab.crash': 'Jeux de crash',
    'casino.tab.table-games': 'Jeux de table',
    'casino.tab.mines': 'Mines',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Dés',
    'casino.tab.scratch': 'Jeux de grattage',
    'casino.tab.other': 'Autre',
    'casino.tab.football': 'Football',
    'casino.tab.horse-racing': 'Course de chevaux',
    'casino.tab.recommended': 'Recommandé',
    'casino.topProviders': 'Meilleurs fournisseurs',
    'casino.groupsAll': 'Tous',
    'casino.groupsNew': 'Nouveaux jeux',
    'casino.groupsTop': 'Meilleurs jeux',
    'casino.groupsWager': 'Pour parier',
    'casino.groupsFreebonus': 'Pour un bonus gratuit',
    'casino.lobbyHome': 'Accueil du hall',
    'casino.groups': 'Groupes',
    'casino.providers': 'Fournisseurs',
    'casino.search': 'Rechercher',
    'casino.play': 'Jouer',
    'casino.demo': 'Démo',
    'casino.searchModal.title': 'Rechercher',
    'casino.searchModal.placeholder': 'Rechercher des jeux',
    'casino.filters': 'Filtres',
    'casino.filtersCount': 'Filtres ({count})',
    'casino.filter.section.functions': 'Fonctions',
    'casino.filter.section.themes': 'Thèmes',
    'casino.filter.bonusGame': 'Jeu bonus',
    'casino.filter.buyFeature': 'Acheter une fonctionnalité',
    'casino.filter.expandingSymbols': 'Symboles en expansion',
    'casino.filter.freeSpins': 'Free Spins',
    'casino.filter.multiplier': 'Multiplicateur',
    'casino.filter.respins': 'Réponses',
    'casino.filter.symbolsCollection': 'Collection de symboles',
    'casino.filter.animals': 'Animaux',
    'casino.filter.books': 'Livres',
    'casino.filter.classic777': 'Classique & 777',
    'casino.filter.coins': 'Pièces',
    'casino.filter.egypt': 'Egypte',
    'casino.filter.fruits': 'Fruits',
    'casino.filter.gods': 'Dieux',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Tous les fournisseurs',
    'casino.selectProvider': 'Sélectionnez le fournisseur',
    'casino.searchProviders': 'Fournisseurs de recherche',
    'casino.loading': 'Chargement des jeux…',
    'casino.noGames': 'Aucun jeu trouvé',
    'casino.lucky': 'j\'ai de la chance',
    'casino.sortBy': 'Trier par',
    'casino.sort.popular': 'Les plus populaires',
    'casino.sort.default': 'Défaut',
    'casino.sort.az': 'De A à Z',
    'casino.sort.za': 'Z à A',
    'casino.sort.new': 'Le plus récent',
    'casino.sort.provider': 'Par fournisseur',
    'casino.sort.name': 'Par nom',
    'casino.showMore': 'Afficher plus',
    'casino.viewAll': 'Tous',
    'casino.games': 'jeux',
    'casino.side.games': 'Jeux',
    'casino.side.tournament': 'Tournoi',
    'casino.side.search': 'Rechercher des jeux',
    'casino.side.recommended': 'Jeux recommandés',
    'casino.side.noGames': 'Aucun jeu trouvé',
    'casino.side.noTournaments': 'Aucun tournoi actif',
    'casino.side.loading': 'Chargement…',
    'casino.game.play': 'Jouer',
    'casino.game.demo': 'Démo',
    'casino.game.favorite': 'Ajouter aux favoris',
    'casino.game.fullscreen': 'Plein écran',
    'casino.game.noFreeSpins': 'Non free spins à ajouter à ce jeu',
    'casino.game.linkCopied': 'Lien copié',
    'casino.game.closeConfirmTitle': 'Fermer le jeu ?',
    'casino.game.closeConfirmText': 'Le jeu se terminera. Voulez-vous continuer ?',
    'casino.game.closeConfirmOk': 'Fermer',
    'casino.game.closeConfirmCancel': 'Annuler',
    'casino.game.popout': 'Ouvrir dans une nouvelle fenêtre',
    'casino.game.playReal': 'Jouez avec de l\'argent réel',
    'casino.game.addFreeSpins': 'Ajouter free spins',
    'casino.game.addFreeSpinsToGame': 'Ajouter free spins au jeu',
    'casino.game.fsBet': 'Pari',
    'casino.game.fsExpiresIn': 'Expire dans',
    'casino.game.fsAdd': 'Ajouter',
    'casino.game.fsBackToGame': 'Retour au jeu',
    'casino.game.fsNewAvailable': 'Nouveau free spins disponible',
    'casino.game.fsUpdateRequired': 'Mise à jour du jeu requise',
    'casino.game.fsUpdate': 'Mise à jour',
    'casino.game.insufficientBalance': 'Solde insuffisant',
    'casino.game.insufficientBalanceHint': 'Rechargez votre solde pour jouer avec de l\'argent réel',
    'casino.game.insufficientContinue': 'Continuer',
    'casino.game.makeDeposit': 'Faire un dépôt',
    'casino.game.bonusInsufficientHint': 'Votre solde bonus est insuffisant pour cette mise. Passer au compte réel annulera le bonus.',
    'casino.game.switchToCash': 'Passer au réel',
    'casino.game.demoMode': 'Mode démo',
    'casino.game.signIn': 'Connectez-vous pour jouer avec de l\'argent réel.',
    'casino.game.tryDemo': 'Essayez la démo',
    'casino.game.loading': 'Chargement du jeu…',
    'casino.game.notFound': 'Jeu introuvable',
    'casino.game.launchFailed': 'Impossible de démarrer le jeu',
    'casino.game.demoUnavailable': 'La démo n\'est pas disponible pour ce jeu.',
    'casino.game.unavailable': 'Ce jeu ne peut pas être démarré pour le moment. Réessayez plus tard.',
    'casino.game.demoSuffix': '(Démo)',
    'casino.badge.top': 'En İyi',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Tournoi',
    'casino.badge.new': 'NOUVEAU',
    'casino.badge.hits': 'COUPS',
    'casino.badge.exclusive': 'exclusif',
    'casino.badge.jackpot': 'cagnotte',
    'casino.bside.tournaments': 'Tournois',
  },
  az: {
    'nav.home': 'Ana səhifə',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'İdman',
    'nav.sportLive': 'Canlı mərc',
    'nav.liveCasino': 'Canlı Kazino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slotlar',
    'nav.virtual': 'Virtual idman',
    'nav.fast': 'Sürətli oyunlar',
    'nav.tv': 'TV oyunları',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Canlı maç yayınlarını izle',
    'vtv.live': 'Canlı',
    'vtv.upcoming': 'Yaklaşan',
    'vtv.search': 'Ara',
    'vtv.searchPh': 'Takım, lig ara…',
    'vtv.allSports': 'Tüm sporlar',
    'vtv.loading': 'Yayınlar yükleniyor…',
    'vtv.empty': 'Maç bulunamadı',
    'vtv.error': 'Yayınlar yüklenemedi',
    'vtv.pick': 'İzlemek için bir maç seç',
    'vtv.streamError': 'Yayın açılamadı',
    'vtv.liveBadge': 'CANLI',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'YENİ',
    'nav.newGames': 'Yeni oyunlar',
    'nav.newPromos': 'Yeni promosyonlar',
    'nav.promos': 'Promosyonlar',
    'nav.casino': 'Kazino',
    'nav.apps': 'Tətbiqlər',
    'nav.results': 'Nəticələr',
    'header.promos': 'Promosyonlar',
    'header.help': 'Kömək',
    'header.search': 'Axtar',
    'header.settings': 'Ayarlar',
    'header.login': 'Daxil ol',
    'header.join': 'Qeydiyyat',
    'header.logout': 'Çıxış',
    'header.account': 'Hesabım',
    'header.deposit': 'Depozit',
    'header.hideBalance': 'Balansı gizlət',
    'header.showBalance': 'Balansı göstər',
    'header.notifications': 'Bildirişlər',
    'mobile.menu': 'Menyu',
    'mobile.home': 'Əsas Səhifə',
    'mobile.myBets': 'bahislərim',
    'mobile.navigation': 'Naviqasiya',
    'mobile.menu.loginTitle': 'Hesabınıza daxil olun',
    'mobile.menu.loginText': 'bütün xidmət seçimlərinə tam giriş üçün',
    'mobile.menu.tournaments': 'Turnirlər',
    'mobile.menu.helpNote': 'Tez-tez verilən suallar, öyrənmə, lüğət',
    'mobile.menu.appsNote': 'Android, iOS üçün',
    'mobile.menu.about': 'VurgunBet haqqında',
    'mobile.menu.aboutNote': 'Məlumat, lisenziyalar',
    'basinda.title': 'Biz Mətbuatda',
    'basinda.lead': 'VurgunBet-nin stadionundan və sahə sponsorluğundan səhnələr.',
    'basinda.menuNote': 'Sponsorluq, mətbuat',
    'basinda.item1': 'Sassuolo - Pisa',
    'basinda.item2': 'Turin - Atalanta',
    'basinda.item3': 'Alaves - Elçe',
    'basinda.item4': 'Levante - Alaves',
    'basinda.item5': 'Fənərbaxça - Poqon Şeçin',
    'mobile.menu.siteTour': 'sayt turu',
    'mobile.menu.siteTourText': 'Cəmi 2 dəqiqə çəkir →',
    'mobile.menu.history': 'Tarixçəyə baxın',
    'mobile.menu.historyEmpty': 'Baxış tarixçəsi hələ yoxdur',
    'mobile.menu.historyEmptyText': 'Baxdığınız bütün epizodları və idman hadisələrini burada tapa bilərsiniz',
    'mobile.menu.clearHistory': 'Tarixi təmizləyin',
    'mobile.menu.openPromos': 'Promosyonlar',
    'mobile.menu.searchGames': 'Oyunlar axtarın',
    'mobile.menu.responsibleGaming': 'məsuliyyətli oyun',
    'mobile.account.number': 'Hesab: {id}',
    'mobile.account.copy': 'Hesab nömrəsini kopyalayın',
    'mobile.account.copied': 'kopyalandı',
    'mobile.account.balance': 'Balans: {amount}',
    'settings.section.sport': 'İdman',
    'settings.section.casino': 'Kazino',
    'settings.section.interface': 'interfeys',
    'settings.section.navigation': 'Naviqasiya',
    'settings.eventDisplay': 'Hadisə görünüşü',
    'settings.eventDisplay.table': 'Cədvəl',
    'settings.eventDisplay.list': 'Siyahı',
    'settings.betSlipLocation': 'kupon yeri',
    'settings.betSlipLocation.bottom': 'Alt paneldə',
    'settings.betSlipLocation.above': 'panelin üstündə',
    'settings.betSlipSettings': 'Kupon parametrləri',
    'settings.betSlip.showLiveTimer': 'Kuponda canlı hadisə taymerini göstərin',
    'settings.betSlip.showEventTime': 'Kuponda tədbir vaxtını və başlama tarixini göstərin',
    'settings.betSlip.skipClearConfirm': 'Kuponunuzu təmizləyərkən təsdiq tələb etməyin',
    'settings.betSlip.view': 'Kupon görünüşü',
    'settings.betSlip.view.auto': 'Avtomatik',
    'settings.betSlip.view.narrow': 'Dar',
    'settings.betSlip.view.wide': 'Geniş',
    'settings.odds.title': 'Oranlar',
    'settings.odds.boosted': 'artırılmış',
    'settings.odds.on': 'açıq',
    'settings.odds.off': 'bağlanıb',
    'settings.odds.hideBoosted': 'İdman bölməsində artan əmsalları göstərin',
    'settings.odds.european': 'Avropa',
    'settings.odds.american': 'amerikan',
    'settings.odds.hongkong': 'Honq Konq',
    'settings.odds.indonesian': 'İndoneziya',
    'settings.odds.malaysian': 'Malayziya',
    'settings.favouriteSports': 'sevimli idman növləri',
    'settings.favouriteSports.empty': 'Seçilməyib',
    'settings.favouriteSports.desc': 'Sevdiyiniz idman növlərini əlavə edin; İlk olaraq idman bölməsində göstərilir.',
    'settings.casinoProMode': 'pro rejimi',
    'settings.casinoProMode.desc': 'Oyun kartında dəyişkənliyi və digər dəyərləri göstərin',
    'settings.casinoView.standard': 'Standart görünüş',
    'settings.casinoView.pro': 'pro rejimi',
    'settings.theme.title': 'Sayt mövzusu',
    'settings.theme.auto': 'Avtomatik',
    'settings.theme.light': 'Açıq',
    'settings.theme.dark': 'Qaranlıq',
    'settings.hideBalance': 'Balansı gizlət',
    'settings.hideBalance.desc': 'Başlıqda balansı gizlətmək üçün sürüşdürün',
    'settings.showUpButton': '"Yuxarı" düyməsini göstərin',
    'settings.language': 'Dil',
    'settings.nav.sportSection': 'İdman bölməsində',
    'settings.nav.casinoSection': 'Kazino bölməsində',
    'settings.nav.menu': 'menyuda',
    'settings.title': 'Sayt parametrləri',
    'settings.reset': 'standarta qayıt',
    'settings.betSlip.title': 'Kupon',
    'settings.nav.betAcceptance': 'Bahislərin qəbulu',
    'settings.nav.cashOut': 'erkən ödəniş',
    'settings.nav.favouriteBets': 'Sevimli mərclər',
    'settings.nav.betSlip': 'Kupon görünüşü',
    'settings.navigation.auto': 'Avtomatik',
    'settings.navigation.left': 'sol',
    'settings.navigation.top': 'üstündə',
    'settings.eventList.title': 'Tədbir siyahısı',
    'settings.eventList.minimised': 'Defolt olaraq bütün hadisələri yığcamlaşdırın',
    'settings.eventPage.title': 'Tədbir səhifəsi',
    'settings.view.large': 'geniş mənzərə',
    'settings.view.compact': 'Kompakt görünüş',
    'settings.favouriteSports.descLong': 'Sevdiyiniz idman növlərini əlavə edin; İlk olaraq idman bölməsində göstərilir. Siz sürükləməklə sıranı dəyişə bilərsiniz',
    'settings.favouriteSports.hint': 'İdmanı sevimlilərə əlavə etmək üçün ★ düyməsini basın',
    'settings.sport.football': 'Futbol',
    'settings.sport.hockey': 'Buzda xokkey',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basketbol',
    'settings.sport.esports': 'e-idman',
    'settings.sport.tableTennis': 'Stolüstü tennis',
    'settings.sport.volleyball': 'Voleybol',
    'settings.sport.handball': 'Həndbol',
    'settings.sport.mixFights': 'qarışıq döyüş',
    'settings.sport.boxing': 'Boks',
    'settings.sport.futsal': 'futzal',
    'settings.sport.baseball': 'beysbol',
    'settings.sport.americanFootball': 'amerikan futbolu',
    'settings.sport.rugby': 'reqbi',
    'settings.sport.waterPolo': 'su polosu',
    'settings.sport.fieldHockey': 'otüstü xokkey',
    'settings.sport.racing': 'Yarış',
    'settings.sport.cycling': 'Velosiped',
    'settings.sport.sports': 'İdman',
    'settings.sport.beachSoccer': 'çimərlik futbolu',
    'settings.sport.basketball3x3': 'Basketbol 3x3',
    'settings.sport.lacrosse': 'lakros',
    'settings.sport.australianFootball': 'Avstraliya futbolu idarə edir',
    'settings.sport.cricket': 'kriket',
    'settings.sport.snooker': 'snooker',
    'settings.sport.darts': 'Dart',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'VurgunBet — Onlayn İdman Mərcləri',
    'auth.login.title': 'Daxil ol',
    'auth.login.submit': 'Daxil ol',
    'auth.login.link': 'Daxil ol',
    'auth.register.title': 'Qeydiyyat',
    'auth.register.bannerHighlight': '100%-ə qədər',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPIN',
    'auth.register.bannerDesc': '+5 FREE BET',
    'auth.register.perkFast': 'Anonim',
    'auth.register.perkSafe': 'Sıfır komissiya',
    'auth.register.perkBonus': 'VPN Dostu',
    'auth.register.orSignUpWith': 'YA DA QEYDİYYAT KEÇİN',
    'auth.login.orSignInWith': 'YA DAXİL OLUN',
    'auth.webauthn.login': 'Face ID / Touch ID ilə daxil olun',
    'auth.webauthn.offerTitle': 'Cihazda Face ID-ni qeydiyyatdan keçirin',
    'auth.webauthn.offerBody': 'Növbəti girişdə Face ID və ya Touch ID ilə tez daxil ola bilərsiniz.',
    'auth.webauthn.offerConfirm': 'Bu cihazda qənaət edin',
    'auth.webauthn.offerSkip': 'İndi yox',
    'auth.webauthn.needRegister': 'Əvvəlcə profildə Face ID / Touch ID qeydiyyatdan keçin',
    'auth.webauthn.failed': 'Biometrik giriş uğursuz oldu',
    'auth.webauthn.unsupported': 'Face ID / Touch ID bu cihazda istifadə edilə bilməz',
    'auth.webauthn.registerFailed': 'Biometrik qeydiyyat alınmadı',
    'auth.webauthn.alreadyRegistered': 'Bu cihaz artıq qeydiyyatdan keçib',
    'auth.webauthn.thisDevice': 'bu cihaz',
    'auth.webauthn.manageTitle': 'Face ID / Touch ID',
    'auth.webauthn.manageDesc': 'Bu cihazda Face ID, Touch ID və ya Windows Hello ilə daxil olmaq üçün açarı qeydiyyatdan keçirin.',
    'auth.webauthn.empty': 'Qeydiyyatdan keçmiş biometrik giriş yoxdur',
    'auth.webauthn.add': 'Bu cihazda qənaət edin',
    'auth.webauthn.remove': 'Sil',
    'auth.webauthn.removed': 'Qeyd silindi',
    'auth.webauthn.registered': 'Biometrik giriş yadda saxlandı',
    'auth.webauthn.loadFailed': 'Qeydləri yükləmək alınmadı',
    'auth.webauthn.removeFailed': 'Qeydi silmək mümkün olmadı',
    'account.profile.tab.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeys': 'Face ID / Touch ID',
    'account.profile.mobile.passkeysHint': 'Tez giriş',
    'auth.register.socialNotConfigured': 'Bu üsul hələ konfiqurasiya edilməyib',
    'auth.register.pageTitle': 'Qeydiyyatdan keçin | VurgunBet',
    'auth.register.submit': 'Qeydiyyat',
    'auth.register.link': 'Qeydiyyat',
    'guestPopup.title': '100 TL pulsuz mərc + 300 pulsuz fırlanma',
    'guestPopup.subtitle': 'yeni müştərilər üçün',
    'guestPopup.cta': 'Qeydiyyat',
    'language.choose': 'Dil seçin',
    'auth.register.slogan': 'OYUNA DAHA YAXIN',
    'auth.register.smsHint': 'Bu nömrəyə SMS kodu göndəriləcək',
    'auth.register.promoToggle': 'Promo kodum var',
    'auth.register.rules': 'Mənim 18 yaşım var və Qaydalar və Şərtləri və Məxfilik Siyasətini qəbul edirəm *',
    'auth.register.rulesBefore': 'Mənim 18 yaşım var və',
    'auth.register.termsLink': 'Qaydalar və Şərtlər',
    'auth.register.rulesAnd': 'ilə',
    'auth.register.privacyLink': 'Məxfilik Siyasəti',
    'auth.register.rulesAfter': 'qəbul edirəm *',
    'auth.register.rulesLink': 'Qaydalar və Şərtlər',
    'auth.register.rulesRequired': 'Şərtləri və məxfilik siyasətini qəbul etməlisiniz',
    'auth.register.serviceMail': 'Mən xidmət bülletenlərini almağa razıyam.',
    'auth.register.serviceMail2': 'Şəxsi məlumatların emalı siyasəti',
    'auth.register.here': 'buradan',
    'auth.register.adMail': 'Reklam poçt siyahısı',
    'auth.register.adTerms': 'Şərtlərinizi qəbul edirəm',
    'auth.register.adTermsLink': 'şərtlər',
    'auth.register.adTermsSuffix': 'qəbul edirəm',
    'auth.register.serviceMailSuffix': 'oxuya bilərsiniz.',
    'auth.register.fullPromotionTerms': 'Tam təşviq qaydaları',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Telefon nömrənizi daxil edin',
    'auth.validation.phoneOrEmailRequired': 'E-poçt və ya telefon daxil edin',
    'auth.validation.phoneInvalid': 'Etibarlı telefon nömrəsi daxil edin',
    'auth.validation.phoneExists': 'Bu telefon nömrəsi artıq qeydiyyatdan keçib',
    'auth.validation.emailRequired': 'E-poçt ünvanınızı daxil edin',
    'auth.validation.emailInvalid': 'Etibarlı e-poçt ünvanı daxil edin',
    'auth.validation.emailDomainInvalid': 'Etibarlı e-poçt istifadə edin (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com və s.)',
    'auth.validation.emailExists': 'Bu e-poçt ünvanı artıq qeydiyyatdan keçib',
    'auth.validation.passwordRequired': 'Parolunuzu daxil edin',
    'auth.validation.passwordShort': 'Parol ən azı 8 simvoldan ibarət olmalıdır',
    'auth.validation.registerFailed': 'Qeyd yaratmaq mümkün olmadı. Yenidən cəhd edin.',
    'auth.validation.loginFieldsRequired': 'Bütün sahələri doldurun',
    'auth.validation.loginInvalid': 'Giriş məlumatı yanlışdır',
    'auth.validation.accountRequired': 'Hesab nömrənizi daxil edin',
    'auth.validation.accountShort': 'Hesab nömrəsi ən azı 6 simvoldan ibarət olmalıdır',
    'auth.validation.codeInvalid': 'Doğrulama kodu yanlışdır',
    'auth.validation.codeRequired': 'Təsdiq kodunu daxil edin',
    'auth.validation.codeSendFailed': 'Kodu göndərmək mümkün olmadı',
    'auth.validation.codeThrottled': 'Kodu yenidən göndərmək üçün bir az gözləyin',
    'auth.validation.challengeExpired': 'Doğrulama müddəti bitdi, yenidən daxil olun',
    'auth.validation.serverUnreachable': 'Serverə qoşulmaq mümkün olmadı. Terminalda npm run dev:server proqramını işə salın.',
    'auth.validation.serverError': 'Daxil olmaq alınmadı. Serveri və verilənlər bazasını yoxlayın.',
    'auth.tab.phone': 'Telefon',
    'auth.tab.email': 'E-poçt',
    'auth.tab.username': 'İstifadəçi adı',
    'auth.tab.account': 'Bill',
    'auth.label.phone': 'telefon nömrəsi',
    'auth.label.phoneOptional': 'Mobil telefon (isteğe bağlı)',
    'auth.label.email': 'E-poçt',
    'auth.label.username': 'İstifadəçi adı',
    'auth.label.account': 'hesab nömrəsi',
    'auth.label.password': 'Şifrə',
    'auth.label.promo': 'promo kodu',
    'auth.placeholder.account': 'hesab nömrəsi',
    'auth.placeholder.username': 'İstifadəçi adı',
    'auth.forgot': 'Parolunuzu unutmusunuz?',
    'auth.noAccount': 'Hesabınız yoxdur?',
    'auth.haveAccount': 'Artıq hesabınız var?',
    'auth.login.pageTitle': 'Daxil ol | VurgunBet',
    'auth.verify.info': 'Hesabınızı qorumaq üçün onun həqiqətən siz olduğuna əmin olmalıyıq.',
    'auth.verify.caption': 'Doğrulama kodunu əldə edin:',
    'auth.verify.methodPhone': 'Kodu SMS və ya Telegram vasitəsilə {contact} nömrəsinə göndərəcəyik.',
    'auth.verify.methodEmail': 'Kodu e-poçtla {contact}-a göndərəcəyik',
    'auth.verify.getCode': 'kodu əldə edin',
    'auth.verify.cancel': 'Ləğv et',
    'auth.verify.noAccess': 'Telefon nömrəsinə çıxışım yoxdur',
    'auth.verify.enterCode': 'Təsdiq kodunu daxil edin:',
    'auth.verify.confirm': 'Təsdiqlə',
    'auth.verify.continue': 'Davam et',
    'auth.verify.codeInfoPhone': 'Doğrulama kodunu daxil edin. Kodu SMS və ya Telegram vasitəsilə {contact} nömrəsinə göndərdik.',
    'auth.verify.codeInfoEmail': 'Doğrulama kodunu daxil edin. Kodu e-poçtla {contact}-a göndərdik.',
    'auth.verify.neverReceived': 'Mən heç vaxt kodu almamışam',
    'auth.verify.resend': 'Kodu yenidən göndərin',
    'auth.verify.noAccessEmail': 'Sizin e-poçt ünvanınıza girişim yoxdur',
    'auth.verify.help.title': 'Təsdiq kodu gəlməyibsə',
    'auth.verify.help.bodyPhone': 'Telefon nömrənizin düzgün olduğuna və cihazınızda kifayət qədər boş yaddaş olduğuna əmin olun. Mesajın spam qovluğuna düşdüyünü yoxlayın.',
    'auth.verify.help.bodyEmail': 'E-poçt ünvanınızın düzgün olduğundan əmin olun. Mesajın spam qovluğuna düşdüyünü yoxlayın.',
    'auth.verify.help.step1': 'Mesajlar tətbiqini açın',
    'auth.verify.help.step2': 'Yuxarı sağ küncdəki düyməni basın',
    'auth.verify.help.step3': '"Spam və bloklandı" seçin',
    'auth.verify.help.understood': 'başa düşürəm',
    'auth.recover.title': 'parol sıfırlama',
    'auth.recover.pageTitle': 'Parolun sıfırlanması | VurgunBet',
    'auth.recover.continue': 'Davam',
    'auth.recover.noAccess': 'Telefon nömrəsinə/e-poçtuna girişim yoxdur',
    'auth.recover.noAccessPhone': 'Telefon nömrəsinə çıxışım yoxdur',
    'auth.recover.noAccessEmail': 'Sizin e-poçt ünvanınıza girişim yoxdur',
    'auth.recover.newPassword': 'Yeni Parol',
    'auth.recover.confirmPassword': 'Yeni parol (yenidən)',
    'auth.recover.passwordMismatch': 'Parollar uyğun gəlmir',
    'auth.recover.save': 'Parolu yadda saxla',
    'auth.recover.success': 'Parolunuz yeniləndi. Yeni parolunuzla daxil ola bilərsiniz.',
    'auth.recover.notFound': 'Bu məlumat üçün heç bir hesab tapılmadı.',
    'auth.verify.expiredTitle': 'Bu proses üçün icazə verilən vaxt başa çatıb.',
    'auth.verify.retry': 'yenidən cəhd edin',
    'welcome.stepLabel': 'Addım 1/3: Qeydiyyat',
    'welcome.title': '100 TL + 300 FS-ə qədər xoş gəlmisiniz!',
    'welcome.step1.title': 'Qeydiyyat',
    'welcome.step1.sub': 'Veb saytında və ya proqramda',
    'welcome.step2.title': 'Tam yoxlama',
    'welcome.step2.sub': 'Yalnız bir neçə dəqiqə çəkir',
    'welcome.step3.title': 'depozit pulu',
    'welcome.step3.sub': 'Daha böyük investisiya – daha böyük bonus!',
    'welcome.start': 'başlamaq',
    'welcome.rules': 'Tam təşviq qaydaları',
    'account.loading': 'Yüklənir...',
    'account.save': 'Yadda saxla',
    'account.empty': 'Heç bir qeyd tapılmadı',
    'account.nav.overview': 'Ümumi baxış',
    'account.nav.profile': 'Şəxsi məlumatlar',
    'account.nav.verification': 'Doğrulama',
    'account.nav.cashier': 'qədər',
    'account.nav.bets': 'bahislərim',
    'account.nav.bonuses': 'Bonuslar',
    'account.nav.notifications': 'Bildirişlər',
    'account.nav.security': 'Təhlükəsizlik',
    'account.nav.support': 'Dəstək',
    'account.menu.profile': 'Profilim',
    'account.menu.payments': 'Depozit və çıxarılması',
    'account.menu.history': 'Bahis və əməliyyat tarixi',
    'account.menu.requests': 'Sorğular',
    'account.menu.responsible': 'məsuliyyətli oyun',
    'account.menu.vip': 'VIP statusunuz',
    'support.liveChat': 'canlı dəstək',
    'account.menu.deposit': 'Depozit',
    'account.overview.title': 'Bank çıxarışı',
    'account.overview.balance': 'Balans',
    'account.overview.bonusBalance': 'Bonus balansı',
    'account.overview.accountNo': 'Hesab nömrəsi',
    'account.overview.verification': 'Doğrulama',
    'account.overview.totalBets': 'ümumi mərc',
    'account.profile.name': 'ad soyad',
    'account.profile.saved': 'Məlumatlarınız yadda saxlanıldı',
    'account.profile.marketingEmail': 'Mən e-poçt vasitəsilə tanıtım bildirişləri almaq istəyirəm',
    'account.profile.marketingSms': 'Mən SMS vasitəsilə tanıtım bildirişləri almaq istəyirəm',
    'account.profile.tab.details': 'Şəxsi məlumat',
    'account.profile.tab.phone': 'Telefon nömrəsini dəyişdirin',
    'account.profile.tab.phoneAdd': 'Telefon nömrəsi əlavə edin',
    'account.profile.tab.phoneVerify': 'Telefon nömrəsini yoxlayın',
    'account.profile.tab.email': 'E-poçtu dəyişdirin',
    'account.profile.tab.emailAdd': 'E-poçt əlavə edin',
    'account.profile.tab.emailVerify': 'E-poçtu təsdiqləyin',
    'account.profile.tab.password': 'Parolu dəyişdirin',
    'account.profile.section.personal': 'ŞƏXSİ MƏLUMATLAR',
    'account.profile.section.lastLogin': 'SON GİRİŞ MƏLUMATI',
    'account.profile.section.contacts': 'Ünsiyyət',
    'account.profile.section.marketing': 'ƏLAQƏ SEÇİMLƏRİ',
    'account.profile.field.name': 'Adı:',
    'account.profile.field.verification': 'Doğrulama statusu:',
    'account.profile.field.accountNo': 'Hesab nömrəsi:',
    'account.profile.field.currency': 'Valyuta:',
    'account.profile.field.phone': 'Telefon nömrəsi:',
    'account.profile.field.email': 'E-poçt:',
    'account.profile.field.time': 'Vaxt:',
    'account.profile.field.ip': 'IP ünvanı:',
    'account.profile.change': 'Dəyişmək',
    'account.profile.add': 'əlavə et',
    'account.profile.status.verified': 'Təsdiq edildi',
    'account.profile.status.unverified': 'Təsdiqlənməmiş',
    'account.profile.marketingIntro': 'Tanıtım və xəbər bildirişləri alın:',
    'account.profile.marketing.email': 'E-poçt',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Push bildirişləri',
    'account.profile.marketing.web': 'Sayt bildirişləri',
    'account.profile.verification.basic': 'Təsdiqlənməyib',
    'account.profile.verification.verified': 'Doğrulanıb',
    'account.profile.verification.pending': 'Gözləmədə',
    'account.profile.verify': 'yoxlayın',
    'account.profile.tab.kyc': 'autentifikasiya',
    'account.profile.kyc.title': 'autentifikasiya',
    'account.profile.kyc.intro': 'TR şəxsiyyət nömrənizi, şəhərinizi, ünvanınızı və şəxsiyyət vəsiqənizin şəkillərini göndərin. Sorğunuz nəzərdən keçirildikdən sonra hesabınız yoxlanılacaq.',
    'account.profile.kyc.tcLabel': 'TR Şəxsiyyət Nömrəsi',
    'account.profile.kyc.tcInvalid': 'Etibarlı 11 rəqəmli TR ID nömrəsini daxil edin',
    'account.profile.kyc.cityLabel': 'Şəhər',
    'account.profile.kyc.cityPlaceholder': 'Şəhər seçin',
    'account.profile.kyc.cityRequired': 'Şəhər seçimi tələb olunur',
    'account.profile.kyc.addressLabel': 'Ünvan',
    'account.profile.kyc.addressHint': 'Tam ünvanınızı yazın. Səhvdirsə, düzəldə bilərsiniz.',
    'account.profile.kyc.addressRequired': 'Ünvan ən azı 5 simvoldan ibarət olmalıdır',
    'account.profile.kyc.frontLabel': 'şəxsiyyət üz örtüyü',
    'account.profile.kyc.frontHint': 'Şəxsiyyət vəsiqənizin önə baxan şəklini yükləyin',
    'account.profile.kyc.backLabel': 'ID arxa tərəfi',
    'account.profile.kyc.backHint': 'Şəxsiyyət vəsiqənizin arxa fotosunu yükləyin',
    'account.profile.kyc.photoRequired': 'Ön şəxsiyyət vəsiqəsinin fotoşəkili məcburidir',
    'account.profile.kyc.backRequired': 'Şəxsiyyət vəsiqəsinin arxa fotoşəkili məcburidir',
    'account.profile.kyc.submit': 'Göndər',
    'account.profile.kyc.submitted': 'Doğrulama sorğunuz qəbul edilib və nəzərdən keçirilir.',
    'account.profile.kyc.pendingMessage': 'Doğrulama sorğunuz nəzərdən keçirilir. Tamamlanana qədər yeni sənədlər göndərə bilməzsiniz.',
    'account.profile.kyc.alreadyVerified': 'Hesabınız artıq təsdiqlənib.',
    'account.profile.todayAt': 'bu gün vaxt',
    'account.profile.mobile.personalData': 'Şəxsi məlumatlar',
    'account.profile.mobile.aboutAccount': 'Hesab haqqında',
    'account.profile.mobile.passwordChange': 'Parolu dəyişdirin',
    'account.profile.next': 'İrəli',
    'account.profile.changeEmailTitle': 'Yeni e-poçt ünvanı',
    'account.profile.changePhoneTitle': 'yeni telefon nömrəsi',
    'account.profile.addEmailTitle': 'E-poçt ünvanı əlavə edin',
    'account.profile.addPhoneTitle': 'Telefon nömrəsi əlavə edin',
    'account.profile.verifyEmailTitle': 'E-poçt ünvanını yoxlayın',
    'account.profile.verifyPhoneTitle': 'Telefon nömrəsini yoxlayın',
    'account.profile.contactSupport': 'Məlumatı dəyişdirmək üçün dəstək xidməti ilə əlaqə saxlayın.',
    'account.profile.contactSupportAddPhone': 'Telefon nömrəsi əlavə etmək üçün dəstək sorğusu yaradın.',
    'account.profile.contactSupportChangePhone': 'Telefon nömrənizi dəyişdirmək üçün dəstək sorğusu yaradın.',
    'account.profile.contactSupportVerifyPhone': 'Telefon nömrənizi təsdiqləmək üçün dəstək sorğusu yaradın.',
    'account.profile.contactSupportAddEmail': 'E-poçt ünvanı əlavə etmək üçün dəstək sorğusu yaradın.',
    'account.profile.contactSupportChangeEmail': 'E-poçt ünvanınızı dəyişdirmək üçün dəstək sorğusu yaradın.',
    'account.profile.step.support': 'Dəstək sorğusu yaradın',
    'account.profile.step.sharePhone': 'Telefon nömrənizi bildirin',
    'account.profile.step.shareNewPhone': 'Yeni telefon nömrənizi bildirin',
    'account.profile.step.requestVerify': 'Doğrulama sorğunuzu göndərin',
    'account.profile.step.confirmSms': 'SMS kodu ilə təsdiqləyin',
    'account.profile.step.shareEmail': 'E-poçt ünvanınızı göstərin',
    'account.profile.step.shareNewEmail': 'Yeni e-poçt ünvanınızı bildirin',
    'account.profile.step.confirmEmail': 'Tam e-poçt yoxlanışı',
    'account.profile.contactSupportBtn': 'Dəstək ilə əlaqə saxlayın',
    'account.profile.otp.addPhoneHint': 'Yeni telefon nömrənizi daxil edin. Doğrulama kodunu SMS vasitəsilə göndərəcəyik.',
    'account.profile.otp.changePhoneHint': 'Yeni telefon nömrənizi daxil edin. Dəyişiklik SMS kodu ilə təsdiqlənir.',
    'account.profile.otp.verifyPhoneHint': 'Telefon nömrənizi doğrulamaq üçün kod göndərəcəyik.',
    'account.profile.otp.addEmailHint': 'E-poçt ünvanınızı daxil edin. Doğrulama kodunu e-poçtla göndərəcəyik.',
    'account.profile.otp.verifyEmailHint': 'E-poçt ünvanınızı doğrulamaq üçün kod göndərəcəyik.',
    'account.profile.otp.changeEmailHint': 'Yeni e-poçt ünvanınızı daxil edin. Dəyişiklik e-poçt kodu ilə təsdiqlənir.',
    'account.profile.otp.codeSentPhone': 'Doğrulama kodunu göndərdik:',
    'account.profile.otp.codeSentEmail': 'Doğrulama kodunu göndərdik:',
    'account.profile.otp.codeSent': 'Doğrulama kodu göndərildi',
    'account.profile.otp.codeLabel': 'doğrulama kodu',
    'account.profile.otp.resend': 'Kodu yenidən göndərin',
    'account.profile.otp.phoneRequired': 'Telefon nömrəsi tələb olunur',
    'account.profile.otp.emailRequired': 'E-poçt ünvanı tələb olunur',
    'account.profile.otp.codeRequired': 'Doğrulama kodu tələb olunur',
    'account.profile.otp.sessionMissing': 'Doğrulama sessiyası tapılmadı',
    'account.profile.otp.saved': 'Əlaqə məlumatınız yeniləndi',
    'account.profile.passwordConfirm': 'Yeni parol (yenidən)',
    'account.profile.passwordRequired': 'Bütün parol sahələrini doldurun',
    'account.profile.passwordMismatch': 'Yeni parollar uyğun gəlmir',
    'account.profile.passwordSame': 'Yeni parol mövcud parol ilə eyni ola bilməz',
    'account.profile.send': 'Göndər',
    'account.profile.passwordHint': 'Şifrəni dəyişdirmək üçün təhlükəsizlik bölməsindən istifadə edin.',
    'account.verification.desc': 'Pulun çıxarılması və hesaba tam giriş üçün şəxsiyyətin təsdiqi tələb olunur.',
    'account.verification.verified': 'Doğrulanıb',
    'account.verification.pending': 'Nəzərdən keçirilir',
    'account.verification.rejected': 'rədd edildi',
    'account.verification.step1': 'Pasportunuzun və ya şəxsiyyət vəsiqənizin şəklini yükləyin',
    'account.verification.step2': 'Sənədi Selfi ilə tutarkən şəklinizi əlavə edin',
    'account.verification.step3': 'Baxış adətən 24 saat ərzində tamamlanır',
    'account.verification.submit': 'Doğrulamağa başlayın',
    'account.verification.submitted': 'Sənədlərinizə baxılır',
    'account.cashier.deposit': 'Depozit',
    'account.cashier.withdraw': 'Pul çıxar',
    'account.cashier.amount': 'Məbləğ (TL)',
    'account.cashier.balance': 'Cari balans: {amount}',
    'account.cashier.history': 'əməliyyat tarixi',
    'account.cashier.type': 'Növ',
    'account.cashier.date': 'Tarix',
    'account.payments.title': 'Depozit və çıxarılması',
    'account.payments.back': 'Geri',
    'account.payments.selectMethod': 'Metod seçin',
    'account.payments.group.havale': 'Havale',
    'account.payments.group.card': 'Kredi Kartı',
    'account.payments.group.crypto': 'Kripto',
    'account.payments.group.other': 'Diğer',
    'account.payments.noMethods': 'Hazırda heç bir üsul mövcud deyil.',
    'account.payments.from': '{amount} TL-dən',
    'account.payments.depositTitle': '{method} ilə balansı doldurun',
    'account.payments.withdrawTitle': '{method} ilə pul çıxarın',
    'account.payments.depositNotice': 'Diqqət! Debet kartı hesab sahibinin adına qeydiyyatdan keçməlidir. Üçüncü tərəf kartları ilə edilən ödənişlər rədd ediləcək.',
    'account.payments.withdrawNotice': 'Çıxarma sorğuları doğrulama statusunuza uyğun olaraq işlənir.',
    'account.payments.addAmount': 'Depozit',
    'account.payments.withdrawSubmit': '{amount} TL-ni çıxarın',
    'account.payments.requests': 'İstəkləriniz',
    'account.payments.insufficientBalance': 'Yetərsiz vəsait',
    'account.payments.minWithdrawNotice': 'Uduşların çıxarılması üçün tələb olunan minimum məbləğ: {amount}',
    'account.payments.withdrawGoDeposit': 'Depozit',
    'account.payments.selectAnotherMethod': 'Başqa bir üsul seçin',
    'account.payments.requestsTitle': 'Əməliyyat sorğuları',
    'account.payments.requestsEmpty': 'Hələ əməliyyat sorğunuz yoxdur.',
    'account.payments.filterAll': 'Hamısı',
    'account.payments.filterCompleted': 'tamamlandı',
    'account.payments.filterProcessing': 'Emal edilir',
    'account.payments.filterCancelled': 'ləğv edildi',
    'account.payments.colNumber': 'NUMBER',
    'account.payments.colDate': 'TARİX',
    'account.payments.colType': 'TİP',
    'account.payments.colMethod': 'METOD',
    'account.payments.colAmount': 'AMOUNT',
    'account.payments.status': 'Vəziyyət',
    'account.payments.status_completed': 'tamamlandı',
    'account.payments.status_pending': 'Gözləmədə',
    'account.payments.status_processing': 'Emal edilir',
    'account.payments.status_cancelled': 'ləğv edildi',
    'account.payments.status_rejected': 'rədd edildi',
    'account.payments.status_failed': 'Uğursuz',
    'account.payments.status_approved': 'Təsdiq edildi',
    'account.payments.status_expired': 'müddəti bitdi',
    'account.payments.goToRequests': 'Mənim tələblərim',
    'account.payments.method.crypto': 'Kripto',
    'account.payments.method.maxhavale': 'Maks Transfer',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Sürətli Köçürmə',
    'account.payments.havalespeed.depositPending': 'Speed ​​​​Transfer investisiyanızı tamamlayın',
    'account.payments.havalespeed.withdrawPending': 'Sürətli pul köçürmə ödənişiniz emal edilir',
    'account.payments.havalespeed.processing': 'Qalan vaxt',
    'account.payments.havalespeed.confirmPaid': 'Pul köçürmə etdim, bildirin',
    'account.payments.havalespeed.confirming': 'Bildiriş göndərilir...',
    'account.payments.havalespeed.confirmSent': 'Bildirişiniz alındı. Təsdiq gözlənilir.',
    'account.payments.havalespeed.cancelDeposit': 'Sorğunu ləğv edin',
    'account.payments.havalespeed.cancelling': 'Ləğv edilir…',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Adı Soyadı',
    'account.payments.havale.amountLabel': 'Məbləğ',
    'account.payments.havalespeed.approvedHint': '{amount} balansınıza əlavə edildi.',
    'account.payments.havalespeed.approvedHintGeneric': 'İnvestisiyanız təsdiqləndi və balansınıza əlavə edildi.',
    'account.payments.havalespeed.rejectedHint': 'Sürətli Köçürmə sorğunuz rədd edildi. Yeni bir investisiya cəhd edə bilərsiniz.',
    'account.payments.maxhavale.depositPending': 'Max Transfer investisiyasını tamamlayın',
    'account.payments.maxhavale.withdrawPending': 'Maksimum Pul Sifarişinizin çıxarılması emal olunur',
    'account.payments.maxhavale.processing': 'Qalan vaxt',
    'account.payments.maxhavale.cancelDeposit': 'Sorğunu ləğv edin',
    'account.payments.maxhavale.cancelling': 'Ləğv edilir…',
    'account.payments.maxhavale.openPayment': 'İnvestisiya səhifəsini açın',
    'account.payments.maxhavale.urlMissing': 'Ödəniş məlumatını əldə etmək mümkün olmadı. Sorğunu ləğv edib yenidən cəhd edə bilərsiniz.',
    'account.payments.maxhavale.bankName': 'Bank',
    'account.payments.havaleBtq.depositPending': 'Havale investisiyasını tamamlayın',
    'account.payments.havaleBtq.withdrawPending': 'Havale çıxarılması emal olunur',
    'account.payments.havaleBtq.processing': 'Qalan vaxt',
    'account.payments.havaleBtq.cancelDeposit': 'Sorğunu ləğv edin',
    'account.payments.havaleBtq.cancelling': 'Ləğv edilir…',
    'account.payments.havaleBtq.openPayment': 'İnvestisiya səhifəsini açın',
    'account.payments.havaleBtq.urlMissing': 'Ödəniş məlumatını əldə etmək mümkün olmadı.',
    'account.payments.havaleBtq.bankName': 'Bank',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'PayUrus cüzdan ID',
    'account.payments.payurus.walletName': 'Pulqabı sahibinin adı',
    'account.payments.payurus.openPayment': 'İnvestisiya səhifəsini yenidən açın',
    'account.payments.payurus.reopenPayment': 'İnvestisiya səhifəsini yenidən açın',
    'account.payments.payurus.urlMissing': 'Ödəniş səhifəsinin linki alınmadı. Sorğunu ləğv edib yenidən cəhd edə bilərsiniz.',
    'account.payments.payurus.cancelDeposit': 'Sorğunu ləğv edin',
    'account.payments.payurus.cancelling': 'Ləğv edilir…',
    'account.payments.payurus.depositPending': 'PayUrus ödənişini tamamlayın',
    'account.payments.payurus.withdrawPending': 'PayUrus çekiniz emal olunur',
    'account.payments.payurus.processing': 'Qalan vaxt',
    'account.payments.payurus.depositSuccess': 'Ödəniş uğurlu oldu',
    'account.payments.payurus.depositSuccessHint': '{amount} balansınıza əlavə edildi.',
    'account.payments.payurus.depositSuccessHintGeneric': 'İnvestisiyanız {provider} balansınıza əlavə edildi.',
    'account.payments.payurus.depositProcessing': 'Ödənişiniz emal olunur',
    'account.payments.payurus.depositProcessingHint': '{provider} Ödənişiniz təsdiqlənir. Zəhmət olmasa gözləyin.',
    'account.payments.payurus.depositFailed': 'Ödəniş alınmadı',
    'account.payments.payurus.depositFailedHint': '{provider} üçün ödəniş tamamlanmadı. Yeni bir investisiya cəhd edə bilərsiniz.',
    'account.payments.payurus.continue': 'Davam et',
    'account.payments.payurus.nameMismatch': 'Adınız və soyadınız məlumatınız uyğun gəlmir',
    'account.payments.payurus.nameMismatchDetail': 'İnfrastrukturdan alınan hesab sahibinin adı və soyadı uyğun gəlmir. Payurus Hesab Sahibi: {name}',
    'account.payments.payurus.rateLimit': 'Qısa müddətdə eyni pul kisəsinə yeni pul vəsaitləri göndərilə bilməz',
    'account.payments.payurus.rateLimitDetail': 'PayUrus eyni pul kisəsi üçün saxlama tətbiq edir. Daha sonra yenidən cəhd edin.',
    'account.payments.payurus.walletInvalid': 'PayUrus pul kisəsi məlumatını yoxlamaq mümkün olmadı',
    'account.payments.payurus.walletInvalidDetail': 'Pulqabı ID-sini və ya pul kisəsinin sahibinin adını yoxlayın və yenidən cəhd edin.',
    'account.payments.method.oplati': 'papara',
    'account.payments.method.raschet': '«Raschet» Ödəniş sistemi',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'TR Şəxsiyyət Nömrəsi',
    'account.payments.havale.firstName': 'ad',
    'account.payments.havale.lastName': 'soyad',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Bank',
    'account.payments.havale.transferTo': 'Aşağıdakı hesaba pul köçürün',
    'account.payments.havale.accountName': 'Hesab adı',
    'account.payments.havale.copyIban': 'surəti',
    'account.payments.havale.copyName': 'surəti',
    'account.payments.havale.copyAmount': 'Kopiya məbləği',
    'account.payments.havale.copyBank': 'surəti bank',
    'account.payments.havale.copied': 'kopyalandı',
    'account.payments.havale.countdown': 'Qalan vaxt',
    'account.payments.havale.activeNotice': 'Aktiv tələbiniz var. Müddət bitmədən yeni sorğu açıla bilməz.',
    'account.payments.havale.amountDue': 'Depozitə qoyulacaq məbləğ',
    'account.payments.havale.waitNew': 'Yeni sorğu gözləyin',
    'account.payments.havale.resultApproved': 'İnvestisiya təsdiq edildi',
    'account.payments.havale.resultApprovedHint': '{amount} balansınıza əlavə edildi.',
    'account.payments.havale.resultRejected': 'İnvestisiya rədd edildi',
    'account.payments.havale.resultRejectedHint': 'Sorğunuz təsdiqlənmədi. Yeni bir investisiya cəhd edə bilərsiniz.',
    'account.payments.havale.resultExpired': 'Sorğunun müddəti bitdi',
    'account.payments.havale.resultExpiredHint': '{provider} ödəniş müddəti bitdi. Siz yeni sorğu yarada bilərsiniz.',
    'account.payments.havale.withdrawReceived': 'Çəkiliş sorğunuz qəbul edildi',
    'account.payments.havale.withdrawReceivedHint': '{amount} məbləğində geri çəkilmə sorğunuz qəbul edildi və nəzərdən keçirilir.',
    'account.payments.havale.withdrawApproved': 'Çəkiliş təsdiqləndi',
    'account.payments.havale.withdrawApprovedHint': '{amount} məbləğində pul çıxarma sorğunuz tamamlandı.',
    'account.payments.havale.withdrawRejected': 'Atış rədd edildi',
    'account.payments.havale.withdrawRejectedHint': 'Çıxarma sorğunuz təsdiqlənmədi. Lazım gələrsə, yeni sorğu yarada bilərsiniz.',
    'account.payments.havale.tryAgain': 'yenidən cəhd edin',
    'account.payments.crypto.selectCoin': 'Kriptovalyutanı seçin',
    'account.payments.crypto.selectNetwork': 'Şəbəkə seçin',
    'account.payments.crypto.network': 'Şəbəkə',
    'account.payments.crypto.selectedNetwork': 'Seçilmiş şəbəkə',
    'account.payments.crypto.networkWarning': 'Yalnız {network} şəbəkəsinə göndərin. Səhv şəbəkədə göndərilən əməliyyatlar itirilə bilər.',
    'account.payments.crypto.coin': 'Kripto',
    'account.payments.crypto.depositAddress': 'İnvestisiya ünvanı',
    'account.payments.crypto.copyAddress': 'ünvanı kopyalayın',
    'account.payments.crypto.yourAddress': 'Pul kisəsinin ünvanı',
    'account.payments.crypto.estimated': 'Təxmini məbləğ',
    'account.payments.crypto.txHashOptional': 'TX Hash (isteğe bağlı)',
    'account.payments.crypto.submitTxHash': 'TX Hash göndərin',
    'account.payments.crypto.continueToWallet': 'Pul kisəsinin ünvanını göstərin',
    'account.payments.crypto.txHashError': 'TX heşini saxlamaq alınmadı',
    'account.payments.crypto.confirmations': 'Şəbəkə təsdiqləri',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': '{amount}-dan',
    'account.cashier.amountUsd': 'Məbləğ (USD)',
    'account.payments.addAmountUsd': 'Depozit {amount}',
    'account.payments.crypto.activeNotice': 'Transferinizi təqdim edin. Şəbəkə təsdiqləri avtomatik olaraq izlənilir; Tələb olunan təsdiqlər əldə edildikdə balans yenilənir.',
    'account.payments.crypto.noAssets': 'Hazırda aktiv kriptovalyuta şəbəkələri yoxdur. Daha sonra yenidən cəhd edin.',
    'account.bets.stake': 'Kupon',
    'account.bets.odds': 'Əmsal',
    'account.bets.win': 'Qazanc',
    'account.bets.status': 'Vəziyyət',
    'account.bets.status_pending': 'gözləyir',
    'account.bets.status_won': 'qazandı',
    'account.bets.status_lost': 'itirdi',
    'account.history.tabBets': 'mərclər',
    'account.history.tabTransactions': 'əməliyyat tarixi',
    'account.history.filters': 'Filtrlər',
    'account.history.filterGroupBetType': 'Bahis növü',
    'account.history.filterGroupResult': 'Bahis nəticələri',
    'account.history.filterBetType_all': 'Hamısı',
    'account.history.filterBetType_bets': 'mərclər',
    'account.history.filterBetType_slot': 'slot oyunu',
    'account.history.filterBetType_dice_live': 'Canlı rejimdə zar oyunu',
    'account.history.filterBetType_card_live': 'Canlı rejimdə kart oyunu',
    'account.history.filterBetType_cylinder_live': 'Canlı rejimdə rulet oyunu',
    'account.history.filterBetType_online_game': 'Bukmekerin onlayn oyunu',
    'account.history.filterResult_all': 'Hamısı',
    'account.history.filterResult_not_settled': 'alınmadı',
    'account.history.filterResult_win': 'Qazanc',
    'account.history.filterResult_loss': 'Uduzma',
    'account.history.filterResult_cashed_out': 'nağd pul çıxarmaq',
    'account.history.filterResult_void': 'Etibarsızdır',
    'account.history.filterResult_return': 'Qayıt',
    'account.history.colDate': 'TARİX',
    'account.history.colTime': 'HOUR',
    'account.history.colBetNo': 'BET №',
    'account.history.colCoupon': 'KUPON',
    'account.history.colStake': 'MƏCƏR MƏBLƏĞİ',
    'account.history.colPotential': 'POTENSİAL',
    'account.history.details': 'Detal',
    'account.history.colTransactionNo': 'ƏMƏLİYYAT №',
    'account.history.colNumber': 'NUMBER',
    'account.history.colTransaction': 'PROSES',
    'account.history.colAmountBonuses': 'MƏBLƏR / BONUSLAR',
    'account.history.colBalanceBonuses': 'BALANS / BONUSLAR',
    'account.history.operation_deposit': 'depozit pulu',
    'account.history.operation_deposit_pending': 'İnvestisiya təsdiqi gözlənilir',
    'account.history.operation_withdrawal_pending': 'Çəkiliş təsdiqi gözlənilir',
    'account.history.operation_withdrawal_cancelled': 'Çəkiliş ləğv edildi',
    'account.history.operation_withdrawal_rejected': 'Atış rədd edildi',
    'account.history.operation_withdrawal_approved': 'Çəkiliş təsdiqləndi',
    'account.history.operation_withdrawal_completed': 'Çəkiliş tamamlandı',
    'account.history.operation_bet_placed': 'mərc qoyulub',
    'account.history.operation_bet_settled': 'Mərc həll olundu',
    'account.history.operation_bet_lost': 'İtirilmiş mərc',
    'account.history.operation_slot_bet_settled': 'Slot oyun mərcinə yekun vuruldu',
    'account.history.operation_slot_bet_placed': 'Slot oyununa mərc qoyuldu',
    'account.history.operation_accrual_bonus_account': 'Bonus hesabına hesablama',
    'account.history.operation_close_bonus_account': 'Bonus hesabı bağlanıb',
    'account.history.operation_bonus_conversion': 'Bonus çevrilməsi',
    'account.history.filterOperation_close_bonus_account': 'Bonus hesabı bağlanıb',
    'account.history.filterOperation_accrual_bonus_account': 'Bonus hesabına hesablama',
    'account.history.filterOperation_slot_bet_settled': 'Slot oyun mərcinə yekun vuruldu',
    'account.history.filterOperation_slot_bet_placed': 'Slot oyununa mərc qoyuldu',
    'account.history.filterOperation_withdrawal_cancelled': 'Çəkiliş ləğv edildi',
    'account.history.filterOperation_withdrawal_rejected': 'Atış rədd edildi',
    'account.history.filterOperation_withdrawal_approved': 'Çəkiliş təsdiqləndi',
    'account.history.filterOperation_withdrawal_completed': 'Çəkiliş tamamlandı',
    'account.history.filterOperation_withdrawal_pending': 'Çəkiliş təsdiqi gözlənilir',
    'account.history.filterOperation_bonus_conversion': 'Bonus çevrilməsi',
    'account.history.filterOperation_bet_lost': 'İtirilmiş mərc',
    'account.history.filterOperation_bet_placed': 'mərc qoyulub',
    'account.history.filterOperation_bet_settled': 'Mərc həll olundu',
    'account.history.filterOperation_deposit': 'depozit pulu',
    'account.history.filterOperation_deposit_pending': 'İnvestisiya təsdiqi gözlənilir',
    'account.history.colBetType': 'MAC NÖVÜ',
    'account.history.colType': 'TİP',
    'account.history.colDescription': 'İZAHI',
    'account.history.colOdds': 'NISBƏT',
    'account.history.colResult': 'NƏTİCƏ',
    'account.history.colAmount': 'AMOUNT',
    'account.history.colStatus': 'VƏZİYYƏT',
    'account.history.betTypeSlot': 'slot oyunu',
    'account.history.betTypeSportsbook': 'İdman mərcləri',
    'account.history.betTypeSingle': 'subay',
    'account.history.betTypeExpress': 'Birləşdirilmiş',
    'account.history.result_pending': 'alınmadı',
    'account.history.result_won': 'Qazanc',
    'account.history.result_lost': 'Uduzma',
    'account.history.result_completed': 'tamamlandı',
    'account.history.betsEmpty': 'Hələ heç bir mərc tarixçəniz yoxdur.',
    'account.history.transactionsEmpty': 'Hələ heç bir əməliyyat tarixçəniz yoxdur.',
    'account.bonuses.welcomeTitle': 'xoş gəlmisiniz bonusu',
    'account.bonuses.welcomeDesc': 'İlk investisiyanız üçün xüsusi bonus imkanlarını qaçırmayın.',
    'account.bonuses.viewPromos': 'Promosyonlara baxın',
    'account.bonuses.freeSpinsTitle': 'Pulsuz oyunlarınız',
    'account.bonuses.freeSpinsEmpty': 'Hələ heç bir pulsuz oyununuz yoxdur.',
    'account.bonuses.viewFreeSpins': 'Bonuslarıma baxın',
    'account.vip.title': 'VIP Cashback',
    'account.vip.subtitleLine1': 'İmtiyazlarınızdan yararlanın',
    'account.vip.subtitleLine2': 'Hər həftə cashback qazanın!',
    'account.vip.yourStatus': 'Sənin vəziyyətin',
    'account.vip.yourCashback': 'Sizin cashback',
    'account.vip.promotionRules': 'Promosyon qaydaları',
    'account.vip.stillQuestions': 'Hələ suallarınız var?',
    'account.vip.cardCashbackFreeAndBonus': 'Pulsuz mərclər və bonuslar',
    'account.vip.cardCashbackBonusOnly': 'Bonuslarda',
    'account.vip.cardCashbackTail': 'qədər cashback',
    'account.vip.tierCashbackDesc': '{metal} — pulsuz mərclər və bonuslar üzrə {percent}%-ə qədər cashback',
    'account.vip.fromAmount': 'Ən azı',
    'account.vip.betAmountWeeks': '4 həftəlik mərc məbləği',
    'account.vip.yourStatusBadge': 'VIP SİZİN STATUS',
    'account.vip.targetStatus': 'MƏQSƏD VƏZİYYƏT',
    'account.vip.cashbackLabel': 'CASHBACK',
    'account.vip.needToBet': 'Mərc etmək üçün lazım olan məbləğ:',
    'account.vip.totalSettled': 'Ümumi hesablanmış mərclər',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '*Cashback pulsuz mərclər idman mərclərində, bonuslar kazino slot oyunlarında istifadə olunur.',
    'account.vip.prev': 'Keçmiş',
    'account.vip.next': 'Sonrakı',
    'account.vip.rulesLoadError': 'Tanıtım qaydalarını yükləmək mümkün olmadı.',
    'account.vip.faqLoadError': 'Tez-tez verilən sualları yükləmək alınmadı.',
    'account.vip.cashbackHistoryTitle': 'Cashback hesablama tarixi',
    'account.vip.cashbackHistoryDesc': 'Əvvəlki həftənin keşbeki hər bazar ertəsi saat 18:00-a kimi hesablanır. Cashback hesablama statusu barədə SMS vasitəsilə məlumat veriləcək.',
    'account.vip.cashbackHistoryDate': 'Tarix',
    'account.vip.cashbackHistoryStatus': 'Vəziyyət',
    'account.vip.cashbackHistoryAmount': 'Cashback məbləği',
    'account.vip.cashbackCalculating': 'Hesablanır',
    'account.vip.pendingCashback': 'bu həftə yığılıb',
    'common.close': 'Bağla',
    'appUpdate.title': 'Yeniləməni yükləyin',
    'appUpdate.text': 'yeni xüsusiyyətlərə daxil olmaq üçün',
    'appUpdate.action': 'Yeniləyin',
    'account.notifications.readAll': 'Hamısını oxumuş kimi qeyd edin',
    'account.notifications.empty': 'bildiriş yoxdur',
    'account.notifications.emptyUnread': 'Oxunmamış bildiriş yoxdur',
    'account.notifications.filterAll': 'Hamısı',
    'account.notifications.filterUnread': 'Oxunmamış ({count})',
    'account.notifications.viewAll': 'Bütün bildirişlər',
    'account.notifications.details': 'Detal',
    'account.security.current': 'Cari Parol',
    'account.security.enterCurrent': 'Cari parolunuzu daxil edin',
    'account.security.new': 'Yeni Parol',
    'account.security.saved': 'Parolunuz yeniləndi',
    'account.responsible.tabDeposit': 'İnvestisiya məhdudiyyətləri',
    'account.responsible.tabSession': 'Oyun sessiyası məhdudiyyətləri',
    'account.responsible.depositDescription': 'İnvestisiya limiti təyin edin. Limitə çatdıqdan sonra, göstərilən müddətin sonuna qədər hesabınıza pul yatıra bilməyəcəksiniz. Limit dərhal aşağı salına və ya silinə bilər. Limiti artırmaq üçün 24 saatlıq gözləmə müddəti keçməlidir.',
    'account.responsible.sessionDescription': 'Oyun sessiyası limiti təyin edin. Gündə, həftədə və ya ayda maksimum oyun vaxtını təyin edin. Limitə çatdıqdan sonra sessiyanız dayandırılacaq və müəyyən edilmiş müddət bitənə qədər siz yenidən daxil ola bilməyəcəksiniz. Limit dərhal aşağı salına və ya silinə bilər. Limiti artırmaq üçün 24 saatlıq gözləmə müddəti keçməlidir.',
    'account.responsible.currentRestrictions': 'Mövcud məhdudiyyətlər',
    'account.responsible.futureRestrictions': 'Gələcək məhdudiyyətlər',
    'account.responsible.limitNotSet': 'Limit təyin edilməyib',
    'account.responsible.notSet': 'Müəyyən deyil',
    'account.responsible.dailyLimit': 'gündəlik limit',
    'account.responsible.weeklyLimit': 'Həftəlik limit',
    'account.responsible.monthlyLimit': 'Aylıq limit',
    'account.responsible.hoursShort': 'saat',
    'account.responsible.saved': 'Limitlər yeniləndi',
    'account.responsible.timeLimitsTitle': 'vaxt məhdudiyyətləri',
    'account.responsible.timeDescription': 'Limitə çatdıqda hesabınızdan çıxacaq və yeni dövr başlayana qədər yenidən daxil ola bilməyəcəksiniz.',
    'account.responsible.sessionLimitMinutes': 'Sessiya limiti (dəqiqə)',
    'account.responsible.install': 'Müraciət edin',
    'account.responsible.confirmTitle': 'Limit təyin edilsin?',
    'account.responsible.confirmRemoveOrLower': 'Limit artırılsa, 24 saatdan sonra qüvvəyə minəcək. Limitin azaldılması dərhal tətbiq edilir.',
    'account.responsible.confirmTightenImmediately': 'Təsdiqdən sonra aşağı hədd dərhal tətbiq edilir.',
    'account.responsible.confirmSet': 'Set',
    'account.responsible.confirmCancel': 'Ləğv et',
    'account.responsible.currentLimits': 'Cari məhdudiyyətlər',
    'account.responsible.sessionLimit': 'Sessiya limiti',
    'account.responsible.timeRemaining': 'Qalan vaxt',
    'account.responsible.delete': 'Sil',
    'account.responsible.confirmChangeTitle': 'Limit dəyərlərini dəyişmək istədiyinizə əminsiniz?',
    'account.responsible.confirmDeleteTitle': 'Limiti silmək istədiyinizə əminsiniz?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Maksimum sessiya müddəti – 1440 dəqiqə (24 saat)',
    'account.responsible.limitBlocked': 'Oyun vaxt limitinə çatdı. Hesabınız sistemdən çıxarılıb.',
    'account.requests.title': 'Sorğular',
    'account.requests.newRequest': 'yeni tələb',
    'account.requests.empty': 'Cari tələb yoxdur',
    'account.requests.chooseType': 'Sorğu növünü seçin',
    'account.requests.cancel': 'Ləğv et',
    'account.requests.sendRequest': 'Sorğu göndərin',
    'account.requests.submit': 'Göndər',
    'account.requests.error': 'Sorğunu göndərmək mümkün olmadı',
    'account.requests.notFound': 'Sorğu növü tapılmadı',
    'account.requests.type.sport_bet_settlement': 'İdman mərclərinin hesablanması',
    'account.requests.type.casino_bet_settlement': 'Casino mərc hesablanması',
    'account.requests.type.hotline': 'Çağrı mərkəzi ilə bağlı sual',
    'account.requests.type.deposit': 'depozit sualı',
    'account.requests.type.withdrawal': 'pul çıxarılması sualı',
    'account.requests.type.website_app': 'Saytdan və ya mobil proqramdan istifadə ilə bağlı sual',
    'account.requests.type.admin': 'Admin üçün sual',
    'account.requests.type.verification': 'yoxlama sualı',
    'account.requests.type.bonus': 'Bonus sual',
    'account.requests.mobile.title': 'problem var?',
    'account.requests.mobile.desc': 'Yeni sorğu yaradın və ya Yardım mərkəzimizdə cavablar tapın',
    'account.requests.mobile.create': 'Yeni sorğu yaradın',
    'account.requests.mobile.helpCentre': 'Yardım mərkəzinə gedin',
    'account.requests.group.deposit': 'Depozit sualı',
    'account.requests.group.withdrawal': 'LÜTFEN SUAL',
    'account.requests.group.other': 'DİGƏR',
    'account.requests.template.depositBankCard': 'Bank kartı',
    'account.requests.template.depositRaschet': '"Raschet" vahid ödəniş sistemi',
    'account.requests.template.depositQiwi': 'QIWI terminalı',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'oplaty',
    'account.requests.template.withdrawalOplati': 'oplaty',
    'account.requests.template.withdrawalBank': 'Bank kartı / köçürmə',
    'account.requests.form.operationDate': 'Əməliyyat tarixi və vaxtı',
    'account.requests.form.amount': 'Əməliyyat məbləği',
    'account.requests.form.selectOperationDesc': 'Sualınızın aid olduğu əməliyyatı seçin',
    'account.requests.form.selectOperationBtn': 'Fəaliyyət seçin',
    'account.requests.form.selectedOperation': 'Seçilmiş fəaliyyət',
    'account.requests.form.noOperations': 'Uyğun əməliyyat tapılmadı',
    'account.requests.form.messagePlaceholder': 'Sualınızı və ya sorğunuzu təsvir edin',
    'account.requests.form.symbolsRemaining': '{count} simvol qalıb',
    'account.requests.form.choose': 'seçin',
    'account.requests.form.dragOrUpload': 'Faylları sürükləyin və ya yükləyin',
    'account.requests.form.attachFile': 'Fayl əlavə edin',
    'account.requests.form.attachHint': 'Maksimum 5 fayl. Format: jpg, jpeg, png, pdf. Maksimum 7 MB.',
    'account.requests.form.attachments': 'qoşmalar',
    'account.helpCentre.title': 'yardım mərkəzi',
    'account.helpCentre.text1': 'Məlumatı burada tapa bilərsiniz',
    'account.helpCentre.text2': 'və istifadə məsləhətləri',
    'account.helpCentre.faq': 'Tez-tez verilən suallar',
    'account.helpCentre.instructions': 'Təlimatlar',
    'account.helpCentre.strategies': 'Bahis strategiyaları',
    'account.helpCentre.glossary': 'Lüğət',
    'account.helpCentre.go': 'Yardım mərkəzinə gedin',
    'account.support.subject': 'Mövzu',
    'account.support.message': 'Mesaj',
    'account.support.send': 'Göndər',
    'account.support.sent': 'Sorğunuz alındı',
    'account.support.history': 'Keçmiş sorğular',
    'account.support.status_open': 'Açıq',
    'account.support.status_closed': 'bağlıdır',
    'account.support.status_pending': 'Gözləmədə',
    'account.support.status_waiting': 'Gözləmədə',
    'account.support.status_answered': 'Cavab verdi',
    'account.support.status_replied': 'Cavab verdi',
    'account.support.status_in_progress': 'prosesində',
    'account.support.status_resolved': 'həll olundu',
    'account.pageTitle': 'Hesabım | VurgunBet',
    'sport.filter.allTime': 'hər zaman',
    'sport.filter.allEvents': 'Bütün hadisələr',
    'sport.filter.live': 'Canlı',
    'sport.filter.prematch': 'matçdan əvvəl',
    'sport.filter.all': 'Hamısı',
    'betslip.title': 'Kupon',
    'betslip.empty': 'kupon boşdur',
    'betslip.stake': 'Mərc məbləği',
    'betslip.totalOdds': 'Ümumi nisbət',
    'betslip.potentialWin': 'mümkün qazanclar',
    'betslip.place': 'mərc qoyun',
    'betslip.clear': 'aydın',
    'betslip.accepted': 'Bahis qəbul edildi',
    'betslip.login': 'Mərc etmək üçün daxil olun',
    'betslip.emptyHint': 'Mərc etmək üçün hadisə seçin',
    'betslip.amount': 'Məbləğ, TL',
    'betslip.promos': 'Promosyonlar',
    'betslip.active': 'Aktiv',
    'betslip.popular': 'Populyar hadisələr',
    'footer.about': 'Haqqımızda',
    'footer.basinda': 'Biz Mətbuatda',
    'footer.licence': 'Lisenziya',
    'footer.privacy': 'Məxfilik Siyasəti',
    'footer.responsible': 'Məsuliyyətli Oyun',
    'footer.rules': 'Qaydalar və Şərtlər',
    'footer.financial': 'maliyyə xidmətləri',
    'footer.vip': 'VIP proqramı',
    'footer.help': 'yardım mərkəzi',
    'footer.payments': 'Ödənişlər',
    'footer.company': 'Şirkət məlumatları',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Mərc nöqtəsi qaydaları',
    'footer.appCaption': 'TƏTBİQ',
    'footer.appIos': 'iOS üçün',
    'footer.appIosLong': 'iOS proqramı',
    'footer.appAndroidLong': 'Android proqramı',
    'footer.appAndroid': 'Android üçün',
    'footer.telegram': 'Telegram',
    'footer.copyright': 'Yaşı 18-dən aşağı olan şəxslərə mərc etmək qadağandır. VurgunBet beynəlxalq onlayn oyun operatoru kimi fəaliyyət göstərir.',
    'footer.legal': 'VurgunBet; 18 yaşdan yuxarı istifadəçilərə idman mərcləri, slot oyunları, canlı kazino və əlaqəli oyun məhsulları təklif edir. İstifadəçi yerləşdiyi yerdə qanuni məhdudiyyətlərə əməl etməyə görə məsuliyyət daşıyır.',
    'footer.legal1': '18 yaşına çatmamış şəxslərə qumar oynamaq qadağandır; Bundan əlavə, kazinolara və virtual kazinolara girişi və/və ya qumar oynaması məhdudlaşdırılan şəxslərin iştirak etməsi qadağandır.',
    'footer.legal2': 'VurgunBet; onlayn idman mərcləri, slot oyunları, canlı kazino və əlaqəli oyun məhsulları təklif edir. Xidmətlər yalnız qanunla icazə verilən yerlərdə və şəraitdə istifadə edilməlidir.',
    'help.title': 'yardım mərkəzi',
    'help.searchPlaceholder': 'Sualınızı axtarın',
    'help.searchSheetTitle': 'Yardım mərkəzi: axtarış',
    'help.searchSheetDesc': 'Sualınıza cavab tapın',
    'help.popularSearches': 'POPULAR AXTARLAR',
    'help.popular.identification': 'Necə yoxlamaq olar?',
    'help.popular.deposit': 'Mən necə pul yatırım?',
    'help.popular.win': 'Mən qazancımı necə çıxara bilərəm?',
    'help.askQuestion': 'sual verin',
    'help.views': 'baxışlar',
    'help.back': 'Geri',
    'help.noResults': 'Heç bir nəticə tapılmadı',
    'help.goToFaq': 'Tez-tez verilən suallara keçin',
    'help.instructions': 'Təlimatlar',
    'help.training': 'Təhsil',
    'help.glossary': 'Lüğət',
    'help.notFound.code': '404',
    'help.notFound.title': 'Səhifə tapılmadı',
    'help.notFound.description': 'Axtardığınız səhifə mövcud deyil. O, köçürülmüş və ya silinmiş ola bilər.',
    'help.notFound.home': 'ana səhifə',
    'help.feedback.review': 'Şərh yazın',
    'help.feedback.helpful': 'Bu məlumat faydalı oldu?',
    'help.feedback.yes': 'Bəli, təşəkkür edirəm',
    'help.feedback.no': 'yox',
    'promos.tab.actions': 'Kampaniyalar',
    'promos.tab.tournaments': 'Turnirlər',
    'promos.tab.actionsDesc': 'Çempion ol',
    'promos.tab.tournamentsDesc': 'Turnirlərə qoşulun',
    'promos.tab.actionsTitle': 'Kampaniyalar',
    'promos.tab.tournamentsTitle': 'Turnirlər',
    'promos.tab.bonuses': 'Bonuslar',
    'promos.tab.bonusesDesc': 'Bonuslarınızı izləyin',
    'promos.tab.bonusesTitle': 'Bonuslarınız',
    'promos.tab.promoCode': 'promo kodu',
    'promos.tab.promoCodeDesc': 'İndi aktivləşdirin',
    'promos.tab.promoCodeTitle': 'Promosyon kodunuz var?',
    'promos.tournamentsIntro': 'Turnirlərə qoşulun və qiymətli hədiyyələr üçün yarışın',
    'promos.filter.all': 'Hamısı',
    'promos.filter.sport': 'İdman',
    'promos.filter.casino': 'Kazino',
    'promos.timer.ended': 'vaxt bitdi',
    'promos.timer.daysLeft': 'Qalan: {count} gün',
    'promos.timer.hoursLeft': 'Qalan: {count} saat',
    'promos.timer.minutesLeft': 'Qalan: {count} dəq',
    'promos.tournament.active': 'Aktiv',
    'promos.tournament.bonusFund': 'bonus fondu',
    'promos.tournament.participants': 'İştirakçılar',
    'promos.tournament.places': 'Aranjiman',
    'promos.tournament.untilCompletion': 'başa çatdırmaq üçün qaldı',
    'promos.tournament.untilStart': 'başlamaq üçün qaldı',
    'promos.tournament.upcoming': 'Tezliklə',
    'promos.tournament.startsIn': 'başlamaq üçün',
    'promos.tournament.joinWhenLive': 'Başlayanda qoşulun',
    'promos.tournament.tab.rating': 'Aranjiman',
    'promos.tournament.tab.terms': 'Qaydalar',
    'promos.tournament.tab.games': 'oyunlar',
    'promos.tournament.col.participant': 'İştirakçı',
    'promos.tournament.col.points': 'Xallar',
    'promos.tournament.col.bonuses': 'Bonuslar',
    'promos.tournament.participate': 'Qatil',
    'promos.tournament.optOut': 'buraxmaq',
    'promos.tournament.loginToJoin': 'Qoşulmaq üçün daxil olun',
    'promos.tournament.promoRules': 'Promosyon qaydaları',
    'promos.tournament.questions': 'Hələ suallarınız var?',
    'promos.tournament.close': 'Bağla',
    'promos.tournament.loading': 'Sıralama yüklənir...',
    'promos.tournament.emptyBoard': 'Hələ reytinq yoxdur. İlk qoşulan siz olun!',
    'promos.tournament.noTerms': 'Qaydalar tezliklə əlavə olunacaq.',
    'promos.tournament.noGames': 'Uyğun oyunların siyahısı tezliklə əlavə olunacaq.',
    'promos.tournament.joinedOk': 'Turnirdə iştirak etmisiniz',
    'promos.tournament.leftOk': 'Siz turniri tərk etdiniz',
    'promos.tournament.actionError': 'Əməliyyatı başa çatdırmaq mümkün olmadı',
    'promos.tournament.working': 'Emal edilir...',
    'promos.tournament.gameBadge': 'TURNİR',
    'promos.tournament.showAllGames': 'Bütün oyunları göstərin',
    'promos.tournament.askQuestion': 'sual verin',
    'promos.tournament.faq.participate.q': 'Turnirə necə qoşula bilərəm?',
    'promos.tournament.faq.participate.a': 'Turnirlər bölməsinə keçin, qoşulmaq istədiyiniz turniri açın və Qoşul düyməsini sıxın.',
    'promos.tournament.faq.deposit.q': 'Turnirdə iştirak etmək üçün pul yatırmalıyam?',
    'promos.tournament.faq.deposit.a': 'Xeyr - qoşulmaq pulsuzdur. Xal qazanmaq üçün real balansınızla (min. 5 TL) Oyunlar siyahısındakı slotlarda oynamaq kifayətdir. Bonus balansı xal sayılmır.',
    'promos.tournament.faq.multiple.q': 'Eyni zamanda birdən çox turnirdə iştirak edə bilərəmmi?',
    'promos.tournament.faq.multiple.a': 'Bəli. Siz eyni vaxtda birdən çox aktiv turnirdə iştirak edə bilərsiniz; Hər bir turnir üçün reytinqlər ayrıca saxlanılır.',
    'promos.tournament.faq.terms.q': 'Turnirin şərtlərinə harada baxa bilərəm?',
    'promos.tournament.faq.terms.a': 'Siz Turnir pəncərəsindəki Qaydalar sekmesinden və ya Promosyon qaydaları linkindən bütün şərtləri nəzərdən keçirə bilərsiniz.',
    'promos.tournament.faq.games.q': 'Turnirə hansı slot oyunları daxildir?',
    'promos.tournament.faq.games.a': 'Uyğun oyunlar turnir pəncərəsindəki Oyunlar tabında verilmişdir. Yalnız siyahıdakı oyunlara edilən mərclər xal qazanır.',
    'promos.tournament.faq.bonuses.q': 'Turnirdə iştirak edib qalib gəlməklə hansı bonusları əldə edə bilərəm?',
    'promos.tournament.faq.bonuses.a': 'Reytinqdəki yerinizə əsasən pul və pulsuz fırlanma (FS) mükafatları qazanırsınız. Mükafatlar turnir bitdikdən sonra 48 saat ərzində müəyyən edilir; FS 7 gün ərzində etibarlıdır, pul mükafatlarına yalnız x2 mərc.',
    'promos.tournament.faq.timed.q': 'Turnirlərin müddəti məhduddurmu?',
    'promos.tournament.faq.timed.a': 'Bəli. VURGUN TIME hər həftə bazar ertəsi saat 11:00-da başlayır və bazar günü saat 23:59-da bitir; sonra avtomatik olaraq yenilənəcək.',
    'promos.tournament.faq.track.q': 'Turnir nəticələrimi və irəliləyişimi necə izləyə bilərəm?',
    'promos.tournament.faq.track.a': 'Siz cari xalınızı və dərəcənizi turnir pəncərəsindəki Sıralama sekmesinden görə bilərsiniz. Ballar real balans mərclərindən dərhal sonra yenilənir.',
    'promos.tournament.faq.more.q': 'Hələ suallarım var.',
    'promos.tournament.faq.more.a': 'Aşağıdakı Sual verin düyməsi ilə dəstək sorğusu yarada bilərsiniz. Komandamız ən qısa zamanda sizinlə əlaqə saxlayacaq.',
    'promos.tournament.ask.title': 'yeni tələb',
    'promos.tournament.ask.subtitle': 'Bonus sual',
    'promos.tournament.ask.placeholder': 'Sualınızı yazın və ya problemi təsvir edin',
    'promos.tournament.ask.charsLeft': '{count} simvol qalıb',
    'promos.tournament.ask.attach': 'Fayl əlavə edin',
    'promos.tournament.ask.attachHint': 'Maksimum 5 fayl. Format: jpg, jpeg, png, pdf. Maksimum 7 MB.',
    'promos.tournament.ask.cancel': 'Ləğv et',
    'promos.tournament.ask.send': 'Sorğu göndərin',
    'promos.tournament.ask.sending': 'Göndərilir...',
    'promos.tournament.ask.sent': 'Sorğunuz alındı. Biz ən qısa zamanda sizinlə əlaqə saxlayacağıq.',
    'promos.tournament.ask.loginRequired': 'Sorğu göndərmək üçün daxil olun',
    'promos.tournament.ask.error': 'Sorğunu göndərmək mümkün olmadı',
    'promos.tournament.terms.periodTitle': 'Həftəlik turnir dövrü',
    'promos.tournament.terms.pointsTitle': 'Xal qazanmaq üçün şərtlər',
    'promos.tournament.terms.points1': 'Minimum mərc cəmi 5 TL-dir — qoşulmaq pulsuzdur, sadəcə xallar üçün real balansla oynayın.',
    'promos.tournament.terms.points2': 'Hər 1 TL real balans mərc = 2 xal. Cümə-Bazar 20% əlavə xal!',
    'promos.tournament.terms.points3': 'Oyunlar sekmesindəki slotlarda edilən bütün real balans mərcləri dərhal reytinqdə qeyd olunur. Bonus balansı nəzərə alınmır.',
    'promos.tournament.terms.bonusesTitle': 'Bonus istifadə şərtləri',
    'promos.tournament.terms.bonuses1': 'Nağd pul və FS mükafatları turnir bitdikdən sonra 48 saat ərzində müəyyən edilir; FS etibarlılıq müddəti 7 gündür.',
    'promos.tournament.terms.bonuses2': 'Mükafat uduşları yalnız x2 mərc ilə geri götürülə bilər - sənaye ortalamasından xeyli aşağı.',
    'promos.tournament.terms.bonuses3': 'Turnir avtomatik olaraq hər bazar ertəsi saat 11:00-da yenilənir; Reytinqlər sıfırlanır, yeni həftə, yeni şans.',
    'promos.bonuses.title': 'Bonuslarınız',
    'promos.promocode.title': 'Promosyon kodunuz var?',
    'promos.promocode.desc': 'Aşağıda promosyon kodunuzu daxil edin və Aktivləşdir düyməsini basın',
    'promos.promocode.placeholder': 'Promo kodu daxil edin',
    'promos.promocode.activate': 'aktivləşdirin',
    'promos.promocode.activating': 'Həyata keçirilir…',
    'promos.promocode.success': 'Promosyon kodu uğurla tətbiq olundu',
    'promos.promocode.error': 'Promosyon kodu tətbiq oluna bilmədi',
    'promos.promocode.loginRequired': 'Promo kodu üçün daxil olmalısınız',
    'promos.bonuses.loading': 'Bonuslarınız yüklənir...',
    'promos.bonuses.empty': 'Hələ bonusunuz yoxdur.',
    'promos.bonuses.emptyCaption': 'Aktiv bonus yoxdur',
    'promos.bonuses.emptyDescription': 'Kampaniyalarda iştirak edin və yeni bonuslar qazanın!',
    'promos.bonuses.emptyButton': 'Kampaniyalara gedin',
    'promos.bonuses.emptyArchiveCaption': 'Arxivdə bonus yoxdur',
    'promos.bonuses.emptyArchiveDescription': 'Kampaniyalarda iştirak edin və yeni bonuslar qazanın!',
    'promos.bonuses.kindFilterBonuses': 'Bonuslar',
    'promos.bonuses.kindFilterFreeSpins': 'pulsuz spin',
    'promos.bonuses.kindFilterAll': 'Hamısı',
    'promos.bonuses.kindFreeSpin': 'pulsuz oyun',
    'promos.bonuses.fieldNominal': 'Nominal',
    'promos.bonuses.fieldStatus': 'Vəziyyət',
    'promos.bonuses.fieldExpires': 'İstifadə müddəti',
    'promos.bonuses.fieldReceived': 'Qəbul tarixi',
    'promos.bonuses.tabActive': 'Aktiv',
    'promos.bonuses.tabArchive': 'Tarixçə',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'Sizin irəliləyişiniz:',
    'promos.bonuses.statusWagering': 'Dövr davam edir',
    'promos.bonuses.moreInfo': 'Ətraflı məlumat',
    'promos.bonuses.detailTitle': 'Bonus aktivdir',
    'promos.bonuses.leftDays': 'qalan {n} gün',
    'promos.bonuses.leftDay': 'qalan {n} gün',
    'promos.bonuses.detailLead': 'Mərc tələbini tamamlayın və bonusunuzu əsas hesabınıza alın',
    'promos.bonuses.placeBets': 'Ümumi mərc {amount}',
    'promos.bonuses.rulesTitle': 'BONUS HESABININ DÖNÜŞMƏSİ QAYDALARI',
    'promos.bonuses.rule1': 'Bonus hesabına əlavə edilən uduşlar məbləğ 25 dəfə çevrildikdən sonra əsas hesabda əldə edilə bilər. Təşkilatçı tərəfindən müəyyən edilmiş bəzi slot oyunları istisna olmaqla, mərc bütün kazino provayderlərinin bütün slot oyunlarında tamamlana bilər.',
    'promos.bonuses.rule2': 'Bonus hesabından köçürmə edərkən əvvəlcə əsas hesab balansı, sonra isə bonus hesabının balansı istifadə olunur.',
    'promos.bonuses.rule3': 'Bonus hesabından istifadə edilən qalıqlardan əldə edilən uduşlar bonus hesabına qaytarılır.',
    'promos.bonuses.rule4': 'Konvertasiya başa çatdıqdan sonra bonus hesabında qalan məbləğ əsas balansa köçürülür; lakin ilkin olaraq bonus hesabına yatırılan məbləğin 3 qatından çox ola bilməz.',
    'promos.bonuses.rule5': 'Bonus hesabı aktivləşdirildiyi andan mərc müddəti 3 gündür.',
    'promos.bonuses.rule6': 'Hər bir sonrakı bonus əvvəlki bonus mərc edildikdən sonra avtomatik olaraq aktivləşdirilir.',
    'promos.bonuses.rule7': 'Bonus hesabında qalıq olduğu halda əsas hesabdan pul çıxarmaq mümkün deyil.',
    'promos.bonuses.promotionRules': 'Promosyon qaydaları',
    'promos.bonuses.askQuestion': 'sual verin',
    'promos.bonuses.cancelBonus': 'Bonusu ləğv edin',
    'promos.bonuses.cancelConfirm': 'Bonus balansınız silinəcək və rollover ləğv ediləcək. Davam etməliyik?',
    'promos.bonuses.cancelBusy': 'Ləğv edilir…',
    'promos.bonuses.cancelTitle': 'Həqiqətən imtina etmək istəyirsən?',
    'promos.bonuses.cancelBody': 'Əgər imtina etsəniz, bonuslar yandırılacaq.\nİstənilən vaxt ləğv edə bilərsiniz.',
    'promos.bonuses.cancelRefuse': 'Mən imtina etmək istəyirəm',
    'promos.bonuses.cancelBack': 'Mən əminəm! qayıt',
    'promos.bonuses.askClose': 'Bağla',
    'promos.bonuses.askFileBadType': 'Dəstəklənməyən fayl formatı.',
    'promos.bonuses.askFileTooBig': 'Fayl 7 Mb-dən böyükdür.',
    'promos.bonuses.askError': 'Sorğunu göndərmək mümkün olmadı',
    'promos.bonuses.askSent': 'Sorğunuz göndərildi.',
    'promos.bonuses.askSending': 'Göndərilir...',
    'promos.bonuses.askSend': 'Sorğu göndərin',
    'promos.bonuses.askCancel': 'Ləğv et',
    'promos.bonuses.askFilesSize': 'Maksimum 7Mb.',
    'promos.bonuses.askFilesMax': 'Maksimum 5 fayl.',
    'promos.bonuses.askAttach': 'Fayl əlavə edin',
    'promos.bonuses.askCharsLeft': '{n} simvol qalıb',
    'promos.bonuses.askPlaceholder': 'Sualınızı yazın və ya problemi təsvir edin',
    'promos.bonuses.askNewRequest': 'yeni tələb',
    'promos.bonuses.askBonusQuestion': 'Bonus sual',
    'promos.bonuses.askHint': 'Bonusunuzla bağlı dəstək komandasına sual göndərin',
    'promos.bonuses.fieldWagering': 'dövrü',
    'promos.bonuses.fieldWageringTime': 'Döngə vaxtı',
    'promos.bonuses.fieldMaxWithdrawal': 'Maks. çəkmək',
    'promos.bonuses.fieldUsed': 'istifadə olunur',
    'promos.bonuses.statusAvailable': 'Mövcuddur',
    'promos.bonuses.statusUsed': 'istifadə olunur',
    'promos.bonuses.activate': 'Aktivləşdirin',
    'promos.bonuses.days': 'gün',
    'promos.bonuses.games': 'oyunlar',
    'promos.bonuses.noGames': 'Oyun məlumatı yoxdur',
    'promos.bonuses.play': 'Oyna',
    'home.showcase.slots.title': 'Kazino',
    'home.showcase.slots.count': '{count} oyunu',
    'home.showcase.slots.link': 'Oyunlara baxın →',
    'home.showcase.live.title': 'canlı kazino',
    'home.showcase.live.count': '{count} oyunu',
    'home.showcase.live.link': 'İndi oyna →',
    'home.showcase.tv.title': 'TV oyunları',
    'home.showcase.tv.count': '{count} oyunu',
    'home.showcase.fast.title': 'Sürətli oyunlar',
    'home.showcase.fast.count': '{count} oyunu',
    'home.showcase.fast.link': 'İndi oyna →',
    'home.showcase.virtual.title': 'Virtual idman',
    'home.showcase.virtual.count': '{count} oyunu',
    'home.showcase.virtual.link': 'İndi oyna →',
    'home.showcase.gamesCount': '{count} oyunu',
    'home.showcase.tv.link': 'İndi oyna →',
    'home.showcase.sport.title': 'İdman',
    'home.showcase.sport.count': '3380 hadisə',
    'home.showcase.sport.link': 'Mərc qoyun →',
    'home.promo.category.promotions': 'Kampaniyalar',
    'home.promo.category.tournaments': 'Turnirlər',
    'home.promo.filter.all': 'Hamısı',
    'home.promo.filter.sport': 'İdman (5)',
    'home.promo.filter.casino': 'Kazino (5)',
    'home.promo.showAll': 'Hamısını göstər →',
    'home.promo.allPromotions': 'Bütün promosyonlar',
    'home.promo.cta.play': 'Oyna',
    'home.promo.cta.join': 'Qatil',
    'home.promo.cta.details': 'Detal',
    'home.promo.cta.signup': 'Qeydiyyatdan keçin',
    'home.sport.searchEvents': 'Hadisələri axtarın',
    'footer.contactUs': 'Bizimlə əlaqə saxlayın',
    'footer.usefulInfo': 'Faydalı məlumat',
    'footer.socialMedia': 'sosial media',
    'footer.partners': 'Rəsmi tərəfdaş',
    'footer.officialPartner': 'Rəsmi\ntərəfdaş',
    'home.casino.loading': 'Oyunlar yüklənir...',
    'home.casino.noGames': 'Oyun tapılmadı',
    'home.casino.viewAllMobile': '{count} oyuna baxın',
    'home.shuffle.title': 'Növbəti oyununuz necə olmalıdır?',
    'home.shuffle.cta': 'İndi tərcümə edin',
    'home.shuffle.modalTitle': 'Gəlin sizə uyğun olan oyunu tapaq!',
    'home.shuffle.respin': 'yenidən yığın',
    'home.shuffle.close': 'Bağla',
    'home.jackpot.casinoTitle': 'Kazino Jackpot',
    'home.jackpot.title': 'VURGUN BÖYÜK JEKPOT',
    'home.jackpot.badgeRest': 'BÖYÜK Jackpot',
    'home.jackpot.winners': 'Ümumi qalib: {count}',
    'home.jackpot.largest': 'ən böyük qələbə',
    'home.jackpot.last': 'son qazanc',
    'home.jackpot.onSlots': 'Bütün yuvalarda',
    'home.jackpot.play': 'Jackpot oyunları',
    'home.liveWins.title': 'Ani qazanc',
    'home.liveWins.heated': 'Çəkmək',
    'home.topWins.title': 'Ən yaxşı qalibiyyətlər',
    'home.topWins.week': 'bu həftə',
    'home.topWins.month': 'bu ay',
    'home.topWins.day': 'Bu gün',
    'home.topWins.play': 'Oyna',
    'home.topWins.prev': 'Keçmiş',
    'home.topWins.next': 'Sonrakı',
    'home.popularSlots.title': 'Populyar Slotlar',
    'home.hotSlots.title': 'Ən Qazanclı',
    'home.hotSlots.badge': 'İSTİ',
    'home.matchCarousel.title': 'Matçlar',
    'home.matchCarousel.liveTv': 'Canlı TV',
    'home.slotsCarousel.showAll': 'Hamısını göstər',
    'home.slotsCarousel.prev': 'Keçmiş',
    'home.slotsCarousel.next': 'Sonrakı',
    'home.jackpot.grand': 'GRAND',
    'home.jackpot.major': 'MAYOR',
    'home.jackpot.minor': 'AZAL',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'VIP Klubu',
    'home.heroSide.vipSub': 'xüsusi imtiyazlar',
    'home.heroSide.promosTitle': 'Bonuslar',
    'home.heroSide.promosSub': 'Cari kampaniyalar',
    'home.heroSide.sportTitle': 'İdman',
    'home.heroSide.sportSub': 'canlı mərclər',
    'header.support': 'Dəstək',
    'home.topEvents.showAll': 'Hamısını göstər',
    'betslip.bonusFund': 'bonus fondu',
    'betslip.participants': '{count} iştirakçı',
    'betslip.hoursLeft': '{hours} saat qalıb',
    'betslip.details': 'Detal',
    'casino.viewAllCaption': 'Hamısına bax →',
    'casino.bside.promos': 'Kampaniyalar',
    'casino.bside.showAll': 'Hamısını göstər →',
    'casino.lobby.slots': 'Slotlar',
    'casino.lobby.live': 'Canlı Kazino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'Televiziya Oyunları',
    'casino.lobby.fast': 'Ani Oyunlar',
    'casino.lobby.virtual': 'Virtual İdman',
    'casino.tab.review': 'Vurğulananlar',
    'casino.tab.favourites': 'sevimlilər',
    'casino.tab.top': 'Ən yaxşısı',
    'casino.tab.peter': 'Peter & Sons Hits',
    'casino.tab.free-spins': 'Pulsuz Fırlanmalar',
    'casino.tab.all': 'Bütün Oyunlar',
    'casino.tab.tournaments': 'Turnirlər',
    'casino.tab.jackpot-cards': 'Jackpot Kartlar',
    'casino.tab.new': 'Yeni',
    'casino.tab.world-cup': 'Dünya Kuboku 2026',
    'casino.tab.buy-bonus': 'Bonus al',
    'casino.tab.exclusive': 'eksklüziv',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Praqmatik oyun',
    'casino.tab.coins-link-vip': 'Coins Link VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'kaskad',
    'casino.tab.megaways': 'meqaways',
    'casino.tab.collect': 'toplamaq',
    'casino.tab.wild': 'Vəhşi',
    'casino.tab.double': 'İkiqat şans',
    'casino.tab.megax': 'MegaX',
    'casino.tab.respin': 'repin',
    'casino.tab.retro': 'retro',
    'casino.tab.fruits': 'meyvələr',
    'casino.tab.books': 'kitablar',
    'casino.tab.fast-football': 'Sürətli Futbol',
    'casino.tab.holdem': 'hold\'em',
    'casino.tab.caribbean': 'Karib dənizi',
    'casino.tab.video-poker': 'Video poker',
    'casino.tab.crash': 'qəza',
    'casino.tab.table-games': 'Stolüstü Oyunlar',
    'casino.tab.mines': 'minalar',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Membran',
    'casino.tab.scratch': 'Scratch Card',
    'casino.tab.other': 'Digər',
    'casino.tab.football': 'Futbol',
    'casino.tab.horse-racing': 'At yarışı',
    'casino.tab.recommended': 'Tövsiyə olunur',
    'casino.topProviders': 'ən yaxşı provayderlər',
    'casino.groupsAll': 'Hamısı',
    'casino.groupsNew': 'Yeniliklər',
    'casino.groupsTop': 'ən yaxşı oyunlar',
    'casino.groupsWager': 'bonus üçün',
    'casino.groupsFreebonus': 'pulsuz bonus üçün',
    'casino.lobbyHome': 'ana səhifə',
    'casino.groups': 'Qruplar',
    'casino.providers': 'Provayderlər',
    'casino.search': 'Axtar',
    'casino.play': 'Oyna',
    'casino.demo': 'demo',
    'casino.searchModal.title': 'Axtar',
    'casino.searchModal.placeholder': 'Oyunlar axtarın',
    'casino.filters': 'Filtrlər',
    'casino.filtersCount': 'Filtrlər ({count})',
    'casino.filter.section.functions': 'Xüsusiyyətlər',
    'casino.filter.section.themes': 'Mövzular',
    'casino.filter.bonusGame': 'Bonus Oyunu',
    'casino.filter.buyFeature': 'Bonus al',
    'casino.filter.expandingSymbols': 'Genişlənən Simvollar',
    'casino.filter.freeSpins': 'Pulsuz Fırlanmalar',
    'casino.filter.multiplier': 'çarpan',
    'casino.filter.respins': 'Qaytarır',
    'casino.filter.symbolsCollection': 'Simvolların toplanması',
    'casino.filter.animals': 'heyvanlar',
    'casino.filter.books': 'kitablar',
    'casino.filter.classic777': 'Klassik və 777',
    'casino.filter.coins': 'sikkələr',
    'casino.filter.egypt': 'Şirin qarğıdalı',
    'casino.filter.fruits': 'meyvələr',
    'casino.filter.gods': 'tanrılar',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Bütün provayderlər',
    'casino.selectProvider': 'Provayderi seçin',
    'casino.searchProviders': 'Provayder axtarın',
    'casino.loading': 'Oyunlar yüklənir...',
    'casino.noGames': 'Oyun tapılmadı',
    'casino.lucky': 'şanslıyam',
    'casino.sortBy': 'Sırala',
    'casino.sort.popular': 'ən populyar',
    'casino.sort.default': 'Defolt',
    'casino.sort.az': 'A-dan Z-yə',
    'casino.sort.za': 'Z-dən A',
    'casino.sort.new': 'Ən son',
    'casino.sort.provider': 'Provayder tərəfindən',
    'casino.sort.name': 'adı ilə',
    'casino.showMore': 'Daha çox göstər',
    'casino.viewAll': 'oyunlar',
    'casino.games': 'oyun',
    'casino.side.games': 'oyunlar',
    'casino.side.tournament': 'Turnir',
    'casino.side.search': 'Oyunlar axtarın',
    'casino.side.recommended': 'Tövsiyə olunan oyunlar',
    'casino.side.noGames': 'Oyun tapılmadı',
    'casino.side.noTournaments': 'Aktiv turnir yoxdur',
    'casino.side.loading': 'Yüklənir...',
    'casino.game.play': 'Oyna',
    'casino.game.demo': 'demo',
    'casino.game.favorite': 'Sevimlilərə əlavə edin',
    'casino.game.fullscreen': 'tam ekran',
    'casino.game.noFreeSpins': 'Bu oyuna əlavə edilmiş heç bir freespin yoxdur',
    'casino.game.linkCopied': 'Link kopyalandı',
    'casino.game.closeConfirmTitle': 'Oyun bağlansın?',
    'casino.game.closeConfirmText': 'Oyun bağlanacaq. Davam etmək istəyirsiniz?',
    'casino.game.closeConfirmOk': 'Bağla',
    'casino.game.closeConfirmCancel': 'Ləğv et',
    'casino.game.popout': 'Yeni pəncərədə açın',
    'casino.game.playReal': 'Real pul üçün oynayın',
    'casino.game.addFreeSpins': 'Pulsuz spinlər əlavə edin',
    'casino.game.addFreeSpinsToGame': 'Oyuna pulsuz fırlanmalar əlavə edin',
    'casino.game.fsBet': 'Mərc',
    'casino.game.fsExpiresIn': 'İstifadə müddəti',
    'casino.game.fsAdd': 'əlavə et',
    'casino.game.fsBackToGame': 'oyuna qayıt',
    'casino.game.fsNewAvailable': 'Yeni pulsuz spinlər hazırdır',
    'casino.game.fsUpdateRequired': 'Oyunu yeniləməlisiniz',
    'casino.game.fsUpdate': 'Yeniləyin',
    'casino.game.insufficientBalance': 'Yetərsiz vəsait',
    'casino.game.insufficientBalanceHint': 'Real pulla oynamaq üçün balansınızı doldurun',
    'casino.game.insufficientContinue': 'Davam et',
    'casino.game.makeDeposit': 'Depozit',
    'casino.game.bonusInsufficientHint': 'Bonus balansınız bu mərc üçün yetərsizdir. Əsas pula keçmək mövcud bonusu ləğv edir.',
    'casino.game.switchToCash': 'Əsas pula keç',
    'casino.game.demoMode': 'demo rejimi',
    'casino.game.signIn': 'Real pul üçün oynamaq üçün daxil olun.',
    'casino.game.tryDemo': 'Demonu sınayın',
    'casino.game.loading': 'Oyun yüklənir...',
    'casino.game.notFound': 'Oyun tapılmadı',
    'casino.game.launchFailed': 'Oyun başladıla bilmədi',
    'casino.game.demoUnavailable': 'Demo bu oyun üçün əlçatan deyil.',
    'casino.game.unavailable': 'Oyun hazırda başladıla bilmir. Zəhmət olmasa sonra yenidən cəhd edin.',
    'casino.game.demoSuffix': '(Demo)',
    'casino.badge.top': 'ƏN YAXŞI',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Turnir',
    'casino.badge.new': 'YENİ',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'eksklüziv',
    'casino.badge.jackpot': 'Jackpot',
    'casino.bside.tournaments': 'Turnirlər',
  },
  tk: {
    'nav.home': 'Baş sahypa',
    'nav.vipClub': 'VIP Club',
    'nav.sport': 'Sport',
    'nav.sportLive': 'Janly bet',
    'nav.liveCasino': 'Janly Kazino',
    'nav.aviator': 'Aviator',
    'nav.slots': 'Slotlar',
    'nav.virtual': 'Wirtual sport',
    'nav.fast': 'Çalt oýunlar',
    'nav.tv': 'TV oýunlary',
    'nav.vurgunTv': 'Vurgun TV',
    'vtv.title': 'Vurgun TV',
    'vtv.lead': 'Janly oýun ýaýlymlaryny gör',
    'vtv.live': 'Janly',
    'vtv.upcoming': 'Ýakynlaşýan',
    'vtv.search': 'Gözle',
    'vtv.searchPh': 'Topar, liga gözle…',
    'vtv.allSports': 'Ähli sportlar',
    'vtv.loading': 'Ýaýlymlar ýüklenýär…',
    'vtv.empty': 'Oýun tapylmady',
    'vtv.error': 'Ýaýlymlar ýüklenmedi',
    'vtv.pick': 'Görmek üçin oýun saýla',
    'vtv.streamError': 'Ýaýlym açylmady',
    'vtv.liveBadge': 'JANLY',
    'vtv.loginRequired': 'Yayınları izlemek için giriş yapın',
    'vtv.loginRequiredLead': 'Canlı ve yaklaşan maç yayınları yalnızca üyelere açıktır.',
    'vtv.membersOnly': 'Üyelere özel',
    'vtv.checkingSession': 'Oturum kontrol ediliyor…',
    'nav.poker': 'Poker',
    'nav.new': 'TÄZE',
    'nav.newGames': 'Täze oýunlar',
    'nav.newPromos': 'Täze aksiýalar',
    'nav.promos': 'Aksiýalar',
    'nav.casino': 'Kazino',
    'nav.apps': 'Programmalar',
    'nav.results': 'Netijeler',
    'header.promos': 'Aksiýalar',
    'header.help': 'Kömek',
    'header.search': 'Gözle',
    'header.settings': 'Sazlamalar',
    'header.login': 'Giriş',
    'header.join': 'Hasaba al',
    'header.logout': 'Çykmak',
    'header.account': 'Hasabym',
    'header.deposit': 'Pul goý',
    'header.hideBalance': 'Balansy gizle',
    'header.showBalance': 'Balansy görkez',
    'header.notifications': 'Duýduryşlar',
    'mobile.menu': 'Menýu',
    'mobile.home': 'Baş sahypa',
    'mobile.myBets': 'jedellerim',
    'mobile.navigation': 'Nawigasiýa',
    'mobile.menu.loginTitle': 'Hasabyňyza giriň',
    'mobile.menu.loginText': 'ähli hyzmat opsiýalaryna doly girmek üçin',
    'mobile.menu.tournaments': 'Turnirler',
    'mobile.menu.helpNote': 'Sorag-jogap, okuw, sözlügi',
    'mobile.menu.appsNote': 'Android, iOS üçin',
    'mobile.menu.about': 'URVURGUNBETX100⟧ hakda',
    'mobile.menu.aboutNote': 'Maglumat, ygtyýarnamalar',
    'basinda.title': 'Biz metbugatda',
    'basinda.lead': 'URVURGUNBETX100⟧ stadionyndan sahnalar we meýdan hemaýatkärleri.',
    'basinda.menuNote': 'Hemaýatkärlik, metbugat',
    'basinda.item1': 'Sassuolo - Pisa',
    'basinda.item2': 'Turin - Atalanta',
    'basinda.item3': 'Alaves - Elçe',
    'basinda.item4': 'Levante - Alaves',
    'basinda.item5': 'Fenerbahçe - Pogon Çeçin',
    'mobile.menu.siteTour': 'sahypa gezelenç',
    'mobile.menu.siteTourText': 'Diňe 2 minut wagt alýar',
    'mobile.menu.history': 'Taryhy gör',
    'mobile.menu.historyEmpty': 'Göz aýlamagyň taryhy ýok',
    'mobile.menu.historyEmptyText': 'Bu ýerde gören bölümleriňiziň we sport wakalaryňyzyň hemmesini şu ýerden tapyp bilersiňiz',
    'mobile.menu.clearHistory': 'Taryhy aýdyň',
    'mobile.menu.openPromos': 'Aksiýalar',
    'mobile.menu.searchGames': 'Oýun gözläň',
    'mobile.menu.responsibleGaming': 'jogapkärli oýun',
    'mobile.account.number': 'Hasap: {id}',
    'mobile.account.copy': 'Hasap belgisini göçüriň',
    'mobile.account.copied': 'göçürildi',
    'mobile.account.balance': 'Balans: {amount}',
    'settings.section.sport': 'Sport',
    'settings.section.casino': 'Kazino',
    'settings.section.interface': 'interfeýsi',
    'settings.section.navigation': 'Nawigasiýa',
    'settings.eventDisplay': 'Çäräniň görnüşi',
    'settings.eventDisplay.table': 'Tablisa',
    'settings.eventDisplay.list': 'Sanaw',
    'settings.betSlipLocation': 'talonyň ýerleşýän ýeri',
    'settings.betSlipLocation.bottom': 'Aşakdaky panelde',
    'settings.betSlipLocation.above': 'paneliň ýokarsynda',
    'settings.betSlipSettings': 'Talon sazlamalary',
    'settings.betSlip.showLiveTimer': 'Talonda göni ýaýlym taýmerini görkeziň',
    'settings.betSlip.showEventTime': 'Talonyň wagty we wagtyny görkeziň',
    'settings.betSlip.skipClearConfirm': 'Talonyňyzy arassalanyňyzda tassyklama soramaň',
    'settings.betSlip.view': 'Talon görnüşi',
    'settings.betSlip.view.auto': 'Awtomat',
    'settings.betSlip.view.narrow': 'Dar',
    'settings.betSlip.view.wide': 'Giň',
    'settings.odds.title': 'Garşylyk',
    'settings.odds.boosted': 'köpeldildi',
    'settings.odds.on': 'açyk',
    'settings.odds.off': 'ýapyk',
    'settings.odds.hideBoosted': 'Sport bölüminde artykmaçlyklary görkeziň',
    'settings.odds.european': 'Europeewropa',
    'settings.odds.american': 'Amerikaly',
    'settings.odds.hongkong': 'Gonkong',
    'settings.odds.indonesian': 'Indoneziýa',
    'settings.odds.malaysian': 'Malaýziýa',
    'settings.favouriteSports': 'halaýan sport görnüşleri',
    'settings.favouriteSports.empty': 'Saýlanmady',
    'settings.favouriteSports.desc': 'Halaýan sportuňyzy goşuň; Ilki bilen sport bölüminde görkezilýär.',
    'settings.casinoProMode': 'pro tertibi',
    'settings.casinoProMode.desc': 'Oýun kartasyndaky üýtgewsizligi we beýleki bahalary görkeziň',
    'settings.casinoView.standard': 'Adaty görnüş',
    'settings.casinoView.pro': 'pro tertibi',
    'settings.theme.title': 'Sahypanyň mowzugy',
    'settings.theme.auto': 'Awtomat',
    'settings.theme.light': 'Açyň',
    'settings.theme.dark': 'Garaňky',
    'settings.hideBalance': 'Balansy gizle',
    'settings.hideBalance.desc': 'Balansy sözbaşyda gizlemek üçin süpüriň',
    'settings.showUpButton': '"" Okarky "düwmesini görkeziň',
    'settings.language': 'Dil',
    'settings.nav.sportSection': 'Sport bölüminde',
    'settings.nav.casinoSection': 'Kazino bölüminde',
    'settings.nav.menu': 'menýuda',
    'settings.title': 'Sahypanyň sazlamalary',
    'settings.reset': 'gaýybana gaýdyp geliň',
    'settings.betSlip.title': 'Talon',
    'settings.nav.betAcceptance': 'Jedelleri kabul etmek',
    'settings.nav.cashOut': 'möhletinden öň tölemek',
    'settings.nav.favouriteBets': 'Halaýan jedeller',
    'settings.nav.betSlip': 'Talon görnüşi',
    'settings.navigation.auto': 'Awtomat',
    'settings.navigation.left': 'çep',
    'settings.navigation.top': 'ýokarsynda',
    'settings.eventList.title': 'Çäreleriň sanawy',
    'settings.eventList.minimised': 'Eventshli hadysalary tertip boýunça ýykyň',
    'settings.eventPage.title': 'Waka sahypasy',
    'settings.view.large': 'giň görnüş',
    'settings.view.compact': 'Ykjam görnüş',
    'settings.favouriteSports.descLong': 'Halaýan sportuňyzy goşuň; Ilki bilen sport bölüminde görkezilýär. Süýräp tertibi üýtgedip bilersiňiz',
    'settings.favouriteSports.hint': 'Sporty halaýanlara goşmak üçin ★ basyň',
    'settings.sport.football': 'Futbol',
    'settings.sport.hockey': 'Hokkeý',
    'settings.sport.tennis': 'Tennis',
    'settings.sport.basketball': 'Basketbol',
    'settings.sport.esports': 'elektron sport',
    'settings.sport.tableTennis': 'Stol tennisi',
    'settings.sport.volleyball': 'Woleýbol',
    'settings.sport.handball': 'Gandbol',
    'settings.sport.mixFights': 'garyşyk söweş',
    'settings.sport.boxing': 'Boks',
    'settings.sport.futsal': 'futsal',
    'settings.sport.baseball': 'beýsbol',
    'settings.sport.americanFootball': 'Amerikan futboly',
    'settings.sport.rugby': 'Rugbi',
    'settings.sport.waterPolo': 'suw polosy',
    'settings.sport.fieldHockey': 'meýdan hokkeýi',
    'settings.sport.racing': 'Acearyş',
    'settings.sport.cycling': 'Welosiped',
    'settings.sport.sports': 'Sport',
    'settings.sport.beachSoccer': 'plýa beach futboly',
    'settings.sport.basketball3x3': 'Basketbol 3x3',
    'settings.sport.lacrosse': 'lakros',
    'settings.sport.australianFootball': 'Awstraliýa futboly dolandyrýar',
    'settings.sport.cricket': 'Kriket',
    'settings.sport.snooker': 'snooker',
    'settings.sport.darts': 'Darts',
    'settings.sport.badminton': 'Badminton',
    'page.title': 'URVURGUNBETX100⟧ - Onlaýn sport jedelleri',
    'auth.login.title': 'Giriş',
    'auth.login.submit': 'Giriş',
    'auth.login.link': 'Giriş',
    'auth.register.title': 'Hasaba alyş',
    'auth.register.bannerHighlight': '100% -e çenli',
    'auth.register.bannerTitle': 'BONUS +100 FREE SPIN',
    'auth.register.bannerDesc': '+5 FREE BET',
    'auth.register.perkFast': 'Anonim',
    'auth.register.perkSafe': 'Nol komissiýasy',
    'auth.register.perkBonus': 'VPN dost',
    'auth.register.orSignUpWith': 'ORA-DA BILEN BOLU ..',
    'auth.login.orSignInWith': 'ORA-DA BILEN GÖRÜ ..',
    'auth.webauthn.login': 'Face ID / Touch ID bilen giriň',
    'auth.webauthn.offerTitle': 'Face ID-ni enjamda bellige alyň',
    'auth.webauthn.offerBody': 'Indiki girişde Face ID ýa-da Touch ID bilen çalt girip bilersiňiz.',
    'auth.webauthn.offerConfirm': 'Bu enjamda ýazdyryň',
    'auth.webauthn.offerSkip': 'Häzir däl',
    'auth.webauthn.needRegister': 'Ilki bilen Face ID / Touch ID-i hasaba alyň',
    'auth.webauthn.failed': 'Biometrik giriş şowsuz',
    'auth.webauthn.unsupported': 'Face ID / Touch ID bu enjamda ulanylyp bilinmez',
    'auth.webauthn.registerFailed': 'Biometrik hasaba alyş şowsuz',
    'auth.webauthn.alreadyRegistered': 'Bu enjam eýýäm hasaba alyndy',
    'auth.webauthn.thisDevice': 'bu enjam',
    'auth.webauthn.manageTitle': 'IDüz belgisi / sensor belgisi',
    'auth.webauthn.manageDesc': 'Bu enjamda Face ID, Touch ID ýa-da Windows Salam bilen girmek üçin açary bellige alyň.',
    'auth.webauthn.empty': 'Hasaba alnan biometrik giriş ýok',
    'auth.webauthn.add': 'Bu enjamda ýazdyryň',
    'auth.webauthn.remove': 'Aýyr',
    'auth.webauthn.removed': 'Recordazgy aýryldy',
    'auth.webauthn.registered': 'Biometrik giriş saklandy',
    'auth.webauthn.loadFailed': 'Recordsazgylary ýükläp bilmedi',
    'auth.webauthn.removeFailed': 'Recordazgyny pozup bolmady',
    'account.profile.tab.passkeys': 'IDüz belgisi / sensor belgisi',
    'account.profile.mobile.passkeys': 'IDüz belgisi / sensor belgisi',
    'account.profile.mobile.passkeysHint': 'Çalt giriş',
    'auth.register.socialNotConfigured': 'Bu usul entek düzülmedi',
    'auth.register.pageTitle': 'Hasaba gir | URVURGUNBETX100⟧',
    'auth.register.submit': 'Hasaba al',
    'auth.register.link': 'Hasaba al',
    'guestPopup.title': '100 TL mugt jedel + 300 mugt aýlaw',
    'guestPopup.subtitle': 'täze müşderiler üçin',
    'guestPopup.cta': 'Hasaba al',
    'language.choose': 'Dil saýlaň',
    'auth.register.slogan': 'Oýuna has ýakyn',
    'auth.register.smsHint': 'Bu belgä SMS kody iberiler',
    'auth.register.promoToggle': 'Mende promo kody bar',
    'auth.register.rules': 'Men 18 ýaşymda, şertleri we gizlinlik ýörelgelerini kabul edýärin *',
    'auth.register.rulesBefore': 'Men 18 ýaşymda we',
    'auth.register.termsLink': 'Şertler we şertler',
    'auth.register.rulesAnd': 'bilen',
    'auth.register.privacyLink': 'Gizlinlik syýasaty',
    'auth.register.rulesAfter': 'Men kabul edýärin *',
    'auth.register.rulesLink': 'Şertler we şertler',
    'auth.register.rulesRequired': 'Şertleri we gizlinlik ýörelgelerini kabul etmeli',
    'auth.register.serviceMail': 'Hyzmat býulletenlerini almaga razy.',
    'auth.register.serviceMail2': 'Şahsy maglumatlary gaýtadan işlemek syýasaty',
    'auth.register.here': 'şu ýerden',
    'auth.register.adMail': 'Mahabat poçta sanawy',
    'auth.register.adTerms': 'Siziň şertleriňizi kabul edýärin',
    'auth.register.adTermsLink': 'şertleri',
    'auth.register.adTermsSuffix': 'Men kabul edýärin',
    'auth.register.serviceMailSuffix': 'okap bilersiňiz.',
    'auth.register.fullPromotionTerms': 'Dolandyryşyň doly düzgünleri',
    'auth.placeholder.email': '',
    'auth.validation.phoneRequired': 'Telefon belgiňizi giriziň',
    'auth.validation.phoneOrEmailRequired': 'E-poçta ýa-da telefon giriziň',
    'auth.validation.phoneInvalid': 'Dogry telefon belgisini giriziň',
    'auth.validation.phoneExists': 'Bu telefon belgisi eýýäm hasaba alyndy',
    'auth.validation.emailRequired': 'E-poçta salgyňyzy giriziň',
    'auth.validation.emailInvalid': 'Dogry e-poçta salgysyny giriziň',
    'auth.validation.emailDomainInvalid': 'Dogry e-poçta ulanyň (gmail.com, hotmail.com, outlook.com, mynet.com, yahoo.com we ş.m.)',
    'auth.validation.emailExists': 'Bu e-poçta salgysy eýýäm hasaba alyndy',
    'auth.validation.passwordRequired': 'Parolyňyzy giriziň',
    'auth.validation.passwordShort': 'Parol azyndan 8 simwoldan ybarat bolmaly',
    'auth.validation.registerFailed': 'Recordazgy döredip bilmedi. Gaýtadan synanyşmagyňyzy haýyş edýäris.',
    'auth.validation.loginFieldsRequired': 'Fieldshli meýdanlary dolduryň',
    'auth.validation.loginInvalid': 'Giriş maglumatlary nädogry',
    'auth.validation.accountRequired': 'Hasap belgiňizi giriziň',
    'auth.validation.accountShort': 'Hasap belgisi azyndan 6 simwoldan ybarat bolmaly',
    'auth.validation.codeInvalid': 'Barlamak kody nädogry',
    'auth.validation.codeRequired': 'Tassyklama kody giriziň',
    'auth.validation.codeSendFailed': 'Kod iberilip bilinmedi',
    'auth.validation.codeThrottled': 'Kod ibermek üçin biraz garaşyň',
    'auth.validation.challengeExpired': 'Barlamagyň möhleti gutardy, gaýtadan giriň',
    'auth.validation.serverUnreachable': 'Serwere birigip bilmedim. Npm run dev: terminalda işlediň.',
    'auth.validation.serverError': 'Girip bilmedi. Serweri we maglumat bazasyny barlaň.',
    'auth.tab.phone': 'Telefon',
    'auth.tab.email': 'E-poçta',
    'auth.tab.username': 'Ulanyjy ady',
    'auth.tab.account': 'Bill',
    'auth.label.phone': 'telefon belgisi',
    'auth.label.phoneOptional': 'Jübi telefony (islege görä)',
    'auth.label.email': 'E-poçta',
    'auth.label.account': 'hasap belgisi',
    'auth.label.password': 'Parol',
    'auth.label.promo': 'promo kody',
    'auth.placeholder.account': 'hasap belgisi',
    'auth.forgot': 'Parolyňyzy ýatdan çykardyňyzmy?',
    'auth.noAccount': 'Hasabyňyz ýokmy?',
    'auth.haveAccount': 'Hasabyňyz barmy?',
    'auth.login.pageTitle': 'Giriş | URVURGUNBETX100⟧',
    'auth.verify.info': 'Hasabyňyzy goramak üçin hakykatdanam siziň bardygyňyzy anyklamalydyrys.',
    'auth.verify.caption': 'Barlag koduny alyň:',
    'auth.verify.methodPhone': 'Kody SMS ýa-da Telegram arkaly {contact} belgisine ibereris',
    'auth.verify.methodEmail': 'Kody {contact} e-poçta bilen ibereris',
    'auth.verify.getCode': 'kod al',
    'auth.verify.cancel': 'Ýatyr',
    'auth.verify.noAccess': 'Telefon belgisine girip bilemok',
    'auth.verify.enterCode': 'Tassyklama kody giriziň:',
    'auth.verify.confirm': 'Tassykla',
    'auth.verify.continue': 'Dowam et',
    'auth.verify.codeInfoPhone': 'Barlag koduny giriziň Kody {contact} belgisine SMS ýa-da Telegram arkaly iberdik.',
    'auth.verify.codeInfoEmail': 'Barlag koduny giriziň Kody {contact} e-poçta bilen iberdik.',
    'auth.verify.neverReceived': 'Men hiç wagt kod almadym',
    'auth.verify.resend': 'Kod iber',
    'auth.verify.noAccessEmail': 'E-poçta salgyňyza girip bilemok',
    'auth.verify.help.title': 'Tassyklama kody gelmedik bolsa',
    'auth.verify.help.bodyPhone': 'Telefon belgiňiziň dogrudygyna we enjamyňyzda ýeterlik boş ýadyň bardygyna göz ýetiriň. Habaryň spam bukjasyna düşendigini ýa-da ýokdugyny barlaň.',
    'auth.verify.help.bodyEmail': 'E-poçta salgyňyzyň dogrudygyna göz ýetiriň. Habaryň spam bukjasyna düşendigini ýa-da ýokdugyny barlaň.',
    'auth.verify.help.step1': 'Habarlar programmasyny açyň',
    'auth.verify.help.step2': 'Rightokarky sag burçdaky düwmä basyň',
    'auth.verify.help.step3': '"Spam we bloklanan" saýlaň',
    'auth.verify.help.understood': 'Men düşündim',
    'auth.recover.title': 'paroly täzeden düzmek',
    'auth.recover.pageTitle': 'Paroly täzeden düzmek | URVURGUNBETX100⟧',
    'auth.recover.continue': 'Dowam',
    'auth.recover.noAccess': 'Telefon belgisine / e-poçta girip bilemok',
    'auth.recover.noAccessPhone': 'Telefon belgisine girip bilemok',
    'auth.recover.noAccessEmail': 'E-poçta salgyňyza girip bilemok',
    'auth.recover.newPassword': 'Täze parol',
    'auth.recover.confirmPassword': 'Täze parol (ýene)',
    'auth.recover.passwordMismatch': 'Parollar gabat gelenok',
    'auth.recover.save': 'Paroly ýazdyryň',
    'auth.recover.success': 'Parolyňyz täzelendi Täze parolyňyz bilen girip bilersiňiz.',
    'auth.recover.notFound': 'Bu maglumat üçin hasap tapylmady.',
    'auth.verify.expiredTitle': 'Bu amal üçin rugsat berlen wagt gutardy.',
    'auth.verify.retry': 'gaýtadan synanyşyň',
    'welcome.stepLabel': '3-nji ädim: Hasaba alyş',
    'welcome.title': '100 TL + 300 FS çenli hoşniýetli bonus alyň!',
    'welcome.step1.title': 'Hasaba al',
    'welcome.step1.sub': 'Web sahypasynda ýa-da programmada',
    'welcome.step2.title': 'Doly barlamak',
    'welcome.step2.sub': 'Diňe birnäçe minut gerek',
    'welcome.step3.title': 'pul goýmak',
    'welcome.step3.sub': 'Has uly maýa goýum - has uly bonus!',
    'welcome.start': 'başla',
    'welcome.rules': 'Dolandyryşyň doly düzgünleri',
    'account.loading': 'Adingüklenýär ...',
    'account.save': 'Ýatda sakla',
    'account.empty': 'Recordazgy tapylmady',
    'account.nav.overview': 'Gysgaça syn',
    'account.nav.profile': 'Şahsy maglumatlar',
    'account.nav.verification': 'Barlamak',
    'account.nav.cashier': 'Şu wagta çenli',
    'account.nav.bets': 'jedellerim',
    'account.nav.bonuses': 'Bonuslar',
    'account.nav.notifications': 'Duýduryşlar',
    'account.nav.security': 'Howpsuzlyk',
    'account.nav.support': 'Goldaw',
    'account.menu.profile': 'Meniň profilim',
    'account.menu.payments': 'Goýum we goýum',
    'account.menu.history': 'Jedel we geleşik taryhy',
    'account.menu.requests': 'Islegler',
    'account.menu.responsible': 'jogapkärli oýun',
    'account.menu.vip': 'VIP ýagdaýyňyz',
    'support.liveChat': 'göni goldaw',
    'account.menu.deposit': 'Pul goý',
    'account.overview.title': 'Bank hasabaty',
    'account.overview.balance': 'Balans',
    'account.overview.bonusBalance': 'Bonus balansy',
    'account.overview.accountNo': 'Hasap belgisi',
    'account.overview.verification': 'Barlamak',
    'account.overview.totalBets': 'jemi jedel',
    'account.profile.name': 'familiýa',
    'account.profile.saved': 'Maglumatyňyz saklandy',
    'account.profile.marketingEmail': 'Mahabat habarnamalaryny e-poçta bilen almak isleýärin',
    'account.profile.marketingSms': 'SMS arkaly mahabat habarnamalaryny alasym gelýär',
    'account.profile.tab.details': 'Şahsy maglumatlar',
    'account.profile.tab.phone': 'Telefon belgisini üýtgediň',
    'account.profile.tab.phoneAdd': 'Telefon belgisini goşuň',
    'account.profile.tab.phoneVerify': 'Telefon belgisini barlaň',
    'account.profile.tab.email': 'E-poçta üýtgediň',
    'account.profile.tab.emailAdd': 'E-poçta goşuň',
    'account.profile.tab.emailVerify': 'E-poçta barlaň',
    'account.profile.tab.password': 'Paroly üýtgetmek',
    'account.profile.section.personal': 'Şahsy maglumatlar',
    'account.profile.section.lastLogin': 'I L GOWY LOGIN MAGLUMATY',
    'account.profile.section.contacts': 'ARAGATNAŞYK',
    'account.profile.section.marketing': 'ARAGATNAŞYK ÜPJÜNÇILIKLERI',
    'account.profile.field.name': 'Ady:',
    'account.profile.field.verification': 'Hakyky tanamak ýagdaýy:',
    'account.profile.field.accountNo': 'Hasap belgisi:',
    'account.profile.field.currency': 'Walýuta:',
    'account.profile.field.phone': 'Telefon belgisi:',
    'account.profile.field.email': 'E-poçta:',
    'account.profile.field.time': 'Wagt:',
    'account.profile.field.ip': 'IP adresi:',
    'account.profile.change': 'Üýtget',
    'account.profile.add': 'Goş',
    'account.profile.status.verified': 'Makullandy',
    'account.profile.status.unverified': 'Makullanmadyk',
    'account.profile.marketingIntro': 'Mahabat we habar habarnamalaryny alyň:',
    'account.profile.marketing.email': 'E-poçta',
    'account.profile.marketing.sms': 'SMS',
    'account.profile.marketing.push': 'Duýduryşlary basyň',
    'account.profile.marketing.web': 'Saýt habarnamalary',
    'account.profile.verification.basic': 'Barlanmady',
    'account.profile.verification.verified': 'Barlanyldy',
    'account.profile.verification.pending': 'Garaşylýar',
    'account.profile.verify': 'barlamak',
    'account.profile.tab.kyc': 'tassyklamak',
    'account.profile.kyc.title': 'tassyklamak',
    'account.profile.kyc.intro': 'TR şahsyýet belgiňizi, şäheriňizi, salgyňyzy we şahsyýet suratlaryňyzy iberiň. Islegiňiz gözden geçirilenden soň hasabyňyz tassyklanar.',
    'account.profile.kyc.tcLabel': 'TR şahsyýet belgisi',
    'account.profile.kyc.tcInvalid': 'Dogry 11 belgili TR ID belgisini giriziň',
    'account.profile.kyc.cityLabel': 'Şäher',
    'account.profile.kyc.cityPlaceholder': 'Şäher saýlaň',
    'account.profile.kyc.cityRequired': 'Şäher saýlamak zerur',
    'account.profile.kyc.addressLabel': 'Salgysy',
    'account.profile.kyc.addressHint': 'Doly salgyňyzy ýazyň. Nädogry bolsa, düzedip bilersiňiz.',
    'account.profile.kyc.addressRequired': 'Salgy azyndan 5 simwoldan ybarat bolmaly',
    'account.profile.kyc.frontLabel': 'şahsyýet ýüzi',
    'account.profile.kyc.frontHint': 'Şahsyýetnamaňyzyň öň tarapdaky suratyny ýükläň',
    'account.profile.kyc.backLabel': 'Yzyna ID',
    'account.profile.kyc.backHint': 'Şahsyýetnamaňyzyň yzky suratyny ýükläň',
    'account.profile.kyc.photoRequired': 'Öňki şahsyýetiň suraty hökmanydyr',
    'account.profile.kyc.backRequired': 'Şahsy şahadatnamanyň suraty hökmanydyr',
    'account.profile.kyc.submit': 'Iber',
    'account.profile.kyc.submitted': 'Barlamak islegiňiz kabul edildi we gözden geçirilýär.',
    'account.profile.kyc.pendingMessage': 'Barlamak haýyşyňyz gözden geçirilýär. Täze resminamalar gutarýança iberip bilmersiňiz.',
    'account.profile.kyc.alreadyVerified': 'Hasabyňyz eýýäm barlandy',
    'account.profile.todayAt': 'Şu gün',
    'account.profile.mobile.personalData': 'Şahsy maglumatlar',
    'account.profile.mobile.aboutAccount': 'Hasap hakda',
    'account.profile.mobile.passwordChange': 'Paroly üýtgetmek',
    'account.profile.next': 'Öňe',
    'account.profile.changeEmailTitle': 'Täze e-poçta salgysy',
    'account.profile.changePhoneTitle': 'täze telefon belgisi',
    'account.profile.addEmailTitle': 'E-poçta salgysyny goşuň',
    'account.profile.addPhoneTitle': 'Telefon belgisini goşuň',
    'account.profile.verifyEmailTitle': 'E-poçta salgysyny barlaň',
    'account.profile.verifyPhoneTitle': 'Telefon belgisini barlaň',
    'account.profile.contactSupport': 'Maglumatlary üýtgetmek üçin goldaw bilen habarlaşmagyňyzy haýyş edýäris.',
    'account.profile.contactSupportAddPhone': 'Telefon belgisini goşmak üçin goldaw haýyşyny dörediň.',
    'account.profile.contactSupportChangePhone': 'Telefon belgiňizi üýtgetmek üçin goldaw haýyşyny dörediň.',
    'account.profile.contactSupportVerifyPhone': 'Telefon belgiňizi barlamak üçin goldaw haýyşyny dörediň.',
    'account.profile.contactSupportAddEmail': 'E-poçta salgysyny goşmak üçin goldaw haýyşyny dörediň.',
    'account.profile.contactSupportChangeEmail': 'E-poçta salgyňyzy üýtgetmek üçin goldaw haýyşyny dörediň.',
    'account.profile.step.support': 'Goldaw haýyşyny dörediň',
    'account.profile.step.sharePhone': 'Telefon belgiňizi habar beriň',
    'account.profile.step.shareNewPhone': 'Täze telefon belgiňizi habar beriň',
    'account.profile.step.requestVerify': 'Barlamak haýyşyňyzy iberiň',
    'account.profile.step.confirmSms': 'SMS kody bilen tassyklaň',
    'account.profile.step.shareEmail': 'E-poçta salgyňyzy beriň',
    'account.profile.step.shareNewEmail': 'Täze e-poçta salgyňyzy habar beriň',
    'account.profile.step.confirmEmail': 'E-poçta tassyklamasy',
    'account.profile.contactSupportBtn': 'Goldaw goldawy',
    'account.profile.otp.addPhoneHint': 'Täze telefon belgiňizi giriziň. Barlag koduny SMS arkaly ibereris.',
    'account.profile.otp.changePhoneHint': 'Täze telefon belgiňizi giriziň. Üýtgetme SMS kody bilen tassyklandy.',
    'account.profile.otp.verifyPhoneHint': 'Telefon belgiňizi barlamak üçin kod ibereris.',
    'account.profile.otp.addEmailHint': 'E-poçta salgyňyzy giriziň. Barlag koduny e-poçta bilen ibereris.',
    'account.profile.otp.verifyEmailHint': 'E-poçta salgyňyzy barlamak üçin kod ibereris.',
    'account.profile.otp.changeEmailHint': 'Täze e-poçta salgyňyzy giriziň. Üýtgetme e-poçta kody bilen tassyklanýar.',
    'account.profile.otp.codeSentPhone': 'Barlag koduny iberdik:',
    'account.profile.otp.codeSentEmail': 'Barlag koduny iberdik:',
    'account.profile.otp.codeSent': 'Barlag kody iberildi',
    'account.profile.otp.codeLabel': 'tassyklama kody',
    'account.profile.otp.resend': 'Kod iber',
    'account.profile.otp.phoneRequired': 'Telefon belgisi gerek',
    'account.profile.otp.emailRequired': 'E-poçta salgysy talap edilýär',
    'account.profile.otp.codeRequired': 'Barlamak kody talap edilýär',
    'account.profile.otp.sessionMissing': 'Hakyky tanamak sessiýasy tapylmady',
    'account.profile.otp.saved': 'Aragatnaşyk maglumatlaryňyz täzelendi',
    'account.profile.passwordConfirm': 'Täze parol (ýene)',
    'account.profile.passwordRequired': 'Passwordhli parol meýdanlaryny dolduryň',
    'account.profile.passwordMismatch': 'Täze parollar gabat gelenok',
    'account.profile.passwordSame': 'Täze parol bar bolan parol bilen birmeňzeş bolup bilmez',
    'account.profile.send': 'Iber',
    'account.profile.passwordHint': 'Paroly üýtgetmek üçin howpsuzlyk bölümini ulanyň.',
    'account.verification.desc': 'Şahsyýeti barlamak we hasaby doly açmak üçin talap edilýär.',
    'account.verification.verified': 'Barlanyldy',
    'account.verification.pending': 'Gözden geçirilýär',
    'account.verification.rejected': 'ret edildi',
    'account.verification.step1': 'Pasportyňyzyň ýa-da şahsyýet resminamaňyzyň suratyny ýükläň',
    'account.verification.step2': 'Selfi bilen resminamany saklaýan suratyňyzy goşuň',
    'account.verification.step3': 'Syn, adatça 24 sagadyň dowamynda tamamlanýar',
    'account.verification.submit': 'Barlamaga başlaň',
    'account.verification.submitted': 'Resminamalaryňyz gözden geçirilýär',
    'account.cashier.deposit': 'Pul goý',
    'account.cashier.withdraw': 'Pul çykar',
    'account.cashier.amount': 'Mukdary (TL)',
    'account.cashier.balance': 'Häzirki balans: {amount}',
    'account.cashier.history': 'geleşik taryhy',
    'account.cashier.type': 'Görnüşi',
    'account.cashier.date': 'Taryh',
    'account.payments.title': 'Goýum we goýum',
    'account.payments.back': 'Yza',
    'account.payments.selectMethod': 'Usuly saýlaň',
    'account.payments.group.havale': 'Geçirim',
    'account.payments.group.card': 'Kredit karty',
    'account.payments.group.crypto': 'Kripto',
    'account.payments.group.other': 'Beýleki',
    'account.payments.noMethods': 'Häzirki wagtda hiç hili usul ýok.',
    'account.payments.from': '{amount} TL-den',
    'account.payments.depositTitle': '{method} bilen balansy dolduryň',
    'account.payments.withdrawTitle': '{method} bilen pul alyň',
    'account.payments.depositNotice': 'Üns beriň! Debet kartoçkasy hasabyň eýesiniň adynda hasaba alynmalydyr. Üçünji tarap kartoçkalary bilen tölenen tölegler ret ediler.',
    'account.payments.withdrawNotice': 'Yza çekmek haýyşlary tassyklama ýagdaýyňyza görä işlenýär.',
    'account.payments.addAmount': 'Pul goý',
    'account.payments.withdrawSubmit': '{amount} TL çykarmak',
    'account.payments.requests': 'Islegleriňiz',
    'account.payments.insufficientBalance': 'Maliýe serişdeleri ýeterlik däl',
    'account.payments.minWithdrawNotice': 'Wineňişleri yzyna almak üçin iň az mukdar: {amount}',
    'account.payments.withdrawGoDeposit': 'Goýum',
    'account.payments.selectAnotherMethod': 'Başga usuly saýlaň',
    'account.payments.requestsTitle': 'Geleşik haýyşlary',
    'account.payments.requestsEmpty': 'Sizde entek geleşik haýyşy ýok.',
    'account.payments.filterAll': 'Hemmesi',
    'account.payments.filterCompleted': 'tamamlandy',
    'account.payments.filterProcessing': 'Gaýtadan işlemek',
    'account.payments.filterCancelled': 'ýatyryldy',
    'account.payments.colNumber': 'NUMBER',
    'account.payments.colDate': 'Taryh',
    'account.payments.colType': 'TYPE',
    'account.payments.colMethod': 'USUL',
    'account.payments.colAmount': 'AMOUNT',
    'account.payments.status': 'Uationagdaý',
    'account.payments.status_completed': 'tamamlandy',
    'account.payments.status_pending': 'Garaşylýar',
    'account.payments.status_processing': 'Gaýtadan işlemek',
    'account.payments.status_cancelled': 'ýatyryldy',
    'account.payments.status_rejected': 'ret edildi',
    'account.payments.status_failed': 'Şowsuz',
    'account.payments.status_approved': 'Makullandy',
    'account.payments.status_expired': 'möhleti gutardy',
    'account.payments.goToRequests': 'Meniň talaplarym',
    'account.payments.method.crypto': 'Kripto',
    'account.payments.method.maxhavale': 'Maksimum Transfer',
    'account.payments.method.havale': 'Havale',
    'account.payments.method.havalespeed': 'Tizlik',
    'account.payments.havalespeed.depositPending': 'Tizlik geçiriş maýa goýumlaryny tamamlaň',
    'account.payments.havalespeed.withdrawPending': 'Tiz pul geçirim tölegiňiz işlenýär',
    'account.payments.havalespeed.processing': 'Galan wagt',
    'account.payments.havalespeed.confirmPaid': 'Pul geçirdim, habar ber',
    'account.payments.havalespeed.confirming': 'Duýduryş iberilýär ...',
    'account.payments.havalespeed.confirmSent': 'Duýduryşyňyz alyndy Tassyklamaga garaşylýar.',
    'account.payments.havalespeed.cancelDeposit': 'Islegiňi ýatyr',
    'account.payments.havalespeed.cancelling': 'Atyryldy ...',
    'account.payments.havalespeed.iban': 'IBAN',
    'account.payments.havalespeed.accountHolder': 'Adynyň familiýasy',
    'account.payments.havale.amountLabel': 'Mukdar',
    'account.payments.havalespeed.approvedHint': 'Balansyňyza {amount} goşuldy.',
    'account.payments.havalespeed.approvedHintGeneric': 'Maýa goýumlaryňyz tassyklandy we balansyňyzy goşdy.',
    'account.payments.havalespeed.rejectedHint': 'Tizligi geçirmek islegiňiz ret edildi. Täze maýa goýumyny synap bilersiňiz.',
    'account.payments.maxhavale.depositPending': 'Maks Transfer maýa goýumyny tamamlaň',
    'account.payments.maxhavale.withdrawPending': 'Maksimum pul sargytyňyzy yzyna almak işlenýär',
    'account.payments.maxhavale.processing': 'Galan wagt',
    'account.payments.maxhavale.cancelDeposit': 'Islegiňi ýatyr',
    'account.payments.maxhavale.cancelling': 'Atyryldy ...',
    'account.payments.maxhavale.openPayment': 'Maýa goýum sahypasyny açyň',
    'account.payments.maxhavale.urlMissing': 'Töleg maglumatlary alyp bolmaýar Islegiňizi ýatyryp, gaýtadan synanyşyp bilersiňiz.',
    'account.payments.maxhavale.bankName': 'Bank',
    'account.payments.havaleBtq.depositPending': 'Havale maýa goýumyny tamamlaň',
    'account.payments.havaleBtq.withdrawPending': 'Havale yzyna almak işlenýär',
    'account.payments.havaleBtq.processing': 'Galan wagt',
    'account.payments.havaleBtq.cancelDeposit': 'Islegiňi ýatyr',
    'account.payments.havaleBtq.cancelling': 'Atyryldy ...',
    'account.payments.havaleBtq.openPayment': 'Maýa goýum sahypasyny açyň',
    'account.payments.havaleBtq.urlMissing': 'Töleg maglumatlary alyp bolmaýar.',
    'account.payments.havaleBtq.bankName': 'Bank',
    'account.payments.method.payferrari': 'PayFerrari',
    'account.payments.payferrari.walletId': 'PayFerrari cüzdan ID',
    'account.payments.payferrari.walletName': 'Cüzdan sahibi adı',
    'account.payments.payferrari.openPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.reopenPayment': 'Yatırım sayfasını tekrar aç',
    'account.payments.payferrari.urlMissing': 'Ödeme sayfası bağlantısı alınamadı.',
    'account.payments.payferrari.cancelDeposit': 'Talebi iptal et',
    'account.payments.payferrari.cancelling': 'İptal ediliyor…',
    'account.payments.payferrari.depositPending': 'PayFerrari ödemesini tamamlayın',
    'account.payments.payferrari.withdrawPending': 'PayFerrari çekiminiz işleniyor',
    'account.payments.payferrari.processing': 'Kalan süre',
    'account.payments.payferrari.nameMismatch': 'Ad ve soyad bilginiz eşleşmiyor',
    'account.payments.payferrari.nameMismatchDetail': 'PayFerrari Hesap Sahibi : {name}',
    'account.payments.payferrari.rateLimit': 'Aynı cüzdana kısa sürede yeni çekim gönderilemez',
    'account.payments.payferrari.rateLimitDetail': 'Lütfen daha sonra tekrar deneyin.',
    'account.payments.payferrari.walletInvalid': 'PayFerrari cüzdan bilgisi doğrulanamadı',
    'account.payments.payferrari.walletInvalidDetail': 'Cüzdan ID veya adı kontrol edin.',
    'account.payments.method.payurus': 'PayUrus',
    'account.payments.payurus.walletId': 'PayUrus gapjyk belgisi',
    'account.payments.payurus.walletName': 'Gapjyk eýesiniň ady',
    'account.payments.payurus.openPayment': 'Maýa goýum sahypasyny açyň',
    'account.payments.payurus.reopenPayment': 'Maýa goýum sahypasyny açyň',
    'account.payments.payurus.urlMissing': 'Töleg sahypasynyň baglanyşygyny alyp bolmady Islegiňizi ýatyryp, gaýtadan synanyşyp bilersiňiz.',
    'account.payments.payurus.cancelDeposit': 'Islegiňi ýatyr',
    'account.payments.payurus.cancelling': 'Atyryldy ...',
    'account.payments.payurus.depositPending': 'PayUrus tölegini doly',
    'account.payments.payurus.withdrawPending': '“PayUrus” barlagyňyz işlenýär',
    'account.payments.payurus.processing': 'Galan wagt',
    'account.payments.payurus.depositSuccess': 'Töleg üstünlikli',
    'account.payments.payurus.depositSuccessHint': 'Balansyňyza {amount} goşuldy.',
    'account.payments.payurus.depositSuccessHintGeneric': 'Maýa goýumyňyz {provider} balansyňyzyza goşuldy.',
    'account.payments.payurus.depositProcessing': 'Tölegiňiz işlenýär',
    'account.payments.payurus.depositProcessingHint': '{provider} Tölegiňiz barlanýar. Garaşmagyňyzy haýyş edýäris.',
    'account.payments.payurus.depositFailed': 'Töleg şowsuz',
    'account.payments.payurus.depositFailedHint': '{provider} üçin töleg gutaryp bilmedi. Täze maýa goýumyny synap bilersiňiz.',
    'account.payments.payurus.continue': 'Dowam et',
    'account.payments.payurus.nameMismatch': 'Adyňyz we familiýaňyz gabat gelenok',
    'account.payments.payurus.nameMismatchDetail': 'Infrastrukturadan alnan hasaby eýesiniň ady we familiýasy gabat gelenok. Payurus hasaby eýesi: {name}',
    'account.payments.payurus.rateLimit': 'Täze pullary gysga wagtyň içinde şol gapjyga iberip bolmaz',
    'account.payments.payurus.rateLimitDetail': '“PayUrus” şol gapjyk üçin tutawaç goýýar. Soňrak synanyşyň.',
    'account.payments.payurus.walletInvalid': '“PayUrus” gapjyk maglumatlary barlanyp bilinmedi',
    'account.payments.payurus.walletInvalidDetail': 'Gapjyk belgisini ýa-da gapjyk eýesiniň adyny barlaň we gaýtadan synanyşyň.',
    'account.payments.method.oplati': 'papara',
    'account.payments.method.raschet': '«Raşet» Töleg ulgamy',
    'account.payments.method.qiwi': 'QIWI',
    'account.payments.havale.tc': 'TR şahsyýet belgisi',
    'account.payments.havale.firstName': 'Ady',
    'account.payments.havale.lastName': 'Familiýa',
    'account.payments.havale.iban': 'IBAN',
    'account.payments.havale.ibanPlaceholder': 'TR00 ACCT-000003 0000 00',
    'account.payments.havale.bank': 'Bank',
    'account.payments.havale.transferTo': 'Pullary aşakdaky hasaby geçiriň',
    'account.payments.havale.accountName': 'Hasabyň ady',
    'account.payments.havale.copyIban': 'göçürmek',
    'account.payments.havale.copyName': 'göçürmek',
    'account.payments.havale.copyAmount': 'Göçüriň',
    'account.payments.havale.copyBank': 'banky göçüriň',
    'account.payments.havale.copied': 'göçürildi',
    'account.payments.havale.countdown': 'Galan wagt',
    'account.payments.havale.activeNotice': 'Sizde işjeň isleg bar. Döwür gutarmanka täze haýyş açylyp bilinmez.',
    'account.payments.havale.amountDue': 'Goýulmaly mukdar',
    'account.payments.havale.waitNew': 'Täze haýyşa garaşyň',
    'account.payments.havale.resultApproved': 'Maýa goýumlary tassyklandy',
    'account.payments.havale.resultApprovedHint': 'Balansyňyza {amount} goşuldy.',
    'account.payments.havale.resultRejected': 'Maýa goýumlary ret edildi',
    'account.payments.havale.resultRejectedHint': 'Islegiňiz tassyklanmady Täze maýa goýumyny synap bilersiňiz.',
    'account.payments.havale.resultExpired': 'Islegiň möhleti gutardy',
    'account.payments.havale.resultExpiredHint': '{provider} töleg möhleti gutardy. Täze haýyş döredip bilersiňiz.',
    'account.payments.havale.withdrawReceived': 'Atyş haýyşyňyz geldi',
    'account.payments.havale.withdrawReceivedHint': '{amount} mukdaryny almak baradaky haýyşyňyz kabul edildi we gözden geçirilýär.',
    'account.payments.havale.withdrawApproved': 'Atyşlyk tassyklandy',
    'account.payments.havale.withdrawApprovedHint': '{amount} mukdary üçin yzyna almak islegiňiz tamamlandy.',
    'account.payments.havale.withdrawRejected': 'Ok atyldy',
    'account.payments.havale.withdrawRejectedHint': 'Çekmek haýyşyňyz tassyklanmady Gerek bolsa täze haýyş döredip bilersiňiz.',
    'account.payments.havale.tryAgain': 'gaýtadan synanyşyň',
    'account.payments.crypto.selectCoin': 'Cryptocurrency saýlaň',
    'account.payments.crypto.selectNetwork': 'Tor saýlaň',
    'account.payments.crypto.network': 'Tor',
    'account.payments.crypto.selectedNetwork': 'Saýlanan ulgam',
    'account.payments.crypto.networkWarning': 'Diňe {network} toruna iberiň. Nädogry torda iberilen amallar ýitip biler.',
    'account.payments.crypto.coin': 'Kripto',
    'account.payments.crypto.depositAddress': 'Maýa goýum salgysy',
    'account.payments.crypto.copyAddress': 'salgysyny göçüriň',
    'account.payments.crypto.yourAddress': 'Gapjyk salgyňyz',
    'account.payments.crypto.estimated': 'Takmynan mukdar',
    'account.payments.crypto.txHashOptional': 'TX Haş (islege görä)',
    'account.payments.crypto.submitTxHash': 'TX Haş iberiň',
    'account.payments.crypto.continueToWallet': 'Gapjyk salgysyny görkeziň',
    'account.payments.crypto.txHashError': 'TX heşini ýazdyryp bilmedi',
    'account.payments.crypto.confirmations': 'Tor tassyklamalary',
    'account.payments.crypto.usdTryHint': '{value}',
    'account.payments.fromUsd': '{amount}-den',
    'account.cashier.amountUsd': 'Mukdary (ABŞ dollary)',
    'account.payments.addAmountUsd': 'Depozit {amount}',
    'account.payments.crypto.activeNotice': 'Transferinizi gönderin. Tor tassyklamalary awtomatiki yzarlanýar; Talap edilýän tassyklamalar gazanylanda balans täzelenýär.',
    'account.payments.crypto.noAssets': 'Häzirki wagtda işjeň kripto torlary ýok. Soňrak synanyşyň.',
    'account.bets.stake': 'Talon',
    'account.bets.odds': 'Koeffisiýent',
    'account.bets.win': 'Utuş',
    'account.bets.status': 'Uationagdaý',
    'account.bets.status_pending': 'garaşýaryn',
    'account.bets.status_won': 'ýeňdi',
    'account.bets.status_lost': 'ýitdi',
    'account.history.tabBets': 'jedeller',
    'account.history.tabTransactions': 'geleşik taryhy',
    'account.history.filters': 'Süzgüçler',
    'account.history.filterGroupBetType': 'Bet görnüşi',
    'account.history.filterGroupResult': 'Betting netijeleri',
    'account.history.filterBetType_all': 'Hemmesi',
    'account.history.filterBetType_bets': 'jedeller',
    'account.history.filterBetType_slot': 'oýun oýny',
    'account.history.filterBetType_dice_live': 'Janly re inimde zar oýny',
    'account.history.filterBetType_card_live': 'Göni re inimde kart oýny',
    'account.history.filterBetType_cylinder_live': 'Göni re modeimde rulet oýny',
    'account.history.filterBetType_online_game': 'Bukmekeriň onlaýn oýny',
    'account.history.filterResult_all': 'Hemmesi',
    'account.history.filterResult_not_settled': 'Netije bermedi',
    'account.history.filterResult_win': 'Utuş',
    'account.history.filterResult_loss': 'Ýitgi',
    'account.history.filterResult_cashed_out': 'nagt',
    'account.history.filterResult_void': 'Nädogry',
    'account.history.filterResult_return': 'Yzyna dolan',
    'account.history.colDate': 'Taryh',
    'account.history.colTime': 'SAGAT',
    'account.history.colBetNo': 'BET №',
    'account.history.colCoupon': 'GÖRNÜŞ',
    'account.history.colStake': 'GÖRNÜŞ',
    'account.history.colPotential': 'Güýçli',
    'account.history.details': 'Jikme-jiklik',
    'account.history.colTransactionNo': 'GEÇIRMEK №',
    'account.history.colNumber': 'NUMBER',
    'account.history.colTransaction': 'Prosess',
    'account.history.colAmountBonuses': 'AMON / BONUS',
    'account.history.colBalanceBonuses': 'BALANS / BONUS',
    'account.history.operation_deposit': 'pul goýmak',
    'account.history.operation_deposit_pending': 'Maýa goýumlarynyň tassyklanmagyna garaşylýar',
    'account.history.operation_withdrawal_pending': 'Atyş tassyklamasyna garaşylýar',
    'account.history.operation_withdrawal_cancelled': 'Atyşlyk ýatyryldy',
    'account.history.operation_withdrawal_rejected': 'Ok atyldy',
    'account.history.operation_withdrawal_approved': 'Atyşlyk tassyklandy',
    'account.history.operation_withdrawal_completed': 'Atyşyk tamamlandy',
    'account.history.operation_bet_placed': 'jedel goýuldy',
    'account.history.operation_bet_settled': 'Bet çözüldi',
    'account.history.operation_bet_lost': 'Bet ýitdi',
    'account.history.operation_slot_bet_settled': 'Oýun oýnamagy tamamlandy',
    'account.history.operation_slot_bet_placed': 'Oýun oýny goýuldy',
    'account.history.operation_accrual_bonus_account': 'Bonus hasaby',
    'account.history.operation_close_bonus_account': 'Bonus hasaby ýapyldy',
    'account.history.operation_bonus_conversion': 'Bonus öwrülişi',
    'account.history.filterOperation_close_bonus_account': 'Bonus hasaby ýapyldy',
    'account.history.filterOperation_accrual_bonus_account': 'Bonus hasaby',
    'account.history.filterOperation_slot_bet_settled': 'Oýun oýnamagy tamamlandy',
    'account.history.filterOperation_slot_bet_placed': 'Oýun oýny goýuldy',
    'account.history.filterOperation_withdrawal_cancelled': 'Atyşlyk ýatyryldy',
    'account.history.filterOperation_withdrawal_rejected': 'Ok atyldy',
    'account.history.filterOperation_withdrawal_approved': 'Atyşlyk tassyklandy',
    'account.history.filterOperation_withdrawal_completed': 'Atyşyk tamamlandy',
    'account.history.filterOperation_withdrawal_pending': 'Atyş tassyklamasyna garaşylýar',
    'account.history.filterOperation_bonus_conversion': 'Bonus öwrülişi',
    'account.history.filterOperation_bet_lost': 'Bet ýitdi',
    'account.history.filterOperation_bet_placed': 'jedel goýuldy',
    'account.history.filterOperation_bet_settled': 'Bet çözüldi',
    'account.history.filterOperation_deposit': 'pul goýmak',
    'account.history.filterOperation_deposit_pending': 'Maýa goýumlarynyň tassyklanmagyna garaşylýar',
    'account.history.colBetType': 'GÖRNÜŞ GÖRNÜŞI',
    'account.history.colType': 'TYPE',
    'account.history.colDescription': 'Düşündiriş',
    'account.history.colOdds': 'RATIO',
    'account.history.colResult': 'Netije',
    'account.history.colAmount': 'AMOUNT',
    'account.history.colStatus': 'SITUATION',
    'account.history.betTypeSlot': 'oýun oýny',
    'account.history.betTypeSportsbook': 'Sport jedelleri',
    'account.history.betTypeSingle': 'ýeke',
    'account.history.betTypeExpress': 'Birleşdirilen',
    'account.history.result_pending': 'Netije bermedi',
    'account.history.result_won': 'Utuş',
    'account.history.result_lost': 'Ýitgi',
    'account.history.result_completed': 'tamamlandy',
    'account.history.betsEmpty': 'Entek jedel taryhyňyz ýok.',
    'account.history.transactionsEmpty': 'Entek hiç hili geleşik taryhyňyz ýok.',
    'account.bonuses.welcomeTitle': 'hoş geldiňiz',
    'account.bonuses.welcomeDesc': 'Ilkinji maýa goýumyňyz üçin ýörite bonus mümkinçiliklerini sypdyrmaň.',
    'account.bonuses.viewPromos': 'Mahabatlara serediň',
    'account.bonuses.freeSpinsTitle': 'Mugt oýunlaryňyz',
    'account.bonuses.freeSpinsEmpty': 'Entek mugt oýunlaryňyz ýok.',
    'account.bonuses.viewFreeSpins': 'Bonuslarymy görüň',
    'account.vip.title': 'VIP Nagt pul',
    'account.vip.subtitleLine1': 'Artykmaçlyklaryňyzdan peýdalanyň',
    'account.vip.subtitleLine2': 'Her hepde nagt pul gazanyň!',
    'account.vip.yourStatus': 'Youragdaýyňyz',
    'account.vip.yourCashback': 'Nagt puluňyz',
    'account.vip.promotionRules': 'Mahabatlandyryş düzgünleri',
    'account.vip.stillQuestions': 'Entegem soraglaryňyz barmy?',
    'account.vip.cardCashbackFreeAndBonus': 'Mugt jedeller we bonuslar',
    'account.vip.cardCashbackBonusOnly': 'Bonuslarda',
    'account.vip.cardCashbackTail': 'nagt pul',
    'account.vip.tierCashbackDesc': '{metal} - mugt jedellerde we bonuslarda {percent}% çenli nagt pul',
    'account.vip.fromAmount': 'Iň az',
    'account.vip.betAmountWeeks': '4 hepde jedeliň mukdary',
    'account.vip.yourStatusBadge': 'VIP Siziň ýagdaýyňyz',
    'account.vip.targetStatus': 'TARGET SAYTY',
    'account.vip.cashbackLabel': 'Nagt pul',
    'account.vip.needToBet': 'Jedel etmegiň mukdary:',
    'account.vip.totalSettled': 'Jemi çözülen jedeller',
    'account.vip.currency': 'TL',
    'account.vip.footnote': '* Nagt pul bilen mugt jedeller sport jedellerinde, bonuslar kazino oýun oýunlarynda ulanylýar.',
    'account.vip.prev': 'Öňki',
    'account.vip.next': 'Indiki',
    'account.vip.rulesLoadError': 'Mahabatlandyryş düzgünleri ýüklenip bilinmedi.',
    'account.vip.faqLoadError': 'Sorag-jogap ýükläp bilmedi',
    'account.vip.cashbackHistoryTitle': 'Nagt puluň hasaplanyş taryhy',
    'account.vip.cashbackHistoryDesc': 'Öňki hepdäniň kassa ýygymy her duşenbe 18: 00-a çenli hasaplanýar. SMS arkaly nagt puluň hasaplanyş ýagdaýy barada size habar berler.',
    'account.vip.cashbackHistoryDate': 'Taryh',
    'account.vip.cashbackHistoryStatus': 'Uationagdaý',
    'account.vip.cashbackHistoryAmount': 'Nagt pul mukdary',
    'account.vip.cashbackCalculating': 'Hasaplamak',
    'account.vip.pendingCashback': 'Bu hepde hasaplandy',
    'common.close': 'Ýap',
    'appUpdate.title': 'Täzelenmäni göçürip alyň',
    'appUpdate.text': 'täze aýratynlyklara girmek üçin',
    'appUpdate.action': 'Täzelen',
    'account.notifications.readAll': 'Hemmesini okaň',
    'account.notifications.empty': 'duýduryş ýok',
    'account.notifications.emptyUnread': 'Okalmadyk habarnamalar ýok',
    'account.notifications.filterAll': 'Hemmesi',
    'account.notifications.filterUnread': 'Okalmadyk ({count})',
    'account.notifications.viewAll': 'Allhli bildirişler',
    'account.notifications.details': 'Jikme-jiklik',
    'account.security.current': 'Häzirki parol',
    'account.security.enterCurrent': 'Häzirki parolyňyzy giriziň',
    'account.security.new': 'Täze parol',
    'account.security.saved': 'Parolyňyz täzelendi',
    'account.responsible.tabDeposit': 'Maýa goýum çäkleri',
    'account.responsible.tabSession': 'Oýun sessiýasynyň çäkleri',
    'account.responsible.depositDescription': 'Maýa goýum çägini belläň. Çäklendirilenden soň, görkezilen möhlet gutarýança hasabyňyza pul goýup bilmersiňiz. Çäk peseldilip ýa-da derrew aýrylyp bilner. Çäklendirmäni ýokarlandyrmak üçin 24 sagat garaşmak möhleti geçmeli.',
    'account.responsible.sessionDescription': 'Oýun sessiýasynyň çägini belläň. Günde, hepdede ýa-da aýda iň köp oýun wagtyny düzüň. Çäk gazanylandan soň, sessiýaňyz bes ediler we görkezilen möhlet gutarýança gaýtadan girip bilmersiňiz. Çäk peseldilip ýa-da derrew aýrylyp bilner. Çäklendirmäni ýokarlandyrmak üçin 24 sagat garaşmak möhleti geçmeli.',
    'account.responsible.currentRestrictions': 'Häzirki çäklendirmeler',
    'account.responsible.futureRestrictions': 'Geljekdäki çäklendirmeler',
    'account.responsible.limitNotSet': 'Çäklendirilmedik',
    'account.responsible.notSet': 'Kesgitli däl',
    'account.responsible.dailyLimit': 'gündelik çäk',
    'account.responsible.weeklyLimit': 'Hepdelik çäk',
    'account.responsible.monthlyLimit': 'Aýlyk çäk',
    'account.responsible.hoursShort': 'sagat',
    'account.responsible.saved': 'Çäklendirmeler täzelendi',
    'account.responsible.timeLimitsTitle': 'wagt çäkleri',
    'account.responsible.timeDescription': 'Çäk gazanylandan soň hasabyňyz çykar we täze döwür başlanýança gaýtadan girip bilmersiňiz.',
    'account.responsible.sessionLimitMinutes': 'Sessiýanyň çäkleri (minutlar)',
    'account.responsible.install': 'Giriş',
    'account.responsible.confirmTitle': 'Çäk belläňmi?',
    'account.responsible.confirmRemoveOrLower': 'Çäk artdyrylsa, 24 sagatdan soň güýje girer. Çäklendirmäni azaltmak derrew ulanylýar.',
    'account.responsible.confirmTightenImmediately': 'Tassyklanylandan soň aşaky çäk derrew ulanylýar.',
    'account.responsible.confirmSet': 'Set',
    'account.responsible.confirmCancel': 'Ýatyr',
    'account.responsible.currentLimits': 'Häzirki çäkler',
    'account.responsible.sessionLimit': 'Sessiýanyň çäkleri',
    'account.responsible.timeRemaining': 'Galan wagt',
    'account.responsible.delete': 'Öçür',
    'account.responsible.confirmChangeTitle': 'Çäklendirilen bahalary üýtgetmek isleýändigiňize ynanýarsyňyzmy?',
    'account.responsible.confirmDeleteTitle': 'Çäkini aýyrmak isleýändigiňize ynanýarsyňyzmy?',
    'account.responsible.minutesShort': 'min',
    'account.responsible.sessionMaxTip': 'Sessiýanyň iň ýokary dowamlylygy - 1440 minut (24 sagat)',
    'account.responsible.limitBlocked': 'Oýun wagty ýetdi. Hasabyňyz çykdy.',
    'account.requests.title': 'Islegler',
    'account.requests.newRequest': 'täze isleg',
    'account.requests.empty': 'Häzirki isleg ýok',
    'account.requests.chooseType': 'Talap görnüşini saýlaň',
    'account.requests.cancel': 'Ýatyr',
    'account.requests.sendRequest': 'Talap iber',
    'account.requests.submit': 'Iber',
    'account.requests.error': 'Talap iberilip bilinmedi',
    'account.requests.notFound': 'Talap görnüşi tapylmady',
    'account.requests.type.sport_bet_settlement': 'Sport jedelleri',
    'account.requests.type.casino_bet_settlement': 'Kazino jedelleri',
    'account.requests.type.hotline': 'Çagyryş merkezi barada sorag',
    'account.requests.type.deposit': 'goýum soragy',
    'account.requests.type.withdrawal': 'pul almak meselesi',
    'account.requests.type.website_app': 'Sahypany ýa-da ykjam programmany ulanmak barada sorag',
    'account.requests.type.admin': 'Admin üçin sorag',
    'account.requests.type.verification': 'barlamak soragy',
    'account.requests.type.bonus': 'Bonus soragy',
    'account.requests.mobile.title': 'Mesele barmy?',
    'account.requests.mobile.desc': 'Täze haýyş dörediň ýa-da Kömek merkezimizde jogap tapyň',
    'account.requests.mobile.create': 'Täze haýyş dörediň',
    'account.requests.mobile.helpCentre': 'Kömek merkezine gidiň',
    'account.requests.group.deposit': 'DEPOSIT SORAG',
    'account.requests.group.withdrawal': 'BILEN SORAG',
    'account.requests.group.other': 'BAŞGA',
    'account.requests.template.depositBankCard': 'Bank kartoçkasy',
    'account.requests.template.depositRaschet': '"Raşet" bitewi töleg ulgamy',
    'account.requests.template.depositQiwi': 'QIWI terminaly',
    'account.requests.template.depositWebmoney': 'WebMoney',
    'account.requests.template.depositOplati': 'oplaty',
    'account.requests.template.withdrawalOplati': 'oplaty',
    'account.requests.template.withdrawalBank': 'Bank kartoçkasy / geçirim',
    'account.requests.form.operationDate': 'Geleşigiň senesi we wagty',
    'account.requests.form.amount': 'Geleşik mukdary',
    'account.requests.form.selectOperationDesc': 'Soragyňyz bilen baglanyşykly geleşigi saýlaň',
    'account.requests.form.selectOperationBtn': 'Hereket saýlaň',
    'account.requests.form.selectedOperation': 'Saýlanan hereket',
    'account.requests.form.noOperations': 'Amatly amal tapylmady',
    'account.requests.form.messagePlaceholder': 'Soragyňyzy ýa-da haýyşyňyzy beýan ediň',
    'account.requests.form.symbolsRemaining': '{count} nyşan galdy',
    'account.requests.form.choose': 'Saýlaň',
    'account.requests.form.dragOrUpload': 'Faýllary süýräň ýa-da ýükläň',
    'account.requests.form.attachFile': 'Faýl goşuň',
    'account.requests.form.attachHint': 'Iň köp 5 faýl. Formaty: jpg, jpeg, png, pdf. Iň köp 7 MB.',
    'account.requests.form.attachments': 'goşundylar',
    'account.helpCentre.title': 'kömek merkezi',
    'account.helpCentre.text1': 'Maglumatlary şu ýerden tapyp bilersiňiz',
    'account.helpCentre.text2': 'we ulanmak boýunça maslahatlar',
    'account.helpCentre.faq': 'Sorag-jogap',
    'account.helpCentre.instructions': 'Görkezmeler',
    'account.helpCentre.strategies': 'Jedel strategiýasy',
    'account.helpCentre.glossary': 'Sözlük',
    'account.helpCentre.go': 'Kömek merkezine gidiň',
    'account.support.subject': 'Mowzuk',
    'account.support.message': 'Habar',
    'account.support.send': 'Iber',
    'account.support.sent': 'Islegiňiz kabul edildi',
    'account.support.history': 'Öňki haýyşlar',
    'account.support.status_open': 'Açyň',
    'account.support.status_closed': '.Apyk',
    'account.support.status_pending': 'Garaşylýar',
    'account.support.status_waiting': 'Garaşylýar',
    'account.support.status_answered': 'Jogap berildi',
    'account.support.status_replied': 'Jogap berildi',
    'account.support.status_in_progress': 'işinde',
    'account.support.status_resolved': 'çözüldi',
    'account.pageTitle': 'Hasabym | URVURGUNBETX100⟧',
    'sport.filter.allTime': 'Hemişe',
    'sport.filter.allEvents': 'Eventshli wakalar',
    'sport.filter.live': 'Göni',
    'sport.filter.prematch': 'oýundan öň',
    'sport.filter.all': 'Hemmesi',
    'betslip.title': 'Talon',
    'betslip.empty': 'talon boş',
    'betslip.stake': 'Has gowy mukdar',
    'betslip.totalOdds': 'Jemi nyrh',
    'betslip.potentialWin': 'bolup biljek girdeji',
    'betslip.place': 'jedel goýuň',
    'betslip.clear': 'düşnükli',
    'betslip.accepted': 'Bet kabul edildi',
    'betslip.login': 'Jedel etmek üçin giriň',
    'betslip.emptyHint': 'Jedel etmek üçin wakany saýlaň',
    'betslip.amount': 'Mukdary, TL',
    'betslip.promos': 'Aksiýalar',
    'betslip.active': 'Işjeň',
    'betslip.popular': 'Meşhur wakalar',
    'footer.about': 'Biz hakda',
    'footer.basinda': 'Biz metbugatda',
    'footer.licence': 'Ygtyýarnama',
    'footer.privacy': 'Gizlinlik syýasaty',
    'footer.responsible': 'Jogapkärçilikli oýun',
    'footer.rules': 'Şertler we şertler',
    'footer.financial': 'maliýe hyzmatlary',
    'footer.vip': 'IPVIPX100⟧ programmasy',
    'footer.help': 'kömek merkezi',
    'footer.payments': 'Tölegler',
    'footer.company': 'Kompaniýanyň maglumatlary',
    'footer.mtd': 'MTD',
    'footer.shopRules': 'Jedeliň düzgünleri',
    'footer.appCaption': 'GÖRNÜŞ',
    'footer.appIos': 'iOS üçin',
    'footer.appIosLong': 'iOS programmasy',
    'footer.appAndroidLong': 'Android programmasy',
    'footer.appAndroid': 'Android üçin',
    'footer.telegram': 'Telegram',
    'footer.copyright': '18 ýaşa ýetmediklere jedel etmek gadagandyr. URVURGUNBETX100⟧ halkara onlaýn oýun operatory hökmünde işleýär.',
    'footer.legal': 'URVURGUNBETX100⟧; 18 ýaşdan uly ulanyjylara sport jedelleri, oýun oýunlary, göni kazino we şuňa meňzeş oýun önümlerini hödürleýär. Ulanyjy ýerleşýän ýerindäki kanuny çäklendirmeleri ýerine ýetirmek üçin jogapkärdir.',
    'footer.legal1': '18 ýaşa ýetmediklere humar oýnamak gadagan; Mundan başga-da, kazinolarda we wirtual kazinolarda girmek we / ýa-da humar oýnamak gadagan edilen adamlara gatnaşmak gadagan.',
    'footer.legal2': 'URVURGUNBETX100⟧; onlaýn sport jedelleri, oýun oýunlary, göni kazino we şuňa meňzeş oýun önümlerini hödürleýär. Hyzmatlar diňe kanuny taýdan rugsat edilen ýerlerde we şertlerde ulanylmaly.',
    'help.title': 'kömek merkezi',
    'help.searchPlaceholder': 'Soragyňyzy gözläň',
    'help.searchSheetTitle': 'Kömek merkezi: gözlemek',
    'help.searchSheetDesc': 'Soragyňyza jogap tapyň',
    'help.popularSearches': 'IOP GOWY Gözlegler',
    'help.popular.identification': 'Nädip barlamaly?',
    'help.popular.deposit': 'Puly nädip goýmaly?',
    'help.popular.win': 'Girdejimi nädip yzyna almaly?',
    'help.askQuestion': 'sorag beriň',
    'help.views': 'görnüşleri',
    'help.back': 'Yza',
    'help.noResults': 'Netije tapylmady',
    'help.goToFaq': 'Sorag-jogap bölümlerine geçiň',
    'help.instructions': 'Görkezmeler',
    'help.training': 'Bilim',
    'help.glossary': 'Sözlük',
    'help.notFound.code': '404',
    'help.notFound.title': 'Sahypa tapylmady',
    'help.notFound.description': 'Gözleýän sahypaňyz ýok. Göçürilen ýa-da öçürilen bolmagy mümkin.',
    'help.notFound.home': 'baş sahypa',
    'help.feedback.review': 'Teswir ýazyň',
    'help.feedback.helpful': 'Bu maglumat peýdaly boldumy?',
    'help.feedback.yes': 'Hawa, sag boluň',
    'help.feedback.no': '.Ok',
    'promos.tab.actions': 'Kampaniýalar',
    'promos.tab.tournaments': 'Turnirler',
    'promos.tab.actionsDesc': 'Çempion boluň',
    'promos.tab.tournamentsDesc': 'Tournaryşlara gatnaşyň',
    'promos.tab.actionsTitle': 'Kampaniýalar',
    'promos.tab.tournamentsTitle': 'Turnirler',
    'promos.tab.bonuses': 'Bonuslar',
    'promos.tab.bonusesDesc': 'Bonuslaryňyzy yzarlaň',
    'promos.tab.bonusesTitle': 'Bonuslaryňyz',
    'promos.tab.promoCode': 'promo kody',
    'promos.tab.promoCodeDesc': 'Indi işjeňleşdiriň',
    'promos.tab.promoCodeTitle': 'Mahabat kody barmy?',
    'promos.tournamentsIntro': 'Tournamentaryşlara gatnaşyň we gymmatly baýraklar üçin bäsleşiň',
    'promos.filter.all': 'Hemmesi',
    'promos.filter.sport': 'Sport',
    'promos.filter.casino': 'Kazino',
    'promos.timer.ended': 'wagt gutardy',
    'promos.timer.daysLeft': 'Galan: {count} gün',
    'promos.timer.hoursLeft': 'Galan: {count} sagat',
    'promos.timer.minutesLeft': 'Galan: {count} min',
    'promos.tournament.active': 'Işjeň',
    'promos.tournament.bonusFund': 'bonus gaznasy',
    'promos.tournament.participants': 'Gatnaşanlar',
    'promos.tournament.places': 'Tertipleşmek',
    'promos.tournament.untilCompletion': 'gutarmak üçin çep',
    'promos.tournament.untilStart': 'başlamak üçin galdy',
    'promos.tournament.upcoming': 'Tizara',
    'promos.tournament.startsIn': 'başlamak',
    'promos.tournament.joinWhenLive': 'Başlananda goşulyň',
    'promos.tournament.tab.rating': 'Tertipleşmek',
    'promos.tournament.tab.terms': 'Düzgünler',
    'promos.tournament.tab.games': 'oýunlar',
    'promos.tournament.col.participant': 'Gatnaşan',
    'promos.tournament.col.points': 'Ballar',
    'promos.tournament.col.bonuses': 'Bonuslar',
    'promos.tournament.participate': 'Killer',
    'promos.tournament.optOut': 'git',
    'promos.tournament.loginToJoin': 'Goşulmak üçin giriň',
    'promos.tournament.promoRules': 'Mahabatlandyryş düzgünleri',
    'promos.tournament.questions': 'Entegem soraglaryňyz barmy?',
    'promos.tournament.close': 'Ýap',
    'promos.tournament.loading': 'Reýting ýüklenýär…',
    'promos.tournament.emptyBoard': 'Entek reýting ýok. Ilkinji bolup goşulyň!',
    'promos.tournament.noTerms': 'Düzgünler ýakyn wagtda goşular.',
    'promos.tournament.noGames': 'Laýyk oýunlaryň sanawy ýakyn wagtda goşular.',
    'promos.tournament.joinedOk': 'Siz ýaryşa gatnaşdyňyz',
    'promos.tournament.leftOk': 'Siz ýaryşdan çykdyňyz',
    'promos.tournament.actionError': 'Amal tamamlanyp bilmedi',
    'promos.tournament.working': 'Gaýtadan işlemek…',
    'promos.tournament.gameBadge': 'SYURAHATÇYLYK',
    'promos.tournament.showAllGames': 'Gameshli oýunlary görkeziň',
    'promos.tournament.askQuestion': 'sorag beriň',
    'promos.tournament.faq.participate.q': 'Bäsleşige nädip goşulyp bilerin?',
    'promos.tournament.faq.participate.a': 'Naryşlar bölümine giriň, goşulmak isleýän ýaryşyňyzy açyň we Goşulmak düwmesini basyň.',
    'promos.tournament.faq.deposit.q': 'Bäsleşige gatnaşmak üçin pul goýmalymy?',
    'promos.tournament.faq.deposit.a': '--Ok - goşulmak mugt. Bal gazanmak üçin, diňe hakyky balansyňyz bilen Oýunlar sanawyndaky ýerleri oýnamak (min. 5 TL). Bonus balansy bal hasaplanmaýar.',
    'promos.tournament.faq.multiple.q': 'Bir wagtyň özünde birden köp ýaryşa gatnaşyp bilerinmi?',
    'promos.tournament.faq.multiple.a': 'Hawa. Bir wagtyň özünde birden köp işjeň ýaryşa gatnaşyp bilersiňiz; Her ýaryşyň reýtingleri aýratyn saklanýar.',
    'promos.tournament.faq.terms.q': 'Thearyş şertlerini nireden görüp bilerin?',
    'promos.tournament.faq.terms.a': 'Conditionshli şertleri ýaryş penjiresindäki Düzgünler goýmasyndan ýa-da Mahabat düzgünleriniň baglanyşygyndan gözden geçirip bilersiňiz.',
    'promos.tournament.faq.games.q': 'Haýsy oýun oýunlary ýaryşa goşulýar?',
    'promos.tournament.faq.games.a': 'Saýlap boljak oýunlar ýaryş penjiresindäki Oýunlar goýmasynda görkezilýär. Diňe sanawdaky oýunlarda edilen jedeller bal gazanýar.',
    'promos.tournament.faq.bonuses.q': 'Bäsleşige gatnaşyp, ýeňiş gazanyp, haýsy baýraklary alyp bilerin?',
    'promos.tournament.faq.bonuses.a': 'Reýtingdäki ornuňyza görä nagt we mugt aýlawlar (FS) gazanarsyňyz. Baýraklar ýaryş gutarandan 48 sagadyň dowamynda kesgitlenýär; FS 7 gün işleýär, diňe nagt pul baýraklarynda işleýär.',
    'promos.tournament.faq.timed.q': 'Tournaryşlar dowamlylygy çäklimi?',
    'promos.tournament.faq.timed.a': 'Hawa. URVURGUNX100⟧ WAGT her hepde duşenbe güni sagat 11: 00-da başlaýar we ýekşenbe güni 23:59; soň awtomatiki usulda täzelener.',
    'promos.tournament.faq.track.q': 'Tournamentaryşyň netijelerini we ösüşini nädip yzarlamaly?',
    'promos.tournament.faq.track.a': 'Häzirki balyňyzy we derejäňizi ýaryş penjiresinde “Reýting” goýmasyndan görüp bilersiňiz. Ballar hakyky balans jedellerinden soň derrew täzelenýär.',
    'promos.tournament.faq.more.q': 'Mende henizem soraglar bar.',
    'promos.tournament.faq.more.a': 'Aşakdaky sorag bermek düwmesi bilen goldaw haýyşyny döredip bilersiňiz. Toparymyz mümkin boldugyça gysga wagtda size gaýdyp geler.',
    'promos.tournament.ask.title': 'täze isleg',
    'promos.tournament.ask.subtitle': 'Bonus soragy',
    'promos.tournament.ask.placeholder': 'Soragyňyzy ýazyň ýa-da meseläni suratlandyryň',
    'promos.tournament.ask.charsLeft': '{count} nyşan galdy',
    'promos.tournament.ask.attach': 'Faýl goşuň',
    'promos.tournament.ask.attachHint': 'Iň köp 5 faýl. Formaty: jpg, jpeg, png, pdf. Iň köp 7 MB.',
    'promos.tournament.ask.cancel': 'Ýatyr',
    'promos.tournament.ask.send': 'Talap iber',
    'promos.tournament.ask.sending': 'Ibermek…',
    'promos.tournament.ask.sent': 'Islegiňiz kabul edildi Mümkin boldugyça gysga wagtda size gaýdyp geleris.',
    'promos.tournament.ask.loginRequired': 'Talap ibermek üçin giriň',
    'promos.tournament.ask.error': 'Talap iberilip bilinmedi',
    'promos.tournament.terms.periodTitle': 'Hepdelik ýaryş döwri',
    'promos.tournament.terms.pointsTitle': 'Bal gazanmagyň şertleri',
    'promos.tournament.terms.points1': 'Iň pes jedel 5 TL - goşulmak mugt, diňe ballar üçin hakyky deňagramlylyk bilen oýnaň.',
    'promos.tournament.terms.points2': 'Her 1 TL hakyky balans jedel = 2 bal. Juma - Sundayekşenbe 20% goşmaça bal!',
    'promos.tournament.terms.points3': 'Oýunlar goýmasyndaky ýerlerde döredilen ähli hakyky balans jedelleri derrew reýtinge ýazylýar. Bonus balansy hasaplanmaýar.',
    'promos.tournament.terms.bonusesTitle': 'Bonus ulanyş şertleri',
    'promos.tournament.terms.bonuses1': 'Nagt we FS baýraklary ýaryş gutarandan 48 sagadyň dowamynda kesgitlenýär; FS-iň güýji 7 gün.',
    'promos.tournament.terms.bonuses2': 'Baýrak baýraklaryny diňe x2 wagon bilen yzyna alyp bolýar - pudagyň ortaça derejesinden has pes.',
    'promos.tournament.terms.bonuses3': 'Bäsleşik her duşenbe güni sagat 11: 00-da awtomatiki usulda täzelenýär; Reýtingler täzeden düzüldi, täze hepde, täze mümkinçilik.',
    'promos.bonuses.title': 'Bonuslaryňyz',
    'promos.promocode.title': 'Mahabat kody barmy?',
    'promos.promocode.desc': 'Aşakdaky promo kody giriziň we Işletmek düwmesine basyň',
    'promos.promocode.placeholder': 'Promo kody giriziň',
    'promos.promocode.activate': 'işjeňleşdir',
    'promos.promocode.activating': 'Erine ýetirilýär…',
    'promos.promocode.success': 'Mahabat kody üstünlikli ulanyldy',
    'promos.promocode.error': 'Mahabat kody ulanylyp bilinmedi',
    'promos.promocode.loginRequired': 'Promo kody üçin girmeli',
    'promos.bonuses.loading': 'Bonuslaryňyz ýüklenýär ...',
    'promos.bonuses.empty': 'Entek bonusyňyz ýok',
    'promos.bonuses.emptyCaption': 'Işjeň bonus ýok',
    'promos.bonuses.emptyDescription': 'Kampaniýalara gatnaşyň we täze bonuslar gazanyň!',
    'promos.bonuses.emptyButton': 'Kampaniýalara gidiň',
    'promos.bonuses.emptyArchiveCaption': 'Arhiwde bonus ýok',
    'promos.bonuses.emptyArchiveDescription': 'Kampaniýalara gatnaşyň we täze bonuslar gazanyň!',
    'promos.bonuses.kindFilterBonuses': 'Bonuslar',
    'promos.bonuses.kindFilterFreeSpins': 'mugt aýlanmak',
    'promos.bonuses.kindFilterAll': 'Hemmesi',
    'promos.bonuses.kindFreeSpin': 'Mugt oýun',
    'promos.bonuses.fieldNominal': 'Nominal',
    'promos.bonuses.fieldStatus': 'Uationagdaý',
    'promos.bonuses.fieldExpires': 'Möhleti gutarýan senesi',
    'promos.bonuses.fieldReceived': 'Alnan senesi',
    'promos.bonuses.tabActive': 'Işjeň',
    'promos.bonuses.tabArchive': 'Taryh',
    'promos.bonuses.kindBonus': 'BONUS',
    'promos.bonuses.yourProgress': 'Öňe gidişligiňiz:',
    'promos.bonuses.statusWagering': 'Sikl dowam edýär',
    'promos.bonuses.moreInfo': 'Has giňişleýin maglumat',
    'promos.bonuses.detailTitle': 'Bonus işjeň',
    'promos.bonuses.leftDays': 'galan {n} günler',
    'promos.bonuses.leftDay': 'galan {n} günler',
    'promos.bonuses.detailLead': 'Iş talaplaryny ýerine ýetiriň we bonusyňyzy esasy hasabyňyza alyň',
    'promos.bonuses.placeBets': 'Jemi {amount}',
    'promos.bonuses.rulesTitle': 'BONUS HASABAT DÜZGÜNLERI',
    'promos.bonuses.rule1': 'Bonus hasabyna goşulan ýeňişler, mukdar 25 gezek öwrülenden soň esasy hasapda bolýar. Wagon, Guramaçy tarapyndan kesgitlenen käbir oýun oýunlaryndan başga ähli kazino üpjün edijileriniň ähli oýun oýunlarynda tamamlanyp bilner.',
    'promos.bonuses.rule2': 'Bonus hasabyndan rol oýnanyňyzda esasy hasap balansy ilki, soň bolsa bonus hasaby galyndysy ulanylýar.',
    'promos.bonuses.rule3': 'Bonus hasabyndan ulanylýan galyndylardan alnan ýeňişler, bonus hasabyna gaýtarylýar.',
    'promos.bonuses.rule4': 'Konwersiýa tamamlanandan soň, bonus hasabyndaky galan mukdar esasy balansa geçirilýär; ýöne başda bonus hasabyna goýlan mukdardan 3 esse köp bolup bilmez.',
    'promos.bonuses.rule5': 'Iş döwri, bonus hasaby işjeňleşdirilen pursadyndan 3 gün.',
    'promos.bonuses.rule6': 'Her bir indiki bonus, öňki bonus geçirilenden soň awtomatiki usulda işjeňleşdirilýär.',
    'promos.bonuses.rule7': 'Bonus hasabynda galyndy bar bolsa, esasy hasapdan pul alyp bolmaýar.',
    'promos.bonuses.promotionRules': 'Mahabatlandyryş düzgünleri',
    'promos.bonuses.askQuestion': 'sorag beriň',
    'promos.bonuses.cancelBonus': 'Bonusy ýatyryň',
    'promos.bonuses.cancelConfirm': 'Bonus balansyňyz pozular we rol oýnamak ýatyrylar. Dowam etmelimi?',
    'promos.bonuses.cancelBusy': 'Atyryldy ...',
    'promos.bonuses.cancelTitle': 'Siz hakykatdanam ýüz öwürmek isleýärsiňizmi?',
    'promos.bonuses.cancelBody': 'Taşlasaňyz, bonuslar ýakylar.\nIslän wagtyňyz ýatyryp bilersiňiz.',
    'promos.bonuses.cancelRefuse': 'Men ýüz öwürmek isleýärin',
    'promos.bonuses.cancelBack': 'Men ynanýaryn! gaýdyp gel',
    'promos.bonuses.askClose': 'Ýap',
    'promos.bonuses.askFileBadType': 'Goldanmaýan faýl formaty.',
    'promos.bonuses.askFileTooBig': 'Faýl 7Mb-dan uly.',
    'promos.bonuses.askError': 'Talap iberilip bilinmedi',
    'promos.bonuses.askSent': 'Islegiňiz iberildi',
    'promos.bonuses.askSending': 'Ibermek…',
    'promos.bonuses.askSend': 'Talap iber',
    'promos.bonuses.askCancel': 'Ýatyr',
    'promos.bonuses.askFilesSize': 'Iň köp 7Mb.',
    'promos.bonuses.askFilesMax': 'Iň köp 5 faýl.',
    'promos.bonuses.askAttach': 'Faýl goşuň',
    'promos.bonuses.askCharsLeft': '{n} nyşan galdy',
    'promos.bonuses.askPlaceholder': 'Soragyňyzy ýazyň ýa-da meseläni suratlandyryň',
    'promos.bonuses.askNewRequest': 'täze isleg',
    'promos.bonuses.askBonusQuestion': 'Bonus soragy',
    'promos.bonuses.askHint': 'Bonusyňyz barada goldaw toparyna sorag iberiň',
    'promos.bonuses.fieldWagering': 'aýlaw',
    'promos.bonuses.fieldWageringTime': 'Sikl wagty',
    'promos.bonuses.fieldMaxWithdrawal': 'Maks. çekmek',
    'promos.bonuses.fieldUsed': 'ulanylýar',
    'promos.bonuses.statusAvailable': 'Elýeterli',
    'promos.bonuses.statusUsed': 'ulanylýar',
    'promos.bonuses.activate': 'Işjeňleşdiriň',
    'promos.bonuses.days': 'gün',
    'promos.bonuses.games': 'oýunlar',
    'promos.bonuses.noGames': 'Oýun hakda maglumat ýok',
    'promos.bonuses.play': 'Oýna',
    'home.showcase.slots.title': 'Kazino',
    'home.showcase.slots.count': '{count} oýny',
    'home.showcase.slots.link': 'Oýunlara serediň',
    'home.showcase.live.title': 'göni kazino',
    'home.showcase.live.count': '{count} oýny',
    'home.showcase.live.link': 'Indi oýna →',
    'home.showcase.tv.title': 'TV oýunlary',
    'home.showcase.tv.count': '{count} oýny',
    'home.showcase.fast.title': 'Çalt oýunlar',
    'home.showcase.fast.count': '{count} oýny',
    'home.showcase.fast.link': 'Indi oýna →',
    'home.showcase.virtual.title': 'Wirtual sport',
    'home.showcase.virtual.count': '{count} oýny',
    'home.showcase.virtual.link': 'Indi oýna →',
    'home.showcase.gamesCount': '{count} oýny',
    'home.showcase.tv.link': 'Indi oýna →',
    'home.showcase.sport.title': 'Sport',
    'home.showcase.sport.count': '3380 waka',
    'home.showcase.sport.link': 'Jedel goýuň →',
    'home.promo.category.promotions': 'Kampaniýalar',
    'home.promo.category.tournaments': 'Turnirler',
    'home.promo.filter.all': 'Hemmesi',
    'home.promo.filter.sport': 'Sport (5)',
    'home.promo.filter.casino': 'Kazino (5)',
    'home.promo.showAll': 'Hemmesini görkez →',
    'home.promo.allPromotions': 'Allhli mahabat',
    'home.promo.cta.play': 'Oýna',
    'home.promo.cta.join': 'Killer',
    'home.promo.cta.details': 'Jikme-jiklik',
    'home.promo.cta.signup': 'Hasaba gir',
    'home.sport.searchEvents': 'Wakalary gözläň',
    'footer.contactUs': 'Biz bilen habarlaşyň',
    'footer.usefulInfo': 'Peýdaly maglumatlar',
    'footer.socialMedia': 'sosial media',
    'footer.partners': 'Resmi hyzmatdaş',
    'footer.officialPartner': 'Resmi\nhyzmatdaş',
    'home.casino.loading': 'Oýunlar ýüklenýär…',
    'home.casino.noGames': 'Oýun tapylmady',
    'home.casino.viewAllMobile': '{count} oýna serediň',
    'home.shuffle.title': 'Indiki oýnuňyz nähili bolmaly?',
    'home.shuffle.cta': 'Indi terjime et',
    'home.shuffle.modalTitle': 'Geliň, size laýyk oýny tapalyň!',
    'home.shuffle.respin': 'gaýtadan aýlaň',
    'home.shuffle.close': 'Ýap',
    'home.jackpot.casinoTitle': 'Kazino Jackpot',
    'home.jackpot.title': 'URVURGUNX100⟧ GRAND JAKPOT',
    'home.jackpot.badgeRest': 'GRAND JAKPOT',
    'home.jackpot.winners': 'Jemi ýeňiji: {count}',
    'home.jackpot.largest': 'Iň uly ýeňiş',
    'home.jackpot.last': 'soňky girdeji',
    'home.jackpot.onSlots': 'Allhli ýerlerde',
    'home.jackpot.play': 'ACJACKPOTX100⟧ oýunlary',
    'home.liveWins.title': 'Derrew gazanç',
    'home.liveWins.heated': 'Haul',
    'home.topWins.title': 'Iň gowy ýeňişler',
    'home.topWins.week': 'şu hepde',
    'home.topWins.month': 'şu aý',
    'home.topWins.day': 'Bu gün',
    'home.topWins.play': 'Oýna',
    'home.topWins.prev': 'Öňki',
    'home.topWins.next': 'Indiki',
    'home.popularSlots.title': 'Meşhur ýerler',
    'home.hotSlots.title': 'Iň girdejili',
    'home.hotSlots.badge': 'Yssy',
    'home.matchCarousel.title': 'Gabat gelýär',
    'home.matchCarousel.liveTv': 'Janly TV',
    'home.slotsCarousel.showAll': 'Hemmesini görkez',
    'home.slotsCarousel.prev': 'Öňki',
    'home.slotsCarousel.next': 'Indiki',
    'home.jackpot.grand': 'GRAND',
    'home.jackpot.major': 'Esasy',
    'home.jackpot.minor': 'MINOR',
    'home.jackpot.mini': 'MINI',
    'home.heroSide.vipTitle': 'IPVIPX100⟧ klub',
    'home.heroSide.vipSub': 'aýratyn artykmaçlyklar',
    'home.heroSide.promosTitle': 'Bonuslar',
    'home.heroSide.promosSub': 'Häzirki kampaniýalar',
    'home.heroSide.sportTitle': 'Sport',
    'home.heroSide.sportSub': 'Janly betler',
    'header.support': 'Goldaw',
    'home.topEvents.showAll': 'Hemmesini görkez',
    'betslip.bonusFund': 'bonus gaznasy',
    'betslip.participants': '{count} gatnaşyjy',
    'betslip.hoursLeft': '{hours} sagat galdy',
    'betslip.details': 'Jikme-jiklik',
    'casino.viewAllCaption': 'Hemmesine serediň',
    'casino.bside.promos': 'Kampaniýalar',
    'casino.bside.showAll': 'Hemmesini görkez →',
    'casino.lobby.slots': 'Slotlar',
    'casino.lobby.live': 'Janly Kazino',
    'casino.lobby.poker': 'Poker',
    'casino.lobby.tv': 'Telewizor oýunlary',
    'casino.lobby.fast': 'Derrew oýunlar',
    'casino.lobby.virtual': 'Wirtual Sport',
    'casino.tab.review': 'Esasy pursatlar',
    'casino.tab.favourites': 'halanýanlar',
    'casino.tab.top': 'Iň gowusy',
    'casino.tab.peter': 'Peter & Sons Hits',
    'casino.tab.free-spins': 'Mugt aýlawlar',
    'casino.tab.all': 'Gameshli oýunlar',
    'casino.tab.tournaments': 'Turnirler',
    'casino.tab.jackpot-cards': 'ACKJACKPOTX100⟧ Kartlar',
    'casino.tab.new': 'Täze',
    'casino.tab.world-cup': 'Dünýä çempionaty 2026',
    'casino.tab.buy-bonus': 'Bonus satyn alyň',
    'casino.tab.exclusive': 'aýratyn',
    'casino.tab.vip-egt': 'VIP EGT',
    'casino.tab.amusnet': 'Amusnet',
    'casino.tab.pragmatic-play': 'Pragmatiki oýun',
    'casino.tab.coins-link-vip': 'Şaýy pullar baglanyşygy VIP',
    'casino.tab.jackpot': 'Jackpot',
    'casino.tab.cascade': 'kaskad',
    'casino.tab.megaways': 'megaway',
    'casino.tab.collect': 'ýygnamak',
    'casino.tab.wild': 'Wildabany',
    'casino.tab.double': 'Iki gezek şans',
    'casino.tab.megax': 'MegaX',
    'casino.tab.respin': 'respin',
    'casino.tab.retro': 'retro',
    'casino.tab.fruits': 'miweler',
    'casino.tab.books': 'kitaplar',
    'casino.tab.fast-football': 'Çalt futbol',
    'casino.tab.holdem': 'sakla',
    'casino.tab.caribbean': 'Karib deňzi',
    'casino.tab.video-poker': 'Wideo Poker',
    'casino.tab.crash': 'heläkçilik',
    'casino.tab.table-games': 'Geňeş oýunlary',
    'casino.tab.mines': 'minalar',
    'casino.tab.plinko': 'Plinko',
    'casino.tab.dice': 'Membrana',
    'casino.tab.scratch': 'Dyzamak kartoçkasy',
    'casino.tab.other': 'Beýlekiler',
    'casino.tab.football': 'Futbol',
    'casino.tab.horse-racing': 'Atçylyk',
    'casino.tab.recommended': 'Maslahat berilýär',
    'casino.topProviders': 'iň gowy üpjün edijiler',
    'casino.groupsAll': 'Hemmesi',
    'casino.groupsNew': 'Innowasiýalar',
    'casino.groupsTop': 'iň gowy oýunlar',
    'casino.groupsWager': 'bonus üçin',
    'casino.groupsFreebonus': 'freebonus üçin',
    'casino.lobbyHome': 'baş sahypa',
    'casino.groups': 'Toparlar',
    'casino.providers': 'Üpjün edijiler',
    'casino.search': 'Gözle',
    'casino.play': 'Oýna',
    'casino.demo': 'demo',
    'casino.searchModal.title': 'Gözle',
    'casino.searchModal.placeholder': 'Oýun gözläň',
    'casino.filters': 'Süzgüçler',
    'casino.filtersCount': 'Süzgüçler ({count})',
    'casino.filter.section.functions': 'Aýratynlyklary',
    'casino.filter.section.themes': 'Mowzuklar',
    'casino.filter.bonusGame': 'Bonus oýny',
    'casino.filter.buyFeature': 'Bonus satyn alyň',
    'casino.filter.expandingSymbols': 'Nyşanlary giňeltmek',
    'casino.filter.freeSpins': 'Mugt aýlawlar',
    'casino.filter.multiplier': 'Köpeltmek',
    'casino.filter.respins': 'Yzyna',
    'casino.filter.symbolsCollection': 'Nyşanlary ýygnamak',
    'casino.filter.animals': 'haýwanlar',
    'casino.filter.books': 'kitaplar',
    'casino.filter.classic777': 'Klassiki & 777',
    'casino.filter.coins': 'teňňeler',
    'casino.filter.egypt': 'Süýji',
    'casino.filter.fruits': 'miweler',
    'casino.filter.gods': 'taňrylar',
    'casino.filter.joker': 'Joker',
    'casino.filter.western': 'Western',
    'casino.filter.vikings': 'Vikings',
    'casino.filter.christmas': 'Christmas',
    'casino.filter.asia': 'Asia',
    'casino.allProviders': 'Provhli üpjün edijiler',
    'casino.selectProvider': 'Üpjün edijini saýlaň',
    'casino.searchProviders': 'Üpjün edijini gözläň',
    'casino.loading': 'Oýunlar ýüklenýär…',
    'casino.noGames': 'Oýun tapylmady',
    'casino.lucky': 'Men bagtly',
    'casino.sortBy': 'Tertipleşdir',
    'casino.sort.popular': 'iň meşhur',
    'casino.sort.default': 'Bellenen',
    'casino.sort.az': 'A-dan Z-a çenli',
    'casino.sort.za': 'Z-dan A.',
    'casino.sort.new': 'Iň soňky',
    'casino.sort.provider': 'Üpjün ediji tarapyndan',
    'casino.sort.name': 'ady bilen',
    'casino.showMore': 'Has köp görkez',
    'casino.viewAll': 'oýunlar',
    'casino.games': 'oýun',
    'casino.side.games': 'oýunlar',
    'casino.side.tournament': 'Naryş',
    'casino.side.search': 'Oýun gözläň',
    'casino.side.recommended': 'Maslahat berilýän oýunlar',
    'casino.side.noGames': 'Oýun tapylmady',
    'casino.side.noTournaments': 'Işjeň ýaryşlar ýok',
    'casino.side.loading': 'Adingüklenýär…',
    'casino.game.play': 'Oýna',
    'casino.game.demo': 'demo',
    'casino.game.favorite': 'Halanýanlara goşuň',
    'casino.game.fullscreen': 'doly ekran',
    'casino.game.noFreeSpins': 'Bu oýna hiç hili erkinlik goşulmady',
    'casino.game.linkCopied': 'Baglanyşyk göçürildi',
    'casino.game.closeConfirmTitle': 'Oýun ýapyňmy?',
    'casino.game.closeConfirmText': 'Oýun ýapylar. Dowam etmek isleýärsiňizmi?',
    'casino.game.closeConfirmOk': 'Ýap',
    'casino.game.closeConfirmCancel': 'Ýatyr',
    'casino.game.popout': 'Täze penjirede açyň',
    'casino.game.playReal': 'Hakyky pul üçin oýnaň',
    'casino.game.addFreeSpins': 'Mugt aýlawlary goşuň',
    'casino.game.addFreeSpinsToGame': 'Oýna mugt aýlaw goşuň',
    'casino.game.fsBet': 'Bet',
    'casino.game.fsExpiresIn': 'Möhleti gutarýan senesi',
    'casino.game.fsAdd': 'Goş',
    'casino.game.fsBackToGame': 'oýna gaýdyp geliň',
    'casino.game.fsNewAvailable': 'Täze mugt aýlawlar taýýar',
    'casino.game.fsUpdateRequired': 'Oýuny täzelemeli',
    'casino.game.fsUpdate': 'Täzelen',
    'casino.game.insufficientBalance': 'Maliýe serişdeleri ýeterlik däl',
    'casino.game.insufficientBalanceHint': 'Hakyky pul üçin oýnamak üçin balansyňyzy dolduryň',
    'casino.game.insufficientContinue': 'Dowam et',
    'casino.game.makeDeposit': 'Pul goý',
    'casino.game.bonusInsufficientHint': 'Bonus balansyňyz bu geleşik üçin ýeterlik däl. Esasy puluna geçmek bonusy ýatyrýar.',
    'casino.game.switchToCash': 'Esasy puluna geç',
    'casino.game.demoMode': 'demo tertibi',
    'casino.game.signIn': 'Hakyky pul üçin oýnamak üçin giriň.',
    'casino.game.tryDemo': 'Demony synap görüň',
    'casino.game.loading': 'Oýun ýüklemek…',
    'casino.game.notFound': 'Oýun tapylmady',
    'casino.game.launchFailed': 'Oýun başladyrylmady',
    'casino.game.demoUnavailable': 'Demo bu oýun üçin elýeterli däl.',
    'casino.game.unavailable': 'Oýun häzir başladyrylyp bilinmeýär. Soňrak synanyşyň.',
    'casino.game.demoSuffix': '(Demo)',
    'casino.badge.top': 'IEST GOWY',
    'casino.badge.fs': 'FS',
    'casino.badge.tournament': 'Naryş',
    'casino.badge.new': 'TÄZE',
    'casino.badge.hits': 'HITS',
    'casino.badge.exclusive': 'aýratyn',
    'casino.badge.jackpot': 'Jackpot',
    'casino.bside.tournaments': 'Turnirler',
  }
};

/** CMS / API content that only exists as tr|en */
export function contentLocale(locale) {
  // Non-English UI languages use TR CMS content (slides/promos).
  return locale === 'en' ? 'en' : 'tr';
}

export function translate(locale, key, params = {}) {
  let text = MESSAGES[locale]?.[key] ?? MESSAGES.en?.[key] ?? MESSAGES.tr?.[key] ?? key;
  Object.entries(params || {}).forEach(([k, v]) => {
    text = String(text).split(`{${k}}`).join(v == null ? '' : String(v));
  });
  return text;
}
